export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  ShortId: any;
  UUID: string;
};

export type AcceptedContainerType = {
  __typename?: 'AcceptedContainerType';
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum AcceptedState {
  Accepted = 'ACCEPTED',
  NotAccepted = 'NOT_ACCEPTED',
  NotSet = 'NOT_SET'
}

export type AccountLedger = {
  __typename?: 'AccountLedger';
  batch_number?: Maybe<Scalars['String']>;
  billomat_invoice_id?: Maybe<Scalars['String']>;
  booking_date?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  cost_center_1?: Maybe<Scalars['String']>;
  cost_center_2?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  credit_amount?: Maybe<Scalars['Decimal']>;
  debit_amount?: Maybe<Scalars['Decimal']>;
  debitor_account_number?: Maybe<Scalars['String']>;
  hidden_at?: Maybe<Scalars['String']>;
  hidden_by?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_reference?: Maybe<Scalars['String']>;
  posting_number: Scalars['Int'];
  statement_descriptor?: Maybe<Scalars['String']>;
  store?: Maybe<Store>;
  updated_at?: Maybe<Scalars['String']>;
};

export type AccountLedgerInput = {
  batch_number?: InputMaybe<Scalars['String']>;
  billomat_invoice_id?: InputMaybe<Scalars['String']>;
  booking_date?: InputMaybe<Scalars['String']>;
  cost_center_1?: InputMaybe<Scalars['String']>;
  cost_center_2?: InputMaybe<Scalars['String']>;
  credit_amount?: InputMaybe<Scalars['Decimal']>;
  debit_amount?: InputMaybe<Scalars['Decimal']>;
  debitor_account_number?: InputMaybe<Scalars['String']>;
  invoice_reference?: InputMaybe<Scalars['String']>;
  posting_number: Scalars['Int'];
  statement_descriptor?: InputMaybe<Scalars['String']>;
};

export type Achievement = {
  __typename?: 'Achievement';
  id: Scalars['ID'];
  unlocked_at?: Maybe<Scalars['String']>;
};

export type ActiveInventoryCheck = {
  __typename?: 'ActiveInventoryCheck';
  expiration_date: Scalars['String'];
  id: Scalars['ID'];
};

export type AdditionalUserInfo = {
  email?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street_extra?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetno?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressSearchResult = {
  __typename?: 'AddressSearchResult';
  city_country?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lonlat?: Maybe<LonLat>;
  title: Scalars['String'];
};

/**
 * Pricing payloads for the admin Container Types screen, mirroring the legacy
 * .NET wire formats. store_default_container_prices_string is the
 * DefaultContainerInformation config JSON (array of {Id, [currency]: prices}),
 * consumer_overdue_prices_string is a JSON object keyed by currency name, then
 * container type id (-1 = default), with cent amounts.
 */
export type AdminContainerPricing = {
  __typename?: 'AdminContainerPricing';
  consumer_overdue_prices_string: Scalars['String'];
  store_default_container_prices_string: Scalars['String'];
};

/**
 * Full container type as edited on the admin dashboard's Container Types
 * screen. Field values mirror the legacy .NET REST endpoints: class is the
 * PascalCase .NET enum name (e.g. ProductPortfolio), segment is Drinks/Food/
 * Cutlery and names_by_language_string is a JSON object keyed by language
 * (En, De, ...).
 */
export type AdminContainerType = {
  __typename?: 'AdminContainerType';
  archived: Scalars['Boolean'];
  branding?: Maybe<Scalars['String']>;
  class: Scalars['String'];
  /**
   * Ids of the OTHER container types this type is physically interchangeable with
   * (the shared M/L cup lid case: same lid, QR code on the lid, so a scan cannot
   * tell them apart). Sorted ascending, excludes this type's own id, empty when the
   * type has no equivalents. A picking scan of any member satisfies an ordered
   * bucket of any other member; the container is retagged to the ordered type when
   * the picking job is confirmed.
   */
  container_equivalent_type_ids: Array<Scalars['Int']>;
  /**
   * Id of the underlying ContainerEquivalents group, or null when the type has no
   * equivalents. Informational — edits go through container_equivalent_type_ids.
   */
  container_equivalents_id?: Maybe<Scalars['Int']>;
  country_codes: Array<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_code?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  legal_owner?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  names_by_language_string: Scalars['String'];
  order_key: Scalars['Int'];
  packing_instructions?: Maybe<Scalars['String']>;
  packing_unit: Scalars['Int'];
  segment?: Maybe<Scalars['String']>;
  size_helper?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  weight: Scalars['Int'];
};

/**
 * Distinct values + aggregates powering the filter chips and the create flow
 * (max_order_key for placing new types on top, max_id to locate a type created
 * via addNewContainerType).
 */
export type AdminContainerTypeFacets = {
  __typename?: 'AdminContainerTypeFacets';
  brandings: Array<Scalars['String']>;
  legal_owners: Array<Scalars['String']>;
  max_id: Scalars['Int'];
  max_order_key: Scalars['Int'];
  sizes: Array<Scalars['String']>;
  total_count: Scalars['Int'];
};

/**
 * Server-side filters for the admin container type list. search matches the
 * id (when numeric) and name/SKU/branding/legal owner substrings; the list
 * filters combine with AND, values within one list with IN. archived: null
 * returns archived and active types alike.
 */
export type AdminContainerTypeFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  brandings?: InputMaybe<Array<Scalars['String']>>;
  classes?: InputMaybe<Array<Scalars['String']>>;
  country_codes?: InputMaybe<Array<Scalars['String']>>;
  group_ids?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legal_owners?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<Scalars['String']>>;
  sizes?: InputMaybe<Array<Scalars['String']>>;
};

export type AdminContainerTypeInput = {
  archived: Scalars['Boolean'];
  branding?: InputMaybe<Scalars['String']>;
  class: Scalars['String'];
  /**
   * Desired equivalence membership: the ids of the OTHER container types this type
   * is physically interchangeable with. Omit (or send null) to leave the current
   * group untouched; send [] to take this type out of its group. Setting a
   * membership moves the listed types out of any group they were in, and a group
   * left with fewer than two members is dissolved. Two inputs in the same call that
   * describe contradictory memberships are rejected.
   */
  container_equivalent_type_ids?: InputMaybe<Array<Scalars['Int']>>;
  country_codes: Array<Scalars['String']>;
  group_id: Scalars['Int'];
  hex_code?: InputMaybe<Scalars['String']>;
  icon_url?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: InputMaybe<Scalars['String']>;
  legal_owner?: InputMaybe<Scalars['String']>;
  names_by_language_string: Scalars['String'];
  order_key: Scalars['Float'];
  packing_instructions?: InputMaybe<Scalars['String']>;
  packing_unit: Scalars['Int'];
  segment?: InputMaybe<Scalars['String']>;
  size_helper?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  weight: Scalars['Int'];
};

/**
 * One page of the admin container type list, sorted OrderKey desc / Id asc.
 * total_count counts everything matching the filter; unfiltered_count applies
 * only the archived flag (the "of M" in "Showing N of M").
 */
export type AdminContainerTypePage = {
  __typename?: 'AdminContainerTypePage';
  items: Array<AdminContainerType>;
  total_count: Scalars['Int'];
  unfiltered_count: Scalars['Int'];
};

export type AdminUpdateUser = {
  email_verified?: InputMaybe<Scalars['Boolean']>;
  feature_next_handout_enabled?: InputMaybe<Scalars['Boolean']>;
  feature_tap_to_borrow_enabled?: InputMaybe<Scalars['Boolean']>;
  feature_tap_to_borrow_two_tap_flow?: InputMaybe<Scalars['Boolean']>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']>;
  tap_to_borrow_type?: InputMaybe<TapToBorrowType>;
};

export type AdvanceWashingHubStationInput = {
  /** Pieces per buffer order (and what the box is packed with). */
  amount: Scalars['Int'];
  /** Defaults to the event's 04_…_Arrival location. */
  arrival_item_location_id?: InputMaybe<Scalars['UUID']>;
  container_station_id: Scalars['ID'];
  container_type_id: Scalars['Int'];
  event_id: Scalars['ID'];
  /**
   * The stage the caller saw. The booking is refused with STAGE_CHANGED when
   * the box has moved on since, so a double click or a second TV cannot book
   * the same step twice. PACKING books nothing and returns the current state:
   * the packing already put the box in storage.
   */
  expected_stage: WashingHubStage;
  /** Required for the hand out and take back steps. */
  gastronomist_event_account_id?: InputMaybe<Scalars['ID']>;
  /** Defaults to PACK_BOXES. */
  packing_feature?: InputMaybe<WashingHubPackingFeature>;
  /**
   * Where the packing step books the box to. Defaults to the buffer order's
   * warehouse location.
   */
  storage_item_location_id?: InputMaybe<Scalars['UUID']>;
};

export type AggregatedEventMerchantOrderData = {
  __typename?: 'AggregatedEventMerchantOrderData';
  amount_container_stations_ordered: Scalars['Int'];
  amount_containers_ordered: Scalars['Int'];
  item_info: ItemInfo;
};

export type AggregatedItemData = {
  __typename?: 'AggregatedItemData';
  fulfillment_type_counts: Array<OrderFulfillmentTypeCount>;
  item_info: ItemInfo;
};

export type AggregatedItemDataV2 = {
  __typename?: 'AggregatedItemDataV2';
  fulfillment_type_counts: Array<OrderFulfillmentTypeCountV2>;
  item_info: ItemInfo;
};

export type AggregatedOrderFulfillmentDataByType = {
  __typename?: 'AggregatedOrderFulfillmentDataByType';
  container_amounts: Array<ContainerTypeAmount>;
  fulfillment_type: OrderFulfillmentType;
};

export type AllNonUsageFeeInfo = {
  __typename?: 'AllNonUsageFeeInfo';
  current_info: Array<NonUsageFeeInfo>;
  previous_info: Array<PreviousNonUsageFeeInfo>;
};

export type AnalyticsUser = {
  __typename?: 'AnalyticsUser';
  accounts: Array<IdName>;
  country?: Maybe<UserCountry>;
  created_at?: Maybe<Scalars['String']>;
  dashboard_variant?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  is_active: Scalars['Boolean'];
  merchant?: Maybe<Scalars['String']>;
  merchants: Array<MerchantInfo>;
  preferred_locale?: Maybe<Scalars['String']>;
  stores: Array<StoreInfo>;
  superset_user_id?: Maybe<Scalars['Int']>;
};

export type AnalyticsUsersPaginatedResult = {
  __typename?: 'AnalyticsUsersPaginatedResult';
  analytics_users: Array<AnalyticsUser>;
  total: Scalars['Int'];
};

export type ApiToken = {
  __typename?: 'ApiToken';
  brand_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['String']>;
  invalidated?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type AppLoginToken = {
  __typename?: 'AppLoginToken';
  created_at?: Maybe<Scalars['String']>;
  created_from_ip?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  login_from_ip?: Maybe<Scalars['String']>;
  ttl?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']>;
};

export enum AppPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum AppTranslationAppType {
  ConsumerApp = 'CONSUMER_APP',
  PartnerApp = 'PARTNER_APP'
}

export type AppTranslationEntry = {
  __typename?: 'AppTranslationEntry';
  app_type?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updated_at: Scalars['String'];
  url: Scalars['String'];
};

export type ApplePassResult = {
  __typename?: 'ApplePassResult';
  file_base_64: Scalars['String'];
};

export type ApplyPromotionResult = {
  __typename?: 'ApplyPromotionResult';
  activated_campaign: Campaign;
  post_activation_action_type: PostApplyPromotionActionType;
  user: User;
};

export type AssetAmount = {
  __typename?: 'AssetAmount';
  amount: Scalars['Int'];
  item_type: ItemType;
};

export enum AssetType {
  Phone = 'PHONE',
  ReturnBox = 'RETURN_BOX'
}

export type Auth0Identities = {
  __typename?: 'Auth0Identities';
  connection?: Maybe<Scalars['String']>;
  isSocial?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  access_token?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  expired_in?: Maybe<Scalars['Int']>;
  expires?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  id_token?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type AuthorizedSigner = {
  __typename?: 'AuthorizedSigner';
  allowed_item_locations?: Maybe<Array<ItemLocation>>;
  can_be_deleted: Scalars['Boolean'];
  can_use_all_item_locations: Scalars['Boolean'];
  event_account: EventAccount;
  event_account_id: Scalars['ID'];
  event_account_name: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AuthorizedSignerReduced = {
  __typename?: 'AuthorizedSignerReduced';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AvailableCarrierService = {
  __typename?: 'AvailableCarrierService';
  carrier: OpsOrderCarrier;
  services: Array<OpsOrderCarrierService>;
};

export type Basket = {
  __typename?: 'Basket';
  campaign?: Maybe<Campaign>;
  currency?: Maybe<Currency>;
  deeplink?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<DeliveryAddress>;
  delivery_fee?: Maybe<Scalars['Int']>;
  discount_amount?: Maybe<Scalars['Int']>;
  discount_by_vytal_credits: Scalars['Int'];
  eat_in?: Maybe<Scalars['Boolean']>;
  enabled_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_shared?: Maybe<Scalars['Boolean']>;
  item_total?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<BasketItem>>>;
  main_basket_id?: Maybe<Scalars['ID']>;
  main_order_id?: Maybe<Scalars['ID']>;
  master_order_placed?: Maybe<Scalars['Boolean']>;
  master_user_id?: Maybe<Scalars['ID']>;
  min_delivery_order_value?: Maybe<Scalars['Int']>;
  min_delivery_order_value_diff?: Maybe<Scalars['Int']>;
  min_order_value_diff?: Maybe<Scalars['Int']>;
  new_master_notified?: Maybe<Scalars['Boolean']>;
  no_fee_campaign?: Maybe<Campaign>;
  order_id?: Maybe<Scalars['ID']>;
  order_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pickup_time?: Maybe<Scalars['String']>;
  placement_time?: Maybe<Scalars['String']>;
  platform_fee?: Maybe<Scalars['Int']>;
  platform_fee_info?: Maybe<Scalars['String']>;
  state?: Maybe<BasketState>;
  store_id?: Maybe<Scalars['ID']>;
  store_total?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  type?: Maybe<OrderType>;
  user_id?: Maybe<Scalars['ID']>;
  users_infos?: Maybe<Array<Maybe<SharedOrderInfo>>>;
};

export type BasketItem = {
  __typename?: 'BasketItem';
  base_price?: Maybe<Scalars['Int']>;
  campaign_id?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  extras?: Maybe<Array<Maybe<Extra>>>;
  full_price?: Maybe<Scalars['Int']>;
  has_cutlery?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  is_promo?: Maybe<Scalars['Boolean']>;
  item_id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  old_price?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  product_category_placeholder?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_max?: Maybe<Scalars['Int']>;
  store_id?: Maybe<Scalars['ID']>;
  teaser_text?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['ID']>;
};

export type BasketItemCreate = {
  comment?: InputMaybe<Scalars['String']>;
  extras?: InputMaybe<Array<InputMaybe<ExtraOrderItemInput>>>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  variant_id?: InputMaybe<Scalars['ID']>;
};

export type BasketItemInput = {
  base_price?: InputMaybe<Scalars['Int']>;
  campaign_id?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  extras?: InputMaybe<Array<InputMaybe<ExtraOrderItemInput>>>;
  full_price?: InputMaybe<Scalars['Int']>;
  has_cutlery?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  is_promo?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  old_price?: InputMaybe<Scalars['Int']>;
  price: Scalars['Int'];
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  quantity_max?: InputMaybe<Scalars['Int']>;
  store_id: Scalars['ID'];
  teaser_text?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['ID']>;
  variants?: InputMaybe<Array<InputMaybe<VariantInput>>>;
};

export type BasketItemUpdate = {
  comment?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export enum BasketState {
  CancelledByMaster = 'CANCELLED_BY_MASTER',
  Open = 'OPEN',
  Placed = 'PLACED',
  Timeout = 'TIMEOUT'
}

export enum BellStatus {
  Confirmed = 'CONFIRMED',
  Ringing = 'RINGING',
  Rung = 'RUNG'
}

/**
 * Groups store assets for revenue reporting. The Invoice Summary reports one
 * revenue column per value, so the set is deliberately coarse: it answers
 * "which kind of asset earned this", not "which item type is it".
 */
export enum BillingCategory {
  CircleCube = 'CIRCLE_CUBE',
  MiniReturner = 'MINI_RETURNER',
  Phone = 'PHONE',
  ReturnBox = 'RETURN_BOX',
  Tab2Borrow = 'TAB2_BORROW'
}

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Yearly = 'YEARLY'
}

export type BillomatArticleIdByCountry = {
  __typename?: 'BillomatArticleIdByCountry';
  article_id: Scalars['Int'];
  country_code: Scalars['String'];
};

export type BillomatArticleIdByCountryInput = {
  article_id: Scalars['Int'];
  country_code: Scalars['String'];
};

export type BillomatInvoice = {
  __typename?: 'BillomatInvoice';
  charged_amount?: Maybe<Scalars['Int']>;
  charged_at?: Maybe<Scalars['String']>;
  charged_charge_id?: Maybe<Scalars['String']>;
  charged_currency?: Maybe<Currency>;
  charged_transaction_id?: Maybe<Scalars['String']>;
  generated_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  send_at?: Maybe<Scalars['String']>;
  send_delivery_id?: Maybe<Scalars['String']>;
  send_delivery_link?: Maybe<Scalars['String']>;
  send_emails_used?: Maybe<Scalars['String']>;
  send_error?: Maybe<Scalars['String']>;
  send_processed_at?: Maybe<Scalars['String']>;
  send_status?: Maybe<BillomatInvoiceSendStatus>;
  status?: Maybe<BillomatInvoiceStatus>;
  title?: Maybe<Scalars['String']>;
};

export enum BillomatInvoiceSendStatus {
  AutomaticSendingDisabled = 'AUTOMATIC_SENDING_DISABLED',
  Error = 'ERROR',
  Sent = 'SENT'
}

export enum BillomatInvoiceStatus {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Overdue = 'OVERDUE',
  Paid = 'PAID'
}

export type Brand = {
  __typename?: 'Brand';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Address>;
  allergens_info?: Maybe<Scalars['String']>;
  allergens_info_url?: Maybe<Scalars['String']>;
  cancelation_time?: Maybe<Scalars['Int']>;
  change_history?: Maybe<Array<Maybe<BrandChangeHistory>>>;
  commission_rate?: Maybe<Scalars['Int']>;
  commission_rate_reduced?: Maybe<Scalars['Int']>;
  contact?: Maybe<Scalars['String']>;
  cross_brand_invoice_group?: Maybe<InvoiceGroup>;
  description?: Maybe<Scalars['String']>;
  dunning_reminder_block_permanent_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_permanent_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_reason?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_type?: Maybe<DunningReminderBlockType>;
  dunning_reminder_block_until?: Maybe<Scalars['String']>;
  external_salesforce_id?: Maybe<Scalars['String']>;
  external_vytal_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_email?: Maybe<Scalars['String']>;
  invoice_group_id?: Maybe<Scalars['ID']>;
  is_dunning_reminder_stopped?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Array<Maybe<StoreLabel>>>;
  legal_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  migrated_from_vytal?: Maybe<Scalars['Boolean']>;
  min_order_time?: Maybe<Scalars['Int']>;
  monthly_fee?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  onboarding_fee_vytal?: Maybe<Scalars['Int']>;
  permanently_removed?: Maybe<Scalars['Boolean']>;
  prefix?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Product>>>;
  regular_payment_target_days?: Maybe<Scalars['Int']>;
  separate_invoice_each_store?: Maybe<Scalars['Boolean']>;
  short_name?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<Maybe<Store>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
};

export type BrandChangeHistory = {
  __typename?: 'BrandChangeHistory';
  changed_at?: Maybe<Scalars['String']>;
  changed_by?: Maybe<Scalars['String']>;
  changed_by_raw?: Maybe<Scalars['String']>;
  new_values?: Maybe<Scalars['String']>;
  old_values?: Maybe<Scalars['String']>;
};

export enum BusinessType {
  Cooperative = 'cooperative',
  GovernmentEntityPublicInstitution = 'government_entity_public_institution',
  LimitedPartnership = 'limited_partnership',
  NonProfitOrganization = 'non_profit_organization',
  Partnership = 'partnership',
  PrivateLimitedCompany = 'private_limited_company',
  PublicLimitedCompany = 'public_limited_company',
  SoleProprietorship = 'sole_proprietorship',
  TrustFoundation = 'trust_foundation'
}

export type CalcPackageCountContainerInput = {
  amount: Scalars['Int'];
  type_id: Scalars['Int'];
};

export type CalcPackageCountItemInput = {
  amount: Scalars['Int'];
  item_type_id: Scalars['Int'];
};

export type CalcPackageCountUntrackedItemInput = {
  amount: Scalars['Int'];
  type_id: Scalars['Int'];
};

export type Campaign = {
  __typename?: 'Campaign';
  activated_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  active_hours?: Maybe<Array<Maybe<OpeningHours>>>;
  allow_pos_usage: Scalars['Boolean'];
  allow_unverified?: Maybe<Scalars['Boolean']>;
  block_activation_from?: Maybe<Scalars['String']>;
  brand_id?: Maybe<Scalars['ID']>;
  brand_name?: Maybe<Scalars['String']>;
  /** @deprecated Field is deprecated, use quantity_max instead! */
  code_single_use?: Maybe<Scalars['Boolean']>;
  discount_amount?: Maybe<Scalars['Int']>;
  discount_percent?: Maybe<Scalars['Int']>;
  discount_type?: Maybe<DiscountType>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_featured?: Maybe<Scalars['Boolean']>;
  min_order_value?: Maybe<Scalars['Int']>;
  new_customers_only?: Maybe<Scalars['Boolean']>;
  offer_name?: Maybe<Scalars['String']>;
  offer_partner_label?: Maybe<Scalars['String']>;
  original_permanent_campaign?: Maybe<Campaign>;
  payed_by_partner_share?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['ID']>;
  promotion_code?: Maybe<Scalars['String']>;
  quantity_max?: Maybe<Scalars['Int']>;
  redeemed_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  referral_name?: Maybe<Scalars['String']>;
  show_success?: Maybe<Scalars['Boolean']>;
  single_use_only?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['String']>;
  store_id?: Maybe<Scalars['ID']>;
  store_name?: Maybe<Scalars['String']>;
  store_street?: Maybe<Scalars['String']>;
  teaser_image_detail?: Maybe<Scalars['String']>;
  teaser_image_start?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  type?: Maybe<CampaignType>;
  used_at?: Maybe<Scalars['String']>;
  user_quantity?: Maybe<Scalars['Int']>;
};

export type CampaignInput = {
  allow_unverified?: InputMaybe<Scalars['Boolean']>;
  block_activation_from?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  code_single_use?: InputMaybe<Scalars['Boolean']>;
  discount_amount?: InputMaybe<Scalars['Int']>;
  discount_percent?: InputMaybe<Scalars['Int']>;
  discount_type?: InputMaybe<DiscountType>;
  end_date?: InputMaybe<Scalars['String']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  min_order_value?: InputMaybe<Scalars['Int']>;
  new_customers_only?: InputMaybe<Scalars['Boolean']>;
  offer_name?: InputMaybe<Scalars['String']>;
  payed_by_partner_share?: InputMaybe<Scalars['Int']>;
  promotion_code?: InputMaybe<Scalars['String']>;
  quantity_max?: InputMaybe<Scalars['Int']>;
  referral_name?: InputMaybe<Scalars['String']>;
  show_success?: InputMaybe<Scalars['Boolean']>;
  single_use_only?: InputMaybe<Scalars['Boolean']>;
  start_date?: InputMaybe<Scalars['String']>;
  store_id?: InputMaybe<Scalars['ID']>;
  teaser_image_detail?: InputMaybe<Scalars['String']>;
  teaser_image_start?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CampaignType>;
  user_quantity?: InputMaybe<Scalars['Int']>;
};

export type CampaignStatistics = {
  __typename?: 'CampaignStatistics';
  ticket_statistics: Array<TicketStatistics>;
};

export enum CampaignType {
  BrandCampaign = 'BRAND_CAMPAIGN',
  CheckoutCampaign = 'CHECKOUT_CAMPAIGN',
  Default = 'DEFAULT',
  IndividualUserCampaign = 'INDIVIDUAL_USER_CAMPAIGN',
  InstantCampaign = 'INSTANT_CAMPAIGN',
  NewBrandCustomer = 'NEW_BRAND_CUSTOMER',
  NoOrderFeeCampaign = 'NO_ORDER_FEE_CAMPAIGN',
  PosCampaign = 'POS_CAMPAIGN',
  PosPermanentCampaign = 'POS_PERMANENT_CAMPAIGN',
  StoreCampaign = 'STORE_CAMPAIGN'
}

export type CatalogAccountType = {
  __typename?: 'CatalogAccountType';
  id: Scalars['ID'];
  /**
   * Stable slug ("venue"), identical across environments — use in URLs and
   * code; ids are per-environment uuids.
   */
  key: Scalars['String'];
  name: Scalars['String'];
};

/** Asset-specific attributes (1:1 with an ASSET product). */
export type CatalogAssetType = {
  __typename?: 'CatalogAssetType';
  can_tracking_checkout: Scalars['Boolean'];
  can_tracking_return: Scalars['Boolean'];
  tracking_technology?: Maybe<CatalogTrackingTechnology>;
};

/**
 * A brand a product can be branded with (product_branding). Flattened: the
 * pivot's is_extended_lead_time rides along on the brand.
 */
export type CatalogBrand = {
  __typename?: 'CatalogBrand';
  id: Scalars['ID'];
  /** Ordering this product with this branding extends the lead time. */
  is_extended_lead_time: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CatalogColor = {
  __typename?: 'CatalogColor';
  id: Scalars['ID'];
  name: Scalars['String'];
  primary_color_hex: Scalars['String'];
  secondary_color_hex?: Maybe<Scalars['String']>;
};

/**
 * One orderable color combination of a product. lid_color is only set for
 * containers with a lid.
 */
export type CatalogColorVariant = {
  __typename?: 'CatalogColorVariant';
  container_color: CatalogColor;
  id: Scalars['ID'];
  lid_color?: Maybe<CatalogColor>;
};

export enum CatalogContainerSegment {
  Cutlery = 'CUTLERY',
  Drinks = 'DRINKS',
  Food = 'FOOD',
  Transport = 'TRANSPORT'
}

/** Container-specific attributes (1:1 with a CONTAINER product). */
export type CatalogContainerType = {
  __typename?: 'CatalogContainerType';
  has_qr_code: Scalars['Boolean'];
  has_rfid: Scalars['Boolean'];
  /**
   * False for a lid or accessory that is its own container type. Such products
   * are hidden from the product listing and reachable through
   * complementary_products.
   */
  is_container_body: Scalars['Boolean'];
  is_dishwasher_safe: Scalars['Boolean'];
  is_freezer_safe: Scalars['Boolean'];
  is_leak_proof: Scalars['Boolean'];
  is_microwaveable: Scalars['Boolean'];
  is_trackable: Scalars['Boolean'];
  /** The lid always comes with the body: one unit, one QR code. */
  lid_included?: Maybe<Scalars['Boolean']>;
  lid_material?: Maybe<CatalogMaterial>;
  /** Number of units per packing unit (e.g. per box). */
  packing_unit: Scalars['Int'];
  qr_code_type?: Maybe<CatalogQrCodeType>;
  rfid_type?: Maybe<CatalogRfidType>;
  segment: CatalogContainerSegment;
  volume_unit?: Maybe<CatalogVolumeUnit>;
  /** Lower bound (or exact value) of the volume. */
  volume_value?: Maybe<Scalars['Float']>;
  /** Upper bound for volume ranges like "300–500ml". */
  volume_value_max?: Maybe<Scalars['Float']>;
};

export type CatalogCountry = {
  __typename?: 'CatalogCountry';
  id: Scalars['ID'];
  /** 2-letter ISO code, e.g. "DE". */
  iso_code: Scalars['String'];
  name: Scalars['String'];
};

/**
 * Filter values that have at least one ACTIVE product, so the frontend can
 * hide empty filters.
 */
export type CatalogFilterMetadata = {
  __typename?: 'CatalogFilterMetadata';
  account_types: Array<CatalogAccountType>;
  categories: Array<CatalogProductCategory>;
  countries: Array<CatalogCountry>;
  /** @deprecated Use account_types */
  market_segments: Array<CatalogAccountType>;
  segments: Array<CatalogContainerSegment>;
  types: Array<CatalogProductType>;
};

/**
 * Languages a product or category can be localized into (localized_products /
 * localized_product_categories rows).
 */
export enum CatalogLanguageCode {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR'
}

export type CatalogMaterial = {
  __typename?: 'CatalogMaterial';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Resin/material symbol, e.g. "PP". */
  symbol?: Maybe<Scalars['String']>;
};

export enum CatalogPackaging {
  SealedBox = 'SEALED_BOX',
  Single = 'SINGLE'
}

export type CatalogPrice = {
  __typename?: 'CatalogPrice';
  /** Integer cents. */
  amount_cents: Scalars['Int'];
  /** 3-letter ISO code, e.g. "EUR". */
  currency: Scalars['String'];
  mode: CatalogPriceMode;
};

/**
 * One way of paying for a product. Which modes a product offers follows from
 * its active Stripe Prices (Stripe is the only source of sell prices — the
 * catalog DB stores none).
 */
export enum CatalogPriceMode {
  /** One-time purchase (Stripe: one-time Price). */
  Purchase = 'PURCHASE',
  /** Flat monthly lease per unit (Stripe: recurring, licensed). */
  RentMonthly = 'RENT_MONTHLY',
  /** Charged per use (Stripe: recurring, metered). */
  RentPerUse = 'RENT_PER_USE'
}

/**
 * A publicly visible catalog product. name/description are resolved to the
 * requested language (fallback: the product's base values).
 *
 * complementary_products / complementary_to are resolved one level deep: the
 * nested products carry all their own attributes, but their complementary
 * lists are always empty.
 */
export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  account_types: Array<CatalogAccountType>;
  /** Set when type = ASSET. */
  asset_type?: Maybe<CatalogAssetType>;
  brands: Array<CatalogBrand>;
  color_variants: Array<CatalogColorVariant>;
  /**
   * Products complementing this one (this product → complement direction).
   * Only ACTIVE complements are returned.
   */
  complementary_products: Array<CatalogProduct>;
  /** Reverse direction: ACTIVE products that list this one as their complement. */
  complementary_to: Array<CatalogProduct>;
  /** Set when type = CONTAINER. */
  container_type?: Maybe<CatalogContainerType>;
  countries: Array<CatalogCountry>;
  created_at: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * The storage_path folder's images, sorted by file name — first is the
   * cover. Empty for an empty or missing folder. Resolved on the list query,
   * the detail query and nested complementary products alike.
   */
  images: Array<CatalogProductImage>;
  is_billed_per_month: Scalars['Boolean'];
  /** Billing flags — which payment modes the product offers. Any combination. */
  is_billed_per_use: Scalars['Boolean'];
  /**
   * Orderable by open-system restaurants. The events funnel ignores this flag;
   * any event can order any product.
   */
  is_open_system: Scalars['Boolean'];
  is_purchaseable: Scalars['Boolean'];
  lead_time_days_max?: Maybe<Scalars['Int']>;
  lead_time_days_min?: Maybe<Scalars['Int']>;
  /** @deprecated Use account_types */
  market_segments: Array<CatalogAccountType>;
  material?: Maybe<CatalogMaterial>;
  min_quantity: Scalars['Int'];
  name: Scalars['String'];
  /** Null for products that ship without packaging (e.g. services). */
  packaging?: Maybe<CatalogPackaging>;
  /**
   * Sell prices, one entry per available payment mode, read from Stripe
   * (cached for a few minutes). Empty while the product has no active Stripe
   * Prices yet.
   */
  prices: Array<CatalogPrice>;
  product_category: CatalogProductCategory;
  sku?: Maybe<Scalars['String']>;
  /**
   * Folder path in blob storage holding the product's gallery images and
   * downloadable documents. Null when no assets have been uploaded yet.
   * Prefer images, which resolves this folder into usable URLs.
   */
  storage_path?: Maybe<Scalars['String']>;
  type: CatalogProductType;
  updated_at: Scalars['String'];
  /** Weight in grams. */
  weight_g?: Maybe<Scalars['Float']>;
};

export type CatalogProductCategory = {
  __typename?: 'CatalogProductCategory';
  id: Scalars['ID'];
  /** Resolved to the requested language (fallback: the category's base name). */
  name: Scalars['String'];
};

/**
 * All filters combine with AND. List filters (ids, enums) match ANY of their
 * values; boolean flags only filter when set.
 */
export type CatalogProductFilter = {
  account_type_ids?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Matches an account type's key or one of its subtypes' keys (a subtype
   * selects its parent's products). Use in shareable URLs instead of ids.
   */
  account_type_keys?: InputMaybe<Array<Scalars['String']>>;
  category_ids?: InputMaybe<Array<Scalars['ID']>>;
  /** 2-letter ISO codes; matches products available in ANY of the countries. */
  country_iso_codes?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Products that come with a lid: lid included, or a lid offered as a
   * complementary product. The lid products themselves never match.
   */
  has_lid?: InputMaybe<Scalars['Boolean']>;
  is_dishwasher_safe?: InputMaybe<Scalars['Boolean']>;
  is_freezer_safe?: InputMaybe<Scalars['Boolean']>;
  is_leak_proof?: InputMaybe<Scalars['Boolean']>;
  is_microwaveable?: InputMaybe<Scalars['Boolean']>;
  /** Matches any product type, not only containers. */
  is_open_system?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated: use account_type_keys. Ignored when account_type_keys is set. */
  market_keys?: InputMaybe<Array<Scalars['String']>>;
  /** Deprecated: use account_type_ids. Ignored when account_type_ids is set. */
  market_segment_ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Container segment — only matches CONTAINER products. */
  segments?: InputMaybe<Array<CatalogContainerSegment>>;
  types?: InputMaybe<Array<CatalogProductType>>;
};

export type CatalogProductImage = {
  __typename?: 'CatalogProductImage';
  /** Absolute and publicly readable — one host for every product image. */
  url: Scalars['String'];
};

export type CatalogProductListResult = {
  __typename?: 'CatalogProductListResult';
  items: Array<CatalogProduct>;
  skip: Scalars['Int'];
  /**
   * The take that was actually applied (requests above the maximum of 100 are
   * clamped).
   */
  take: Scalars['Int'];
  /** Total matching products ignoring pagination. */
  total_count: Scalars['Int'];
};

export enum CatalogProductSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum CatalogProductType {
  Asset = 'ASSET',
  Container = 'CONTAINER',
  Service = 'SERVICE'
}

export enum CatalogQrCodeType {
  Iml = 'IML',
  Lasered = 'LASERED',
  QrRfidSticker = 'QR_RFID_STICKER',
  Sticker = 'STICKER'
}

export enum CatalogRfidType {
  Embedded = 'EMBEDDED',
  Sticker = 'STICKER'
}

export enum CatalogTrackingTechnology {
  Qr = 'QR',
  QrAndRfid = 'QR_AND_RFID',
  Rfid = 'RFID'
}

export enum CatalogVolumeUnit {
  L = 'L',
  Ml = 'ML',
  Oz = 'OZ'
}

export type Category = {
  __typename?: 'Category';
  icon?: Maybe<Scalars['String']>;
  icon_cyan?: Maybe<Scalars['String']>;
  icon_green?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Product>>>;
  published?: Maybe<Scalars['Boolean']>;
  reusable_packaging?: Maybe<Scalars['Boolean']>;
};

export type CategoryAndStores = {
  __typename?: 'CategoryAndStores';
  categories?: Maybe<Array<Maybe<CategoryRaw>>>;
  store_id?: Maybe<Scalars['ID']>;
};

export type CategoryRaw = {
  __typename?: 'CategoryRaw';
  icon?: Maybe<Scalars['String']>;
  icon_cyan?: Maybe<Scalars['String']>;
  icon_green?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  product_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Product>>>;
};

export type City = {
  __typename?: 'City';
  id?: Maybe<Scalars['ID']>;
  lonlat?: Maybe<LonLat>;
  name?: Maybe<Scalars['String']>;
  store_count?: Maybe<Scalars['Int']>;
};

export type ClientToken = {
  __typename?: 'ClientToken';
  braintreeToken?: Maybe<Scalars['ID']>;
};

export type CommittedTransactionVolume = {
  __typename?: 'CommittedTransactionVolume';
  committed_volume: Scalars['Int'];
  discount_per_transaction_in_cents: Scalars['Int'];
  id: Scalars['ID'];
  store_uuid: Scalars['ID'];
};

export type Compartment = {
  __typename?: 'Compartment';
  compartment_id?: Maybe<Scalars['String']>;
  preordered?: Maybe<Array<Maybe<PreorderedProducts>>>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export enum ContactRole {
  /** @deprecated Per-relation SF roles collapsed onto flat Zoho `Contact_Type`. Use `contact_departments` (Zoho 'Finance') directly. */
  CanteensAccountingManagement = 'CANTEENS_ACCOUNTING_MANAGEMENT',
  /** @deprecated Per-relation SF roles collapsed onto flat Zoho `Contact_Type`. Use `contact_departments` (Zoho 'Management') directly. */
  CanteensDecisionManagement = 'CANTEENS_DECISION_MANAGEMENT',
  /** @deprecated Per-relation SF roles collapsed onto flat Zoho `Contact_Type`. Use `COMMUNICATOR` or read `contact_departments` directly. */
  CanteensRegionalManagement = 'CANTEENS_REGIONAL_MANAGEMENT',
  /** @deprecated Per-relation SF roles collapsed onto flat Zoho `Contact_Type`. Use `COMMUNICATOR` or read `contact_departments` directly. */
  CanteensStoreManagement = 'CANTEENS_STORE_MANAGEMENT',
  Communicator = 'COMMUNICATOR',
  /** @deprecated Per-relation SF roles collapsed onto flat Zoho `Contact_Type`. Use `COMMUNICATOR` or read `contact_departments` directly. */
  KamStoreManagement = 'KAM_STORE_MANAGEMENT'
}

export type Container = {
  __typename?: 'Container';
  checkout_time?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  return_deadline?: Maybe<Scalars['String']>;
  size_helper?: Maybe<Scalars['String']>;
  status?: Maybe<ContainerStatus>;
  type_id?: Maybe<Scalars['Int']>;
};

export type ContainerAmount = {
  __typename?: 'ContainerAmount';
  amount: Scalars['Int'];
  container_type_id: Scalars['Int'];
  container_type_image?: Maybe<Scalars['String']>;
  container_type_name: Scalars['String'];
  container_type_size_helper?: Maybe<Scalars['String']>;
};

export type ContainerAmountReturn = {
  __typename?: 'ContainerAmountReturn';
  container_type_id: Scalars['Int'];
  count: Scalars['Int'];
  event_account_id: Scalars['ID'];
  type: Scalars['String'];
};

export type ContainerCheckin = {
  __typename?: 'ContainerCheckin';
  container_from_user_id: Scalars['ID'];
};

export type ContainerCheckinInput = {
  added_credits?: InputMaybe<Scalars['Int']>;
  container_from_user_id?: InputMaybe<Scalars['ID']>;
  container_from_user_uuid?: InputMaybe<Scalars['ID']>;
  containers: Array<InputMaybe<ContainerInput>>;
  is_self_scan?: InputMaybe<Scalars['Boolean']>;
  returned_purchased_bowl?: InputMaybe<Scalars['Boolean']>;
  send_cio_event?: InputMaybe<Scalars['Boolean']>;
  store_id: Scalars['ID'];
  store_name?: InputMaybe<Scalars['String']>;
  unlocked_achievement_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type ContainerCheckout = {
  __typename?: 'ContainerCheckout';
  checkout_time?: Maybe<Scalars['String']>;
  containers?: Maybe<Array<Maybe<Container>>>;
  receiving_user_id?: Maybe<Scalars['ID']>;
  store?: Maybe<Store>;
  store_id?: Maybe<Scalars['ID']>;
  store_name?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['ID']>;
  unlocked_achievements?: Maybe<Array<Maybe<Achievement>>>;
};

export type ContainerCheckoutInput = {
  checkout_time: Scalars['String'];
  containers: Array<InputMaybe<ContainerInput>>;
  delivery_token_id?: InputMaybe<Scalars['ID']>;
  double_transaction?: InputMaybe<Scalars['Boolean']>;
  is_self_scan?: InputMaybe<Scalars['Boolean']>;
  only_returnable_at?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['ID']>;
  promotion_code?: InputMaybe<Scalars['String']>;
  receiving_external_user_id?: InputMaybe<Scalars['String']>;
  receiving_user_id?: InputMaybe<Scalars['ID']>;
  send_cio_event?: InputMaybe<Scalars['Boolean']>;
  store_id: Scalars['ID'];
  store_name?: InputMaybe<Scalars['String']>;
  tap2borrow_save_payment_details?: InputMaybe<Scalars['Boolean']>;
  tap2borrow_setup_id?: InputMaybe<Scalars['ID']>;
  transaction_id?: InputMaybe<Scalars['ID']>;
  unlocked_achievement_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type ContainerGroup = {
  __typename?: 'ContainerGroup';
  admin_only?: Maybe<Scalars['Boolean']>;
  can_edit?: Maybe<Scalars['Boolean']>;
  container_types?: Maybe<Array<Maybe<AcceptedContainerType>>>;
  id: Scalars['ID'];
  id_int: Scalars['Int'];
  image_urls?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_accepted_by_store?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order_key?: Maybe<Scalars['Int']>;
};

export type ContainerInput = {
  checkout_time?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  return_deadline?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ContainerStatus>;
  type_id?: InputMaybe<Scalars['Int']>;
};

export enum ContainerLocationDirection {
  In = 'In',
  Out = 'Out'
}

export enum ContainerLocationStatus {
  Broken = 'Broken',
  BrokenAtUser = 'BrokenAtUser',
  CheckedOut = 'CheckedOut',
  Completed = 'Completed',
  InStock = 'InStock',
  Lost = 'Lost',
  LostByStore = 'LostByStore',
  OnHold = 'OnHold',
  Overdue = 'Overdue',
  OverdueError = 'OverdueError',
  OverdueNoCharge = 'OverdueNoCharge',
  OverdueSold = 'OverdueSold',
  Recovered = 'Recovered',
  Unknown = 'Unknown'
}

export type ContainerQrRedirectionCampaign = {
  __typename?: 'ContainerQrRedirectionCampaign';
  comment?: Maybe<Scalars['String']>;
  container_type_id: Scalars['Int'];
  end_date: Scalars['String'];
  forward_container_short_id?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  redirect_url: Scalars['String'];
  start_date: Scalars['String'];
  visit_count: Scalars['Int'];
};

export type ContainerStation = {
  __typename?: 'ContainerStation';
  authorized_signer_name?: Maybe<Scalars['String']>;
  /** @deprecated Use item_type instead */
  color_hex_code?: Maybe<Scalars['String']>;
  containers: Array<ContainerStationContainer>;
  counted_after_return: Scalars['Boolean'];
  counted_at?: Maybe<Scalars['String']>;
  counted_by_id?: Maybe<Scalars['ID']>;
  counted_by_name?: Maybe<Scalars['String']>;
  current_item_location?: Maybe<ContainerStationItemLocationInfo>;
  epc_tag: Scalars['String'];
  id: Scalars['ID'];
  /** @deprecated Use item_type instead */
  image_url?: Maybe<Scalars['String']>;
  is_recalled: Scalars['Boolean'];
  item_location?: Maybe<ItemLocation>;
  item_location_name?: Maybe<Scalars['String']>;
  item_type: ItemType;
  last_change?: Maybe<Scalars['String']>;
  last_changed_by_user_name?: Maybe<Scalars['String']>;
  /** @deprecated Use current_item_location instead */
  last_event?: Maybe<ContainerStationLastEvent>;
  last_event_item_location?: Maybe<ContainerStationItemLocationInfo>;
  last_order_fulfillment?: Maybe<ContainerStationOrderFulfillmentInfo>;
  name: Scalars['String'];
  pictures: Array<OrderFulfillmentPicture>;
  previous_item_location?: Maybe<ContainerStationItemLocationInfo>;
  status?: Maybe<ContainerStationStatus>;
  stock: Array<ContainerStationStock>;
  store: Store;
  store_id: Scalars['ID'];
  total_stock: Scalars['Int'];
  /** @deprecated Use item_type instead */
  type: ContainerStationType;
};

export type ContainerStationAmount = {
  __typename?: 'ContainerStationAmount';
  amount: Scalars['Int'];
  amount_sealed: Scalars['Int'];
  countLater: Scalars['Int'];
  counted: Scalars['Int'];
  empty: Scalars['Int'];
  /** @deprecated Use item_type.image_url instead */
  image_url?: Maybe<Scalars['String']>;
  item_type: ItemType;
  /** @deprecated Use item_type.name instead */
  type: Scalars['String'];
};

export type ContainerStationContainer = {
  __typename?: 'ContainerStationContainer';
  id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner_since: Scalars['String'];
  owner_till?: Maybe<Scalars['String']>;
  size_helper?: Maybe<Scalars['String']>;
  status: ContainerLocationStatus;
  type_id: Scalars['Int'];
  type_name: Scalars['String'];
};

export type ContainerStationContainerTypeAmount = {
  __typename?: 'ContainerStationContainerTypeAmount';
  amount: Scalars['Int'];
  container_type_id: Scalars['Int'];
  container_type_image?: Maybe<Scalars['String']>;
  container_type_name: Scalars['String'];
  container_type_packing_unit?: Maybe<Scalars['Int']>;
  container_type_size_helper?: Maybe<Scalars['String']>;
  segment?: Maybe<ContainerTypeSegment>;
};

export type ContainerStationContainerTypeAmountInput = {
  amount: Scalars['Int'];
  container_type_id: Scalars['Int'];
};

export type ContainerStationDeliveryFulfillmentInfo = {
  __typename?: 'ContainerStationDeliveryFulfillmentInfo';
  authorized_signer?: Maybe<IdName>;
  container_station: IdName;
  delivered_container_count: Scalars['Int'];
  delivered_container_count_by_type: Array<ContainerTypeAmount>;
  delivered_date?: Maybe<Scalars['String']>;
  item_location?: Maybe<IdName>;
};

export type ContainerStationItemLocationInfo = {
  __typename?: 'ContainerStationItemLocationInfo';
  allowed_container_types?: Maybe<Array<ContainerType>>;
  event_account?: Maybe<IdName>;
  event_id?: Maybe<Scalars['ID']>;
  event_name?: Maybe<Scalars['String']>;
  event_type?: Maybe<EventType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ContainerStationLastEvent = {
  __typename?: 'ContainerStationLastEvent';
  allowed_container_types: Array<ContainerType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: EventType;
};

export type ContainerStationOrderFulfillmentInfo = {
  __typename?: 'ContainerStationOrderFulfillmentInfo';
  authorized_signer_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures: Array<OrderFulfillmentPicture>;
  type: Scalars['String'];
};

export type ContainerStationPackingInfoInput = {
  returned_container_station_info: Array<ContainerStationWithContainers>;
  target_container_station_info: Array<ContainerStationWithContainers>;
};

export type ContainerStationPackingInput = {
  container_station_id: Scalars['ID'];
  manual_amount: Scalars['Int'];
};

export type ContainerStationPackingInputV2 = {
  container_station_id: Scalars['ID'];
  manual_amounts: Array<ContainerStationContainerTypeAmountInput>;
  picture_ids: Array<Scalars['ID']>;
};

export type ContainerStationPaginatedResponse = {
  __typename?: 'ContainerStationPaginatedResponse';
  container_stations: Array<ContainerStation>;
  total: Scalars['Int'];
};

export type ContainerStationReturn = {
  __typename?: 'ContainerStationReturn';
  color_hex_code?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  event_account_id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ContainerStationReturnEntry = ContainerAmountReturn | ContainerStationReturn;

export type ContainerStationSearchPaginatedResponse = {
  __typename?: 'ContainerStationSearchPaginatedResponse';
  container_stations: Array<ContainerStation>;
  total: Scalars['Int'];
};

export enum ContainerStationStatus {
  Counted = 'COUNTED',
  Empty = 'EMPTY',
  Sealed = 'SEALED',
  Uncounted = 'UNCOUNTED'
}

export type ContainerStationStock = {
  __typename?: 'ContainerStationStock';
  amount: Scalars['Int'];
  color_hex_code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sealed: Scalars['Boolean'];
};

export type ContainerStationStockEntry = {
  __typename?: 'ContainerStationStockEntry';
  /** @deprecated Use item_type instead */
  color_hex_code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use item_type instead */
  image_url?: Maybe<Scalars['String']>;
  item_type: ItemType;
  name: Scalars['String'];
  sealed: Scalars['Boolean'];
  status: ContainerStationStatus;
  /** @deprecated Use item_type instead */
  type: ContainerStationType;
};

export enum ContainerStationType {
  BigCollectionBox = 'big_collection_box',
  Box = 'box',
  CrateCollapsibleUs = 'crate_collapsible_us',
  CutleryBox = 'cutlery_box',
  Default = 'default',
  MwkBox320 = 'mwk_box320',
  MwkBox420 = 'mwk_box420'
}

export type ContainerStationWithContainerAmounts = {
  __typename?: 'ContainerStationWithContainerAmounts';
  /** @deprecated Use item_type instead */
  color_hex_code?: Maybe<Scalars['String']>;
  container_amounts: Array<ContainerTypeAmount>;
  id: Scalars['ID'];
  /** @deprecated Use item_type instead */
  image_url?: Maybe<Scalars['String']>;
  item_type: ItemType;
  name: Scalars['String'];
  returned_sealed: Scalars['Boolean'];
  status: ContainerStationStatus;
  /** @deprecated Use item_type instead */
  type: ContainerStationType;
};

export type ContainerStationWithContainers = {
  container_station_id: Scalars['ID'];
  containers: Array<Scalars['ID']>;
  manual_amounts: Array<ContainerTypeAmountInput>;
};

export type ContainerStationWithManualAmountStock = {
  __typename?: 'ContainerStationWithManualAmountStock';
  arrival_date: Scalars['String'];
  booked_by_user_id?: Maybe<Scalars['String']>;
  booked_by_user_name?: Maybe<Scalars['String']>;
  /** @deprecated Use item_type.color_hex_code instead */
  color_hex_code?: Maybe<Scalars['String']>;
  container_type_amounts: Array<ContainerStationContainerTypeAmount>;
  counted_by?: Maybe<Scalars['String']>;
  counted_date?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated Use item_type.image_url instead */
  image_url?: Maybe<Scalars['String']>;
  item_type: ItemType;
  name: Scalars['String'];
  sealed?: Maybe<Scalars['Boolean']>;
  status: ContainerStationStatus;
  /** @deprecated Use item_type.name instead */
  type: Scalars['String'];
};

export enum ContainerStatus {
  CheckedOut = 'CheckedOut',
  Overdue = 'Overdue',
  OverdueSold = 'OverdueSold'
}

export type ContainerType = {
  __typename?: 'ContainerType';
  color_hex_code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  packing_unit?: Maybe<Scalars['Int']>;
  segment?: Maybe<ContainerTypeSegment>;
  size_helper?: Maybe<Scalars['String']>;
};

export type ContainerTypeAmount = {
  __typename?: 'ContainerTypeAmount';
  amount: Scalars['Int'];
  amount_sealed: Scalars['Int'];
  container_type_id: Scalars['Int'];
  container_type_image?: Maybe<Scalars['String']>;
  container_type_name: Scalars['String'];
  container_type_packing_unit?: Maybe<Scalars['Int']>;
  container_type_size_helper?: Maybe<Scalars['String']>;
  segment?: Maybe<ContainerTypeSegment>;
};

export type ContainerTypeAmountInput = {
  amount: Scalars['Int'];
  amount_sealed?: InputMaybe<Scalars['Int']>;
  container_type_id: Scalars['Int'];
  old_container_type_id?: InputMaybe<Scalars['Int']>;
};

export type ContainerTypeGroup = {
  __typename?: 'ContainerTypeGroup';
  category?: Maybe<Scalars['String']>;
  container_types: Array<ContainerType>;
  has_linked_stores: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  store_countries: Array<Scalars['String']>;
};

export type ContainerTypeGroupUpdateInput = {
  container_type_group_id: Scalars['Int'];
  container_type_id: Scalars['Int'];
};

export enum ContainerTypeSegment {
  Cutlery = 'CUTLERY',
  Drinks = 'DRINKS',
  Food = 'FOOD'
}

/**
 * In-stock containers of one container type at one store, as counted by
 * getStoresContainerStock. Field names follow the container station stock rows.
 */
export type ContainerTypeStockCount = {
  __typename?: 'ContainerTypeStockCount';
  container_type_color_hex_code?: Maybe<Scalars['String']>;
  container_type_id: Scalars['Int'];
  container_type_image?: Maybe<Scalars['String']>;
  container_type_name: Scalars['String'];
  in_stock: Scalars['Int'];
};

export enum ContentType {
  DeepLink = 'DEEP_LINK',
  Link = 'LINK'
}

export type CopyServicePackageToCurrencyInput = {
  /** ID of the source ServicePackage to copy from. */
  source_package_id: Scalars['ID'];
  /** ISO 4217 code of the currency. */
  target_currency: Scalars['String'];
};

export type CopyServicePackageToCurrencyResult = {
  __typename?: 'CopyServicePackageToCurrencyResult';
  /** The newly created package for the target currency. */
  package: ServicePackage;
};

export type CopyServicePackageToTermInput = {
  /** ID of the source ServicePackageRevision to copy from. */
  source_revision_id: Scalars['ID'];
  /** The new contract term in months. */
  target_min_contract_term_months: Scalars['Int'];
};

export type CountAndPackInput = {
  container_station_ids: Array<Scalars['String']>;
  container_type_id: Scalars['Int'];
  event_id: Scalars['ID'];
  left_over_amount: Scalars['Int'];
  order_fulfillment_id: Scalars['ID'];
  target_item_location_id: Scalars['ID'];
};

export type CountryCode = {
  __typename?: 'CountryCode';
  country_code: Scalars['String'];
  country_name: Scalars['String'];
};

export type CreateAddress = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_extra?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateAnalyticsUserInput = {
  account_ids?: InputMaybe<Array<Scalars['String']>>;
  country?: InputMaybe<UserCountry>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  merchant_text_ids: Array<Scalars['String']>;
  preferred_locale: Scalars['String'];
  store_text_ids: Array<Scalars['String']>;
  superset_role: SupersetRole;
};

export type CreateAnonUserResponse = {
  __typename?: 'CreateAnonUserResponse';
  access_token?: Maybe<Scalars['String']>;
  anon_user_id?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type CreateAppTranslationInput = {
  app_type: AppTranslationAppType;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CreateBillomatArticlesResult = {
  __typename?: 'CreateBillomatArticlesResult';
  store_lost_cost_article_id?: Maybe<Scalars['ID']>;
  transaction_article_id?: Maybe<Scalars['ID']>;
};

export type CreateBrand = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<CreateAddress>;
  brand_id?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_vytal_id?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  migrated_from_vytal?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  permanently_removed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCategory = {
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateContainerQrRedirectionCampaignByContainerTypeInput = {
  comment?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  forward_container_short_id?: InputMaybe<Scalars['Boolean']>;
  redirect_url: Scalars['String'];
  start_date: Scalars['String'];
};

export type CreateCustomerCateringUser = {
  store_text_id: Scalars['ID'];
  user_email: Scalars['String'];
  user_name: Scalars['String'];
};

export type CreateEventAccountInput = {
  billing_additional_address_info?: InputMaybe<Scalars['String']>;
  billing_city?: InputMaybe<Scalars['String']>;
  billing_country_code?: InputMaybe<Scalars['String']>;
  billing_mail?: InputMaybe<Scalars['String']>;
  billing_state?: InputMaybe<Scalars['String']>;
  billing_street?: InputMaybe<Scalars['String']>;
  billing_zip?: InputMaybe<Scalars['String']>;
  business_type?: InputMaybe<BusinessType>;
  company_name?: InputMaybe<Scalars['String']>;
  corporate_structure_info?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<LegalEntity>;
  event_id?: InputMaybe<Scalars['ID']>;
  external_zoho_id?: InputMaybe<Scalars['ID']>;
  invoice_language?: InputMaybe<InvoiceLanguage>;
  is_billable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  should_send_order_fulfillment_emails?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EventAccountType>;
  vat?: InputMaybe<Scalars['String']>;
};

export type CreateEventDeliveryAddressInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /**
   * When true, marks this delivery address as the event default and clears
   * the previous default for the event. The first address created on an event
   * becomes its default regardless.
   */
  is_event_default?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateEventInput = {
  billing_contact_zoho_id?: InputMaybe<Scalars['ID']>;
  carrier_pickup_date?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deal_owner_zoho_user_id?: InputMaybe<Scalars['ID']>;
  default_logistics?: InputMaybe<EventDefaultLogistics>;
  delivery_date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<LegalEntity>;
  event_manager_zoho_user_id?: InputMaybe<Scalars['ID']>;
  external_zoho_id?: InputMaybe<Scalars['ID']>;
  head_of_operations_zoho_user_id?: InputMaybe<Scalars['ID']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_authorized_signer_necessary?: InputMaybe<Scalars['Boolean']>;
  main_contracting_event_account_id?: InputMaybe<Scalars['ID']>;
  merchant_order_form_deadline?: InputMaybe<Scalars['String']>;
  merchant_order_form_info_text?: InputMaybe<Scalars['String']>;
  minimum_cleaning_fee_rate?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pickup_date_after_event?: InputMaybe<Scalars['String']>;
  pipeline?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventType>;
  uses_deposit?: InputMaybe<Scalars['Boolean']>;
};

export type CreateInvoiceCollection = {
  disable_automatic_partner_invoice_sending?: InputMaybe<Scalars['Boolean']>;
  invoice_address?: InputMaybe<CreateAddress>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_email_subject_prefix?: InputMaybe<Scalars['String']>;
  invoice_headline?: InputMaybe<Scalars['String']>;
  invoice_iban?: InputMaybe<Scalars['String']>;
  invoice_iban_name?: InputMaybe<Scalars['String']>;
  invoice_routing_id?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order_number?: InputMaybe<Scalars['String']>;
  /**
   * Defaults to ALL. Cannot be changed after creation. A PENALTY_BILLS_ONLY
   * collection cannot collapse its invoice items.
   */
  scope?: InputMaybe<InvoiceCollectionScope>;
  seller_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<StoreType>;
  vat_number?: InputMaybe<Scalars['String']>;
};

export type CreateInvoiceItem = {
  category?: InputMaybe<Scalars['String']>;
  charged_price_amount: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  sku?: InputMaybe<Scalars['ID']>;
  standard_price_amount?: InputMaybe<Scalars['Int']>;
  sub_items?: InputMaybe<Array<InputMaybe<CreateInvoiceItem>>>;
  upc?: InputMaybe<Scalars['ID']>;
  vat_rate: Scalars['Int'];
};

export type CreateItem = {
  base_price?: InputMaybe<Scalars['Int']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  category_id?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  extras?: InputMaybe<Array<InputMaybe<ExtraOrderItemInput>>>;
  featured_product_id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  product_id: Scalars['ID'];
  quantity: Scalars['Int'];
  store_id?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teaser_text?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['ID']>;
  vat_rate?: InputMaybe<Scalars['Int']>;
};

export type CreateItemType = {
  billing_category?: InputMaybe<BillingCategory>;
  billing_frequency?: InputMaybe<BillingFrequency>;
  category: ItemTypeCategory;
  color_hex_code?: InputMaybe<Scalars['String']>;
  custom_field_definitions?: InputMaybe<Array<CustomFieldDefinitionInput>>;
  /** Entries for currencies left out are not touched. */
  default_event_prices?: InputMaybe<Array<ItemTypeDefaultEventPriceInput>>;
  depth_mm?: InputMaybe<Scalars['Int']>;
  height_mm?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Int']>;
  /** Uppercased and trimmed; an empty string clears it. Must be unique. */
  sku?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
  width_mm?: InputMaybe<Scalars['Int']>;
};

export type CreateMerchantOrderSharedLinkInput = {
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
};

export type CreateNewsContent = {
  banner?: InputMaybe<Scalars['String']>;
  city_id?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<UserCountry>;
  country_codes?: InputMaybe<Array<InputMaybe<UserCountry>>>;
  for_consumers?: InputMaybe<Scalars['Boolean']>;
  for_partners?: InputMaybe<Scalars['Boolean']>;
  geohash?: InputMaybe<Scalars['String']>;
  hide_from?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  only_for_languages?: InputMaybe<Array<InputMaybe<UserLocale>>>;
  only_for_non_usage_fee_enabled?: InputMaybe<Scalars['Boolean']>;
  only_for_store_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  only_never_used_delivery_token_users?: InputMaybe<Scalars['Boolean']>;
  only_new_users?: InputMaybe<Scalars['Boolean']>;
  only_used_brands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  only_used_stores?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  published?: InputMaybe<Scalars['Boolean']>;
  radius_meter?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ContentType>;
};

export type CreateOpeningHours = {
  day: Scalars['Int'];
  time: Scalars['String'];
};

export type CreateOpeningHoursMulti = {
  day: Scalars['Int'];
  time?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateOpsDeliveryAddress = {
  additional_info?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateOrder = {
  basket_hash?: InputMaybe<Scalars['String']>;
  basket_id?: InputMaybe<Scalars['ID']>;
  campaign_id?: InputMaybe<Scalars['ID']>;
  cutlery?: InputMaybe<CutleryPreferences>;
  eat_in?: InputMaybe<Scalars['Boolean']>;
  items: Array<InputMaybe<CreateItem>>;
  payment_intent?: InputMaybe<Scalars['ID']>;
  payment_token?: InputMaybe<Scalars['ID']>;
  payment_type?: InputMaybe<Scalars['String']>;
  pickup_slot?: InputMaybe<Scalars['ID']>;
  pickup_time?: InputMaybe<Scalars['String']>;
  platform_fee?: InputMaybe<Scalars['Int']>;
  platform_fee_campaign_id?: InputMaybe<Scalars['ID']>;
  push_id?: InputMaybe<Scalars['ID']>;
  source_id?: InputMaybe<Scalars['ID']>;
  store_id: Scalars['ID'];
  stripe_account?: InputMaybe<StripeAccount>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrderType>;
  user_id: Scalars['ID'];
  vending_machine_id?: InputMaybe<Scalars['ID']>;
};

export type CreateOrderFromBasket = {
  basket_id: Scalars['ID'];
  campaign_id?: InputMaybe<Scalars['ID']>;
  cutlery?: InputMaybe<CutleryPreferences>;
  eat_in?: InputMaybe<Scalars['Boolean']>;
  is_shared?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<CreateItem>>>;
  main_basket_id?: InputMaybe<Scalars['ID']>;
  payment_intent?: InputMaybe<Scalars['ID']>;
  payment_token?: InputMaybe<Scalars['ID']>;
  payment_type?: InputMaybe<Scalars['String']>;
  pickup_time?: InputMaybe<Scalars['String']>;
  platform_fee?: InputMaybe<Scalars['Int']>;
  platform_fee_campaign_id?: InputMaybe<Scalars['ID']>;
  push_id?: InputMaybe<Scalars['ID']>;
  source_id?: InputMaybe<Scalars['ID']>;
  stripe_account?: InputMaybe<StripeAccount>;
  type?: InputMaybe<OrderType>;
  vending_machine_id?: InputMaybe<Scalars['ID']>;
};

export type CreateOrderFulfillmentResult = {
  __typename?: 'CreateOrderFulfillmentResult';
  assets: Array<TrackableItem>;
  authorized_signer_name?: Maybe<Scalars['String']>;
  confirmation_email_recipients: Array<Scalars['String']>;
  container_amounts: Array<ContainerTypeAmount>;
  container_stations: Array<ContainerStationWithContainerAmounts>;
  event_account_name: Scalars['String'];
  id: Scalars['ID'];
  item_location_name: Scalars['String'];
  left_over_amounts: Array<ContainerTypeAmount>;
  timestamp: Scalars['String'];
};

export type CreatePayment = {
  cashier?: InputMaybe<Scalars['String']>;
  items: Array<InputMaybe<CreateInvoiceItem>>;
  location_id: Scalars['ID'];
  payment_token: Scalars['String'];
  register?: InputMaybe<Scalars['String']>;
  spend_amount: Scalars['Int'];
};

export type CreatePickingOrderFulfillmentInput = {
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  container_ids: Array<Scalars['ID']>;
  container_station_ids: Array<Scalars['ID']>;
  event_id: Scalars['ID'];
  item_location_id: Scalars['ID'];
  manual_amounts?: InputMaybe<Array<ContainerTypeAmountInput>>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
  timestamp?: InputMaybe<Scalars['String']>;
};

export type CreateProductStore = {
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  store_id: Scalars['ID'];
};

export type CreateRaffleCampaignInput = {
  cycle_interval_type?: InputMaybe<Scalars['String']>;
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  deduplicate_winner_emails?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  partner_email_addresses?: InputMaybe<Array<Scalars['String']>>;
  redirect_campaign_ids?: InputMaybe<Array<Scalars['Int']>>;
  select_winners_overall_stores: Scalars['Boolean'];
  select_winners_per_store_per_cycle: Scalars['Boolean'];
  status: Scalars['String'];
  store_ids: Array<Scalars['String']>;
  winners_per_cycle?: InputMaybe<Scalars['Int']>;
};

export type CreateReturnOrderFulfillmentContainerStation = {
  container_station_id: Scalars['ID'];
  manual_amounts: Array<ContainerStationContainerTypeAmountInput>;
  picture_ids?: InputMaybe<Array<Scalars['ID']>>;
  status: ContainerStationStatus;
};

export type CreateReturnOrderFulfillmentResult = {
  __typename?: 'CreateReturnOrderFulfillmentResult';
  additional_container_count: Scalars['Int'];
  container_stations: Array<OrderFulfillmentContainerStationReduced>;
  id: Scalars['ID'];
};

export type CreateReturnOrderFulfillmentV2Input = {
  additional_confirmation_email_recipient?: InputMaybe<Scalars['String']>;
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  authorized_signer_id?: InputMaybe<Scalars['ID']>;
  container_stations: Array<CreateReturnOrderFulfillmentContainerStation>;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  manual_amounts?: InputMaybe<Array<ContainerTypeAmountInput>>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
  picture_ids?: InputMaybe<Array<Scalars['ID']>>;
  source_item_location_id: Scalars['ID'];
  target_item_location_id: Scalars['ID'];
  timestamp?: InputMaybe<Scalars['String']>;
  type_override?: InputMaybe<OrderFulfillmentType>;
};

export type CreateReturnOrderFulfillmentV3Input = {
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  container_stations: Array<CreateReturnOrderFulfillmentContainerStation>;
  id_prefix?: InputMaybe<Scalars['ID']>;
  picture_ids?: InputMaybe<Array<Scalars['ID']>>;
  target_item_location_id: Scalars['ID'];
  timestamp?: InputMaybe<Scalars['String']>;
  type_override?: InputMaybe<OrderFulfillmentType>;
};

export type CreateReturnOrderFulfillmentV3Result = {
  __typename?: 'CreateReturnOrderFulfillmentV3Result';
  assets: Array<TrackableItem>;
  confirmation_email_recipients: Array<Scalars['String']>;
  container_amounts: Array<ContainerTypeAmount>;
  container_stations: Array<ContainerStationWithContainerAmounts>;
  event_account_names: Array<Scalars['String']>;
  item_location_names: Array<Scalars['String']>;
  left_over_amounts: Array<ContainerTypeAmount>;
  not_found_item_ids: Array<Scalars['ID']>;
  order_fulfillments: Array<CreateOrderFulfillmentResult>;
  timestamp: Scalars['String'];
};

export type CreateSpeicalOpeningHoursMulti = {
  day: Scalars['String'];
  time?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateStore = {
  address: CreateAddress;
  banner?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  can_get_bowl?: InputMaybe<Scalars['Boolean']>;
  can_preorder?: InputMaybe<Scalars['Boolean']>;
  contracted_date?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']>;
  external_vytal_id?: InputMaybe<Scalars['String']>;
  food_info_de?: InputMaybe<Scalars['String']>;
  food_info_en?: InputMaybe<Scalars['String']>;
  foreign_id?: InputMaybe<Scalars['ID']>;
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  migrated_from_vytal?: InputMaybe<Scalars['Boolean']>;
  min_order_time?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onboarded_date?: InputMaybe<Scalars['String']>;
  online?: InputMaybe<Scalars['Boolean']>;
  opening_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHours>>>;
  opening_hours_multi?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  permanently_removed?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  show_in_stats?: InputMaybe<Scalars['Boolean']>;
  test_period_end?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateStoreAssetBaseInput = {
  /**
   * Exclusive end of billing: the first day that is NOT billed (ISO date).
   * Billing runs up to but not including this day — e.g. to bill through the
   * whole of May 2026, set 2026-06-01 (NOT 2026-05-31, which stops after May 30).
   * Must be after billing_start. Omit for open-ended billing.
   */
  billing_end?: InputMaybe<Scalars['String']>;
  billing_frequency: BillingFrequency;
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  custom_fields?: InputMaybe<Array<CustomFieldValueInput>>;
  description?: InputMaybe<Scalars['String']>;
  /** Vytal-internal note, never shown to the partner. */
  internal_comment?: InputMaybe<Scalars['String']>;
  is_billable?: InputMaybe<Scalars['Boolean']>;
  item_type_id: Scalars['Int'];
  price: Scalars['Int'];
  store_id?: InputMaybe<Scalars['ID']>;
};

export type CreateStoreAssetInput = {
  base: CreateStoreAssetBaseInput;
};

export type CreateStoreMiniReturner = {
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  monthly_charge: Scalars['Int'];
};

export type CreateStorePhone = {
  billing_frequency?: InputMaybe<BillingFrequency>;
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  creation_timestamp?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  monthly_charge?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  serial_number?: InputMaybe<Scalars['String']>;
  sim_card_number?: InputMaybe<Scalars['String']>;
  sim_provided?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateStoreReturnBox = {
  billing_frequency?: InputMaybe<BillingFrequency>;
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  creation_timestamp?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['String']>;
  monthly_charge?: InputMaybe<Scalars['Int']>;
  publish_return_box_in_app?: InputMaybe<Scalars['Boolean']>;
  serviced?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateStoreTap2BorrowDevice = {
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  hide_on_invoice?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  monthly_charge: Scalars['Int'];
  serial_number?: InputMaybe<Scalars['String']>;
  type: StoreTap2BorrowDeviceType;
};

export type CreateTrackableItem = {
  item_type_id: Scalars['Int'];
  name: Scalars['String'];
};

export type CreateVytalCharge = {
  currency?: InputMaybe<Currency>;
  statement_descriptor?: InputMaybe<Scalars['String']>;
  total: Scalars['Int'];
  transaction_type?: InputMaybe<TransactionType>;
  user_id: Scalars['String'];
  vytal_bill_id: Scalars['String'];
};

export type CreateZohoQuoteInput = {
  dealId: Scalars['String'];
  includeCleaning: Scalars['Boolean'];
  includeClearing: Scalars['Boolean'];
  includeLoss: Scalars['Boolean'];
  includeRent: Scalars['Boolean'];
  language: Scalars['String'];
  lineItems: Array<ZohoQuoteLineItemInput>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type CreateZohoQuoteResult = {
  __typename?: 'CreateZohoQuoteResult';
  estimateId: Scalars['String'];
  estimateNumber?: Maybe<Scalars['String']>;
  estimateUrl: Scalars['String'];
};

export type CreatedUserResponse = {
  __typename?: 'CreatedUserResponse';
  id: Scalars['ID'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type CreditToPartnerOption = {
  __typename?: 'CreditToPartnerOption';
  api_name: Scalars['String'];
  name: Scalars['String'];
};

export enum Currency {
  Aed = 'AED',
  All = 'ALL',
  Chf = 'CHF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Eur = 'EUR',
  Gbp = 'GBP',
  Huf = 'HUF',
  Ils = 'ILS',
  Mxn = 'MXN',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  default_value?: Maybe<Scalars['String']>;
  depends_on?: Maybe<CustomFieldDependency>;
  id: Scalars['String'];
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  type: CustomFieldType;
};

export type CustomFieldDefinitionInput = {
  default_value?: InputMaybe<Scalars['String']>;
  depends_on?: InputMaybe<CustomFieldDependencyInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  type: CustomFieldType;
};

export type CustomFieldDependency = {
  __typename?: 'CustomFieldDependency';
  field_id: Scalars['String'];
  value: Scalars['String'];
};

export type CustomFieldDependencyInput = {
  field_id: Scalars['String'];
  value: Scalars['String'];
};

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  Number = 'NUMBER',
  String = 'STRING'
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  id: Scalars['String'];
  name: Scalars['String'];
  type: CustomFieldType;
  value?: Maybe<Scalars['String']>;
};

export type CustomFieldValueInput = {
  id: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type CustomInvoiceItem = {
  __typename?: 'CustomInvoiceItem';
  billing_frequency?: Maybe<BillingFrequency>;
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  type?: Maybe<CustomInvoiceItemType>;
};

export type CustomInvoiceItemInput = {
  billing_frequency?: InputMaybe<BillingFrequency>;
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CustomInvoiceItemType>;
};

export enum CustomInvoiceItemType {
  CleaningFee = 'CLEANING_FEE',
  Cutlery = 'CUTLERY',
  Default = 'DEFAULT',
  Franchise = 'FRANCHISE',
  SocialMediaAd = 'SOCIAL_MEDIA_AD',
  UpgradeToPremium = 'UPGRADE_TO_PREMIUM',
  WebloginButton = 'WEBLOGIN_BUTTON'
}

export type CustomerCateringUser = {
  __typename?: 'CustomerCateringUser';
  container_amounts: Array<ContainerAmount>;
  store_text_id: Scalars['ID'];
  user_email?: Maybe<Scalars['String']>;
  user_name: Scalars['String'];
  user_uuid: Scalars['ID'];
};

export enum CutleryPreferences {
  NoPrefrence = 'NO_PREFRENCE',
  WithoutCutlery = 'WITHOUT_CUTLERY',
  WithCutlery = 'WITH_CUTLERY'
}

export type DefaultCarrierByCountryEntry = {
  __typename?: 'DefaultCarrierByCountryEntry';
  country_code: Scalars['String'];
  defaults: Array<DefaultCarrierByCountryServiceEntry>;
};

export type DefaultCarrierByCountryInput = {
  country_code: Scalars['String'];
  defaults: Array<DefaultCarrierByCountryServiceInput>;
};

export type DefaultCarrierByCountryServiceEntry = {
  __typename?: 'DefaultCarrierByCountryServiceEntry';
  carrier: OpsOrderCarrier;
  carrier_service: OpsOrderCarrierService;
};

export type DefaultCarrierByCountryServiceInput = {
  carrier: OpsOrderCarrier;
  carrier_service: OpsOrderCarrierService;
};

export type DefaultCarrierEntry = {
  __typename?: 'DefaultCarrierEntry';
  carrier: OpsOrderCarrier;
  carrier_service: OpsOrderCarrierService;
};

export type DefaultCarrierEntryInput = {
  carrier: OpsOrderCarrier;
  carrier_service: OpsOrderCarrierService;
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  additional_info?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  in_delivery_area?: Maybe<Scalars['Boolean']>;
  lonlat?: Maybe<LonLat>;
  phone_number?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetno?: Maybe<Scalars['String']>;
  type?: Maybe<DeliveryAddressType>;
  zip?: Maybe<Scalars['String']>;
};

export type DeliveryAddressInfo = {
  __typename?: 'DeliveryAddressInfo';
  additional_info?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetno?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DeliveryAddressInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
  lonlat?: InputMaybe<LonLatIn>;
  phone_number?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DeliveryAddressType>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum DeliveryAddressType {
  Home = 'HOME',
  Love = 'LOVE',
  Other = 'OTHER',
  Work = 'WORK'
}

export type DeliveryAddressUpdateInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type DeliveryToken = {
  __typename?: 'DeliveryToken';
  created_at?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  ttl?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']>;
  vytal_user_id?: Maybe<Scalars['String']>;
};

export type DevParcelStatusCatalog = {
  __typename?: 'DevParcelStatusCatalog';
  scenarios: Array<DevParcelStatusScenarioInfo>;
  statuses: Array<DevParcelStatusOption>;
};

export type DevParcelStatusInput = {
  /** A SendCloud status message from devParcelStatusCatalog.statuses. */
  message: Scalars['String'];
  /**
   * 0-based parcel this status belongs to. Omit to apply it to every parcel,
   * which is what a forward-progress status needs to advance the order.
   */
  parcel_index?: InputMaybe<Scalars['Int']>;
  /**
   * ISO timestamp to record. Omit to have the sequence spread backwards from
   * now in minutes_between_statuses steps.
   */
  timestamp?: InputMaybe<Scalars['String']>;
};

/**
 * One SendCloud carrier status message the webhook machinery understands, with
 * the effect replaying it has on the order. Mirrors SENDCLOUD_STATUS_MAP.
 */
export type DevParcelStatusOption = {
  __typename?: 'DevParcelStatusOption';
  /** The error message an ERROR status parks on the order revision. */
  error_message?: Maybe<Scalars['String']>;
  /**
   * PICKED / IN_TRANSIT / DELIVERED / CANCELED / ERROR / RETURN_TO_SENDER, or
   * null for a log-only status that never changes the order status.
   */
  internal_status?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  /** Whether a real webhook would send the customer.io status email. */
  sends_cio: Scalars['Boolean'];
  /**
   * Forward-progress tier (PICKED=1, IN_TRANSIT=2, DELIVERED=3). Every parcel of
   * the active shipment attempt must reach a tier before the order advances to
   * it. Null for CANCELED, ERROR, RETURN_TO_SENDER and log-only statuses, which
   * apply on a single parcel.
   */
  tier?: Maybe<Scalars['Int']>;
};

/**
 * Preset carrier status sequences, covering the delivery happy path, the
 * service-point variants, the return-pickup flow and every error and
 * return-to-sender shape. Query devParcelStatusCatalog for each one's messages
 * and the order status it lands on.
 */
export enum DevParcelStatusScenario {
  AddressInvalid = 'ADDRESS_INVALID',
  Announced = 'ANNOUNCED',
  AnnouncementFailed = 'ANNOUNCEMENT_FAILED',
  AtCustoms = 'AT_CUSTOMS',
  AwaitingCustomerPickup = 'AWAITING_CUSTOMER_PICKUP',
  Cancelled = 'CANCELLED',
  CollectedByCustomer = 'COLLECTED_BY_CUSTOMER',
  Delivered = 'DELIVERED',
  DeliveredThenReturnedToSender = 'DELIVERED_THEN_RETURNED_TO_SENDER',
  DeliveryAttemptFailed = 'DELIVERY_ATTEMPT_FAILED',
  DeliveryDelayed = 'DELIVERY_DELAYED',
  Exception = 'EXCEPTION',
  InTransit = 'IN_TRANSIT',
  NoLabel = 'NO_LABEL',
  RealReturnAfterRefusal = 'REAL_RETURN_AFTER_REFUSAL',
  RealReturnRoundTripDhl = 'REAL_RETURN_ROUND_TRIP_DHL',
  RealReturnRoundTripDpd = 'REAL_RETURN_ROUND_TRIP_DPD',
  RealReturnWithoutAnnounce = 'REAL_RETURN_WITHOUT_ANNOUNCE',
  RefusedThenReturnedToSender = 'REFUSED_THEN_RETURNED_TO_SENDER',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  ReturnNotCollected = 'RETURN_NOT_COLLECTED',
  ReturnPaymentFailed = 'RETURN_PAYMENT_FAILED',
  ReturnPickedUpByDriver = 'RETURN_PICKED_UP_BY_DRIVER',
  ReturnToSenderThenLateScan = 'RETURN_TO_SENDER_THEN_LATE_SCAN',
  UnableToDeliver = 'UNABLE_TO_DELIVER'
}

/** A named status sequence seedDevParcelStatusHistory can replay. */
export type DevParcelStatusScenarioInfo = {
  __typename?: 'DevParcelStatusScenarioInfo';
  description: Scalars['String'];
  messages: Array<Scalars['String']>;
  scenario: DevParcelStatusScenario;
};

export enum DiscountType {
  BasketPercentDiscount = 'BASKET_PERCENT_DISCOUNT',
  Donation = 'DONATION',
  FullAmountDiscount = 'FULL_AMOUNT_DISCOUNT',
  NoOrderFeeDiscount = 'NO_ORDER_FEE_DISCOUNT'
}

export type Distance = {
  __typename?: 'Distance';
  distance?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['String']>;
};

export type DownloadParcelLabelResult = {
  __typename?: 'DownloadParcelLabelResult';
  /** Signed URL of the single parcel's label PDF. Expires after an hour. */
  label_url: Scalars['String'];
  parcel_id: Scalars['String'];
  tracking_number?: Maybe<Scalars['String']>;
};

export type DpdStatusHistory = {
  __typename?: 'DpdStatusHistory';
  modified_timestamp: Scalars['String'];
  status: Scalars['String'];
  tracking_code: Scalars['String'];
};

export enum DunningReminderBlockType {
  Permanently = 'PERMANENTLY',
  Temporary = 'TEMPORARY'
}

export type Event = {
  __typename?: 'Event';
  allowed_container_types: Array<ContainerType>;
  /**
   * Item types (container stations, assets) that may be put on this event's
   * orders — the counterpart of allowed_container_types for non-container
   * lines. Only non-archived types of category CONTAINER_STATION or ASSET can
   * be on the list; which of the two an order may carry still depends on the
   * order type (assets are buffer-order only).
   */
  allowed_item_types: Array<ItemType>;
  billing_contact_zoho_id?: Maybe<Scalars['ID']>;
  carrier_pickup_date?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  deal_owner?: Maybe<ZohoUser>;
  deal_owner_zoho_user_id?: Maybe<Scalars['ID']>;
  /**
   * The carrier a NEW order of this event starts with: pallet gives it the
   * OTHERS (Logistic Partner) carrier, parcel the destination country's default
   * parcel carrier. Persisted on the order at creation, so changing the setting
   * later leaves existing orders untouched; the carrier can be changed per order.
   */
  default_logistics: EventDefaultLogistics;
  delivery_date?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  entity: LegalEntity;
  event_manager?: Maybe<ZohoUser>;
  event_manager_zoho_user_id?: Maybe<Scalars['ID']>;
  event_participants?: Maybe<Array<EventAccount>>;
  external_zoho_id?: Maybe<Scalars['ID']>;
  head_of_operations?: Maybe<ZohoUser>;
  head_of_operations_zoho_user_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  is_authorized_signer_necessary: Scalars['Boolean'];
  is_deleted: Scalars['Boolean'];
  main_contracting_event_account?: Maybe<EventAccount>;
  merchant_order_form_deadline?: Maybe<Scalars['String']>;
  merchant_order_form_info_text?: Maybe<Scalars['String']>;
  minimum_cleaning_fee_rate?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /**
   * The date the containers are picked up again after the event has ended,
   * synced one-way from the Zoho CRM deal's "Pickup Date after Event".
   */
  pickup_date_after_event?: Maybe<Scalars['String']>;
  pipeline?: Maybe<Scalars['String']>;
  prices: Array<EventPrice>;
  project_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  type: EventType;
  uses_deposit: Scalars['Boolean'];
};

export type EventAccount = {
  __typename?: 'EventAccount';
  authorized_signers: Array<AuthorizedSigner>;
  billing_additional_address_info?: Maybe<Scalars['String']>;
  billing_city?: Maybe<Scalars['String']>;
  billing_contact?: Maybe<ZohoContact>;
  billing_contact_zoho_id?: Maybe<Scalars['ID']>;
  billing_country_code?: Maybe<Scalars['String']>;
  billing_mail?: Maybe<Scalars['String']>;
  billing_state?: Maybe<Scalars['String']>;
  billing_street?: Maybe<Scalars['String']>;
  billing_zip?: Maybe<Scalars['String']>;
  business_type?: Maybe<BusinessType>;
  company_name?: Maybe<Scalars['String']>;
  corporate_structure_info?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['String']>;
  debitor_account_number: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<LegalEntity>;
  external_zoho_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  invoice_language: InvoiceLanguage;
  is_billable: Scalars['Boolean'];
  is_deleted: Scalars['Boolean'];
  is_event_account: Scalars['Boolean'];
  item_locations?: Maybe<Array<ItemLocation>>;
  name?: Maybe<Scalars['String']>;
  /**
   * When set, partner invoices for every store below this account — directly
   * linked or through nested child accounts — are held in DRAFT until a purchase
   * order is provided, in addition to any store-level flag. Not synchronized
   * with Zoho.
   */
  needs_purchasing_order_number: Scalars['Boolean'];
  /**
   * Whether inventory checks created from now on for any store below this partner
   * account — directly linked or through nested parent accounts — are marked
   * non-billable. Purely a creation-time policy: switching it never changes
   * inventory checks that already exist. Unrelated to is_billable, which
   * controls event billing.
   */
  new_inventory_checks_are_non_billable: Scalars['Boolean'];
  /**
   * Container checkout limit for offline cards handed out by any store below this
   * account — directly linked or through nested child accounts. Null means the
   * account configures none, so the closest ancestor that does decides, and the
   * default offline card limit applies when no account in the chain does.
   */
  offline_card_checkout_limit?: Maybe<Scalars['Int']>;
  participating_in_events?: Maybe<Array<Event>>;
  phone_number?: Maybe<Scalars['String']>;
  /**
   * Purchasing-order contact(s), semicolon separated. Recipients for the PO
   * request mail of gated stores below this account that have no contact of
   * their own. Only settable while needs_purchasing_order_number is on.
   */
  purchasing_order_email?: Maybe<Scalars['String']>;
  /**
   * Return deadline in days for consumer checkouts at any store below this account —
   * directly linked or through nested child accounts. Null means the account
   * configures none, so the closest ancestor that does decides. It can only ever
   * lengthen a deadline: it applies when it is longer than the deadline the checkout
   * would otherwise get, so it never undercuts the default or a longer
   * per-container-type or per-store deadline.
   */
  return_deadline_days?: Maybe<Scalars['Int']>;
  send_order_fulfillment_emails: Scalars['Boolean'];
  stores: Array<Store>;
  type?: Maybe<EventAccountType>;
  users: Array<EventAccountUser>;
  vat?: Maybe<Scalars['String']>;
};

export type EventAccountInfo = {
  __typename?: 'EventAccountInfo';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type EventAccountInfoForSharedLink = {
  __typename?: 'EventAccountInfoForSharedLink';
  billing_additional_address_info?: Maybe<Scalars['String']>;
  billing_city?: Maybe<Scalars['String']>;
  billing_country_code?: Maybe<Scalars['String']>;
  billing_email?: Maybe<Scalars['String']>;
  billing_first_name?: Maybe<Scalars['String']>;
  billing_last_name?: Maybe<Scalars['String']>;
  billing_mail?: Maybe<Scalars['String']>;
  billing_state?: Maybe<Scalars['String']>;
  billing_street?: Maybe<Scalars['String']>;
  billing_zip?: Maybe<Scalars['String']>;
  business_type?: Maybe<BusinessType>;
  company_name?: Maybe<Scalars['String']>;
  corporate_structure_info?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_zoho_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  item_locations: Array<ItemLocationReduced>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type EventAccountMissingEmail = {
  __typename?: 'EventAccountMissingEmail';
  event_account_id: Scalars['ID'];
  event_account_name?: Maybe<Scalars['String']>;
};

export type EventAccountSearchFilter = {
  include_deleted?: InputMaybe<Scalars['Boolean']>;
  is_event_account?: InputMaybe<Scalars['Boolean']>;
  only_in_use?: InputMaybe<Scalars['Boolean']>;
  only_parents?: InputMaybe<Scalars['Boolean']>;
  only_top_level?: InputMaybe<Scalars['Boolean']>;
  only_with_stores?: InputMaybe<Scalars['Boolean']>;
};

export type EventAccountSearchResult = {
  __typename?: 'EventAccountSearchResult';
  company_name?: Maybe<Scalars['String']>;
  has_children: Scalars['Boolean'];
  id: Scalars['String'];
  is_event_account: Scalars['Boolean'];
  is_top_level: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  parent_account_id?: Maybe<Scalars['String']>;
  store_count: Scalars['Int'];
};

export type EventAccountStock = {
  __typename?: 'EventAccountStock';
  /** @deprecated No longer supported */
  container_station_deliveries: Array<ContainerStationStockEntry>;
  /** @deprecated No longer supported */
  container_station_returns: Array<ContainerStationStockEntry>;
  container_types: Array<ContainerType>;
  /** @deprecated No longer supported */
  goodwill: Array<ContainerTypeAmount>;
  item_location_stock: Array<ItemLocationStockEntry>;
  prices: Array<EventAccountStockPrice>;
};

export type EventAccountStockPrice = {
  __typename?: 'EventAccountStockPrice';
  currency: Scalars['String'];
  id_number?: Maybe<Scalars['Int']>;
  id_text?: Maybe<Scalars['ID']>;
  price_in_cents: Scalars['Int'];
  type: EventAccountStockPriceType;
};

export enum EventAccountStockPriceType {
  Container = 'CONTAINER',
  ContainerStation = 'CONTAINER_STATION'
}

export enum EventAccountType {
  Logistics = 'logistics',
  Other = 'other'
}

export type EventAccountUser = {
  __typename?: 'EventAccountUser';
  can_do_order_fulfillments: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export enum EventDefaultLogistics {
  Pallet = 'pallet',
  Parcel = 'parcel'
}

export type EventDeliveryAddress = {
  __typename?: 'EventDeliveryAddress';
  additional_info?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_event_default: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  linked_item_location_count: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetno?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type EventFulfillmentDataByFulfillmentStep = {
  __typename?: 'EventFulfillmentDataByFulfillmentStep';
  container_station_returns: Array<ContainerStationReturn>;
  container_types: Array<ContainerType>;
  event_accounts: Array<EventAccountInfo>;
  stock_entries: Array<EventFulfillmentStepEntry>;
};

export type EventFulfillmentDataByFulfillmentStepV2 = {
  __typename?: 'EventFulfillmentDataByFulfillmentStepV2';
  container_types: Array<ContainerType>;
  event_accounts: Array<EventAccountInfo>;
  stock_entries: Array<EventFulfillmentStepEntryV2>;
  stock_event_summary?: Maybe<EventFulfillmentStepStockSummary>;
};

export type EventFulfillmentStepEntry = {
  __typename?: 'EventFulfillmentStepEntry';
  cleaned: Scalars['Int'];
  container_type_id: Scalars['Int'];
  delivered: Scalars['Int'];
  event_account_id: Scalars['ID'];
  handed_out: Scalars['Int'];
  in_stock: Scalars['Int'];
  ordered?: Maybe<Scalars['Int']>;
  received_dirty: Scalars['Int'];
  received_sealed: Scalars['Int'];
};

export type EventFulfillmentStepEntryV2 = {
  __typename?: 'EventFulfillmentStepEntryV2';
  container_station_type_id?: Maybe<Scalars['ID']>;
  container_type_id?: Maybe<Scalars['ID']>;
  event_account_id: Scalars['ID'];
  total_container_stations_delivered: Scalars['Int'];
  total_container_stations_in_stock: Scalars['Int'];
  total_container_stations_ordered: Scalars['Int'];
  total_container_stations_returned: Scalars['Int'];
  total_container_stations_returned_based_on_history: Scalars['Int'];
  total_containers_delivered: Scalars['Int'];
  total_containers_in_stock: Scalars['Int'];
  total_containers_ordered: Scalars['Int'];
  total_containers_returned: Scalars['Int'];
};

export type EventFulfillmentStepStockSummary = {
  __typename?: 'EventFulfillmentStepStockSummary';
  container_stations_currently_at_event_item_locations: Scalars['Int'];
  handed_out_container_stations: Scalars['Int'];
  returned_container_stations: Scalars['Int'];
  sealed_container_stations_at_warehouse: Scalars['Int'];
};

export type EventInfoForSharedLink = {
  __typename?: 'EventInfoForSharedLink';
  allowed_container_types: Array<ContainerType>;
  /**
   * Item types (container stations, assets) the event allows on its orders.
   * The public order form does not offer them yet; ops sees them on the order
   * detail page and the order links table.
   */
  allowed_item_types: Array<ItemType>;
  currency: Scalars['String'];
  end_date?: Maybe<Scalars['String']>;
  event_manager?: Maybe<ZohoUser>;
  event_manager_zoho_user_id?: Maybe<Scalars['ID']>;
  head_of_operations?: Maybe<ZohoUser>;
  head_of_operations_zoho_user_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  merchant_order_form_deadline?: Maybe<Scalars['String']>;
  merchant_order_form_info_text?: Maybe<Scalars['String']>;
  minimum_cleaning_fee_rate?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ops_form_submission_deadline?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type EventInvoicingReadiness = {
  __typename?: 'EventInvoicingReadiness';
  event_account_id: Scalars['ID'];
  /** @deprecated This field is deprecated and will always return false. Use missing_main_contractor instead. */
  full_event_with_more_than_one_billable_account: Scalars['Boolean'];
  missing_main_contractor: Scalars['Boolean'];
  missing_prices_container_type_ids: Array<Scalars['Int']>;
  /**
   * Item types the account used that invoicing has no price for in the event's
   * currency.
   */
  missing_prices_item_type_ids: Array<Scalars['Int']>;
  missing_sku_container_type_ids: Array<Scalars['Int']>;
  /**
   * Item types the account used that have no SKU, so they are not synced to Zoho Books
   * and have no item to bill with.
   */
  missing_sku_item_type_ids: Array<Scalars['Int']>;
  not_allowed_container_type_ids: Array<Scalars['Int']>;
  /**
   * Item types (container stations, assets) the account used that the event does not
   * allow.
   */
  not_allowed_item_type_ids: Array<Scalars['Int']>;
  uncounted_container_station_ids: Array<Scalars['String']>;
  wrong_class_container_type_ids: Array<Scalars['Int']>;
};

export type EventLinkedUser = {
  __typename?: 'EventLinkedUser';
  id: Scalars['ID'];
  password?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_name: Scalars['String'];
};

export type EventLinkedUserInput = {
  event_id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  user_name: Scalars['String'];
};

export type EventMerchantOrderSharedLinkInfo = {
  __typename?: 'EventMerchantOrderSharedLinkInfo';
  can_submit_or_edit: Scalars['Boolean'];
  event?: Maybe<EventInfoForSharedLink>;
  event_account?: Maybe<EventAccountInfoForSharedLink>;
  ops_order?: Maybe<MerchantOrderInfo>;
  prices?: Maybe<Array<EventPrice>>;
};

export type EventOrderedContainerTotal = {
  __typename?: 'EventOrderedContainerTotal';
  ordered: Scalars['Int'];
  type: OpsOrderContainerType;
};

export type EventOrderedItemTotal = {
  __typename?: 'EventOrderedItemTotal';
  ordered: Scalars['Int'];
  type: OpsOrderUntrackedItemType;
};

export type EventOrderedTotals = {
  __typename?: 'EventOrderedTotals';
  container_types: Array<EventOrderedContainerTotal>;
  item_types: Array<EventOrderedItemTotal>;
};

export type EventPaginatedResult = {
  __typename?: 'EventPaginatedResult';
  events: Array<Event>;
  total: Scalars['Int'];
};

/**
 * Exactly one of container_type_id and item_type_id is set. For item type rows
 * cleaning_price, deposit_price and logistic_partner_cleaning_price are always
 * null. A null price means "use the type's default".
 */
export type EventPrice = {
  __typename?: 'EventPrice';
  cleaning_price?: Maybe<Scalars['Int']>;
  container_type_id?: Maybe<Scalars['Int']>;
  deposit_price?: Maybe<Scalars['Int']>;
  is_default: Scalars['Boolean'];
  item_type_id?: Maybe<Scalars['Int']>;
  /** Which of the two id fields is set. Switch on this rather than on null-ness. */
  kind: EventPriceKind;
  logistic_partner_cleaning_price?: Maybe<Scalars['Int']>;
  lost_price?: Maybe<Scalars['Int']>;
  rental_price?: Maybe<Scalars['Int']>;
};

/**
 * Exactly one of container_type_id and item_type_id must be set. Neither, or both,
 * is EVENT_PRICE_TARGET_INVALID.
 */
export type EventPriceInput = {
  cleaning_price?: InputMaybe<Scalars['Int']>;
  container_type_id?: InputMaybe<Scalars['Int']>;
  deposit_price?: InputMaybe<Scalars['Int']>;
  item_type_id?: InputMaybe<Scalars['Int']>;
  logistic_partner_cleaning_price?: InputMaybe<Scalars['Int']>;
  lost_price?: InputMaybe<Scalars['Int']>;
  rental_price?: InputMaybe<Scalars['Int']>;
};

export enum EventPriceKind {
  ContainerType = 'CONTAINER_TYPE',
  ItemType = 'ITEM_TYPE'
}

export type EventReduced = {
  __typename?: 'EventReduced';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EventStock = {
  __typename?: 'EventStock';
  container_types: Array<ContainerType>;
  item_location_stock: Array<ItemLocationStockEntry>;
  prices: Array<EventAccountStockPrice>;
};

export enum EventType {
  Default = 'default',
  DeliveryOnlyFullEvent = 'delivery_only_full_event',
  PilotOneOff = 'pilot_one_off',
  Recurring = 'recurring',
  StandardFullEvent = 'standard_full_event',
  StandardPerGastronomist = 'standard_per_gastronomist'
}

export type EventsFilterInput = {
  event_account_id?: InputMaybe<Scalars['ID']>;
  include_deleted?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<Range>;
  search?: InputMaybe<Scalars['String']>;
  show_past_events?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EventType>;
};

export type ExtLocationRequest = {
  coordinates?: InputMaybe<LonLatIn>;
  external_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ExtendContainerDeadlineInput = {
  container_id?: InputMaybe<Scalars['ID']>;
  container_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  payment_intent?: InputMaybe<Scalars['ID']>;
  payment_source?: InputMaybe<Scalars['String']>;
  payment_token?: InputMaybe<Scalars['ID']>;
  payment_type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type ExtendContainerResult = {
  __typename?: 'ExtendContainerResult';
  /** @deprecated not supported anymore, do not use */
  new_deadline_at?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['ID']>;
};

export type ExtendContainerResultSca = ExtendContainerResult | PaymentAuthRequired;

export type ExtendedContainers = {
  __typename?: 'ExtendedContainers';
  container_id: Scalars['String'];
  return_deadline: Scalars['String'];
};

export type ExternalAuthClient = {
  __typename?: 'ExternalAuthClient';
  client_id?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
};

export type ExternalEventSupervisor = {
  __typename?: 'ExternalEventSupervisor';
  id: Scalars['ID'];
  password: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  user_name: Scalars['String'];
};

export type ExternalEventSupervisorInput = {
  event_id: Scalars['ID'];
  role?: InputMaybe<Scalars['String']>;
  user_name: Scalars['String'];
};

export type Extra = {
  __typename?: 'Extra';
  allergens?: Maybe<Array<Maybe<Scalars['String']>>>;
  disabled_minutes?: Maybe<Scalars['Int']>;
  extra_id: Scalars['ID'];
  /** @deprecated Field is deprecated, used in extra_groups anyways! */
  group_id?: Maybe<Scalars['ID']>;
  /** @deprecated Field is deprecated, used in extra_groups anyways! */
  group_name?: Maybe<Scalars['String']>;
  in_stock?: Maybe<Scalars['Boolean']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Field is deprecated, match with default_extras array! */
  is_default?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field is deprecated, match with default_extras array! */
  is_selected?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  price_raw?: Maybe<Scalars['Int']>;
  specialities?: Maybe<Specialities>;
  vat_rate?: Maybe<Scalars['Int']>;
  vat_shadow_price?: Maybe<Scalars['Int']>;
};

export type ExtraGroup = {
  __typename?: 'ExtraGroup';
  default_extra?: Maybe<Scalars['ID']>;
  default_extras?: Maybe<Array<Maybe<Scalars['ID']>>>;
  extra_group_id?: Maybe<Scalars['ID']>;
  has_inputfield?: Maybe<Scalars['Boolean']>;
  is_multiselect?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_required?: Maybe<Scalars['Boolean']>;
  is_selected?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<Extra>>>;
  maximum_extras?: Maybe<Scalars['Int']>;
  minimum_extras?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ExtraGroupCreate = {
  default_extras?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  is_open?: InputMaybe<Scalars['Boolean']>;
  maximum_extras?: InputMaybe<Scalars['Int']>;
  minimum_extras?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ExtraGroupResponse = {
  __typename?: 'ExtraGroupResponse';
  group_id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
};

export type ExtraGroupUpdate = {
  default_extras?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  is_open?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maximum_extras?: InputMaybe<Scalars['Int']>;
  minimum_extras?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ExtraInGroupResponse = {
  __typename?: 'ExtraInGroupResponse';
  extra?: Maybe<Product>;
  group_id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
};

export type ExtraOrderItemInput = {
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  extra_id: Scalars['ID'];
  group_id?: InputMaybe<Scalars['ID']>;
  group_name?: InputMaybe<Scalars['String']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  is_selected?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  specialities?: InputMaybe<SpecialitiesInput>;
  vat_rate?: InputMaybe<Scalars['Int']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  feature_new_order_management: Scalars['Boolean'];
  new_return_experience: Scalars['Boolean'];
  offline_self_checkout: Scalars['Boolean'];
  partner_app_feature_flags?: Maybe<PartnerAppFeatureFlags>;
  tap_to_borrow_stripe_payment_intent_charge_full_amount_initially: Scalars['Boolean'];
};

export type FeaturedProduct = ProductInterface & {
  __typename?: 'FeaturedProduct';
  allergens?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  distance?: Maybe<Distance>;
  extra_groups?: Maybe<Array<Maybe<ExtraGroup>>>;
  extras?: Maybe<Array<Maybe<Extra>>>;
  geo_hash?: Maybe<Scalars['String']>;
  has_cutlery?: Maybe<Scalars['Boolean']>;
  has_extras_or_variants?: Maybe<Scalars['Boolean']>;
  has_inherited_extras?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  in_stock?: Maybe<Scalars['Boolean']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_featued?: Maybe<Scalars['Boolean']>;
  is_promo?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  old_price?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  preferred_height?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  reusable_packaging?: Maybe<Scalars['Boolean']>;
  specialities?: Maybe<Specialities>;
  store?: Maybe<Store>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  teaser_text?: Maybe<Scalars['String']>;
  teaser_text_long?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<Product>>>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type FeedbackVote = {
  helpfull?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['Int']>;
  recommend?: InputMaybe<Scalars['Int']>;
};

export enum FinanceBulkImportEntityType {
  InvoiceCollection = 'INVOICE_COLLECTION',
  Store = 'STORE'
}

/**
 * One field the row changes. Values are written as the template writes them:
 * empty is "", booleans are "true"/"false", dates are YYYY-MM-DD.
 */
export type FinanceBulkImportFieldChange = {
  __typename?: 'FinanceBulkImportFieldChange';
  column: Scalars['String'];
  new_value: Scalars['String'];
  old_value: Scalars['String'];
};

export type FinanceBulkImportFieldChangeInput = {
  column: Scalars['String'];
  new_value: Scalars['String'];
  old_value: Scalars['String'];
};

export type FinanceBulkImportResult = {
  __typename?: 'FinanceBulkImportResult';
  /** Errors of the whole file. When there is one, no row is validated. */
  file_errors: Array<Scalars['String']>;
  /** Columns the import does not know; their values are not read. */
  ignored_columns: Array<Scalars['String']>;
  /** The importable columns the file has. A column the file does not have is left unchanged. */
  imported_columns: Array<Scalars['String']>;
  rows: Array<FinanceBulkImportRowResult>;
};

export type FinanceBulkImportRowError = {
  __typename?: 'FinanceBulkImportRowError';
  /** The column the error belongs to; null for an error of the whole row. */
  column?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type FinanceBulkImportRowInput = {
  /**
   * apply only: the changes the validation returned for this row and the user
   * confirmed. The row is written only when the changes are still the same.
   */
  expected_changes?: InputMaybe<Array<FinanceBulkImportFieldChangeInput>>;
  /** Echoed back in the result, so the admin can match rows. The admin sends the spreadsheet row (the header is row 1). */
  row_number: Scalars['Int'];
  /** The raw cells, in the order of columns. A row with fewer cells than columns is an error. */
  values: Array<InputMaybe<Scalars['String']>>;
};

export type FinanceBulkImportRowResult = {
  __typename?: 'FinanceBulkImportRowResult';
  changes: Array<FinanceBulkImportFieldChange>;
  entity_type?: Maybe<FinanceBulkImportEntityType>;
  errors: Array<FinanceBulkImportRowError>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  row_number: Scalars['Int'];
  status: FinanceBulkImportRowStatus;
};

export enum FinanceBulkImportRowStatus {
  /** apply only: the row is written. */
  Applied = 'APPLIED',
  /** The row changes at least one stored value. Validation only. */
  Changed = 'CHANGED',
  /** apply only: the stored values changed after the validation, so the row is not written. */
  Conflict = 'CONFLICT',
  /** The row has at least one error and is not written. */
  Error = 'ERROR',
  /** The row matches the stored values. */
  Unchanged = 'UNCHANGED'
}

export type FindMovedContainersForContainerStationPaginatedResponse = {
  __typename?: 'FindMovedContainersForContainerStationPaginatedResponse';
  containers: Array<ContainerStationContainer>;
  total: Scalars['Int'];
};

export type FindStockOnDayForContainerStationPaginatedResponse = {
  __typename?: 'FindStockOnDayForContainerStationPaginatedResponse';
  containers: Array<ContainerStationContainer>;
  total: Scalars['Int'];
};

export enum FoodCategory {
  AsianFusion = 'ASIAN_FUSION',
  Austrian = 'AUSTRIAN',
  Bowls = 'BOWLS',
  Breakfast = 'BREAKFAST',
  Burger = 'BURGER',
  Butcher = 'BUTCHER',
  CoffeeCake = 'COFFEE_CAKE',
  German = 'GERMAN',
  GlutenFree = 'GLUTEN_FREE',
  Greek = 'GREEK',
  Halal = 'HALAL',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Lunch = 'LUNCH',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  Nepalese = 'NEPALESE',
  Organic = 'ORGANIC',
  Pizza = 'PIZZA',
  Salads = 'SALADS',
  Sandwich = 'SANDWICH',
  Snacks = 'SNACKS',
  Soups = 'SOUPS',
  Spanish = 'SPANISH',
  Sushi = 'SUSHI',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN',
  Vietnamese = 'VIETNAMESE',
  ZeroWaste = 'ZERO_WASTE'
}

export enum FoodTypeEnum {
  Standard = 'STANDARD',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

/**
 * One answered funnel step: step/value are the shop URL param's key and value,
 * verbatim. position is the index the step was shown at in this visitor's
 * funnel. iteration bumps every time the visitor walks back; earlier
 * iterations are immutable.
 */
export type FunnelAnswer = {
  __typename?: 'FunnelAnswer';
  iteration: Scalars['Int'];
  position: Scalars['Int'];
  step: Scalars['String'];
  value: Scalars['String'];
};

/** Contact left at the funnel's close. Write-only: the contact never comes back. */
export type FunnelLead = {
  __typename?: 'FunnelLead';
  created_at: Scalars['String'];
  id: Scalars['UUID'];
  kind: FunnelLeadKind;
};

export enum FunnelLeadKind {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

/**
 * A Guided Path (shop configurator) session — the draft "project" a visitor
 * builds. Anonymous: the uuid travels in the shop's URL (project=) and is the
 * only handle to read or write the project.
 */
export type FunnelProject = {
  __typename?: 'FunnelProject';
  /**
   * Answers of the highest iteration only — the project's current state,
   * ready to hydrate a shared link. Earlier iterations are analytics history
   * and not part of the public read.
   */
  answers: Array<FunnelAnswer>;
  id: Scalars['UUID'];
  /** Display name; null until named (AI naming comes later). */
  name?: Maybe<Scalars['String']>;
};

export type GenerateInvoiceResponse = {
  __typename?: 'GenerateInvoiceResponse';
  result?: Maybe<InvoiceResultType>;
  url?: Maybe<Scalars['String']>;
};

export type GetAggregatedEventMerchantOrderDataByTypeResult = {
  __typename?: 'GetAggregatedEventMerchantOrderDataByTypeResult';
  container_types: Array<AggregatedEventMerchantOrderData>;
};

export type GetAggregatedOrderFulfillmentDataByTypeResult = {
  __typename?: 'GetAggregatedOrderFulfillmentDataByTypeResult';
  assets: Array<AggregatedItemData>;
  container_stations: Array<AggregatedItemData>;
  container_types: Array<AggregatedItemData>;
};

export type GetAggregatedOrderFulfillmentDataByTypeV2Result = {
  __typename?: 'GetAggregatedOrderFulfillmentDataByTypeV2Result';
  assets: Array<AggregatedItemDataV2>;
  container_stations: Array<AggregatedItemDataV2>;
  container_types: Array<AggregatedItemDataV2>;
};

export type GetAllEventSupervisorsFilterInput = {
  event_id?: InputMaybe<Scalars['ID']>;
};

export type GetAllLinkedUserFilterInput = {
  event_id?: InputMaybe<Scalars['ID']>;
};

export type GetCustomerCateringUsersForStoreResult = {
  __typename?: 'GetCustomerCateringUsersForStoreResult';
  total: Scalars['Int'];
  users: Array<CustomerCateringUser>;
};

export type GetFilteredItemLocationsResponse = {
  __typename?: 'GetFilteredItemLocationsResponse';
  item_locations: Array<ItemLocation>;
  total: Scalars['Int'];
};

export type GetItemLocationHistoryPaginatedResponse = {
  __typename?: 'GetItemLocationHistoryPaginatedResponse';
  items: Array<ItemLocationHistoryEntry>;
  total: Scalars['Int'];
};

export type GetMerchantOrderSharedLinksForEventResponse = {
  __typename?: 'GetMerchantOrderSharedLinksForEventResponse';
  eventMerchantorderSharedLinks: Array<MerchantOrderSharedLink>;
  total: Scalars['Int'];
};

export type GetRaffleTicketsInput = {
  cycle_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type GetUnlinkedOrderFulfillmentPicturesResult = {
  __typename?: 'GetUnlinkedOrderFulfillmentPicturesResult';
  pictures: Array<OrderFulfillmentPicture>;
  total: Scalars['Int'];
};

export type GlypoUser = {
  __typename?: 'GlypoUser';
  default_source?: Maybe<StripeSource>;
  id?: Maybe<Scalars['ID']>;
  paypal_id?: Maybe<Scalars['ID']>;
  sources?: Maybe<Array<Maybe<StripeSource>>>;
  stripe_id?: Maybe<Scalars['ID']>;
};

export type GrafanaStoreFilter = {
  billing_info_incomplete?: InputMaybe<Scalars['Boolean']>;
  disable_automatic_partner_charging?: InputMaybe<Scalars['Boolean']>;
  disable_automatic_partner_invoice_sending?: InputMaybe<Scalars['Boolean']>;
};

export type GroupedStore = {
  __typename?: 'GroupedStore';
  close_stores?: Maybe<Array<Maybe<Store>>>;
  store?: Maybe<Store>;
};

export type HeavenHrJobs = {
  __typename?: 'HeavenHrJobs';
  department?: Maybe<Scalars['String']>;
  employmentTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['ID']>;
  jobTitle?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type IdName = {
  __typename?: 'IdName';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ImageSource {
  Google = 'GOOGLE',
  UploadByStore = 'UPLOAD_BY_STORE',
  UploadByVytal = 'UPLOAD_BY_VYTAL'
}

export type IngestExtraInput = {
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  default_extra?: InputMaybe<Scalars['String']>;
  extra_group_id: Scalars['String'];
  has_inputfield?: InputMaybe<Scalars['Boolean']>;
  is_multiselect?: InputMaybe<Scalars['Boolean']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maximum_extras?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type IntegrationOption = {
  __typename?: 'IntegrationOption';
  api_name: Scalars['String'];
  name: Scalars['String'];
};

export type InternalTransactionFromStore = {
  __typename?: 'InternalTransactionFromStore';
  booking_dates: Array<Scalars['String']>;
  container_type_name: Scalars['String'];
  count: Scalars['Int'];
  store_name: Scalars['String'];
};

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection';
  billomat_client_id?: Maybe<Scalars['String']>;
  change_history?: Maybe<Array<Maybe<InvoiceCollectionChangeHistory>>>;
  collapse_invoice_items?: Maybe<Scalars['Boolean']>;
  disable_automatic_partner_invoice_sending?: Maybe<Scalars['Boolean']>;
  dunning_reminder_block_permanent_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_permanent_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_reason?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_type?: Maybe<DunningReminderBlockType>;
  dunning_reminder_block_until?: Maybe<Scalars['String']>;
  excluded_store_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  excluded_stores: Array<Maybe<Store>>;
  /**
   * External id of this collection at the customer, e.g. \"ES123456\". The
   * collection-level counterpart of Store.external_id.
   */
  external_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  inkassokennzeichen?: Maybe<Scalars['Boolean']>;
  invoice_address?: Maybe<Address>;
  invoice_collection_debitor_account_number: Scalars['Int'];
  invoice_email?: Maybe<Scalars['String']>;
  invoice_email_subject_prefix?: Maybe<Scalars['String']>;
  invoice_headline?: Maybe<Scalars['String']>;
  invoice_iban?: Maybe<Scalars['String']>;
  invoice_iban_name?: Maybe<Scalars['String']>;
  invoice_routing_id?: Maybe<Scalars['String']>;
  is_dunning_reminder_stopped?: Maybe<Scalars['Boolean']>;
  legal_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  needs_invoice_collection_breakdown?: Maybe<Scalars['Boolean']>;
  needs_purchasing_order_number?: Maybe<Scalars['Boolean']>;
  order_number?: Maybe<Scalars['String']>;
  partner_account_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /**
   * Partner accounts attached to this collection, resolved with their hierarchy
   * path and the number of member stores they contribute.
   */
  partner_accounts: Array<InvoiceCollectionPartnerAccount>;
  /**
   * Dedicated purchasing-order contact(s) for this collection,
   * semicolon-separated. Deliberately separate from invoice_email and never
   * derived from the member stores' contacts. At most three addresses.
   */
  purchasing_order_email?: Maybe<Scalars['String']>;
  regular_payment_target_days?: Maybe<Scalars['Int']>;
  /**
   * Set when the collection is created and never changed afterwards.
   * Collections created before scopes existed read as ALL.
   */
  scope: InvoiceCollectionScope;
  seller_id?: Maybe<Scalars['String']>;
  sepa_2_percent_discount?: Maybe<Scalars['Boolean']>;
  store_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /**
   * Canonical membership: directly associated stores plus every active store
   * under the selected partner accounts and their descendant accounts, with
   * excluded_stores removed. A store's brand plays no part. This is exactly the
   * set that gets billed on the collection invoice.
   */
  stores: Array<Maybe<Store>>;
  type?: Maybe<StoreType>;
  updated_at: Scalars['String'];
  vat_number?: Maybe<Scalars['String']>;
};

export type InvoiceCollectionChangeHistory = {
  __typename?: 'InvoiceCollectionChangeHistory';
  changed_at?: Maybe<Scalars['String']>;
  changed_by?: Maybe<Scalars['String']>;
  changed_by_raw?: Maybe<Scalars['String']>;
  new_values?: Maybe<Scalars['String']>;
  old_values?: Maybe<Scalars['String']>;
};

/**
 * A request to rebuild one invoice collection's Billomat draft — and its
 * breakdown files — of a finished generation run from current data. The
 * draft is updated in place: it keeps its id, its number (the statutory
 * ES-NNNN- for Spain), its date and its tags. Executed by the invoice-run
 * worker; poll status.
 */
export type InvoiceCollectionDraftRegeneration = {
  __typename?: 'InvoiceCollectionDraftRegeneration';
  billomat_invoice_id?: Maybe<Scalars['String']>;
  billomat_url?: Maybe<Scalars['String']>;
  enqueued_at: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['String']>;
  generation_run_id: Scalars['UUID'];
  id: Scalars['UUID'];
  invoice_collection_id: Scalars['ID'];
  invoice_collection_name?: Maybe<Scalars['String']>;
  last_activity_at?: Maybe<Scalars['String']>;
  requested_by?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['String']>;
  status: InvoiceRunStatus;
  /**
   * true: the existing draft was updated in place. false: the collection had
   * no draft for the period, so a new one was created. null until done.
   */
  updated_in_place?: Maybe<Scalars['Boolean']>;
};

export type InvoiceCollectionPartnerAccount = {
  __typename?: 'InvoiceCollectionPartnerAccount';
  company_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  parent_account_id?: Maybe<Scalars['ID']>;
  /** Account names from the top of the hierarchy down to this account, e.g. "Root Group > Mid Holding > Leaf". */
  partner_account_path?: Maybe<Scalars['String']>;
  /** Active member stores this account and its descendant accounts contribute, before exclusions. */
  store_count: Scalars['Int'];
};

/**
 * What an invoice collection bills for its member stores.
 * ALL: every charge of a member goes on the collection invoice; the member's
 * own store invoice is a draft that is never charged.
 * PENALTY_BILLS_ONLY: only the penalty bills of external POS integrations
 * (overdue containers) go on the collection invoice. Every other charge of a
 * member goes on the member's own store invoice, exactly as for a store in no
 * collection.
 */
export enum InvoiceCollectionScope {
  All = 'ALL',
  PenaltyBillsOnly = 'PENALTY_BILLS_ONLY'
}

export type InvoiceGroup = {
  __typename?: 'InvoiceGroup';
  address?: Maybe<Address>;
  legal_name?: Maybe<Scalars['String']>;
};

export enum InvoiceLanguage {
  English = 'english',
  German = 'german'
}

export type InvoicePdfResponse = {
  __typename?: 'InvoicePdfResponse';
  file_base64?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
};

export enum InvoiceResultType {
  NoTurnover = 'NO_TURNOVER',
  Success = 'SUCCESS'
}

export type InvoiceRun = {
  __typename?: 'InvoiceRun';
  /**
   * For generation runs: the charge run pointing at them, if any (its status
   * tells whether the run is actually charged).
   */
  charge_run?: Maybe<InvoiceRun>;
  /**
   * Why regenerateCollectionDraft is refused for this run right now (not a
   * finished, real generation run, or its charge run has started), or null
   * when it is allowed.
   */
  collection_draft_regeneration_blocked_reason?: Maybe<Scalars['String']>;
  /**
   * Generation runs: the collection invoices of the run with their draft
   * regeneration history. Reads the run's created-invoices file from S3 —
   * query it on the run detail, not in lists. Empty for charge runs.
   */
  collection_invoices: Array<InvoiceRunCollectionInvoice>;
  dry_run: Scalars['Boolean'];
  /**
   * When the run may start (generation runs only; a charge run is due once
   * its parent is done). pending + due_at in the future renders as Scheduled.
   */
  due_at?: Maybe<Scalars['String']>;
  enqueued_at: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  error_count?: Maybe<Scalars['Int']>;
  errors: Array<InvoiceRunError>;
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /**
   * Of those, the ones that actually have an invoice in Billomat (results
   * SUCCESS or ALREADY_CREATED). Much smaller than processed_count, and null
   * for runs that finished before the count was recorded.
   */
  invoice_count?: Maybe<Scalars['Int']>;
  /** 0-based, JS Date#getMonth convention — matches the backend throughout. */
  iso_month: Scalars['Int'];
  last_activity_at?: Maybe<Scalars['String']>;
  open_error_count: Scalars['Int'];
  /** For charge runs: the generation run they charge. */
  parent_run?: Maybe<InvoiceRun>;
  parent_run_id?: Maybe<Scalars['UUID']>;
  /**
   * Entities the run got a result for — stores, final-inventory stores and
   * invoice collections — including every one that was billed nothing. This is
   * the progress numerator against total_count, NOT an invoice count.
   */
  processed_count?: Maybe<Scalars['Int']>;
  requested_by?: Maybe<Scalars['String']>;
  requested_es_invoice_number?: Maybe<Scalars['Int']>;
  resolved_es_invoice_number?: Maybe<Scalars['Int']>;
  result_files: Array<InvoiceRunFile>;
  started_at?: Maybe<Scalars['String']>;
  status: InvoiceRunStatus;
  total_count?: Maybe<Scalars['Int']>;
  type: InvoiceRunType;
  year: Scalars['Int'];
};

/**
 * An invoice collection a generation run created a draft for, or failed to
 * (it is then in the run's error list), or whose draft was regenerated.
 */
export type InvoiceRunCollectionInvoice = {
  __typename?: 'InvoiceRunCollectionInvoice';
  /**
   * The draft's Billomat link: from the newest successful regeneration if
   * there is one, else from the run's created-invoices file.
   */
  billomat_url?: Maybe<Scalars['String']>;
  invoice_collection_id: Scalars['ID'];
  invoice_collection_name?: Maybe<Scalars['String']>;
  /** Newest first. */
  regenerations: Array<InvoiceCollectionDraftRegeneration>;
  /**
   * The run's result for the collection: SUCCESS, or ERROR when the run
   * logged an error for it, or null when only a regeneration knows it.
   */
  result?: Maybe<Scalars['String']>;
};

/**
 * One per-entity error of a generation run, ingested live while the run
 * executes. Resolving is bookkeeping for finance ("handled by hand in
 * Billomat") — it never re-invoices anything.
 */
export type InvoiceRunError = {
  __typename?: 'InvoiceRunError';
  entity_id: Scalars['ID'];
  entity_name?: Maybe<Scalars['String']>;
  external_vytal_id?: Maybe<Scalars['String']>;
  first_seen_at: Scalars['String'];
  id: Scalars['UUID'];
  kind: InvoiceRunErrorKind;
  last_seen_at: Scalars['String'];
  message: Scalars['String'];
  resolution_note?: Maybe<Scalars['String']>;
  resolved_at?: Maybe<Scalars['String']>;
  resolved_by?: Maybe<Scalars['String']>;
};

export enum InvoiceRunErrorKind {
  Collection = 'COLLECTION',
  FinalInventory = 'FINAL_INVENTORY',
  Store = 'STORE'
}

export type InvoiceRunFile = {
  __typename?: 'InvoiceRunFile';
  /**
   * Object key in the reports bucket; pass to invoiceRunFileUrl for a fresh
   * download link.
   */
  key: Scalars['String'];
  last_modified: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
};

export enum InvoiceRunStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum InvoiceRunType {
  CompleteAndCharge = 'COMPLETE_AND_CHARGE',
  Default = 'DEFAULT',
  Es = 'ES'
}

export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  custom_items_total?: Maybe<Scalars['Int']>;
  invoice_xml?: Maybe<Scalars['String']>;
  lost_containers_cost_total?: Maybe<Scalars['Int']>;
  monthly_fee?: Maybe<Scalars['Int']>;
  onboarding_fee_vytal?: Maybe<Scalars['Int']>;
  store_cards_sold_total?: Maybe<Scalars['Int']>;
  store_preorder_total?: Maybe<Scalars['Int']>;
  tax_fee?: Maybe<Scalars['Int']>;
  total_minus_taxes?: Maybe<Scalars['Int']>;
  total_platform_fee?: Maybe<Scalars['Int']>;
  transaction_cost_total?: Maybe<Scalars['Int']>;
  would_generate_invoice?: Maybe<Scalars['Boolean']>;
};

export type InvoicingCapability = {
  __typename?: 'InvoicingCapability';
  /**
   * Whether the current viewer may start, retry and charge runs (invoicing
   * owner or administrator). Everyone passing the finance gate may view and
   * resolve errors.
   */
  can_act: Scalars['Boolean'];
  owner_name?: Maybe<Scalars['String']>;
};

export type Item = {
  __typename?: 'Item';
  arrival_date: Scalars['String'];
  booked_by_user_id?: Maybe<Scalars['String']>;
  booked_by_user_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_type: ItemType;
  name: Scalars['String'];
};

export type ItemInfo = {
  __typename?: 'ItemInfo';
  color_hex_code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ItemLocation = {
  __typename?: 'ItemLocation';
  can_be_deleted: Scalars['Boolean'];
  delivery_address?: Maybe<IdName>;
  disabled_at?: Maybe<Scalars['String']>;
  event?: Maybe<EventReduced>;
  event_account?: Maybe<EventAccount>;
  event_account_id?: Maybe<Scalars['ID']>;
  event_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type ItemLocationFilterInput = {
  event_account_id?: InputMaybe<Scalars['ID']>;
  event_id?: InputMaybe<Scalars['ID']>;
  include_disabled?: InputMaybe<Scalars['Boolean']>;
};

export type ItemLocationHistoryEntry = {
  __typename?: 'ItemLocationHistoryEntry';
  arrival_date: Scalars['String'];
  booked_by?: Maybe<Scalars['String']>;
  booked_by_id?: Maybe<Scalars['ID']>;
  container_type_amounts: Array<ContainerTypeAmount>;
  counted_at?: Maybe<Scalars['String']>;
  counted_by_id?: Maybe<Scalars['ID']>;
  counted_by_name?: Maybe<Scalars['String']>;
  current_location_id: Scalars['ID'];
  current_location_name?: Maybe<Scalars['String']>;
  departure_date?: Maybe<Scalars['String']>;
  event?: Maybe<EventReduced>;
  id: Scalars['ID'];
  item_id: Scalars['ID'];
  item_type?: Maybe<ItemType>;
  next_location_id?: Maybe<Scalars['ID']>;
  next_location_name?: Maybe<Scalars['String']>;
  order_fulfillment_id?: Maybe<Scalars['ID']>;
  pictures: Array<OrderFulfillmentPicture>;
  status?: Maybe<ContainerStationStatus>;
};

export type ItemLocationReduced = {
  __typename?: 'ItemLocationReduced';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ItemLocationStock = {
  __typename?: 'ItemLocationStock';
  asset_amounts: Array<AssetAmount>;
  container_station_amounts: Array<ContainerStationAmount>;
  container_type_amounts: Array<ContainerTypeAmount>;
};

export type ItemLocationStockEntry = {
  __typename?: 'ItemLocationStockEntry';
  /** Assets handed out to this location, counted per item type. */
  asset_deliveries: Array<ItemTypeAmount>;
  /** Assets taken back from this location, counted per item type. */
  asset_returns: Array<ItemTypeAmount>;
  container_deliveries: Array<ContainerTypeAmount>;
  container_returns: Array<ContainerTypeAmount>;
  container_station_deliveries: Array<ContainerStationStockEntry>;
  container_station_returns: Array<ContainerStationStockEntry>;
  container_totals: Array<ContainerTypeAmount>;
  containers_used: Array<ContainerTypeAmount>;
  goodwill: Array<ContainerTypeAmount>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ItemLocationType = {
  __typename?: 'ItemLocationType';
  id: Scalars['Int'];
  type: Scalars['String'];
};

export type ItemType = {
  __typename?: 'ItemType';
  archived: Scalars['Boolean'];
  billing_category?: Maybe<BillingCategory>;
  billing_frequency?: Maybe<BillingFrequency>;
  billomat_article_ids_by_country?: Maybe<Array<BillomatArticleIdByCountry>>;
  category: ItemTypeCategory;
  color_hex_code?: Maybe<Scalars['String']>;
  custom_field_definitions?: Maybe<Array<CustomFieldDefinition>>;
  /**
   * One entry per supported currency (EUR, USD), always both present when the
   * field is selected; a currency the type has no defaults for carries null
   * prices. Nullable only so partial ItemType selections stay assignable.
   */
  default_event_prices?: Maybe<Array<ItemTypeDefaultEventPrice>>;
  /** Shipping-unit depth in millimeters. Used by the pallet count estimator. */
  depth_mm?: Maybe<Scalars['Int']>;
  epc_asset_id: Scalars['Int'];
  /** Shipping-unit height in millimeters. Used by the pallet count estimator. */
  height_mm?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  /**
   * Hand-maintained stock keeping unit, unique across item types. Zoho Books
   * items derive their SKU from it (R<SKU> rent, L<SKU> loss, C<SKU> cleaning). Null means the
   * type is not synced to Zoho Books and cannot be billed on event orders.
   */
  sku?: Maybe<Scalars['String']>;
  weight: Scalars['Int'];
  /** Shipping-unit width in millimeters. Used by the pallet count estimator. */
  width_mm?: Maybe<Scalars['Int']>;
};

/**
 * How many times an asset of this item type changed hands, counted over every fulfillment:
 * one asset handed out twice counts twice, the same way a container does. Assets are
 * tracked individually, so there is no sealed or packing-unit counterpart.
 */
export type ItemTypeAmount = {
  __typename?: 'ItemTypeAmount';
  amount: Scalars['Int'];
  item_type_id: Scalars['Int'];
  item_type_image?: Maybe<Scalars['String']>;
  item_type_name: Scalars['String'];
};

/**
 * What kind of thing an item type describes, mirroring the Postgres enum
 * item_type_category on ItemTypes.Category. Decides where its items can be
 * ordered: CONTAINER_STATION and ASSET types are the ones an event can put on
 * its allow list (Event.allowed_item_types) and order on event orders,
 * STORE_ASSET types travel with open-system store orders only. In picking it
 * distinguishes pickable assets (e.g. cleaning kit) from container stations
 * (which fan out into their contents on scan) and store-fixture assets.
 */
export enum ItemTypeCategory {
  Asset = 'ASSET',
  ContainerStation = 'CONTAINER_STATION',
  StoreAsset = 'STORE_ASSET'
}

/**
 * Default event prices of an item type for one Zoho Books organisation
 * currency (EUR = Global, USD = US), net cents per piece. They are the rate of
 * the synced Zoho Books items and seed the event prices of a newly created
 * event; events created earlier keep the rows they were seeded with.
 */
export type ItemTypeDefaultEventPrice = {
  __typename?: 'ItemTypeDefaultEventPrice';
  cleaning_price?: Maybe<Scalars['Int']>;
  currency: ItemTypeEventPriceCurrency;
  lost_price?: Maybe<Scalars['Int']>;
  rental_price?: Maybe<Scalars['Int']>;
};

export type ItemTypeDefaultEventPriceInput = {
  cleaning_price?: InputMaybe<Scalars['Int']>;
  currency: ItemTypeEventPriceCurrency;
  lost_price?: InputMaybe<Scalars['Int']>;
  rental_price?: InputMaybe<Scalars['Int']>;
};

/**
 * The currencies an item type carries default event prices for — one per Zoho
 * Books organisation the item is synced to.
 */
export enum ItemTypeEventPriceCurrency {
  Eur = 'EUR',
  Usd = 'USD'
}

export type ItemTypeFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<ItemTypeCategory>;
};

export type ItemTypePrice = {
  __typename?: 'ItemTypePrice';
  billing_frequency?: Maybe<BillingFrequency>;
  price?: Maybe<Scalars['Int']>;
};

export type ItemTypeSearchFilter = {
  item_type_id?: InputMaybe<Scalars['Int']>;
  show_unused?: InputMaybe<Scalars['Boolean']>;
};

export type ItemTypesResult = {
  __typename?: 'ItemTypesResult';
  items: Array<ItemType>;
  total: Scalars['Int'];
};

export type LastAccountLedgerProcessedConfig = {
  __typename?: 'LastAccountLedgerProcessedConfig';
  id: Scalars['String'];
  last_account_ledger_batch_number: Scalars['String'];
  last_account_ledger_processed_at: Scalars['String'];
  updated_at: Scalars['String'];
};

export type LastAccountLedgerProcessedConfigInput = {
  last_account_ledger_batch_number: Scalars['String'];
  last_account_ledger_processed_at: Scalars['String'];
};

export enum LegalEntity {
  VytalGlobal = 'vytal_global',
  VytalUs = 'vytal_us'
}

export type LinkType = {
  __typename?: 'LinkType';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  external_id?: Maybe<Scalars['ID']>;
  floor_plan?: Maybe<Scalars['String']>;
  geo_hash?: Maybe<Scalars['ID']>;
  geo_key?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  lonlat?: Maybe<LonLat>;
  name?: Maybe<Scalars['String']>;
  near_stores?: Maybe<Array<Maybe<Store>>>;
  store_count?: Maybe<Scalars['Int']>;
  stores?: Maybe<Array<Maybe<Store>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<LocationType>;
};

export type LocationCategories = {
  __typename?: 'LocationCategories';
  categories?: Maybe<Array<Maybe<StoreCategory>>>;
  location?: Maybe<Location>;
};

export type LocationFilter = {
  only_cities?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupedStores = {
  __typename?: 'LocationGroupedStores';
  near_stores?: Maybe<Array<Maybe<GroupedStore>>>;
  stores?: Maybe<Array<Maybe<GroupedStore>>>;
};

export type LocationHistoryEntry = {
  __typename?: 'LocationHistoryEntry';
  arrival_date: Scalars['String'];
  current_location_id: Scalars['ID'];
  current_location_name?: Maybe<Scalars['String']>;
  departure_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_id: Scalars['ID'];
  next_location_id?: Maybe<Scalars['ID']>;
  next_location_name?: Maybe<Scalars['String']>;
};

export type LocationStores = {
  __typename?: 'LocationStores';
  near_stores?: Maybe<Array<Maybe<Store>>>;
  stores?: Maybe<Array<Maybe<Store>>>;
};

export type LocationTopProducts = {
  __typename?: 'LocationTopProducts';
  location?: Maybe<Location>;
  stores?: Maybe<Array<Maybe<Store>>>;
  top_products?: Maybe<Array<Maybe<Product>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum LocationType {
  Airport = 'AIRPORT',
  City = 'CITY',
  Mall = 'MALL',
  TrainStation = 'TRAIN_STATION'
}

export type LoginViaAppLoginResponse = {
  __typename?: 'LoginViaAppLoginResponse';
  app_login_token?: Maybe<AppLoginToken>;
};

export type LonLat = {
  __typename?: 'LonLat';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type LonLatIn = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type MerchantInfo = {
  __typename?: 'MerchantInfo';
  name?: Maybe<Scalars['String']>;
  text_id: Scalars['String'];
  uuid: Scalars['String'];
};

export type MerchantOrderContainerInfo = {
  __typename?: 'MerchantOrderContainerInfo';
  amount_int: Scalars['Int'];
  container_type?: Maybe<ContainerType>;
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  status: MerchantOrderItemStatusEnum;
  type_id: Scalars['Int'];
  unit: MerchantOrderItemUnit;
};

export enum MerchantOrderErrorTypeEnum {
  CarrierError = 'CARRIER_ERROR',
  DeliveryBookingFailed = 'DELIVERY_BOOKING_FAILED',
  ItemBookedOnOtherPickingJob = 'ITEM_BOOKED_ON_OTHER_PICKING_JOB',
  PickingJobEventsNotUniform = 'PICKING_JOB_EVENTS_NOT_UNIFORM',
  PickingJobResolved = 'PICKING_JOB_RESOLVED',
  SendcloudAddressInvalid = 'SENDCLOUD_ADDRESS_INVALID',
  SendcloudBuildError = 'SENDCLOUD_BUILD_ERROR',
  SendcloudError = 'SENDCLOUD_ERROR',
  SendcloudLabelCreateError = 'SENDCLOUD_LABEL_CREATE_ERROR',
  SendcloudOrderCreateError = 'SENDCLOUD_ORDER_CREATE_ERROR',
  SendcloudParcelBuildError = 'SENDCLOUD_PARCEL_BUILD_ERROR',
  SendcloudParcelCreateError = 'SENDCLOUD_PARCEL_CREATE_ERROR',
  SendcloudReturnError = 'SENDCLOUD_RETURN_ERROR',
  StoreUserMissingError = 'STORE_USER_MISSING_ERROR',
  ZohoSalesOrderCreationFailed = 'ZOHO_SALES_ORDER_CREATION_FAILED'
}

export type MerchantOrderInfo = {
  __typename?: 'MerchantOrderInfo';
  comment?: Maybe<Scalars['String']>;
  created_by_user_id?: Maybe<Scalars['ID']>;
  created_timestamp: Scalars['String'];
  delivery_note_id: Scalars['Int'];
  dpd_status_codes?: Maybe<Scalars['String']>;
  dpd_status_history: Array<DpdStatusHistory>;
  dpd_tracking_code?: Maybe<Scalars['String']>;
  dpd_tracking_codes: Array<Scalars['String']>;
  id: Scalars['ID'];
  internal_transactions_from_store?: Maybe<Array<InternalTransactionFromStore>>;
  latest_revision?: Maybe<MerchantOrderRevisionInfo>;
  status: MerchantOrderStatusEnum;
  target_store_id?: Maybe<Scalars['ID']>;
};

export type MerchantOrderInput = {
  deliveryNoteId?: InputMaybe<Scalars['Int']>;
  delivery_note_id?: InputMaybe<Scalars['Int']>;
  dpd_tracking_code?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<MerchantOrderItemInput>>>;
  orderExecutionDate?: InputMaybe<Scalars['String']>;
  order_execution_date?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  targetStoreId?: InputMaybe<Scalars['String']>;
  target_store_id?: InputMaybe<Scalars['String']>;
};

export type MerchantOrderItemInfo = {
  __typename?: 'MerchantOrderItemInfo';
  amount_int: Scalars['Int'];
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  item_type?: Maybe<ItemType>;
  item_type_id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  status: MerchantOrderItemStatusEnum;
  unit: MerchantOrderItemUnit;
};

export type MerchantOrderItemInput = {
  amount: Scalars['Int'];
  name: Scalars['String'];
};

export type MerchantOrderItemOption = {
  __typename?: 'MerchantOrderItemOption';
  box_size?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  names_by_language?: Maybe<Scalars['String']>;
  order_key: Scalars['Int'];
  pickup_disabled?: Maybe<Scalars['Boolean']>;
  purchase_price_cents: Scalars['Int'];
  resupply_disabled?: Maybe<Scalars['Boolean']>;
  resupply_disabled_until?: Maybe<Scalars['String']>;
  resupply_options: Array<Scalars['Int']>;
  type_id: Scalars['Int'];
};

export type MerchantOrderItemOptionsFilter = {
  include_all_containers?: InputMaybe<Scalars['Boolean']>;
  merchant_order_id?: InputMaybe<Scalars['ID']>;
  order_type: MerchantOrderTypeEnum;
  store_text_id?: InputMaybe<Scalars['String']>;
};

export enum MerchantOrderItemStatusEnum {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Undefined = 'UNDEFINED'
}

export enum MerchantOrderItemUnit {
  Boxes = 'boxes',
  Pieces = 'pieces'
}

export type MerchantOrderRevisionInfo = {
  __typename?: 'MerchantOrderRevisionInfo';
  carrier_pickup_date: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  container_send_back_count: Scalars['Int'];
  containers: Array<MerchantOrderContainerInfo>;
  created_by?: Maybe<Scalars['ID']>;
  created_by_user_name?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<DeliveryAddressInfo>;
  delivery_address_id?: Maybe<Scalars['ID']>;
  /** @deprecated Use ops_comment instead */
  internal_comment?: Maybe<Scalars['String']>;
  items: Array<MerchantOrderItemInfo>;
  language?: Maybe<Scalars['String']>;
  merchant_order_id: Scalars['ID'];
  modified_timestamp: Scalars['String'];
  ops_comment?: Maybe<Scalars['String']>;
  /** @deprecated Use carrier_pickup_date instead */
  order_execution_date: Scalars['String'];
  order_execution_date_exact: Scalars['Boolean'];
  package_weights: Array<Scalars['Int']>;
  parcel_count: Scalars['Int'];
  priority: Scalars['Int'];
  region_id?: Maybe<Scalars['Int']>;
  revision_id: Scalars['Int'];
  status: MerchantOrderStatusEnum;
  type: MerchantOrderTypeEnum;
  untracked_items: Array<MerchantOrderUntrackedItemInfo>;
  /** @deprecated Field is deprecated, use package_weights instead */
  weight_class: WeightClass;
};

export type MerchantOrderSharedLink = {
  __typename?: 'MerchantOrderSharedLink';
  can_submit_or_edit: Scalars['Boolean'];
  created_at: Scalars['String'];
  created_by_id: Scalars['ID'];
  deleted_at?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  event_account?: Maybe<EventAccount>;
  event_account_id?: Maybe<Scalars['ID']>;
  event_id?: Maybe<Scalars['ID']>;
  form_last_opened_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_locations: Array<ItemLocationReduced>;
  merchant_order?: Maybe<MerchantOrderInfo>;
  merchant_order_id?: Maybe<Scalars['ID']>;
  prices?: Maybe<Array<EventPrice>>;
  sales_order_external_zoho_id?: Maybe<Scalars['String']>;
  sales_order_send_reference_id?: Maybe<Scalars['String']>;
  sales_order_url?: Maybe<Scalars['String']>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type MerchantOrderSharedLinksFilter = {
  event_account_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<MerchantOrderStatusEnum>;
};

export enum MerchantOrderStatusEnum {
  AllPrinted = 'ALL_PRINTED',
  Approved = 'APPROVED',
  ApprovedForLocalDelivery = 'APPROVED_FOR_LOCAL_DELIVERY',
  ApprovedForPackageDelivery = 'APPROVED_FOR_PACKAGE_DELIVERY',
  ApprovedForPickshareDelivery = 'APPROVED_FOR_PICKSHARE_DELIVERY',
  ApprovedSalesOrderSent = 'APPROVED_SALES_ORDER_SENT',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CreatedForReview = 'CREATED_FOR_REVIEW',
  CreatedForReviewPickshare = 'CREATED_FOR_REVIEW_PICKSHARE',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  DpdError = 'DPD_ERROR',
  Error = 'ERROR',
  ErrorRetryable = 'ERROR_RETRYABLE',
  Invalid = 'INVALID',
  InTransit = 'IN_TRANSIT',
  OnHold = 'ON_HOLD',
  OrderReceived = 'ORDER_RECEIVED',
  PendingApproval = 'PENDING_APPROVAL',
  Picked = 'PICKED',
  PickshareOrderCreated = 'PICKSHARE_ORDER_CREATED',
  PlannedOnTour = 'PLANNED_ON_TOUR',
  ReadyToSendByPartner = 'READY_TO_SEND_BY_PARTNER',
  Rejected = 'REJECTED',
  ReturnToSender = 'RETURN_TO_SENDER',
  SalesOrderSent = 'SALES_ORDER_SENT',
  SentByPartner = 'SENT_BY_PARTNER',
  SentToPicking = 'SENT_TO_PICKING'
}

export enum MerchantOrderTypeEnum {
  DpdPickup = 'DPD_PICKUP',
  DpdShopReturn = 'DPD_SHOP_RETURN',
  EventsSample = 'EVENTS_SAMPLE',
  EventAccountOrder = 'EVENT_ACCOUNT_ORDER',
  EventBufferOrder = 'EVENT_BUFFER_ORDER',
  Inventory = 'INVENTORY',
  Onboarding = 'ONBOARDING',
  OnboardingL = 'ONBOARDING_L',
  OnboardingM = 'ONBOARDING_M',
  OnboardingS = 'ONBOARDING_S',
  Pickup = 'PICKUP',
  Resupply = 'RESUPPLY',
  Sample = 'SAMPLE',
  Special = 'SPECIAL',
  Termination = 'TERMINATION',
  Undefined = 'UNDEFINED',
  WarehouseTransfer = 'WAREHOUSE_TRANSFER'
}

export type MerchantOrderUntrackedItemInfo = {
  __typename?: 'MerchantOrderUntrackedItemInfo';
  amount_int: Scalars['Int'];
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  status: MerchantOrderItemStatusEnum;
  type_id: Scalars['Int'];
  unit: MerchantOrderItemUnit;
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['ID'];
  text: Scalars['String'];
  type: MessageType;
};

export enum MessageType {
  Greeting = 'greeting',
  Test = 'test'
}

export type MinOrderTimeRuleInput = {
  day?: InputMaybe<Scalars['Int']>;
  min_order_time?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['String']>;
};

/**
 * One physical mini returner (QR scanner box, firmware 2.1+). The row is written by the
 * .NET upload endpoint on every contact; name and notes are the only operator-editable
 * fields. last_status_json is the device's last status document verbatim (uptime, link
 * details, counters, heap, supply, ...) for the detail view.
 */
export type MiniReturner = {
  __typename?: 'MiniReturner';
  clock_valid?: Maybe<Scalars['Boolean']>;
  config_json?: Maybe<Scalars['String']>;
  config_pending: Scalars['Boolean'];
  firmware_version?: Maybe<Scalars['String']>;
  /** ISO timestamps. */
  first_seen: Scalars['String'];
  hardware_id?: Maybe<Scalars['String']>;
  iccid?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** True while the device was heard from within two status intervals plus five minutes. */
  is_online: Scalars['Boolean'];
  last_boot_count: Scalars['Int'];
  /** LTE signal quality 0..31 at the last contact on LTE. */
  last_csq?: Maybe<Scalars['Int']>;
  last_ip?: Maybe<Scalars['String']>;
  /** LTE or ETH at the last contact. */
  last_link?: Maybe<Scalars['String']>;
  last_message_counter: Scalars['Int'];
  last_scan_at?: Maybe<Scalars['String']>;
  last_scan_code?: Maybe<Scalars['String']>;
  last_seen: Scalars['String'];
  last_seq: Scalars['Int'];
  last_status_at?: Maybe<Scalars['String']>;
  last_status_json?: Maybe<Scalars['String']>;
  /** ESP32 factory MAC, 12 hex digits. */
  mac?: Maybe<Scalars['String']>;
  merchant_store?: Maybe<MiniReturnerStore>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** MCC+MNC of the network the device registered on. */
  operator?: Maybe<Scalars['String']>;
  pending_commands_json?: Maybe<Scalars['String']>;
  queue_depth?: Maybe<Scalars['Int']>;
  queue_full?: Maybe<Scalars['Boolean']>;
  /** The LTE modem's IMEI, the device's serial number. */
  serial_number: Scalars['String'];
  /** Expected seconds between status documents; drives is_online. */
  status_interval_seconds: Scalars['Int'];
  total_rejected: Scalars['Int'];
  total_scans: Scalars['Int'];
  total_uploads: Scalars['Int'];
};

/** The store a mini returner was last seen uploading for (resolved from the store's return API key). */
export type MiniReturnerStore = {
  __typename?: 'MiniReturnerStore';
  city?: Maybe<Scalars['String']>;
  /** The DynamoDB text id (str_…), used by the admin store pages. */
  external_pickpack_id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  is_removed: Scalars['Boolean'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  street_address?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAgb?: Maybe<User>;
  acknowledgedMessage?: Maybe<User>;
  addCategoryToStore?: Maybe<Store>;
  addEventAccountToEventParticipants: Event;
  addEventLinkedUser: Array<EventLinkedUser>;
  addExternalEventSupervisor: Array<ExternalEventSupervisor>;
  addExtraGroup?: Maybe<NewExtraGroup>;
  addExtraToGroup?: Maybe<ExtraInGroupResponse>;
  addExtrasToGroup?: Maybe<Product>;
  addFavoriteStore?: Maybe<User>;
  addItemToBasket?: Maybe<Basket>;
  /**
   * Records a single scan against a picking job. If the job is still virtual,
   * the supplied context materializes it before the scan is recorded
   *
   * item_id is a string id of:
   *   - Container.Id (uuid)              for category = CONTAINER
   *   - TrackableItem.Id (varchar(6))    for category = ITEM
   *   - ContainerStation.Id (varchar(6)) for category = CONTAINER_STATION
   *   - MerchantOrderItemOption.TypeId (parsed as int) for category = UNTRACKED_ITEM
   *   - ContainerCollections.Id (short barcode id, like ContainerStation/TrackableItem) for category = CONTAINER_COLLECTION
   *
   * amount must be 1 for tracked categories (CONTAINER / ITEM /
   * CONTAINER_STATION / CONTAINER_COLLECTION); UNTRACKED_ITEM accepts
   * amount >= 1 to add N scans in a single call.
   *
   * When a ContainerStation with contents is scanned (CONTAINER_STATION
   * category), the scan inserts ONE row but its contribution to
   * AmountPicked is dispatched across the CONTAINER buckets matching the
   * station's current contents. An empty station counts toward its own
   * CONTAINER_STATION bucket. category=ITEM rejects station ids and
   * category=CONTAINER_STATION rejects trackable ids — no fall-through.
   *
   * When a ContainerCollection is scanned (CONTAINER_COLLECTION category),
   * the collection itself is not persisted on the job — instead, N rows are
   * inserted in one transaction, one per container in the collection's
   * ContainerIds, each behaving exactly like a direct CONTAINER scan.
   * Strict failure: if any container is already scanned, missing in the
   * Containers table, or has no matching CONTAINER bucket on the job, the
   * whole scan is rejected.
   *
   * A recalled ContainerStation / TrackableItem is rejected at scan time with
   * BOX_RECALLED (the same gate delivery enforces) — the picker is told to set
   * the item aside instead of discovering it at delivery confirmation.
   * Containers carry no recall flag, so CONTAINER / CONTAINER_COLLECTION scans
   * are unaffected.
   */
  addItemToPickingJob: PickingJob;
  /**
   * V2 of addItemToPickingJob: records exactly the same scan (same
   * materialization, same checkpoints and error codes) but returns a lean
   * PickingJobScanAck instead of the full PickingJob — cutting the response
   * build off the scan's critical path for faster scanning. The full job is
   * rebuilt by a background worker and published to onPickingJobUpdate moments
   * later; clients merge the ack's changed_items into their last full fetch
   * (by bucket id) for an instant local update and reconcile on the
   * subscription push.
   *
   * Input is EXACTLY ONE of:
   *   • code — the raw scanned QR content; the backend classifies it, replacing
   *     the separate CheckCode round-trip the V1 flow needed. Supported:
   *     container QR codes (c-prefixed / bare / https://…?q=-wrapped uuid),
   *     VYT.TO/XXXXXX (container short code), partner-container codes resolved
   *     by external id (herobox / tiffinloop / bumerang URLs, raw
   *     urn:epc:raw:96 RFID EPCs), VYT.TO/CC/XXXXXX (container collection),
   *     VYT.TO/CS/XXXXXX (container station), VYT.TO/TI/XXXXXX (trackable
   *     item). amount must be 1 (a code books one instance).
   *   • category + item_id — the explicit V1-style pair; required for
   *     UNTRACKED_ITEM (no scannable code), available as fallback everywhere.
   *
   * Errors (on top of the V1 scan error codes):
   *   INVALID_INPUT     — both or neither of code / category+item_id supplied.
   *   INVALID_SCAN_CODE — code is unrecognized, or classifies as something
   *                       that cannot be picked (user QR, operator token,
   *                       container type, self-return) or a format not
   *                       supported for picking (epc:tag: GRAI/hex RFID tags).
   *   SCANNED_ITEM_NOT_FOUND — a container short code / external id that
   *                       matches no container (also thrown by the scan itself
   *                       for missing instances, as in V1).
   */
  addItemToPickingJobV2: PickingJobScanAck;
  addNewContainerType?: Maybe<Scalars['Boolean']>;
  /**
   * Adds `amount` new offline cards to stock.
   *
   * One transaction creates everything a card is: the ASP.NET Identity user
   * carrying the signup code, the STORE_ASSET TrackableItem the picker scans,
   * and its booking into warehouse stock. Either a card exists completely or
   * not at all — there is no state for the backfill script to repair.
   *
   * `item_location_id` overrides where the cards are booked; omitted, it
   * defaults to the configured warehouse (Cologne). The assets are created
   * without a price, because offline cards are billed once through the flat
   * cards-sold charge and must not bill again per asset.
   */
  addOfflineCardsToStock: Array<OfflineCard>;
  addPartnerAccountToInvoiceCollection?: Maybe<InvoiceCollection>;
  addProductsToCategory?: Maybe<Category>;
  addStoreToInvoiceCollection?: Maybe<InvoiceCollection>;
  /** @deprecated No longer supported */
  addToBasket?: Maybe<Basket>;
  addUserToEventAccount: EventAccount;
  addUserToSharedBasket?: Maybe<Basket>;
  /** @deprecated No longer supported */
  addVariant?: Maybe<Product>;
  addVytalCredits?: Maybe<User>;
  adminUpdateUser?: Maybe<User>;
  /**
   * Performs the real booking that moves the container station to its next
   * stage (picking scan + confirm, delivery confirmation, hand out, take back,
   * receive shipment, count + clear, pack into the storage location) and
   * returns the new state. Never creates invoices or touches the event's
   * invoicing. Operations and administrators only.
   */
  advanceWashingHubStation: WashingHubStationState;
  /**
   * Validates the file again and writes every CHANGED row whose changes equal
   * its expected_changes. Each row is written on its own; a failed row does not
   * stop the others.
   */
  applyFinanceBulkImport: FinanceBulkImportResult;
  applyPromotion?: Maybe<User>;
  applyPromotionEx?: Maybe<ApplyPromotionResult>;
  archiveOrderFulfillment: Scalars['Boolean'];
  associateStoresToInvoicesByCsv?: Maybe<Scalars['Boolean']>;
  cancelOpsOrder: Scalars['Boolean'];
  cancelOrder?: Maybe<Order>;
  cancelTransaction?: Maybe<Transaction>;
  /**
   * Cancels the event's open demo buffer order (ops comment starting with
   * "[DEMO] Washing Hub", or the older "[washing-hub]") through the regular ops
   * order status change to CANCELED. Orders without the marker are never
   * touched. Refused with WASHING_HUB_ORDER_ALREADY_PICKED once the order is on
   * a confirmed picking job, WASHING_HUB_ORDER_PICKING_STARTED once a box is
   * scanned into it, and WASHING_HUB_NO_OPEN_ORDER when there is nothing to
   * cancel. Fulfillments and location history stay as they are. Operations and
   * administrators only.
   */
  cancelWashingHubBufferOrder: WashingHubBufferOrder;
  capturePayment?: Maybe<PaymentConfirmation>;
  changeItemLocation: Scalars['Boolean'];
  changeItemsLocation: Scalars['Boolean'];
  clearBasket?: Maybe<Basket>;
  clearContainerStation: ContainerStation;
  clearContainerStations: Array<ContainerStation>;
  /**
   * Creates the charge run for a finished generation run (completes invoices
   * in Billomat, sets up SEPA, emails partners — all-or-nothing, not
   * undoable). Retries a previously failed charge run instead of duplicating.
   */
  completeAndChargeInvoiceRun: InvoiceRun;
  /**
   * Mark the project COMPLETED. Idempotent; answers stay writable. Separate
   * from saveFunnelLead so the terminal action can change later.
   */
  completeFunnelProject: FunnelProject;
  confirmArrivalBell?: Maybe<Scalars['Boolean']>;
  /**
   * Finalizes a picking job. Requires every bucket on the job to have
   * AmountPicked === AmountOrdered (no under-picked, no over-picked) —
   * otherwise errors INCOMPLETE_PICKING. On success bulk-flips every linked
   * ops order's latest revision to status=PICKED in a single transaction,
   * sets PickingJobs.Status='picked', fires SendCloud + status-update
   * emails (best-effort, post-commit), and publishes pickingJobUpdate.
   *
   * The override args are optional and let ops correct the shipment at the
   * moment of confirm. All weight inputs and outputs are in *kilograms*
   * (integer) to match package_weights_kg; the column stores grams
   * internally so the conversion is value * 1000:
   *   - override_total_weight_kg / override_pallet_count: event-segment only.
   *     Persisted on PickingJobs.OverrideTotalWeightG (in grams) /
   *     OverridePalletCount. When the override differs from the calculated
   *     value a Slack notification fires to #event_ops_international.
   *   - package_weights_kg: open-system only. Saved onto the linked merchant
   *     order's latest MerchantOrderRevisions.PackageWeights row; array
   *     length = package count.
   * Passing the same fields against the wrong segment errors INVALID_INPUT.
   * Pass an explicit null to clear a previously set override; omit the arg
   * to leave the existing value alone.
   *
   * Errors:
   *   INCOMPLETE_PICKING — at least one bucket has AmountPicked != AmountOrdered.
   *   EMPTY_JOB — job has no items at all (defensive).
   *   JOB_ALREADY_PICKED — confirm has already run for this job.
   *   STATUS_TRANSITION_NOT_ALLOWED — a linked order can't transition to
   *     PICKED (typically already CANCELED / DELIVERED externally; the
   *     picker should refresh — the revision trigger will have unlinked
   *     the offender by then).
   *   INVALID_INPUT — override args supplied against the wrong segment, or
   *     a non-positive weight / negative pallet count.
   */
  confirmPickingJob: PickingJob;
  /**
   * Finalizes the delivery side of a MANUAL-carrier picking job. Idempotent —
   * a picker can submit DELIVERY_INCOMPLETE first and re-submit DELIVERED once
   * the missing items are found.
   *
   * status:
   *   - DELIVERED: requires EVERY picked item (tracked AND untracked) to be
   *     fully delivered (delivered_amount == amount); else NOT_ALL_DELIVERED.
   *     Untracked items are not auto-marked — deliver them via the mark
   *     mutation first.
   *   - DELIVERY_INCOMPLETE: accepts any partial state; comment is required
   *     (else MISSING_COMMENT).
   *
   * Both statuses flip every linked ops order to DELIVERED (per Notion: even an
   * incomplete delivery sets the order DELIVERED — stock is booked only for
   * what was actually marked delivered). On success: writes a fresh DELIVERED
   * revision per linked order, persists the comment / confirmed-at / -by on the
   * job, then (best-effort, post-commit) books the delivered inventory via the
   * Phase 5 helper, fires the CIO status email for open-system (Hawaii) jobs
   * with the comment as the carrier message (no email for events), and
   * publishes pickingJobUpdate.
   *
   * Errors carry codes from PickingJobDeliveryErrorCode: PICKING_JOB_NOT_FOUND,
   * JOB_ALREADY_DELIVERED, INCOMPLETE_PICKING_BLOCKS_CONFIRM,
   * DELIVERY_NOT_ELIGIBLE_CARRIER, DELIVERY_NOT_ELIGIBLE_EVENT_TYPE,
   * INVALID_STATUS, MISSING_COMMENT, NOT_ALL_DELIVERED,
   * STATUS_TRANSITION_NOT_ALLOWED.
   */
  confirmPickingJobDelivery: PickingJob;
  confirmSignupValidation?: Maybe<AuthResponse>;
  copyCampaign?: Maybe<Campaign>;
  copyCategories?: Maybe<Scalars['Boolean']>;
  copyExtras?: Maybe<Product>;
  copyPartnerSelfSignupConfig?: Maybe<PartnerSelfSignupConfig>;
  /**
   * Copies an existing service package into a new currency.
   * Prices are copied as-is (no FX conversion).
   * Only the latest revision per contract term is copied.
   */
  copyServicePackageToCurrency: CopyServicePackageToCurrencyResult;
  /**
   * Copies a revision to a different contract term within the same package.
   * The new revision starts at revision_number 1.
   */
  copyServicePackageToTerm: SaveServicePackageRevisionResult;
  copyVariant?: Maybe<Product>;
  countAndPack: CreateOrderFulfillmentResult;
  createAnalyticsUser: AnalyticsUser;
  createAnonUser?: Maybe<CreateAnonUserResponse>;
  createAppLoginToken?: Maybe<AppLoginToken>;
  createAppTranslation: AppTranslationEntry;
  createAuthorizedSigner: AuthorizedSigner;
  createBalanceReport?: Maybe<Scalars['Int']>;
  createBillomatArticles?: Maybe<CreateBillomatArticlesResult>;
  createBrand?: Maybe<Brand>;
  createBrandInvoiceSummary?: Maybe<Scalars['Int']>;
  createBrandMonthlySummary?: Maybe<Scalars['Boolean']>;
  createBufferOrder: Scalars['ID'];
  createCampaign?: Maybe<Campaign>;
  createCategory?: Maybe<Category>;
  createCheckouts: Scalars['Boolean'];
  createContainerQrRedirectionCampaignForContainerType?: Maybe<ContainerQrRedirectionCampaign>;
  createContainerStation: ContainerStation;
  createContainerTypeGroup: ContainerTypeGroup;
  createCustomerCateringUser: Scalars['String'];
  createDeliveryAddress?: Maybe<DeliveryAddress>;
  createDeliveryOrderFulfillment: CreateOrderFulfillmentResult;
  createEvent: Event;
  createEventAccount: EventAccount;
  createEventDeliveryAddress: EventDeliveryAddress;
  createEventInvoices: Scalars['Boolean'];
  createExternalAuthClientConfig?: Maybe<ExternalAuthClient>;
  /**
   * Start a new funnel project; the shop appends the id to the URL as
   * project=. visitor_id is the shop's visitor cookie; the visitor row is
   * created on first sight.
   */
  createFunnelProject: FunnelProject;
  createInvoiceCollection?: Maybe<InvoiceCollection>;
  createItemLocation: ItemLocation;
  createItemType: ItemType;
  createManyAuthorizedSigners: Scalars['Int'];
  createManyContainerStations: Array<ContainerStation>;
  createManyTrackableItems: Array<TrackableItem>;
  createMerchantOrderSharedLink: MerchantOrderSharedLink;
  createNewApiToken?: Maybe<ApiToken>;
  createNewsContent?: Maybe<NewsContentCreationResult>;
  createOrUpdateStoreRegionsSF?: Maybe<Scalars['Boolean']>;
  createOrder?: Maybe<Order>;
  createOrderFromBasket?: Maybe<Order>;
  createOrderFromBasketSca?: Maybe<OrderCreatedResult>;
  createOrderSca?: Maybe<OrderCreatedResult>;
  createPartnerSelfSignupConfig?: Maybe<PartnerSelfSignupConfig>;
  createPickingOrderFulfillment: CreateOrderFulfillmentResult;
  createProduct?: Maybe<Product>;
  createProductStore?: Maybe<ProductStore>;
  createRaffleCampaign?: Maybe<RaffleCampaign>;
  createRaffleCycle?: Maybe<RaffleCycle>;
  /**
   * Creates a replacement Sendcloud shipment for an outbound order the carrier
   * returned to sender, and moves it RETURN_TO_SENDER → PICKED. This is the only
   * way out of RETURN_TO_SENDER: the ordinary status dropdown offers nothing.
   *
   * Requires the order to be outbound, on a Sendcloud carrier, currently
   * RETURN_TO_SENDER, with a returned shipment attempt whose stock has not been
   * booked. Correct the delivery address with updateOpsOrder BEFORE calling this
   * — the replacement is announced with whatever address the order carries now.
   *
   * Only the parcels that actually came back are replaced. A parcel counts as
   * returned once its round trip has closed at the warehouse — a "Returned to
   * sender" scan in its history and a "Delivered" as its newest scan. Those
   * parcels stay on the previous attempt, which is marked SUPERSEDED (their
   * parcel ids, tracking numbers and status history are kept for the audit
   * trail); every other parcel of the set — in transit, or already with the
   * recipient — is carried onto the new attempt and keeps its tracking. Only the
   * returned packages are announced and labelled again, under the new attempt's
   * own Sendcloud order numbers.
   *
   * The order reaches RETURN_TO_SENDER on the carrier's FIRST return scan, which
   * is well before the parcel is physically back, so a call in that window is
   * refused with INVALID_INPUT: there is nothing a label could be stuck on yet.
   * Retry once the parcel is delivered back. An order with one parcel back and
   * another still coming is therefore replaced in two rounds.
   *
   * The labels this call buys are also mailed to the warehouse that holds the
   * returned parcels, since that is who has to print them. Use
   * downloadParcelLabel to reprint any single parcel's label afterwards;
   * OpsOrderCarrierStatus.is_replacement marks the parcels a replacement bought.
   *
   * Idempotent: a retry after a timeout returns the replacement that was already
   * created instead of buying a second parcel set — created is false then, and
   * the order is moved to PICKED if the first call did not get that far.
   *
   * If Sendcloud rejects the new shipment before any parcel exists, the attempt
   * it had opened is rolled back: the order is left RETURN_TO_SENDER on its
   * returned attempt and a retry reuses the same attempt number. Once a parcel
   * has been created the attempt is kept even on error — a billable parcel must
   * stay visible — and the error says so. The status is restored along with the
   * attempt: the Sendcloud batch calls mark a failing order ERROR themselves, and
   * leaving it there would take away the retry this promises.
   *
   * An ERROR whose current attempt is a replacement Sendcloud accepted but never
   * labelled is therefore also accepted, and moved back to RETURN_TO_SENDER
   * before anything is announced. It is the one state a failed replacement can be
   * left in if the process dies before the status is restored, and nothing else
   * can move it: that attempt has no parcel for the delivery poller to read.
   *
   * So is an ERROR whose attempt is recorded as returned. A carrier scan can
   * displace the status after the return — Sendcloud's return flow emits "Return
   * payment failed" on the way back — and the attempt state is what says the
   * shipment came back; the order is moved to RETURN_TO_SENDER first, exactly as
   * above.
   *
   * Errors: INVALID_INPUT (wrong status, carrier, direction, nothing announced to
   * replace, no parcel whose return has completed yet, or the stock is already
   * resolved), NOT_FOUND (no such order), SENDCLOUD_ERROR (Sendcloud rejected the
   * announce or the label).
   */
  createReplacementSendCloudShipment: ReplacementShipmentResult;
  createReturnOrderFulfillment: CreateOrderFulfillmentResult;
  createReturnOrderFulfillmentShortIds: CreateOrderFulfillmentResult;
  createReturnOrderFulfillmentV2: CreateOrderFulfillmentResult;
  createReturnOrderFulfillmentV3: CreateReturnOrderFulfillmentV3Result;
  createScanTunnel: ScanTunnel;
  /**
   * Creates `amount` self-return QR codes, mints one STORE_ASSET TrackableItem
   * per code and books all of them into stock — everything in one transaction,
   * so a code never exists without its trackable.
   *
   * `item_location_id` overrides where the new stickers are booked; omitted, it
   * defaults to the configured warehouse (Cologne). The assets are deliberately
   * created without a price, so they never appear on a store invoice.
   */
  createSelfReturnCodes: Array<SelfReturnCode>;
  createStore?: Maybe<Store>;
  createStoreAsset: StoreAssetV2;
  createStoreInvoiceSummary?: Maybe<Scalars['Int']>;
  createTestOrderTerminal?: Maybe<Order>;
  createTrackableItem: TrackableItem;
  createUserWithRole?: Maybe<CreatedUserResponse>;
  createVendingMachine?: Maybe<VendingMachine>;
  createVytalCharge?: Maybe<VytalCharge>;
  createZohoQuoteForDeal: CreateZohoQuoteResult;
  deactivateAnalyticsUser: AnalyticsUser;
  deleteAuthorizedSigner: Scalars['String'];
  deleteBasket?: Maybe<Basket>;
  deleteContainerTypeGroup: Scalars['Boolean'];
  deleteDeliveryToken?: Maybe<Scalars['Boolean']>;
  deleteEvent: Scalars['ID'];
  deleteEventAccount: Scalars['ID'];
  deleteEventDeliveryAddress: Scalars['ID'];
  deleteItemLocation: Scalars['ID'];
  deleteMerchantOrderSharedLink: Scalars['Boolean'];
  deleteOrderFulfillmentPictures: Scalars['Boolean'];
  deletePartnerSelfSignupConfig?: Maybe<Scalars['Boolean']>;
  deleteScanTunnel: Scalars['ID'];
  deleteSource?: Maybe<User>;
  /** @deprecated Use removeStoreAsset instead. */
  deleteStoreAsset: Scalars['Boolean'];
  /** @deprecated No longer supported */
  deleteVariant?: Maybe<Product>;
  disableSharedBasket?: Maybe<Basket>;
  /**
   * Downloads the label of ONE SendCloud parcel and returns a signed PDF URL.
   *
   * refetchOrderDocuments is per order and merges every label of the order's
   * current shipment attempt, which is the wrong unit after a partial replacement: the warehouse needs
   * the label of the parcel that was actually replaced, not a sheet that also
   * reprints the ones already in the post. Parcel ids come from
   * OpsOrderCarrierStatus.parcel_id.
   *
   * Downloads only — it never creates a parcel, so it cannot make a shipment
   * more expensive, and it works in any order status.
   */
  downloadParcelLabel: DownloadParcelLabelResult;
  enableBrand?: Maybe<Scalars['Boolean']>;
  enableSharedBasket?: Maybe<Basket>;
  enableStore?: Maybe<Scalars['Boolean']>;
  enqueueMerchantOrderUpdate?: Maybe<Scalars['Boolean']>;
  /**
   * Returns the event's open washing hub buffer order, creating one first when
   * there is none: createBufferOrder + updateOpsOrder (containers, marker
   * comment, a pickup day whose picking job no other order uses) + approve +
   * sendOpsOrderToPicking. Serialised per event with a Postgres advisory lock,
   * so concurrent callers get the same order. Operations and administrators only.
   */
  ensureWashingHubBufferOrder: WashingHubBufferOrder;
  exportOpsOrder: Scalars['String'];
  extendContainerDeadline?: Maybe<ExtendContainerResult>;
  extendContainerDeadlineSca?: Maybe<ExtendContainerResultSca>;
  generateInvoice?: Maybe<GenerateInvoiceResponse>;
  generateInvoiceForInvoiceCollection?: Maybe<GenerateInvoiceResponse>;
  generateNewPOSCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  generateNewRndCampaigns?: Maybe<Scalars['String']>;
  getAppleUserQrCodePass?: Maybe<ApplePassResult>;
  getDeliveryToken?: Maybe<DeliveryToken>;
  getGoogleUserQrCodePass?: Maybe<Scalars['String']>;
  getInvoicePdf?: Maybe<InvoicePdfResponse>;
  getLatestContainerCacheLink: Scalars['String'];
  getLatestEPCContainerCacheLink: Scalars['String'];
  getPaymentIntent?: Maybe<PaymentIntent>;
  getPaymentTerminalConnectionToken?: Maybe<Scalars['String']>;
  getReportResultLink?: Maybe<Scalars['String']>;
  getStripeTerminalLocation?: Maybe<StripeTerminalLocation>;
  /** @deprecated The payment intent is created in the frontend by the Stripe SDK instead */
  getTapToBorrowPaymentIntent?: Maybe<PaymentIntent>;
  getTapToBorrowUser?: Maybe<Scalars['String']>;
  /**
   * Adds cards printed elsewhere to stock: the supplier brings the id and the
   * signup code, and everything after that is identical to the mutation above —
   * identity, trackable and booking in one transaction — so an imported card is
   * pickable exactly like a generated one.
   *
   * Replaces the admin frontend's CSV upload straight to vytal, which created the
   * identity and nothing else. All-or-nothing: a signup code already in use fails
   * the whole batch rather than importing part of it.
   *
   * `item_location_id` behaves as it does above.
   */
  importOfflineCardsToStock: Array<OfflineCard>;
  ingestCategory?: Maybe<Category>;
  ingestProduct?: Maybe<Product>;
  ingestProductStore?: Maybe<ProductStore>;
  invalidateApiToken?: Maybe<ApiToken>;
  linkAccounts?: Maybe<Scalars['Boolean']>;
  linkAccountsForUser?: Maybe<Scalars['Boolean']>;
  linkCustomerCateringUserToStore: Scalars['Boolean'];
  linkExternalEventSupervisor: Array<ExternalEventSupervisor>;
  linkItemLocationToDeliveryAddress: EventDeliveryAddress;
  linkItemLocationToEvent: ItemLocation;
  linkItemLocationToEventAccount: ItemLocation;
  linkOrderFulfillmentPictures: Scalars['Int'];
  linkOrderFulfillmentPicturesToItemLocationHistoryEntry: Scalars['Int'];
  linkUserToContainerStation: Scalars['Boolean'];
  linkUserToEvent: Array<EventLinkedUser>;
  loginViaAppLogin?: Maybe<LoginViaAppLoginResponse>;
  manualStoreInvoiceCharge?: Maybe<StoreInvoiceChargeResult>;
  markBrokenAtUserContainersAsBroken: Scalars['Boolean'];
  /**
   * Marks one picked instance (or N untracked pieces) as delivered on a
   * MANUAL-carrier picking job. Input shape mirrors addItemToPickingJob.
   *
   * category whitelist (delivery side is narrower than picking):
   *   - CONTAINER_STATION / ITEM (tracked): amount must be 1; flips the
   *     resolved picked-item row to delivered (DeliveredAmount = 1).
   *   - UNTRACKED_ITEM: amount >= 1; distributes the amount across the bucket's
   *     picked rows newest-first via DeliveredAmount increments (partial
   *     delivery supported). Over-delivering errors INVALID_AMOUNT.
   *   - CONTAINER is rejected (delivered implicitly via its station) and
   *     CONTAINER_COLLECTION is rejected (per Notion checkpoint).
   *
   * The first successful mark against a PICKED job atomically flips its status
   * to DELIVERY_IN_PROGRESS. Publishes pickingJobUpdate. Errors carry codes
   * from PickingJobDeliveryErrorCode (PICKING_JOB_NOT_FOUND,
   * JOB_ALREADY_DELIVERED, DELIVERY_NOT_ELIGIBLE_CARRIER,
   * DELIVERY_NOT_ELIGIBLE_EVENT_TYPE, CONTAINER_NOT_ALLOWED,
   * COLLECTION_CODE_NOT_ALLOWED, INCOMPLETE_PICKING_BLOCKS_CONFIRM,
   * INVALID_AMOUNT, SCANNED_ITEM_NOT_FOUND, ITEM_NOT_IN_PICKING_JOB,
   * ITEM_ALREADY_DELIVERED).
   */
  markPickingJobItemAsDelivered: PickingJob;
  /**
   * Reverses markPickingJobItemAsDelivered. Same id space and category
   * whitelist (CONTAINER_STATION / ITEM / UNTRACKED_ITEM). Decrements
   * DeliveredAmount and clears DeliveredAt/DeliveredById when a row drops below
   * its amount. The job status does NOT auto-revert from DELIVERY_IN_PROGRESS
   * — that is an explicit ops action, not implied by item state. Errors with
   * ITEM_NOT_DELIVERED when nothing on the target is delivered, INVALID_AMOUNT
   * when removing more than is delivered, plus the same not-found / whitelist /
   * eligibility / terminal-state codes as the mark direction.
   */
  markPickingJobItemAsNotDelivered: PickingJob;
  mergeAnonUser?: Maybe<User>;
  notifyContainerCheckin?: Maybe<ContainerCheckin>;
  notifyContainerCheckout?: Maybe<ContainerCheckout>;
  notifyMerchantOrderUpdate?: Maybe<Scalars['String']>;
  orderItemsToStoreBasket?: Maybe<Basket>;
  outOfStock?: Maybe<ProductStore>;
  outOfStock2?: Maybe<Product>;
  packContainerStation: ContainerStation;
  packContainerStationAfterUncountedReturn: Scalars['Int'];
  packContainerStationV2: ContainerStation;
  /**
   * Packs the given containers into a container station by handing the transfer to
   * the vytal backend bulk-transfer endpoint, so its post-processing runs.
   * Access: admins, or any user linked to a store that has the container-station
   * packing feature enabled (the container station's own store is not considered).
   */
  packContainerStationWithContainers: Scalars['Boolean'];
  packContainerStations: Scalars['Boolean'];
  packContainerStationsV2: Scalars['Boolean'];
  partialRefundOverduePenaltyBill?: Maybe<OverduePenaltyBillRefundResult>;
  participateInRaffle?: Maybe<ParticipateInRaffleResponse>;
  participateInRaffleMock?: Maybe<ParticipateInRaffleResponse>;
  paypalAuthorizePayment?: Maybe<PaypalPaymentInfo>;
  paypalCapturePayment?: Maybe<PaypalPaymentInfo>;
  paypalExecutePayment?: Maybe<PaypalPaymentInfo>;
  paypalRefundPayment?: Maybe<PaypalPaymentInfo>;
  placeSharedOrder?: Maybe<Order>;
  processAccountLedgers: ProcessAccountLedgersResult;
  reactivateAnalyticsUser: AnalyticsUser;
  readyOrderItem?: Maybe<Order>;
  recallTrackableItem: TrackableItem;
  receiveShipment: Scalars['Boolean'];
  receiveShipmentV2: CreateOrderFulfillmentResult;
  /**
   * Admin-only. Re-fetches (regenerating on the fly when missing) the delivery
   * note(s) for the given ops orders and returns a single merged delivery-note
   * PDF URL. Unlike refetchOrderDocuments this fetches ONLY the delivery note -
   * no shipping label - so an order without a downloadable label does not set
   * has_errors. Works for orders in ANY status, including CANCELED. Intended as an
   * administrator escape hatch to always reach an order's delivery note (e.g.
   * after the order was cancelled). Does not change order status.
   */
  refetchDeliveryNote: RefetchDeliveryNoteResult;
  /**
   * Re-fetches both order documents - the shipping label(s) and the delivery
   * note(s) - for the given ops orders in one call. Never throws for an order's
   * status.
   *
   * Labels (non-MANUAL/OTHERS orders only), per order status:
   * - PICKED, IN_TRANSIT, DELIVERED, RETURN_TO_SENDER: the labels of the parcels
   *   of the current shipment attempt are downloaded. The labels of parcels a
   *   replacement superseded are not included.
   * - PICKED without any parcel on its current attempt: the SendCloud order (when
   *   missing), the parcels and the labels are CREATED, as the picking
   *   confirmation would have done. An order whose attempts were all superseded
   *   is not re-announced.
   * - After PICKED, a missing parcel is never created, so a shipped order cannot
   *   get a second, paid shipment.
   * Any other order gets no label and sets has_errors.
   *
   * Each delivery note is fetched from its picking job, regenerating it on the
   * fly when the print pipeline never produced one (PickingJobs.DeliveryNoteS3Key
   * missing). A missing label never withholds the delivery note.
   *
   * Returns a merged label PDF URL and a merged delivery-note PDF URL; either is
   * empty when nothing was produced for it. Failures of either document surface
   * via has_errors. Does not change order status.
   */
  refetchOrderDocuments: RefetchOrderDocumentsResult;
  refreshAccessToken?: Maybe<RefreshAccessTokenResponse>;
  refreshHeartbeat?: Maybe<Store>;
  /**
   * Queues a rebuild of one collection's draft of a finished generation run
   * and wakes the worker. Refused once the run's charge run has started, and
   * by the worker when the Billomat invoice is no longer a draft. Without a
   * draft for the period a new one is created. Returns the open request when
   * one already exists for the collection.
   */
  regenerateCollectionDraft: InvoiceCollectionDraftRegeneration;
  registerForT2bReturnReminders?: Maybe<Scalars['Boolean']>;
  registerSource?: Maybe<User>;
  registerSourceForStore?: Maybe<Store>;
  registerSourceIntent?: Maybe<RegisterSourceIntent>;
  removeAllProductFromBasket?: Maybe<Basket>;
  removeAppTranslation: Scalars['Boolean'];
  removeBrand?: Maybe<Scalars['Boolean']>;
  removeCategory?: Maybe<Scalars['Boolean']>;
  removeCategoryFromStore?: Maybe<Store>;
  /**
   * Removes the committed transaction volume for a store.
   * The store will be billed at full price again.
   */
  removeCommittedTransactionVolume: Scalars['Boolean'];
  removeContainerQrRedirectionCampaign?: Maybe<ContainerQrRedirectionCampaign>;
  removeDeliveryAddress?: Maybe<Array<Maybe<DeliveryAddress>>>;
  removeEventAccountFromEventParticipants: Event;
  removeExtraFromGroup?: Maybe<Product>;
  removeExtraGroupFromProduct?: Maybe<Product>;
  removeFavoriteStore?: Maybe<User>;
  removeFromBasket?: Maybe<Basket>;
  /**
   * Reverses a scan. Tracked categories find the scan by instance id and
   * delete it. UNTRACKED_ITEM walks that bucket's PickedItem rows newest-first,
   * decrementing-or-deleting until the requested amount has been removed.
   * CONTAINER_COLLECTION is symmetric with the add path: looks up the
   * collection's ContainerIds and removes all matching rows in one call;
   * if any of the collection's containers isn't currently scanned on the
   * job, the whole removal fails with NOT_FOUND (picker falls back to
   * per-container removal).
   *
   * CONTAINER_STATION removes the box together with its contents: on an
   * open-system job the box row and the picked rows of every container
   * currently in the box go in one call.
   *
   * A single CONTAINER that currently sits in a container station scanned on
   * this job cannot be removed on its own — it errors
   * CONTAINER_PART_OF_STATION and the picker has to remove the box instead.
   */
  removeItemFromPickingJob: PickingJob;
  removeOrderFulfillmentContainerStationManualAmount: OrderFulfillment;
  removePartnerAccountFromInvoiceCollection?: Maybe<InvoiceCollection>;
  removeProduct?: Maybe<Scalars['Boolean']>;
  removeProductFromCategory?: Maybe<Scalars['Boolean']>;
  removeProductStore?: Maybe<ProductStore>;
  removeProductStore2?: Maybe<Scalars['Boolean']>;
  removeScannedItemsFromSession: ScanTunnelSession;
  removeStore?: Maybe<Scalars['Boolean']>;
  removeStoreAsset: Scalars['Boolean'];
  removeStoreFromInvoiceCollection?: Maybe<InvoiceCollection>;
  removeUser?: Maybe<Scalars['Boolean']>;
  removeUserFromSharedBasket?: Maybe<Basket>;
  reportPowerCableStatusChange?: Maybe<Store>;
  reportProblem?: Maybe<Scalars['Boolean']>;
  requestContainerStationPictureUploadUrl: RequestOrderFulfillmentPictureUploadUrlResult;
  requestInventoryCheck?: Maybe<Scalars['Boolean']>;
  requestOrderFulfillmentPictureUploadUrl: RequestOrderFulfillmentPictureUploadUrlResult;
  requestPaymentToken?: Maybe<OneTimeToken>;
  requestUploadUrl?: Maybe<Scalars['String']>;
  /**
   * Drops the demo world and seeds it again by running docker/seed-demo — the
   * very entry point the containerised stack runs — so a preview goes back to
   * the state it was created in. Everything in the vytalprod schema is
   * TRUNCATEd first (the EF migration ledger excepted).
   *
   * Refused outright unless the target is a throwaway database: the host in
   * DATABASE_URL and CATALOG_DATABASE_URL must be localhost or 127.0.0.1, the
   * database must be the demo one, and the stage must not be prod. The host
   * allowlist is hardcoded, so no environment can opt into wiping a shared
   * database. Local and preview stacks only.
   */
  reseedDemoDatabase: ReseedDemoDatabaseResult;
  resendValidationEmail?: Maybe<Scalars['Boolean']>;
  resetAnalyticsUserPassword: AnalyticsUser;
  resolveInvoiceRunError: InvoiceRunError;
  /**
   * Decides where the picked stock of a stuck picking job went — the one way
   * out of a job that the picking and delivery flows can no longer finish.
   * Job-level, because one job bundles several orders and owns one set of
   * picked stock, which cannot be split between destinations.
   *
   * WAREHOUSE undoes the whole job:
   *   - Every picked item the warehouse or the partner of an order the job
   *     owns holds comes back to the warehouse (the warehouse of those orders),
   *     recorded NON-billable (a correction of our own is not a movement to
   *     invoice). Anything another store holds now, or with no open location
   *     (or a container on loan), stays where it is and is named, with the
   *     reason, in Slack.
   *   - Every order the job owns that is not CANCELED ends CANCELED, DELIVERED
   *     and in-transit orders included. Where the status machine has no direct
   *     hop to CANCELED (PICKED, IN_TRANSIT, DELIVERED) the order goes through
   *     ERROR first. Every revision carries error_type PICKING_JOB_RESOLVED and
   *     the reason in error_message.
   *   - The shipment attempt of every owned order is superseded: the poller
   *     and the carrier webhook stop acting on its parcels, and a re-pick gets
   *     a fresh attempt.
   *   - The job ends RELEASED.
   *   Allowed from PICKING_IN_PROGRESS, PICKED, DELIVERY_IN_PROGRESS and
   *   DELIVERY_INCOMPLETE for OPEN_SYSTEM; for EVENT only from
   *   PICKING_IN_PROGRESS with no picked row booked or delivered
   *   (has_booked_or_delivered_rows), because past picking-confirm an event
   *   job's stock is inside a billable fulfillment with no reversal path.
   *   Refused with INVALID_STATUS when every order the job owns is DELIVERED:
   *   its stock is with the partner.
   *
   * PARTNER records a delivery nobody could confirm:
   *   - An OPEN_SYSTEM job's picked stock that the warehouse holds is booked
   *     to the partner of the orders it owns; STOCK_NOT_BOOKABLE when those
   *     orders do not resolve to one warehouse and one partner with the stock
   *     user and item location the stock needs. What the partner holds already
   *     counts as booked (no second hand-over); anything another store holds,
   *     on a loan or with no open location stays where it is and is named, with
   *     the reason, in Slack. An EVENT job books nothing, so its stock has to
   *     be with the event already (EVENT_STOCK_NOT_BOOKED otherwise).
   *   - Every picked row is marked delivered; every owned order at PICKED,
   *     IN_TRANSIT, ERROR or RETURN_TO_SENDER becomes DELIVERED (DELIVERED and
   *     CANCELED orders are left as they are, any other status refuses the
   *     job); every owned order's open shipment attempt is settled as booked.
   *   - The job ends DELIVERED with delivery_confirmed_at / _by set.
   *   Refused with INCOMPLETE_PICKING_BLOCKS_CONFIRM while the job is still
   *   PICKING_IN_PROGRESS, and with STATUS_TRANSITION_NOT_ALLOWED when the job
   *   owns no order or every order it owns is CANCELED.
   *
   * Both destinations act only on the orders the job owns
   * (PickingJobOpsOrder.owned_by_job); an order now on a newer job is that
   * job's. Order statuses are judged as migrated, so a legacy raw status counts
   * as the status it stands for. Every order is checked before anything moves:
   * one that cannot reach the destination refuses the whole job with
   * STATUS_TRANSITION_NOT_ALLOWED, naming it.
   *
   * One transaction under the job's advisory lock: the gates, the stock, the
   * order revisions, the attempts and the job's status and resolution commit
   * together or not at all, and a refusal writes nothing. The resolution is
   * recorded as PickingJob.resolution (destination, time, actor, reason) and
   * announced in Slack. A second call is refused with JOB_ALREADY_RESOLVED.
   *
   * reason is required (trimmed, at most 1,000 characters; a reason of only
   * whitespace or invisible characters counts as blank, and control
   * characters other than tabs and line breaks are refused).
   *
   * Errors: FORBIDDEN, PICKING_JOB_NOT_FOUND, INVALID_INPUT (the reason: blank,
   * too long or with a control character), JOB_ALREADY_RESOLVED, JOB_ALREADY_DELIVERED, INVALID_STATUS,
   * INCOMPLETE_PICKING_BLOCKS_CONFIRM, EVENT_STOCK_NOT_BOOKED,
   * STATUS_TRANSITION_NOT_ALLOWED, LABEL_RETRY_IN_PROGRESS, STOCK_NOT_BOOKABLE.
   */
  resolvePickingJob: PickingJob;
  restock?: Maybe<ProductStore>;
  restock2?: Maybe<Product>;
  /**
   * Flips a failed run back to pending and wakes the worker. Safe: the
   * generator skips already-created invoices on resume.
   */
  retryInvoiceRun: InvoiceRun;
  /**
   * Retries the Sendcloud label of ONE order in ERROR_RETRYABLE now, instead of
   * waiting for the next 15-minute RETRY_SENDCLOUD_LABELS run. Makes the same
   * single attempt a cron run makes: on success the order returns to PICKED and
   * the withheld status and warehouse emails are sent; on a transient failure it
   * stays ERROR_RETRYABLE and the cron keeps retrying; on a permanent failure it
   * moves to ERROR.
   *
   * Does not change the 24h retry window: a failed manual retry leaves the
   * moment of escalation to ERROR where it was.
   *
   * A retry of the same order that is already running (the cron's or another
   * manual one) is never duplicated: the call returns IN_PROGRESS and does
   * nothing, because two concurrent attempts could buy the same parcel twice.
   *
   * Errors: INVALID_INPUT (the order is not ERROR_RETRYABLE, or Sendcloud is not
   * connected in this environment), NOT_FOUND (no such order).
   */
  retrySendCloudLabel: RetrySendCloudLabelResult;
  /**
   * Reverses a "tap to borrow & pay" transaction (STRIPE_PAYMENT_INTENT_AND_PAY or
   * STRIPE_PAYMENT_INTENT_AND_PAY_SAVED_CARD) after the POS cashier system asked the
   * terminal to reverse it. Refunds or cancels the PaymentIntent on the Stripe account
   * of the store's country, books the containers that are still at the tap-to-borrow
   * user back to the terminal's store (transaction type TAP_TO_BORROW_REVERSAL) and marks
   * the original checkout as not billable for the store.
   *
   * Only the terminal user of the store the containers were checked out from may call
   * it. When no containers are linked to the transaction (the container booking never
   * went through), any terminal user may call it and only the payment is refunded or
   * canceled. That includes payment intents vytal has never seen (the terminal processed
   * the payment on Stripe, but the transaction was never booked): they are looked up on
   * the Stripe account of the calling terminal user's store country and must carry
   * metadata.type STRIPE_PAYMENT_INTENT_AND_PAY or STRIPE_PAYMENT_INTENT_AND_PAY_SAVED_CARD.
   * Idempotent: a retry skips the payment step
   * when the payment was already refunded or canceled and books back only the containers
   * still outstanding.
   *
   * Errors: TAP_TO_BORROW_TRANSACTION_NOT_FOUND (payment intent unknown to vytal and
   * not found on the store country's Stripe account),
   * TAP_TO_BORROW_REVERSAL_UNSUPPORTED_FLOW (not an "& pay" transaction),
   * TAP_TO_BORROW_REVERSAL_WRONG_STORE (containers were not checked out by this store).
   */
  reverseTapToBorrowPayment: TapToBorrowPaymentReversal;
  ringArrivalBell?: Maybe<Scalars['Boolean']>;
  saveContainerPricingAdmin: AdminContainerPricing;
  /**
   * Upsert one answer of the project's current pass: same
   * (funnel_project_id, iteration, step) replaces the value. iteration must
   * be the project's highest existing iteration or the one right after it —
   * the shop opens the next pass the moment the visitor walks back to an
   * earlier step and seeds it with every current answer. Anything lower is
   * immutable history and rejected.
   */
  saveFunnelAnswer: FunnelAnswer;
  /**
   * Record the contact left at the close. One row per call, never an
   * overwrite. Format is the shop's job; colugo only caps the length.
   */
  saveFunnelLead: FunnelLead;
  saveRemoveProduct?: Maybe<Scalars['Boolean']>;
  /**
   * Writes a new revision for a given (package, term) pair.
   * If store_uuid is provided, the new revision overwrites the store's current
   * revision (revision_number = current + 1) and re-links the store.
   */
  saveServicePackageRevision: SaveServicePackageRevisionResult;
  saveTrackingNumbersAndMarkAsPicked: OpsOrderDetail;
  seedDevContainerCollection: SeedDevContainerCollectionResult;
  seedDevContainerStation: SeedDevContainerStationResult;
  seedDevContainers: SeedDevContainersResult;
  seedDevEventOrders: SeedDevEventOrdersResult;
  /**
   * Promotes the order(s) linked to a picked picking job to DELIVERED via the
   * normal status path (PICKED → IN_TRANSIT → DELIVERED), simulating the carrier
   * flow. Pass the picking_job_id returned by a seedDevPicked* mutation.
   * Throws NOT_APPLICABLE_FOR_MANUAL_CARRIER if any linked order is MANUAL —
   * those must be delivered via the delivery-confirmation flow instead.
   * Fails (all-or-nothing) unless every linked order is currently PICKED.
   * Dev/staging only.
   */
  seedDevMarkOrderDelivered: SeedDevMarkOrderDeliveredResult;
  seedDevMinimalEventOrders: SeedDevMinimalEventOrdersResult;
  /**
   * Gives an order a carrier parcel status history without SendCloud. Seeds
   * parcels (ids + tracking numbers) onto the order's active shipment attempt,
   * then replays the chosen sequence through the very machinery the SendCloud
   * webhook uses — so the order transitions, the RETURN_TO_SENDER handling, the
   * attempt state and the carrier-status rows come out exactly as they would in
   * production, with no external call and no webhook.
   *
   * SendCloud has no non-production environment, so in a simulated environment a
   * parcel is announced by the simulator and no carrier ever scans it. This is
   * how you drive one: it is the way to get an order to RETURN_TO_SENDER, the
   * status createReplacementSendCloudShipment is built around, and — with
   * new_shipment_attempt — a way to reach a second attempt without one.
   *
   * Pass merchant_order_id to apply a sequence to an existing order, or store_id
   * to get a fresh PICKED order to hang it on. Pick a preset with scenario (see
   * devParcelStatusCatalog) or spell the sequence out in statuses.
   *
   * A status the order's current state disallows is reported in
   * applied[].error and the replay carries on, matching how separate webhooks
   * would behave. Dev/staging only.
   */
  seedDevParcelStatusHistory: SeedDevParcelStatusHistoryResult;
  /**
   * Seeds an EVENT picking job already in the picked state: a filled container
   * station holding a manual container count (one packing unit of the container
   * type), 1 ASSET trackable, and 1 empty container station — all fully picked.
   * Items live in the default event warehouse. Dev/staging only.
   */
  seedDevPickedEventPickingJob: SeedDevPickedEventPickingJobResult;
  /**
   * Seeds an OPEN_SYSTEM, MANUAL-carrier picking job already in the picked
   * state, with 3 containers booked into a container station, 1 store asset and
   * 1 untracked item (qty 5) all fully picked. Items live in the given store's
   * stock. untracked_item_option_id defaults to an existing MerchantOrderItemOptions
   * (TypeId < 0). Dev/staging only.
   */
  seedDevPickedOpenSystemPickingJob: SeedDevPickedOpenSystemPickingJobResult;
  seedDevTrackableItems: SeedDevTrackableItemsResult;
  selectRaffleWinners: Array<RaffleWinner>;
  selectRaffleWinnersOnSchedule: Scalars['Boolean'];
  sendCioEventForStore?: Maybe<Scalars['Boolean']>;
  sendEventMerchantOrderFormLinks: SendEventMerchantOrderFormLinksResult;
  sendMessage: Message;
  sendOpsOrderToPicking: SendToPickingResult;
  sendOrderFulfillmentUpdateEmail: Scalars['Boolean'];
  sendOrderReceipt?: Maybe<Scalars['Boolean']>;
  sendPartnerEvent?: Maybe<Scalars['Boolean']>;
  /**
   * Sends the picking job's delivery documents to the warehouse printer by
   * creating print jobs: shipping LABELs (when the job has merged SendCloud
   * labels) and the DELIVERY_NOTE (generated on demand when not yet cached).
   * The created jobs are published on the print-job subscriptions and picked
   * up by the warehouse print desktop. Resolves true once the jobs are
   * enqueued.
   */
  sendPickingJobToPrinter: Scalars['Boolean'];
  setAppMetadata?: Maybe<User>;
  /**
   * Replace the visitor's bookmarks with this list (the browser's favorites).
   * Unknown product ids are dropped, not an error. Returns the ids stored.
   */
  setBookmarks: Array<Scalars['UUID']>;
  /** Sets or updates the committed transaction volume for a store. */
  setCommittedTransactionVolume: CommittedTransactionVolume;
  setDefaultCarrierByCountryConfig: Array<DefaultCarrierByCountryEntry>;
  setDefaultSource?: Maybe<User>;
  setDefaultSourceForStore?: Maybe<Store>;
  setInvoiceAsPaid?: Maybe<Scalars['Boolean']>;
  setItemTypePrice: Scalars['Boolean'];
  setLastAccountLedgerProcessedConfig: LastAccountLedgerProcessedConfig;
  setLastInventoryCheckDate?: Maybe<Scalars['Boolean']>;
  setOrderWarehouseConfig: OrderWarehouseConfig;
  /**
   * Sets the account-wide container settings: the checkout limit of offline cards
   * handed out by any store below the account — directly linked or under nested child
   * accounts — and the return deadline of checkouts at those stores. Both replace
   * hardcoded per-brand lists in the backend, so one partner with several brands is
   * now configured once. Internal users only.
   *
   * A partial update. Passing a setting as null clears it and hands it back to the
   * closest ancestor that has one; **omitting** it leaves the stored value alone, so
   * raising the limit does not require knowing the stored deadline.
   *
   * offline_card_checkout_limit takes 1-100 and wins over the brand lists it
   * replaces. return_deadline_days takes 1-365 and can only ever lengthen a deadline:
   * it applies when it is longer than the deadline the checkout would otherwise get,
   * so it never undercuts the default or a longer per-container-type or per-store
   * deadline. Like the other partner account policies, colugo-owned and never
   * overwritten by the Zoho account sync.
   */
  setPartnerAccountContainerPolicy: EventAccount;
  /**
   * Sets the account-wide inventory-check billing policy. Applies to the account and
   * every store below it, including stores under nested child accounts. Only affects
   * inventory checks created after the change; existing checks keep their billability
   * and can still be overridden individually. Internal users only, and never
   * overwritten by the Zoho account sync.
   */
  setPartnerAccountInventoryCheckBillingPolicy: EventAccount;
  /**
   * Sets the account-wide purchasing-order policy. While the flag is on, partner
   * invoices of every store below the account — directly linked or under nested
   * child accounts — are held in DRAFT until a purchase order is provided, and
   * purchasing_order_email supplies the PO request recipients for gated stores
   * without a contact of their own. The contact requires the flag: passing one
   * while the flag is off is rejected, and switching the flag off clears the
   * stored contact. Internal users only.
   *
   * Deliberately not part of UpdateEventAccountInput: those fields are the
   * Zoho-synced account surface (the inbound account webhook overwrites them
   * wholesale) and updateEventAccount is open to the account's own users, while
   * this policy is colugo-owned, Finance-only, and must survive every sync.
   */
  setPartnerAccountPurchasingOrderPolicy: EventAccount;
  /** Assigns a specific service package revision to a merchant store. */
  setStoreServicePackage: Scalars['Boolean'];
  setVytalCredits?: Maybe<User>;
  splitOpsOrder: Scalars['ID'];
  /**
   * Manual catch-up start; the scheduled runs never need this. ES runs take
   * the confirmed sequence number from the form; the worker re-validates it
   * against Billomat at run start and fails fast on a collision.
   */
  startInvoiceRun: InvoiceRun;
  /**
   * Starts an asynchronous report generation. The result file is uploaded to the
   * reports bucket, and the download links are posted to the finance Slack channel.
   *
   * The invoice_numbers argument is required by BILLOMAT_INVOICE_PDF_ARCHIVE, which
   * downloads the invoice PDF of every listed invoice number and delivers them as one
   * ZIP archive. One entry may hold several invoice numbers separated by whitespace, a
   * comma or a semicolon, so a pasted list can be passed unchanged. Every other report
   * type ignores invoice_numbers and uses year and month.
   */
  startReportGeneration?: Maybe<Scalars['Boolean']>;
  startScanTunnelSession: ScanTunnelSession;
  stockReduction?: Maybe<ProductStore>;
  /**
   * Record free-text feedback from an internal user about an admin page.
   * `path` identifies the screen (e.g. "edit-container-types"). Best-effort:
   * returns true once accepted; the user id + role are taken from the session,
   * never from the client. Stored in ClickHouse (t_colugo_admin_feedback).
   */
  submitAdminFeedback: Scalars['Boolean'];
  submitEventMerchantOrder: EventMerchantOrderSharedLinkInfo;
  submitFeedback?: Maybe<Scalars['Boolean']>;
  submitProblem?: Maybe<Scalars['Boolean']>;
  submitProblemExtended: SubmitProblemExtendedResult;
  submitSupportRequest?: Maybe<Scalars['Boolean']>;
  syncBillomatInvoicesForStore?: Maybe<SyncBillomatInvoicesResult>;
  syncContainerTypesToZoho: Scalars['Boolean'];
  /**
   * Queue a Zoho Books item sync (one rent and one loss item per Zoho
   * organisation) for each item type. Every sync also replaces the items' image
   * with the type's image_url. The admin queues this when the SKU, name, image,
   * archived flag or default event prices change; use it to re-sync by hand.
   * Types without an SKU, or archived ones, are skipped.
   */
  syncItemTypesToZoho: Scalars['Boolean'];
  tempOverwriteMinOrderTime?: Maybe<Store>;
  trackAction?: Maybe<Scalars['Boolean']>;
  transferCustomerCateringUserContainersToStore: Scalars['Boolean'];
  /**
   * (Re-)emits a fresh set of print jobs for a picking job. Always creates new
   * rows — never reuses or mutates existing ones — so each attempt has its own
   * audit trail. A requested role whose source S3 key is absent is silently
   * skipped (e.g. LABEL on an event / logistics-partner job with no carrier),
   * so the returned list contains only the rows actually created.
   */
  triggerPrintJobsForPickingJob: Array<PrintJob>;
  unlinkCustomerCateringUserFromStore: Scalars['Boolean'];
  unlinkExternalEventSupervisor: Array<ExternalEventSupervisor>;
  unlinkItemLocationFromDeliveryAddress: EventDeliveryAddress;
  unlinkOrderFulfillmentPictures: Scalars['Int'];
  unlinkUserFromEvent: Array<EventLinkedUser>;
  unrecallTrackableItem: TrackableItem;
  unresolveInvoiceRunError: InvoiceRunError;
  updateAccountLedger: AccountLedger;
  updateAnalyticsUser: AnalyticsUser;
  updateAppTranslation: AppTranslationEntry;
  updateAuthorizedSigner: AuthorizedSigner;
  updateBasket?: Maybe<Basket>;
  /** @deprecated No longer supported */
  updateBasketItem?: Maybe<Basket>;
  updateBrand?: Maybe<Brand>;
  updateBrandInvoiceInfo?: Maybe<Brand>;
  updateCampaign?: Maybe<Campaign>;
  updateCategory?: Maybe<Category>;
  updateContainerQrRedirectCampaignById?: Maybe<ContainerQrRedirectionCampaign>;
  updateContainerStation: ContainerStation;
  updateContainerTypeGroup: Scalars['Boolean'];
  updateContainerTypeGroups: Scalars['Boolean'];
  updateContainerTypeInformationAdmin: Array<AdminContainerType>;
  updateCustomBillomatArticlesConfig?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  updateDefaultVariant?: Maybe<Product>;
  updateDeliveryAddress?: Maybe<DeliveryAddress>;
  updateDynamoDbContainerTypesFromPostgres: Scalars['Boolean'];
  updateEmailSubscription?: Maybe<User>;
  updateEvent: Event;
  updateEventAccount: EventAccount;
  updateEventAccountPrices: EventAccount;
  updateEventAccountUser: Scalars['ID'];
  updateEventDeliveryAddress: EventDeliveryAddress;
  updateExtra?: Maybe<Product>;
  updateExtraGroup?: Maybe<NewExtraGroup>;
  updateInvoiceCollection?: Maybe<InvoiceCollection>;
  updateInvoiceCollectionBillomatClient: Scalars['Boolean'];
  updateItem?: Maybe<Basket>;
  updateItemLocation: ItemLocation;
  updateItemType: ItemType;
  updateMerchantOrderSharedLink: EventMerchantOrderSharedLinkInfo;
  updateMinOrderTimeSchedule?: Maybe<Store>;
  /** Sets the operator label and notes of a mini returner. Operations or administrator role. */
  updateMiniReturner: MiniReturner;
  updateNewsContent?: Maybe<Array<Maybe<NewsContent>>>;
  updateOpsOrder: OpsOrderDetail;
  updateOpsOrderStatus: Scalars['Boolean'];
  updateOrder?: Maybe<Order>;
  updateOrderFulfillment: OrderFulfillment;
  updateOrderFulfillmentContainerStationManualAmount: OrderFulfillment;
  updateOrderFulfillmentPicture: OrderFulfillmentPicture;
  updatePartnerSelfSignupConfig?: Maybe<PartnerSelfSignupConfig>;
  /**
   * Persists the same overrides as confirmPickingJob without flipping the
   * job to PICKED. Lets the picker app adjust pallet count / weight (event
   * segment) or per-package weights (open system) incrementally, then call
   * confirmPickingJob bare when done. Slack notification fires on event-
   * segment changes only when the override differs from the calculated
   * value, same rule as confirmPickingJob. Weight inputs in kilograms.
   *
   * Errors:
   *   JOB_NOT_FOUND, JOB_ALREADY_PICKED, INVALID_INPUT (same rules as
   *   confirmPickingJob's override validation).
   */
  updatePickingJob: PickingJob;
  /**
   * Reports a print job's status back from the desktop. The server enforces
   * terminal-state immutability only: a write is rejected when the existing
   * row is already COMPLETED / FAILED / CANCELLED. All other transitions are
   * trusted — the desktop owns the in-flight state machine. Publishes a
   * PrintJobUpdated event to both the per-item-location and per-picking-job
   * topics.
   */
  updatePrintJobStatus: PrintJob;
  updateProduct?: Maybe<Product>;
  updateProductAsCopy?: Maybe<Product>;
  updateProductStore?: Maybe<ProductStore>;
  updatePushSubscription?: Maybe<User>;
  updateRaffleCampaignDeduplicateWinnerEmails?: Maybe<RaffleCampaign>;
  updateRaffleCampaignPartnerEmails?: Maybe<RaffleCampaign>;
  updateRaffleCampaignStatus?: Maybe<RaffleCampaign>;
  updateScanTunnel: ScanTunnel;
  updateStore?: Maybe<Store>;
  updateStoreAsset: StoreAssetV2;
  updateStoreAvailability?: Maybe<Store>;
  updateStoreSettings?: Maybe<Store>;
  updateStoreSuperAdmin?: Maybe<Store>;
  updateTrackableItem: TrackableItem;
  updateTrackableItems: Array<TrackableItem>;
  updateUser?: Maybe<User>;
  updateVariant?: Maybe<Product>;
  updateVendingMachine?: Maybe<VendingMachine>;
  /**
   * Validates a file and returns per row the errors and the changes it would
   * write. Writes nothing. The id selects a store (str_…) or an invoice
   * collection (inc_…). An empty cell clears the field; an empty boolean is
   * false. Values are the stored values of the entity itself, not the values
   * a store inherits from its brand.
   *
   * The dunning block columns are exclusive: TEMPORARY needs
   * dunning_reminder_block_until (not in the past), PERMANENTLY needs
   * dunning_reminder_block_reason and no until, and no block type needs both
   * empty. The block audit fields (set at / set by) are set by the server.
   */
  validateFinanceBulkImport: FinanceBulkImportResult;
};


export type MutationAcceptAgbArgs = {
  user_id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationAcknowledgedMessageArgs = {
  messageId: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationAddCategoryToStoreArgs = {
  category_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationAddEventAccountToEventParticipantsArgs = {
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
};


export type MutationAddEventLinkedUserArgs = {
  payload: EventLinkedUserInput;
};


export type MutationAddExternalEventSupervisorArgs = {
  payload: ExternalEventSupervisorInput;
};


export type MutationAddExtraGroupArgs = {
  group_id?: InputMaybe<Scalars['ID']>;
  item?: InputMaybe<ExtraGroupCreate>;
  product_id: Scalars['ID'];
};


export type MutationAddExtraToGroupArgs = {
  extra_id?: InputMaybe<Scalars['ID']>;
  group_id: Scalars['ID'];
  item?: InputMaybe<ProductInput>;
  product_id: Scalars['ID'];
};


export type MutationAddExtrasToGroupArgs = {
  extra_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  group_id: Scalars['ID'];
  item?: InputMaybe<ProductInput>;
  product_id: Scalars['ID'];
};


export type MutationAddFavoriteStoreArgs = {
  store_id: Scalars['ID'];
};


export type MutationAddItemToBasketArgs = {
  basket_id?: InputMaybe<Scalars['ID']>;
  item: BasketItemCreate;
};


export type MutationAddItemToPickingJobArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  category: OpsOrderItemCategory;
  context?: InputMaybe<PickingJobContextInput>;
  item_id: Scalars['ID'];
  picking_job_id: Scalars['ID'];
};


export type MutationAddItemToPickingJobV2Args = {
  amount?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<OpsOrderItemCategory>;
  code?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<PickingJobContextInput>;
  item_id?: InputMaybe<Scalars['ID']>;
  picking_job_id: Scalars['ID'];
};


export type MutationAddNewContainerTypeArgs = {
  container_type_name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  is_white_label?: InputMaybe<Scalars['Boolean']>;
  prices_by_currency_string: Scalars['String'];
  segment?: InputMaybe<ContainerTypeSegment>;
};


export type MutationAddOfflineCardsToStockArgs = {
  amount: Scalars['Int'];
  item_location_id?: InputMaybe<Scalars['ID']>;
};


export type MutationAddPartnerAccountToInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
  partner_account_id: Scalars['ID'];
};


export type MutationAddProductsToCategoryArgs = {
  category_id?: InputMaybe<Scalars['ID']>;
  product_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationAddStoreToInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationAddToBasketArgs = {
  basket_id?: InputMaybe<Scalars['ID']>;
  item: BasketItemInput;
};


export type MutationAddUserToEventAccountArgs = {
  event_account_id: Scalars['ID'];
  input: UpdateEventAccountUserInput;
};


export type MutationAddUserToSharedBasketArgs = {
  main_basket_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationAddVariantArgs = {
  payload: VariantInput;
  product_id: Scalars['ID'];
};


export type MutationAddVytalCreditsArgs = {
  user_id: Scalars['ID'];
  vytal_credits: Scalars['Int'];
};


export type MutationAdminUpdateUserArgs = {
  id: Scalars['ID'];
  item: AdminUpdateUser;
};


export type MutationAdvanceWashingHubStationArgs = {
  input: AdvanceWashingHubStationInput;
};


export type MutationApplyFinanceBulkImportArgs = {
  columns: Array<Scalars['String']>;
  rows: Array<FinanceBulkImportRowInput>;
};


export type MutationApplyPromotionArgs = {
  promotion_code: Scalars['String'];
  user_id: Scalars['ID'];
};


export type MutationApplyPromotionExArgs = {
  promotion_code: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationArchiveOrderFulfillmentArgs = {
  order_fulfillment_id: Scalars['ID'];
};


export type MutationAssociateStoresToInvoicesByCsvArgs = {
  csv?: InputMaybe<Scalars['String']>;
};


export type MutationCancelOpsOrderArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCancelOrderArgs = {
  id: Scalars['ID'];
};


export type MutationCancelTransactionArgs = {
  transaction_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCancelWashingHubBufferOrderArgs = {
  event_id: Scalars['ID'];
};


export type MutationCapturePaymentArgs = {
  payment?: InputMaybe<CreatePayment>;
};


export type MutationChangeItemLocationArgs = {
  from_location_id?: InputMaybe<Scalars['ID']>;
  item_id: Scalars['ID'];
  to_location_id: Scalars['ID'];
};


export type MutationChangeItemsLocationArgs = {
  from_location_id?: InputMaybe<Scalars['ID']>;
  item_ids?: InputMaybe<Array<Scalars['ID']>>;
  to_location_id: Scalars['ID'];
};


export type MutationClearBasketArgs = {
  basket_id: Scalars['ID'];
};


export type MutationClearContainerStationArgs = {
  id: Scalars['ID'];
};


export type MutationClearContainerStationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationCompleteAndChargeInvoiceRunArgs = {
  generation_run_id: Scalars['UUID'];
};


export type MutationCompleteFunnelProjectArgs = {
  funnel_project_id: Scalars['UUID'];
};


export type MutationConfirmArrivalBellArgs = {
  order_id: Scalars['ID'];
};


export type MutationConfirmPickingJobArgs = {
  override_pallet_count?: InputMaybe<Scalars['Int']>;
  override_total_weight_kg?: InputMaybe<Scalars['Int']>;
  package_weights_kg?: InputMaybe<Array<Scalars['Int']>>;
  picking_job_id: Scalars['ID'];
};


export type MutationConfirmPickingJobDeliveryArgs = {
  comment?: InputMaybe<Scalars['String']>;
  picking_job_id: Scalars['ID'];
  status: PickingJobDeliveryStatusInput;
};


export type MutationConfirmSignupValidationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCopyCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationCopyCategoriesArgs = {
  add_to_store?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationCopyExtrasArgs = {
  product_id_from: Scalars['ID'];
  variant_id_to: Scalars['ID'];
};


export type MutationCopyPartnerSelfSignupConfigArgs = {
  id: Scalars['String'];
  signup_code: Scalars['String'];
};


export type MutationCopyServicePackageToCurrencyArgs = {
  input: CopyServicePackageToCurrencyInput;
};


export type MutationCopyServicePackageToTermArgs = {
  input: CopyServicePackageToTermInput;
};


export type MutationCopyVariantArgs = {
  from_product_id: Scalars['ID'];
  to_product_id: Scalars['ID'];
  variant_id: Scalars['ID'];
};


export type MutationCountAndPackArgs = {
  input: CountAndPackInput;
};


export type MutationCreateAnalyticsUserArgs = {
  input: CreateAnalyticsUserInput;
};


export type MutationCreateAnonUserArgs = {
  session_device_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateAppLoginTokenArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  hostname?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAppTranslationArgs = {
  input: CreateAppTranslationInput;
};


export type MutationCreateAuthorizedSignerArgs = {
  event_account_id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateBillomatArticlesArgs = {
  container_id: Scalars['ID'];
  container_name: Scalars['String'];
};


export type MutationCreateBrandArgs = {
  payload: CreateBrand;
};


export type MutationCreateBrandInvoiceSummaryArgs = {
  data: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type MutationCreateBrandMonthlySummaryArgs = {
  brand_id?: InputMaybe<Scalars['ID']>;
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type MutationCreateBufferOrderArgs = {
  event_id: Scalars['ID'];
};


export type MutationCreateCampaignArgs = {
  promotion_code: Scalars['String'];
};


export type MutationCreateCategoryArgs = {
  item: CreateCategory;
};


export type MutationCreateCheckoutsArgs = {
  container_type_ids?: InputMaybe<Array<Scalars['Int']>>;
  count: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type MutationCreateContainerQrRedirectionCampaignForContainerTypeArgs = {
  container_qr_redirects: CreateContainerQrRedirectionCampaignByContainerTypeInput;
  type_id: Scalars['Int'];
};


export type MutationCreateContainerStationArgs = {
  name: Scalars['String'];
  store_id: Scalars['ID'];
};


export type MutationCreateContainerTypeGroupArgs = {
  name: Scalars['String'];
};


export type MutationCreateCustomerCateringUserArgs = {
  payload: CreateCustomerCateringUser;
};


export type MutationCreateDeliveryAddressArgs = {
  delivery_address: DeliveryAddressInput;
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateDeliveryOrderFulfillmentArgs = {
  additional_confirmation_email_recipient?: InputMaybe<Scalars['String']>;
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  authorized_signer_id?: InputMaybe<Scalars['ID']>;
  container_ids: Array<Scalars['ID']>;
  container_station_ids: Array<Scalars['ID']>;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  item_location_id: Scalars['ID'];
  manual_amounts?: InputMaybe<Array<ContainerTypeAmountInput>>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
  timestamp?: InputMaybe<Scalars['String']>;
  type_override?: InputMaybe<OrderFulfillmentType>;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateEventAccountArgs = {
  input: CreateEventAccountInput;
};


export type MutationCreateEventDeliveryAddressArgs = {
  event_id: Scalars['ID'];
  input: CreateEventDeliveryAddressInput;
};


export type MutationCreateEventInvoicesArgs = {
  event_account_ids: Array<Scalars['ID']>;
  event_id: Scalars['ID'];
};


export type MutationCreateExternalAuthClientConfigArgs = {
  client_id: Scalars['String'];
  display_name?: InputMaybe<Scalars['String']>;
  hostname: Scalars['String'];
};


export type MutationCreateFunnelProjectArgs = {
  visitor_id?: InputMaybe<Scalars['UUID']>;
};


export type MutationCreateInvoiceCollectionArgs = {
  item: CreateInvoiceCollection;
};


export type MutationCreateItemLocationArgs = {
  event_account_id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCreateItemTypeArgs = {
  create: CreateItemType;
};


export type MutationCreateManyAuthorizedSignersArgs = {
  amount: Scalars['Int'];
  event_account_id: Scalars['ID'];
  prefix: Scalars['String'];
};


export type MutationCreateManyContainerStationsArgs = {
  count: Scalars['Int'];
  store_id: Scalars['ID'];
  type?: InputMaybe<ContainerStationType>;
  type_id?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateManyTrackableItemsArgs = {
  amount: Scalars['Int'];
  item_type_id: Scalars['Int'];
};


export type MutationCreateMerchantOrderSharedLinkArgs = {
  input: CreateMerchantOrderSharedLinkInput;
};


export type MutationCreateNewApiTokenArgs = {
  brand_id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};


export type MutationCreateNewsContentArgs = {
  payload?: InputMaybe<CreateNewsContent>;
};


export type MutationCreateOrUpdateStoreRegionsSfArgs = {
  regions?: InputMaybe<Array<InputMaybe<RegionInput>>>;
};


export type MutationCreateOrderArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  order: CreateOrder;
};


export type MutationCreateOrderFromBasketArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  order: CreateOrderFromBasket;
};


export type MutationCreateOrderFromBasketScaArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  order: CreateOrderFromBasket;
};


export type MutationCreateOrderScaArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  order: CreateOrder;
};


export type MutationCreatePartnerSelfSignupConfigArgs = {
  signup_code: Scalars['String'];
};


export type MutationCreatePickingOrderFulfillmentArgs = {
  payload: CreatePickingOrderFulfillmentInput;
};


export type MutationCreateProductArgs = {
  payload: ProductInput;
};


export type MutationCreateProductStoreArgs = {
  item?: InputMaybe<CreateProductStore>;
};


export type MutationCreateRaffleCampaignArgs = {
  input: CreateRaffleCampaignInput;
};


export type MutationCreateRaffleCycleArgs = {
  campaign_id: Scalars['String'];
  cycle_interval_type: Scalars['String'];
  cycle_iteration: Scalars['Int'];
};


export type MutationCreateReplacementSendCloudShipmentArgs = {
  order_id: Scalars['ID'];
};


export type MutationCreateReturnOrderFulfillmentArgs = {
  authorized_signer_id?: InputMaybe<Scalars['ID']>;
  book_to_container_station_id?: InputMaybe<Scalars['ID']>;
  container_ids: Array<Scalars['ID']>;
  container_station_ids: Array<Scalars['ID']>;
  container_station_packing_info?: InputMaybe<ContainerStationPackingInfoInput>;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  goodwill?: InputMaybe<Array<ContainerTypeAmountInput>>;
  item_location_id?: InputMaybe<Scalars['ID']>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
  returned_sealed_container_station_ids?: InputMaybe<Array<Scalars['ID']>>;
  store_uuid?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  transfer_container_stations_to_item_location_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateReturnOrderFulfillmentShortIdsArgs = {
  authorized_signer_id?: InputMaybe<Scalars['ID']>;
  book_to_container_station_id?: InputMaybe<Scalars['ID']>;
  container_ids: Array<Scalars['ID']>;
  container_station_ids: Array<Scalars['ID']>;
  container_station_packing_info?: InputMaybe<ContainerStationPackingInfoInput>;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  goodwill?: InputMaybe<Array<ContainerTypeAmountInput>>;
  item_location_id?: InputMaybe<Scalars['ID']>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
  returned_sealed_container_station_ids?: InputMaybe<Array<Scalars['ID']>>;
  store_uuid?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  transfer_container_stations_to_item_location_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateReturnOrderFulfillmentV2Args = {
  payload: CreateReturnOrderFulfillmentV2Input;
};


export type MutationCreateReturnOrderFulfillmentV3Args = {
  payload: CreateReturnOrderFulfillmentV3Input;
};


export type MutationCreateScanTunnelArgs = {
  name: Scalars['String'];
};


export type MutationCreateSelfReturnCodesArgs = {
  amount: Scalars['Int'];
  item_location_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateStoreArgs = {
  payload?: InputMaybe<CreateStore>;
};


export type MutationCreateStoreAssetArgs = {
  input: CreateStoreAssetInput;
};


export type MutationCreateStoreInvoiceSummaryArgs = {
  data: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type MutationCreateTestOrderTerminalArgs = {
  store_id: Scalars['ID'];
};


export type MutationCreateTrackableItemArgs = {
  create: CreateTrackableItem;
};


export type MutationCreateUserWithRoleArgs = {
  role: Scalars['String'];
  user_name: Scalars['String'];
};


export type MutationCreateVendingMachineArgs = {
  api_key: Scalars['ID'];
  store_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationCreateVytalChargeArgs = {
  payload?: InputMaybe<CreateVytalCharge>;
};


export type MutationCreateZohoQuoteForDealArgs = {
  input: CreateZohoQuoteInput;
};


export type MutationDeactivateAnalyticsUserArgs = {
  email: Scalars['String'];
};


export type MutationDeleteAuthorizedSignerArgs = {
  authorized_signer_id: Scalars['ID'];
};


export type MutationDeleteBasketArgs = {
  basket_id: Scalars['ID'];
};


export type MutationDeleteContainerTypeGroupArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDeliveryTokenArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteEventArgs = {
  event_id: Scalars['ID'];
};


export type MutationDeleteEventAccountArgs = {
  event_account_id: Scalars['ID'];
};


export type MutationDeleteEventDeliveryAddressArgs = {
  delivery_address_id: Scalars['ID'];
};


export type MutationDeleteItemLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMerchantOrderSharedLinkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderFulfillmentPicturesArgs = {
  picture_ids: Array<Scalars['ID']>;
};


export type MutationDeletePartnerSelfSignupConfigArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScanTunnelArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSourceArgs = {
  source_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationDeleteStoreAssetArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteVariantArgs = {
  product_id: Scalars['ID'];
  variant_id: Scalars['ID'];
};


export type MutationDisableSharedBasketArgs = {
  main_basket_id: Scalars['ID'];
};


export type MutationDownloadParcelLabelArgs = {
  order_id: Scalars['UUID'];
  parcel_id: Scalars['String'];
};


export type MutationEnableBrandArgs = {
  id: Scalars['ID'];
};


export type MutationEnableSharedBasketArgs = {
  basket_id: Scalars['ID'];
};


export type MutationEnableStoreArgs = {
  id: Scalars['ID'];
};


export type MutationEnqueueMerchantOrderUpdateArgs = {
  id: Scalars['ID'];
};


export type MutationEnsureWashingHubBufferOrderArgs = {
  amount: Scalars['Int'];
  container_station_id?: InputMaybe<Scalars['ID']>;
  container_type_id: Scalars['Int'];
  event_id: Scalars['ID'];
};


export type MutationExportOpsOrderArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationExtendContainerDeadlineArgs = {
  payload: ExtendContainerDeadlineInput;
};


export type MutationExtendContainerDeadlineScaArgs = {
  payload: ExtendContainerDeadlineInput;
};


export type MutationGenerateInvoiceArgs = {
  month: Scalars['Int'];
  store_id: Scalars['ID'];
  year: Scalars['Int'];
};


export type MutationGenerateInvoiceForInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type MutationGenerateNewPosCampaignsArgs = {
  count: Scalars['Int'];
  discount_amount: Scalars['Int'];
};


export type MutationGenerateNewRndCampaignsArgs = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};


export type MutationGetAppleUserQrCodePassArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationGetDeliveryTokenArgs = {
  expires?: InputMaybe<Scalars['Boolean']>;
  generate?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationGetGoogleUserQrCodePassArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationGetInvoicePdfArgs = {
  invoice_id: Scalars['ID'];
};


export type MutationGetLatestContainerCacheLinkArgs = {
  container_cache_type: Scalars['String'];
};


export type MutationGetPaymentIntentArgs = {
  amount: Scalars['Int'];
  currency?: InputMaybe<Currency>;
  instant?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGetReportResultLinkArgs = {
  report_file_key: Scalars['String'];
};


export type MutationGetStripeTerminalLocationArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationGetTapToBorrowPaymentIntentArgs = {
  amount: Scalars['Int'];
  currency: Currency;
};


export type MutationGetTapToBorrowUserArgs = {
  setup_intent_id: Scalars['ID'];
};


export type MutationImportOfflineCardsToStockArgs = {
  cards: Array<OfflineCardImportInput>;
  item_location_id?: InputMaybe<Scalars['ID']>;
};


export type MutationIngestCategoryArgs = {
  externalId: Scalars['String'];
  item: CreateCategory;
  prefix: Scalars['String'];
};


export type MutationIngestProductArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  payload: ProductInput;
  prefix?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['ID']>;
  variants?: InputMaybe<Array<InputMaybe<VariantInput>>>;
};


export type MutationIngestProductStoreArgs = {
  item?: InputMaybe<CreateProductStore>;
};


export type MutationInvalidateApiTokenArgs = {
  token: Scalars['ID'];
};


export type MutationLinkAccountsArgs = {
  link_type: Scalars['String'];
  token: Scalars['String'];
};


export type MutationLinkAccountsForUserArgs = {
  link_type: Scalars['String'];
  token: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationLinkCustomerCateringUserToStoreArgs = {
  store_text_id: Scalars['ID'];
  user_uuid: Scalars['ID'];
};


export type MutationLinkExternalEventSupervisorArgs = {
  event_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationLinkItemLocationToDeliveryAddressArgs = {
  delivery_address_id: Scalars['ID'];
  item_location_id: Scalars['ID'];
};


export type MutationLinkItemLocationToEventArgs = {
  event_id: Scalars['ID'];
  item_location_id: Scalars['ID'];
};


export type MutationLinkItemLocationToEventAccountArgs = {
  event_account_id: Scalars['ID'];
  event_id?: InputMaybe<Scalars['ID']>;
  item_location_id: Scalars['ID'];
};


export type MutationLinkOrderFulfillmentPicturesArgs = {
  order_fulfillment_id: Scalars['ID'];
  picture_ids: Array<Scalars['ID']>;
};


export type MutationLinkOrderFulfillmentPicturesToItemLocationHistoryEntryArgs = {
  item_location_history_entry_id: Scalars['Int'];
  picture_ids: Array<Scalars['ID']>;
};


export type MutationLinkUserToContainerStationArgs = {
  container_station_id: Scalars['ID'];
  user_uuid: Scalars['ID'];
};


export type MutationLinkUserToEventArgs = {
  event_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationLoginViaAppLoginArgs = {
  app_login_token: Scalars['ID'];
};


export type MutationManualStoreInvoiceChargeArgs = {
  invoice_id: Scalars['ID'];
};


export type MutationMarkBrokenAtUserContainersAsBrokenArgs = {
  container_ids: Array<Scalars['ID']>;
  store_id?: InputMaybe<Scalars['String']>;
};


export type MutationMarkPickingJobItemAsDeliveredArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  category: OpsOrderItemCategory;
  item_id: Scalars['ID'];
  picking_job_id: Scalars['ID'];
};


export type MutationMarkPickingJobItemAsNotDeliveredArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  category: OpsOrderItemCategory;
  item_id: Scalars['ID'];
  picking_job_id: Scalars['ID'];
};


export type MutationMergeAnonUserArgs = {
  additional_info?: InputMaybe<AdditionalUserInfo>;
  anon_access_token?: InputMaybe<Scalars['String']>;
};


export type MutationNotifyContainerCheckinArgs = {
  payload: ContainerCheckinInput;
};


export type MutationNotifyContainerCheckoutArgs = {
  payload: ContainerCheckoutInput;
};


export type MutationNotifyMerchantOrderUpdateArgs = {
  payload: MerchantOrderInput;
};


export type MutationOrderItemsToStoreBasketArgs = {
  order_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationOutOfStockArgs = {
  product_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationOutOfStock2Args = {
  minutes?: InputMaybe<Scalars['Int']>;
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  store_id: Scalars['ID'];
  type: OutOfStockUntilType;
};


export type MutationPackContainerStationArgs = {
  book_to_item_location_id: Scalars['ID'];
  container_ids: Array<Scalars['ID']>;
  container_type_id: Scalars['Int'];
  id: Scalars['ID'];
  manual_amount: Scalars['Int'];
  picture_ids?: InputMaybe<Array<Scalars['String']>>;
  sealed: Scalars['Boolean'];
};


export type MutationPackContainerStationAfterUncountedReturnArgs = {
  id: Scalars['ID'];
  manual_amounts: Array<ContainerStationContainerTypeAmountInput>;
  picture_ids: Array<Scalars['String']>;
  sealed: Scalars['Boolean'];
};


export type MutationPackContainerStationV2Args = {
  container_ids: Array<Scalars['ID']>;
  id: Scalars['ID'];
  manual_amounts: Array<ContainerStationContainerTypeAmountInput>;
  picture_ids: Array<Scalars['String']>;
  sealed: Scalars['Boolean'];
  target_item_location_id: Scalars['ID'];
};


export type MutationPackContainerStationWithContainersArgs = {
  container_ids: Array<Scalars['UUID']>;
  container_station_id: Scalars['ShortId'];
};


export type MutationPackContainerStationsArgs = {
  book_to_item_location_id: Scalars['ID'];
  container_station_packing_info?: InputMaybe<Array<ContainerStationPackingInput>>;
  container_type_id: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['ID']>>;
  manual_amount?: InputMaybe<Scalars['Int']>;
  sealed: Scalars['Boolean'];
};


export type MutationPackContainerStationsV2Args = {
  container_station_packing_info: Array<ContainerStationPackingInputV2>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  manual_amounts: Array<ContainerStationContainerTypeAmountInput>;
  sealed: Scalars['Boolean'];
  target_item_location_id: Scalars['ID'];
};


export type MutationPartialRefundOverduePenaltyBillArgs = {
  bill_id: Scalars['ID'];
  containers: Array<OverduePenaltyContainerKey>;
};


export type MutationParticipateInRaffleArgs = {
  container_short_id: Scalars['String'];
  email_address?: InputMaybe<Scalars['String']>;
  raffle_campaign_id: Scalars['String'];
  raffle_participant_id?: InputMaybe<Scalars['String']>;
};


export type MutationParticipateInRaffleMockArgs = {
  container_short_id: Scalars['String'];
  email_address?: InputMaybe<Scalars['String']>;
  raffle_campaign_id: Scalars['String'];
  raffle_participant_id?: InputMaybe<Scalars['String']>;
};


export type MutationPaypalAuthorizePaymentArgs = {
  amount: Scalars['Int'];
};


export type MutationPaypalCapturePaymentArgs = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};


export type MutationPaypalExecutePaymentArgs = {
  input?: InputMaybe<PaypalDataInput>;
  token: Scalars['String'];
};


export type MutationPaypalRefundPaymentArgs = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};


export type MutationPlaceSharedOrderArgs = {
  basket_id: Scalars['ID'];
};


export type MutationProcessAccountLedgersArgs = {
  account_ledgers: Array<AccountLedgerInput>;
};


export type MutationReactivateAnalyticsUserArgs = {
  email: Scalars['String'];
};


export type MutationReadyOrderItemArgs = {
  item_id?: InputMaybe<Scalars['ID']>;
  order_id: Scalars['ID'];
  product_id?: InputMaybe<Scalars['ID']>;
  status: Scalars['Boolean'];
};


export type MutationRecallTrackableItemArgs = {
  id: Scalars['ID'];
};


export type MutationReceiveShipmentArgs = {
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  container_station_info: Array<ReceiveShipmentInput>;
  picture_ids?: InputMaybe<Array<Scalars['ID']>>;
  target_item_location_id: Scalars['ID'];
};


export type MutationReceiveShipmentV2Args = {
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  container_station_info: Array<ReceiveShipmentInput>;
  picture_ids?: InputMaybe<Array<Scalars['ID']>>;
  target_item_location_id: Scalars['ID'];
};


export type MutationRefetchDeliveryNoteArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRefetchOrderDocumentsArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRefreshAccessTokenArgs = {
  refresh_token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRefreshHeartbeatArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRegenerateCollectionDraftArgs = {
  generation_run_id: Scalars['UUID'];
  invoice_collection_id: Scalars['ID'];
};


export type MutationRegisterForT2bReturnRemindersArgs = {
  email: Scalars['String'];
  transaction_id: Scalars['ID'];
};


export type MutationRegisterSourceArgs = {
  fraud_payload?: InputMaybe<SepaFraudCheck>;
  stripe_account?: InputMaybe<StripeAccount>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user_id: Scalars['ID'];
};


export type MutationRegisterSourceForStoreArgs = {
  fraud_payload?: InputMaybe<SepaFraudCheck>;
  store_id: Scalars['ID'];
  stripe_account?: InputMaybe<StripeAccount>;
  token: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterSourceIntentArgs = {
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRemoveAllProductFromBasketArgs = {
  basket_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationRemoveAppTranslationArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBrandArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCategoryFromStoreArgs = {
  category_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationRemoveCommittedTransactionVolumeArgs = {
  store_uuid: Scalars['ID'];
};


export type MutationRemoveContainerQrRedirectionCampaignArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveDeliveryAddressArgs = {
  address_id: Scalars['ID'];
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRemoveEventAccountFromEventParticipantsArgs = {
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
};


export type MutationRemoveExtraFromGroupArgs = {
  extra_id: Scalars['ID'];
  group_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationRemoveExtraGroupFromProductArgs = {
  group_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationRemoveFavoriteStoreArgs = {
  store_id: Scalars['ID'];
};


export type MutationRemoveFromBasketArgs = {
  basket_id: Scalars['ID'];
  item_id: Scalars['ID'];
};


export type MutationRemoveItemFromPickingJobArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  category: OpsOrderItemCategory;
  item_id: Scalars['ID'];
  picking_job_id: Scalars['ID'];
};


export type MutationRemoveOrderFulfillmentContainerStationManualAmountArgs = {
  container_station_id: Scalars['ID'];
  manual_amount: ContainerTypeAmountInput;
  order_fulfillment_id: Scalars['ID'];
};


export type MutationRemovePartnerAccountFromInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
  partner_account_id: Scalars['ID'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveProductFromCategoryArgs = {
  category_id?: InputMaybe<Scalars['ID']>;
  product_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRemoveProductStoreArgs = {
  productId: Scalars['ID'];
  storeId: Scalars['ID'];
};


export type MutationRemoveProductStore2Args = {
  product_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationRemoveScannedItemsFromSessionArgs = {
  container_ids: Array<Scalars['ID']>;
  item_ids: Array<Scalars['ID']>;
  session_id: Scalars['ID'];
};


export type MutationRemoveStoreArgs = {
  id: Scalars['ID'];
  removal_reason?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveStoreAssetArgs = {
  id: Scalars['ID'];
  mark_deleted?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveStoreFromInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationRemoveUserArgs = {
  send_deletion_mail?: InputMaybe<Scalars['Boolean']>;
  user_id: Scalars['ID'];
};


export type MutationRemoveUserFromSharedBasketArgs = {
  main_basket_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationReportPowerCableStatusChangeArgs = {
  id: Scalars['ID'];
  power_cable_status: PowerCableStatusChange;
  source?: InputMaybe<PowerStatusSource>;
};


export type MutationReportProblemArgs = {
  comment?: InputMaybe<Scalars['String']>;
  problem: Scalars['String'];
  store_id: Scalars['ID'];
};


export type MutationRequestContainerStationPictureUploadUrlArgs = {
  comment?: InputMaybe<Scalars['String']>;
  file_type: Scalars['String'];
  item_location_history_entry_id?: InputMaybe<Scalars['Int']>;
  lon_lat?: InputMaybe<LonLatIn>;
};


export type MutationRequestInventoryCheckArgs = {
  store_text_id: Scalars['String'];
};


export type MutationRequestOrderFulfillmentPictureUploadUrlArgs = {
  comment?: InputMaybe<Scalars['String']>;
  file_type: Scalars['String'];
  lon_lat?: InputMaybe<LonLatIn>;
  order_fulfillment_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRequestPaymentTokenArgs = {
  source_id?: InputMaybe<Scalars['ID']>;
};


export type MutationRequestUploadUrlArgs = {
  filename?: InputMaybe<Scalars['String']>;
  filetype?: InputMaybe<Scalars['String']>;
  is_profile_picture?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<RequestUploadUrlType>;
};


export type MutationResendValidationEmailArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationResetAnalyticsUserPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResolveInvoiceRunErrorArgs = {
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationResolvePickingJobArgs = {
  destination: PickingJobResolutionDestination;
  picking_job_id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationRestockArgs = {
  product_id: Scalars['ID'];
  quantity: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type MutationRestock2Args = {
  product_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationRetryInvoiceRunArgs = {
  id: Scalars['UUID'];
};


export type MutationRetrySendCloudLabelArgs = {
  order_id: Scalars['ID'];
};


export type MutationReverseTapToBorrowPaymentArgs = {
  payment_intent_id: Scalars['String'];
};


export type MutationRingArrivalBellArgs = {
  order_id: Scalars['ID'];
};


export type MutationSaveContainerPricingAdminArgs = {
  consumer_overdue_prices_string: Scalars['String'];
  store_default_container_prices_string: Scalars['String'];
};


export type MutationSaveFunnelAnswerArgs = {
  funnel_project_id: Scalars['UUID'];
  iteration: Scalars['Int'];
  position: Scalars['Int'];
  step: Scalars['String'];
  value: Scalars['String'];
};


export type MutationSaveFunnelLeadArgs = {
  contact: Scalars['String'];
  funnel_project_id: Scalars['UUID'];
  kind: FunnelLeadKind;
};


export type MutationSaveRemoveProductArgs = {
  product_id?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveServicePackageRevisionArgs = {
  input: SaveServicePackageRevisionInput;
  store_uuid?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveTrackingNumbersAndMarkAsPickedArgs = {
  id: Scalars['ID'];
  tracking_numbers: Array<Scalars['String']>;
};


export type MutationSeedDevContainerCollectionArgs = {
  amount: Scalars['Int'];
  container_amount: Scalars['Int'];
  container_type_id: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type MutationSeedDevContainerStationArgs = {
  amount: Scalars['Int'];
  container_type_id?: InputMaybe<Scalars['Int']>;
  empty?: InputMaybe<Scalars['Boolean']>;
  item_location_id?: InputMaybe<Scalars['ID']>;
  station_type?: InputMaybe<ContainerStationType>;
  store_id: Scalars['ID'];
};


export type MutationSeedDevContainersArgs = {
  amount: Scalars['Int'];
  container_type_id: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type MutationSeedDevEventOrdersArgs = {
  event_id: Scalars['ID'];
  status: MerchantOrderStatusEnum;
};


export type MutationSeedDevMarkOrderDeliveredArgs = {
  picking_job_id: Scalars['ID'];
};


export type MutationSeedDevMinimalEventOrdersArgs = {
  event_id: Scalars['ID'];
  status: MerchantOrderStatusEnum;
};


export type MutationSeedDevParcelStatusHistoryArgs = {
  input: SeedDevParcelStatusHistoryInput;
};


export type MutationSeedDevPickedEventPickingJobArgs = {
  container_type_id?: InputMaybe<Scalars['Int']>;
  event_id: Scalars['ID'];
};


export type MutationSeedDevPickedOpenSystemPickingJobArgs = {
  container_type_id?: InputMaybe<Scalars['Int']>;
  store_asset_item_type_id?: InputMaybe<Scalars['Int']>;
  store_id: Scalars['ID'];
  untracked_item_option_id?: InputMaybe<Scalars['Int']>;
};


export type MutationSeedDevTrackableItemsArgs = {
  amount: Scalars['Int'];
  item_location_id?: InputMaybe<Scalars['ID']>;
  item_type_id: Scalars['Int'];
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationSelectRaffleWinnersArgs = {
  campaign_id: Scalars['String'];
};


export type MutationSendCioEventForStoreArgs = {
  affected_roles?: InputMaybe<Array<InputMaybe<ContactRole>>>;
  event_data_json: Scalars['String'];
  event_name: Scalars['String'];
  store_id: Scalars['ID'];
};


export type MutationSendEventMerchantOrderFormLinksArgs = {
  input: SendEventMerchantOrderFormLinksInput;
};


export type MutationSendMessageArgs = {
  text: Scalars['String'];
  type?: InputMaybe<MessageType>;
};


export type MutationSendOpsOrderToPickingArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSendOrderFulfillmentUpdateEmailArgs = {
  order_fulfillment_id: Scalars['ID'];
};


export type MutationSendOrderReceiptArgs = {
  email?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type MutationSendPartnerEventArgs = {
  affected_roles: Array<InputMaybe<ContactRole>>;
  create_sf_chatter: Scalars['Boolean'];
  create_sf_task: Scalars['Boolean'];
  name: Scalars['String'];
  send_event_to_store_cio_account?: InputMaybe<Scalars['Boolean']>;
  store_id: Scalars['ID'];
  value: Scalars['String'];
};


export type MutationSendPickingJobToPrinterArgs = {
  picking_job_id: Scalars['ID'];
};


export type MutationSetAppMetadataArgs = {
  json: Scalars['String'];
  user_id: Scalars['ID'];
};


export type MutationSetBookmarksArgs = {
  product_ids: Array<Scalars['UUID']>;
  visitor_id: Scalars['UUID'];
};


export type MutationSetCommittedTransactionVolumeArgs = {
  input: SetCommittedTransactionVolumeInput;
};


export type MutationSetDefaultCarrierByCountryConfigArgs = {
  entries: Array<DefaultCarrierByCountryInput>;
};


export type MutationSetDefaultSourceArgs = {
  source_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationSetDefaultSourceForStoreArgs = {
  source_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationSetInvoiceAsPaidArgs = {
  comment: Scalars['String'];
  invoice_id: Scalars['ID'];
  total_in_cent: Scalars['Int'];
};


export type MutationSetItemTypePriceArgs = {
  input: SetItemTypePriceInput;
};


export type MutationSetLastAccountLedgerProcessedConfigArgs = {
  input: LastAccountLedgerProcessedConfigInput;
};


export type MutationSetLastInventoryCheckDateArgs = {
  date: Scalars['String'];
  store_text_id: Scalars['String'];
};


export type MutationSetOrderWarehouseConfigArgs = {
  input: OrderWarehouseConfigInput;
};


export type MutationSetPartnerAccountContainerPolicyArgs = {
  event_account_id: Scalars['ID'];
  offline_card_checkout_limit?: InputMaybe<Scalars['Int']>;
  return_deadline_days?: InputMaybe<Scalars['Int']>;
};


export type MutationSetPartnerAccountInventoryCheckBillingPolicyArgs = {
  event_account_id: Scalars['ID'];
  new_inventory_checks_are_non_billable: Scalars['Boolean'];
};


export type MutationSetPartnerAccountPurchasingOrderPolicyArgs = {
  event_account_id: Scalars['ID'];
  needs_purchasing_order_number: Scalars['Boolean'];
  purchasing_order_email?: InputMaybe<Scalars['String']>;
};


export type MutationSetStoreServicePackageArgs = {
  input: SetStoreServicePackageInput;
};


export type MutationSetVytalCreditsArgs = {
  user_id: Scalars['ID'];
  vytal_credits: Scalars['Int'];
};


export type MutationSplitOpsOrderArgs = {
  containers?: InputMaybe<Array<OpsOrderSplitContainerInput>>;
  id: Scalars['ID'];
  items?: InputMaybe<Array<OpsOrderSplitItemInput>>;
  untracked_items?: InputMaybe<Array<OpsOrderSplitUntrackedItemInput>>;
};


export type MutationStartInvoiceRunArgs = {
  dry_run?: InputMaybe<Scalars['Boolean']>;
  iso_month: Scalars['Int'];
  next_es_invoice_number?: InputMaybe<Scalars['Int']>;
  type: InvoiceRunType;
  year: Scalars['Int'];
};


export type MutationStartReportGenerationArgs = {
  invoice_numbers?: InputMaybe<Array<Scalars['String']>>;
  month: Scalars['Int'];
  report_type: ReportType;
  year: Scalars['Int'];
};


export type MutationStartScanTunnelSessionArgs = {
  scan_tunnel_id: Scalars['ID'];
  session_id?: InputMaybe<Scalars['String']>;
};


export type MutationStockReductionArgs = {
  count?: InputMaybe<Scalars['Int']>;
  product_id: Scalars['ID'];
  store_id: Scalars['ID'];
};


export type MutationSubmitAdminFeedbackArgs = {
  comment: Scalars['String'];
  path: Scalars['String'];
};


export type MutationSubmitEventMerchantOrderArgs = {
  input: SubmitEventMerchantOrderInput;
};


export type MutationSubmitFeedbackArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  vote?: InputMaybe<FeedbackVote>;
};


export type MutationSubmitProblemArgs = {
  device_id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<ReportProblemInput>;
};


export type MutationSubmitProblemExtendedArgs = {
  container_ids?: InputMaybe<Array<Scalars['ID']>>;
  device_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  returned_at_store?: InputMaybe<Scalars['String']>;
  returned_at_time?: InputMaybe<Scalars['String']>;
  selections: Array<Selection>;
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationSubmitSupportRequestArgs = {
  contact_info: Scalars['String'];
  name: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSyncBillomatInvoicesForStoreArgs = {
  store_id: Scalars['ID'];
};


export type MutationSyncContainerTypesToZohoArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationSyncItemTypesToZohoArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationTempOverwriteMinOrderTimeArgs = {
  min_order_time: Scalars['Int'];
  minutes: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type MutationTrackActionArgs = {
  id: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationTransferCustomerCateringUserContainersToStoreArgs = {
  user_uuids: Array<Scalars['ID']>;
};


export type MutationTriggerPrintJobsForPickingJobArgs = {
  picking_job_id: Scalars['ID'];
  roles?: InputMaybe<Array<PrinterRole>>;
};


export type MutationUnlinkCustomerCateringUserFromStoreArgs = {
  user_uuids: Array<Scalars['ID']>;
};


export type MutationUnlinkExternalEventSupervisorArgs = {
  event_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationUnlinkItemLocationFromDeliveryAddressArgs = {
  delivery_address_id: Scalars['ID'];
  item_location_id: Scalars['ID'];
};


export type MutationUnlinkOrderFulfillmentPicturesArgs = {
  picture_ids: Array<Scalars['ID']>;
};


export type MutationUnlinkUserFromEventArgs = {
  event_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationUnrecallTrackableItemArgs = {
  id: Scalars['ID'];
};


export type MutationUnresolveInvoiceRunErrorArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateAccountLedgerArgs = {
  input: UpdateAccountLedgerInput;
};


export type MutationUpdateAnalyticsUserArgs = {
  email: Scalars['String'];
  input: UpdateAnalyticsUserInput;
};


export type MutationUpdateAppTranslationArgs = {
  input: UpdateAppTranslationInput;
};


export type MutationUpdateAuthorizedSignerArgs = {
  allowed_item_location_ids?: InputMaybe<Array<Scalars['ID']>>;
  authorized_signer_id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateBasketArgs = {
  basket: UpdateBasket;
  basket_id: Scalars['ID'];
};


export type MutationUpdateBasketItemArgs = {
  basket_id: Scalars['ID'];
  item: BasketItemInput;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['ID'];
  payload: UpdateBrand;
};


export type MutationUpdateBrandInvoiceInfoArgs = {
  id: Scalars['ID'];
  payload: UpdateBrandInvoiceInfo;
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['ID'];
  payload: CampaignInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['ID'];
  item: UpdateCategory;
};


export type MutationUpdateContainerQrRedirectCampaignByIdArgs = {
  container_qr_redirects: CreateContainerQrRedirectionCampaignByContainerTypeInput;
  id: Scalars['Int'];
};


export type MutationUpdateContainerStationArgs = {
  id: Scalars['ID'];
  is_recalled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: InputMaybe<ContainerStationType>;
  type_id?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateContainerTypeGroupArgs = {
  id: Scalars['Int'];
  payload: UpdateContainerTypeGroupInput;
};


export type MutationUpdateContainerTypeGroupsArgs = {
  link_new_group_to_previous_group_stores?: InputMaybe<Scalars['Boolean']>;
  updates: Array<ContainerTypeGroupUpdateInput>;
};


export type MutationUpdateContainerTypeInformationAdminArgs = {
  container_types: Array<AdminContainerTypeInput>;
};


export type MutationUpdateCustomBillomatArticlesConfigArgs = {
  update: Scalars['String'];
};


export type MutationUpdateDefaultVariantArgs = {
  product_id: Scalars['ID'];
  variant_id: Scalars['ID'];
};


export type MutationUpdateDeliveryAddressArgs = {
  address_id: Scalars['ID'];
  delivery_address: DeliveryAddressInput;
  store_id?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateEmailSubscriptionArgs = {
  subscription_state: SubscriptionState;
  user_id: Scalars['ID'];
};


export type MutationUpdateEventArgs = {
  event_id: Scalars['ID'];
  input: UpdateEventInput;
};


export type MutationUpdateEventAccountArgs = {
  event_account_id: Scalars['ID'];
  input: UpdateEventAccountInput;
};


export type MutationUpdateEventAccountPricesArgs = {
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  prices: Array<EventPriceInput>;
};


export type MutationUpdateEventAccountUserArgs = {
  event_account_id: Scalars['ID'];
  input: UpdateEventAccountUserInput;
  user_id: Scalars['ID'];
};


export type MutationUpdateEventDeliveryAddressArgs = {
  delivery_address_id: Scalars['ID'];
  input: UpdateEventDeliveryAddressInput;
};


export type MutationUpdateExtraArgs = {
  extra_id: Scalars['ID'];
  item: ProductInput;
  product_id?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateExtraGroupArgs = {
  group_id: Scalars['ID'];
  item: ExtraGroupUpdate;
  product_id: Scalars['ID'];
};


export type MutationUpdateInvoiceCollectionArgs = {
  id: Scalars['ID'];
  payload?: InputMaybe<UpdateInvoiceCollection>;
};


export type MutationUpdateInvoiceCollectionBillomatClientArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateItemArgs = {
  basket_id: Scalars['ID'];
  item: BasketItemUpdate;
  item_id: Scalars['ID'];
};


export type MutationUpdateItemLocationArgs = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  event_account_id?: InputMaybe<Scalars['ID']>;
  event_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateItemTypeArgs = {
  id: Scalars['Int'];
  update: UpdateItemType;
};


export type MutationUpdateMerchantOrderSharedLinkArgs = {
  input: UpdateMerchantOrderSharedLinkInput;
};


export type MutationUpdateMinOrderTimeScheduleArgs = {
  id: Scalars['ID'];
  scheduled_min_order_time_rules?: InputMaybe<Array<InputMaybe<MinOrderTimeRuleInput>>>;
};


export type MutationUpdateMiniReturnerArgs = {
  id: Scalars['UUID'];
  input: UpdateMiniReturnerInput;
};


export type MutationUpdateNewsContentArgs = {
  content_id: Scalars['ID'];
  payload?: InputMaybe<UpdateNewsContent>;
};


export type MutationUpdateOpsOrderArgs = {
  id: Scalars['ID'];
  update: OpsOrderUpdateInput;
};


export type MutationUpdateOpsOrderStatusArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  status: MerchantOrderStatusEnum;
};


export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  order: UpdateOrder;
};


export type MutationUpdateOrderFulfillmentArgs = {
  asset_ids?: InputMaybe<Array<Scalars['ID']>>;
  container_station_ids?: InputMaybe<Array<Scalars['ID']>>;
  manual_amounts?: InputMaybe<Array<ContainerTypeAmountInput>>;
  order_fulfillment_id: Scalars['ID'];
  timestamp?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrderFulfillmentContainerStationManualAmountArgs = {
  container_station_id: Scalars['ID'];
  manual_amount: ContainerTypeAmountInput;
  order_fulfillment_id: Scalars['ID'];
};


export type MutationUpdateOrderFulfillmentPictureArgs = {
  picture_id: Scalars['ID'];
  update: UpdateOrderFulfillmentPictureInput;
};


export type MutationUpdatePartnerSelfSignupConfigArgs = {
  id: Scalars['String'];
  update?: InputMaybe<PartnerSelfSignupConfigUpdate>;
};


export type MutationUpdatePickingJobArgs = {
  override_pallet_count?: InputMaybe<Scalars['Int']>;
  override_total_weight_kg?: InputMaybe<Scalars['Int']>;
  package_weights_kg?: InputMaybe<Array<Scalars['Int']>>;
  picking_job_id: Scalars['ID'];
};


export type MutationUpdatePrintJobStatusArgs = {
  job_id: Scalars['ID'];
  status: PrintJobStatus;
  status_message?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProductArgs = {
  id: Scalars['ID'];
  payload: ProductInput;
};


export type MutationUpdateProductAsCopyArgs = {
  id: Scalars['ID'];
  payload: ProductInput;
  replace_in_category: Scalars['ID'];
};


export type MutationUpdateProductStoreArgs = {
  id: Scalars['ID'];
  item?: InputMaybe<UpdateProductStore>;
};


export type MutationUpdatePushSubscriptionArgs = {
  subscription_state: SubscriptionState;
  user_id: Scalars['ID'];
};


export type MutationUpdateRaffleCampaignDeduplicateWinnerEmailsArgs = {
  campaign_id: Scalars['String'];
  deduplicate_winner_emails: Scalars['Boolean'];
};


export type MutationUpdateRaffleCampaignPartnerEmailsArgs = {
  campaign_id: Scalars['String'];
  partner_email_addresses: Array<Scalars['String']>;
};


export type MutationUpdateRaffleCampaignStatusArgs = {
  campaign_id: Scalars['String'];
  status: Scalars['String'];
};


export type MutationUpdateScanTunnelArgs = {
  id: Scalars['ID'];
  input: UpdateScanTunnelInput;
};


export type MutationUpdateStoreArgs = {
  id: Scalars['ID'];
  payload?: InputMaybe<UpdateStore>;
};


export type MutationUpdateStoreAssetArgs = {
  id: Scalars['ID'];
  input: UpdateStoreAssetInput;
};


export type MutationUpdateStoreAvailabilityArgs = {
  minutes?: InputMaybe<Scalars['Int']>;
  online: Scalars['Boolean'];
  store_id: Scalars['ID'];
  type?: InputMaybe<OutOfStockUntilType>;
};


export type MutationUpdateStoreSettingsArgs = {
  settings: StoreSettings;
  store_id: Scalars['ID'];
};


export type MutationUpdateStoreSuperAdminArgs = {
  id: Scalars['ID'];
  payload?: InputMaybe<UpdateStoreSuperAdmin>;
};


export type MutationUpdateTrackableItemArgs = {
  id: Scalars['ID'];
  update: UpdateTrackableItem;
};


export type MutationUpdateTrackableItemsArgs = {
  updates: Array<UpdateTrackableItemBulk>;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  item: UpdateUser;
};


export type MutationUpdateVariantArgs = {
  item: VariantInput;
  variant_id: Scalars['ID'];
};


export type MutationUpdateVendingMachineArgs = {
  id?: InputMaybe<Scalars['ID']>;
  payload?: InputMaybe<UpdateVendingMachine>;
};


export type MutationValidateFinanceBulkImportArgs = {
  columns: Array<Scalars['String']>;
  rows: Array<FinanceBulkImportRowInput>;
};

export type NearestStoresNoLocationResponse = {
  __typename?: 'NearestStoresNoLocationResponse';
  geo_hash_by_ip?: Maybe<Scalars['String']>;
  selected_city?: Maybe<Location>;
  stores?: Maybe<Array<Maybe<Store>>>;
};

export type NewExtraGroup = {
  __typename?: 'NewExtraGroup';
  group_id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
};

export type NewsContent = {
  __typename?: 'NewsContent';
  banner?: Maybe<Scalars['String']>;
  city_id?: Maybe<Scalars['String']>;
  country_code?: Maybe<UserCountry>;
  country_codes?: Maybe<Array<Maybe<UserCountry>>>;
  for_consumers: Scalars['Boolean'];
  for_partners: Scalars['Boolean'];
  geohash?: Maybe<Scalars['String']>;
  hide_from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  link_al?: Maybe<Scalars['String']>;
  link_ca?: Maybe<Scalars['String']>;
  link_da?: Maybe<Scalars['String']>;
  link_de?: Maybe<Scalars['String']>;
  link_el?: Maybe<Scalars['String']>;
  link_en?: Maybe<Scalars['String']>;
  link_es?: Maybe<Scalars['String']>;
  link_et?: Maybe<Scalars['String']>;
  link_eu?: Maybe<Scalars['String']>;
  link_fr?: Maybe<Scalars['String']>;
  link_gl?: Maybe<Scalars['String']>;
  link_hu?: Maybe<Scalars['String']>;
  link_lb?: Maybe<Scalars['String']>;
  link_nl?: Maybe<Scalars['String']>;
  link_no?: Maybe<Scalars['String']>;
  link_pl?: Maybe<Scalars['String']>;
  link_pt?: Maybe<Scalars['String']>;
  link_sv?: Maybe<Scalars['String']>;
  only_for_languages?: Maybe<Array<Maybe<UserLocale>>>;
  only_for_non_usage_fee_enabled?: Maybe<Scalars['Boolean']>;
  only_for_store_types?: Maybe<Array<Maybe<Scalars['String']>>>;
  only_never_used_delivery_token_users: Scalars['Boolean'];
  only_new_users: Scalars['Boolean'];
  only_used_brands?: Maybe<Array<Maybe<Scalars['String']>>>;
  only_used_stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  published: Scalars['Boolean'];
  radius_meter?: Maybe<Scalars['Int']>;
  score: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  subtitle_al?: Maybe<Scalars['String']>;
  subtitle_ca?: Maybe<Scalars['String']>;
  subtitle_da?: Maybe<Scalars['String']>;
  subtitle_de?: Maybe<Scalars['String']>;
  subtitle_el?: Maybe<Scalars['String']>;
  subtitle_en?: Maybe<Scalars['String']>;
  subtitle_es?: Maybe<Scalars['String']>;
  subtitle_et?: Maybe<Scalars['String']>;
  subtitle_eu?: Maybe<Scalars['String']>;
  subtitle_fr?: Maybe<Scalars['String']>;
  subtitle_gl?: Maybe<Scalars['String']>;
  subtitle_hu?: Maybe<Scalars['String']>;
  subtitle_lb?: Maybe<Scalars['String']>;
  subtitle_nl?: Maybe<Scalars['String']>;
  subtitle_no?: Maybe<Scalars['String']>;
  subtitle_pl?: Maybe<Scalars['String']>;
  subtitle_pt?: Maybe<Scalars['String']>;
  subtitle_sv?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  title_al?: Maybe<Scalars['String']>;
  title_ca?: Maybe<Scalars['String']>;
  title_da?: Maybe<Scalars['String']>;
  title_de?: Maybe<Scalars['String']>;
  title_el?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_et?: Maybe<Scalars['String']>;
  title_eu?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_gl?: Maybe<Scalars['String']>;
  title_hu?: Maybe<Scalars['String']>;
  title_lb?: Maybe<Scalars['String']>;
  title_nl?: Maybe<Scalars['String']>;
  title_no?: Maybe<Scalars['String']>;
  title_pl?: Maybe<Scalars['String']>;
  title_pt?: Maybe<Scalars['String']>;
  title_sv?: Maybe<Scalars['String']>;
  type: ContentType;
};

export type NewsContentCreationResult = {
  __typename?: 'NewsContentCreationResult';
  all?: Maybe<Array<Maybe<NewsContent>>>;
  created_news_content?: Maybe<NewsContent>;
};

export type NonUsageFeeInfo = {
  __typename?: 'NonUsageFeeInfo';
  allowance?: Maybe<Scalars['Int']>;
  avg_daily_checkouts: Scalars['Float'];
  avg_weekly_checkouts: Scalars['Int'];
  container_type_id: Scalars['Int'];
  container_type_name: Scalars['String'];
  exclusion_reason?: Maybe<Scalars['String']>;
  last_updated_at?: Maybe<Scalars['String']>;
  non_return_cost?: Maybe<Scalars['Int']>;
  send_back_suggestion?: Maybe<Scalars['Int']>;
  stock: Scalars['Int'];
};

export type NonUsageFeeTotalInfo = {
  __typename?: 'NonUsageFeeTotalInfo';
  allowance: Scalars['Int'];
  avg_weekly_checkouts: Scalars['Int'];
  non_return_cost: Scalars['Int'];
  send_back_suggestion: Scalars['Int'];
  stock: Scalars['Int'];
};

export type Notification = {
  __typename?: 'Notification';
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * An offline card as stock: the identity user its QR code encodes plus the
 * STORE_ASSET TrackableItem that makes it pickable and deliverable.
 */
export type OfflineCard = {
  __typename?: 'OfflineCard';
  /** The signup code printed on the card. */
  signup_code: Scalars['String'];
  /** The minted store asset. This is what a picker's scan resolves to. */
  trackable_item_id: Scalars['ID'];
  /** The user id the card's QR code encodes, scanned as u<uuid>. */
  user_id: Scalars['ID'];
};

/** One row of a supplier's card batch. */
export type OfflineCardImportInput = {
  /** The signup code printed on the card. Stored upper-case. */
  signup_code: Scalars['String'];
  /** The user id the card's QR encodes, without the scanned `u` prefix. */
  user_id: Scalars['ID'];
};

export type OnboardingProduct = {
  __typename?: 'OnboardingProduct';
  article_number?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  gtin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OnboardingProductUpdate = {
  article_number?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  gtin?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum OnboardingStatus {
  Active = 'active',
  Offboarding = 'offboarding',
  Open = 'open',
  Terminated = 'terminated',
  WonOnboarding = 'won_onboarding'
}

export type OneTimeToken = {
  __typename?: 'OneTimeToken';
  order_id?: Maybe<Scalars['ID']>;
  qr_code: Scalars['String'];
  source_id: Scalars['ID'];
  status: PaymentStatusEnum;
  token: Scalars['ID'];
  user_id: Scalars['ID'];
  valid_until: Scalars['ID'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  day?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
};

export type OpeningHoursMulti = {
  __typename?: 'OpeningHoursMulti';
  day: Scalars['Int'];
  time?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OpsDeliveryAddress = {
  __typename?: 'OpsDeliveryAddress';
  additional_info?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetno?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OpsOrder = {
  __typename?: 'OpsOrder';
  box_counts: Array<OpsOrderBoxCount>;
  carrier?: Maybe<OpsOrderCarrier>;
  carrier_pickup_date?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  container_types_used: Array<Scalars['Int']>;
  containers: Array<OpsOrderSearchContainer>;
  country: Scalars['String'];
  created_at: Scalars['String'];
  created_by?: Maybe<IdName>;
  created_by_user_name?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<DeliveryAddressInfo>;
  delivery_date?: Maybe<Scalars['String']>;
  delivery_note_id?: Maybe<Scalars['Int']>;
  event?: Maybe<IdName>;
  event_account?: Maybe<IdName>;
  health: OpsOrderHealthEnum;
  id: Scalars['ID'];
  item_locations: Array<OpsOrderItemLocation>;
  items: Array<OpsOrderSearchItem>;
  language?: Maybe<Scalars['String']>;
  last_updated: Scalars['String'];
  /** @deprecated Use carrier_pickup_date instead */
  order_execution_date?: Maybe<Scalars['String']>;
  order_form_deadline?: Maybe<Scalars['String']>;
  order_form_id?: Maybe<Scalars['ID']>;
  status: MerchantOrderStatusEnum;
  store?: Maybe<TextIdName>;
  store_tier?: Maybe<Scalars['String']>;
  store_type?: Maybe<Scalars['String']>;
  system: Scalars['String'];
  target_store_user_id?: Maybe<Scalars['UUID']>;
  total_amount: Scalars['Int'];
  total_purchase_price_cents?: Maybe<Scalars['Int']>;
  type?: Maybe<MerchantOrderTypeEnum>;
  untracked_items: Array<OpsOrderSearchUntrackedItem>;
  warehouse?: Maybe<TextIdName>;
};

export type OpsOrderBoxCount = {
  __typename?: 'OpsOrderBoxCount';
  box_size: Scalars['String'];
  count: Scalars['Int'];
};

export enum OpsOrderCarrier {
  Dhl = 'DHL',
  Dpd = 'DPD',
  /**
   * In-house / manual carrier (Hawaii hybrid). No SendCloud labels and no
   * carrier-driven status webhooks; delivery is confirmed via the PAPP
   * delivery-confirmation flow instead. Displayed as "Ho'i Ops".
   */
  Manual = 'MANUAL',
  /**
   * Shipping arranged off-platform: a logistic partner (pallets — the default for
   * event orders) or a third-party service for urgent or special deliveries.
   * Displayed as "Logistic Partner". Available in every country for PICKUP and
   * HOME_DELIVERY. Like MANUAL it gets no SendCloud label, parcel or webhook —
   * picking produces the delivery note only. Unlike MANUAL there is no later
   * confirmation step: on an open-system job picking-confirm books the stock,
   * moves the order straight to DELIVERED and sends no further emails. Never
   * auto-selected as a country default for store orders — it must be chosen
   * explicitly or configured.
   */
  Others = 'OTHERS',
  Ups = 'UPS'
}

export enum OpsOrderCarrierService {
  Dropoff = 'DROPOFF',
  HomeDelivery = 'HOME_DELIVERY',
  Pickup = 'PICKUP'
}

export type OpsOrderCarrierStatus = {
  __typename?: 'OpsOrderCarrierStatus';
  /**
   * True when this parcel was bought to replace one the carrier returned. A
   * partial replacement leaves replaced and carried-over parcels on the same
   * live attempt, so the attempt number alone no longer says which labels are
   * the new ones. Stays true for the rest of the parcel's life, including
   * after a later replacement carries it forward again.
   */
  is_replacement: Scalars['Boolean'];
  /**
   * True for rows of an attempt a replacement has taken over. Superseded rows
   * stay visible for the audit trail but no longer drive the order's status.
   */
  is_superseded: Scalars['Boolean'];
  /**
   * The SendCloud parcel this row is about, under either keying the carrier
   * feeds use. Null for rows that predate parcel bookkeeping (legacy DPD).
   * Pass it to downloadParcelLabel to reprint this one parcel's label.
   */
  parcel_id?: Maybe<Scalars['String']>;
  /**
   * Which shipment attempt this row belongs to. 1 for the original shipment,
   * higher for each replacement. Null when the row cannot be attributed to an
   * attempt (legacy DPD rows, or history older than shipment attempts).
   */
  shipment_attempt_number?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  status_details?: Maybe<Scalars['String']>;
  tracking_code: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

/** The address validation rules of one carrier the order can be switched to. */
export type OpsOrderCarrierValidationRules = {
  __typename?: 'OpsOrderCarrierValidationRules';
  carrier: OpsOrderCarrier;
  validation_rules: OpsOrderValidationRules;
};

export type OpsOrderContainer = {
  __typename?: 'OpsOrderContainer';
  amount: Scalars['Int'];
  disabled: Scalars['Boolean'];
  disabled_until?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  item_location_name?: Maybe<Scalars['String']>;
  sales_order_url?: Maybe<Scalars['String']>;
  type: OpsOrderContainerType;
};

export type OpsOrderContainerType = {
  __typename?: 'OpsOrderContainerType';
  box_count: Scalars['Int'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  packing_unit: Scalars['Int'];
  purchase_price_cents?: Maybe<Scalars['Int']>;
};

export type OpsOrderContainerUpdateInput = {
  amount: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  item_location_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type_id: Scalars['Int'];
};

export type OpsOrderDetail = {
  __typename?: 'OpsOrderDetail';
  available_carrier_services: Array<AvailableCarrierService>;
  carrier?: Maybe<OpsOrderCarrier>;
  carrier_pickup_date?: Maybe<Scalars['String']>;
  carrier_service?: Maybe<OpsOrderCarrierService>;
  carrier_status: Array<OpsOrderCarrierStatus>;
  /**
   * validation_rules per carrier in available_carrier_services, so the form
   * can validate the address against the carrier selected in the sidebar
   * before the order is saved (validation_rules itself follows the stored
   * carrier).
   */
  carrier_validation_rules: Array<OpsOrderCarrierValidationRules>;
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  container_types_used: Array<ContainerType>;
  containers: Array<OpsOrderContainer>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  created_by?: Maybe<IdName>;
  delivery_address?: Maybe<DeliveryAddressInfo>;
  delivery_date?: Maybe<Scalars['String']>;
  delivery_note_id?: Maybe<Scalars['Int']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<MerchantOrderErrorTypeEnum>;
  /**
   * Event account the order belongs to (EVENT_ACCOUNT_ORDER / buffer orders).
   * Null for open-system orders.
   */
  event_account_id?: Maybe<Scalars['ID']>;
  event_account_name?: Maybe<Scalars['String']>;
  event_end_date?: Maybe<Scalars['String']>;
  /**
   * Event the order belongs to. Set for event orders (EVENT_ACCOUNT_ORDER /
   * buffer orders); null for open-system orders. This is what drives system.
   */
  event_id?: Maybe<Scalars['ID']>;
  event_manager?: Maybe<Scalars['String']>;
  /**
   * Event-wide totals of containers and item types ordered across all
   * non-logistics event accounts on this order's event. Null for orders
   * not linked to an event. Sums the current revision of every
   * EVENT_ACCOUNT_ORDER on the event.
   */
  event_ordered_totals?: Maybe<EventOrderedTotals>;
  event_start_date?: Maybe<Scalars['String']>;
  health: Scalars['String'];
  id: Scalars['ID'];
  internal_transactions: Array<OpsOrderInternalTransaction>;
  item_location?: Maybe<Scalars['String']>;
  item_locations: Array<OpsOrderItemLocation>;
  items: Array<OpsOrderItem>;
  language?: Maybe<Scalars['String']>;
  last_updated: Scalars['String'];
  ops_comment?: Maybe<Scalars['String']>;
  /** @deprecated Use carrier_pickup_date instead */
  order_execution_date?: Maybe<Scalars['String']>;
  order_form_deadline?: Maybe<Scalars['String']>;
  order_form_id?: Maybe<Scalars['ID']>;
  package_count: Scalars['Int'];
  package_weights: Array<Scalars['Int']>;
  /**
   * The picking job this order is bundled into. Null when the order never
   * reached picking, and also while the job is still virtual — a job row is
   * only persisted on the first scan, so an order sitting at SENT_TO_PICKING
   * with nothing picked yet has no job to link to.
   */
  picking_job?: Maybe<OpsOrderPickingJobLink>;
  status: MerchantOrderStatusEnum;
  status_history: Array<OpsOrderStatusHistory>;
  store_name?: Maybe<Scalars['String']>;
  store_text_id?: Maybe<Scalars['String']>;
  system: Scalars['String'];
  target_store_user_id?: Maybe<Scalars['UUID']>;
  total_purchase_price_cents?: Maybe<Scalars['Int']>;
  type?: Maybe<MerchantOrderTypeEnum>;
  untracked_items: Array<OpsOrderUntrackedItem>;
  validation_rules: OpsOrderValidationRules;
  warehouse?: Maybe<Scalars['String']>;
  warehouse_is_automatic: Scalars['Boolean'];
  warehouse_uuid?: Maybe<Scalars['UUID']>;
};

export type OpsOrderFilter = {
  active_only?: InputMaybe<Scalars['Boolean']>;
  carrier?: InputMaybe<OpsOrderCarrier>;
  city?: InputMaybe<Scalars['String']>;
  container_types_used?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<RangeInput>;
  delivery_address_ids?: InputMaybe<Array<Scalars['UUID']>>;
  delivery_date?: InputMaybe<RangeInput>;
  event_account_id?: InputMaybe<Scalars['ID']>;
  event_id?: InputMaybe<Scalars['ID']>;
  health?: InputMaybe<OpsOrderHealthEnum>;
  item_location_id?: InputMaybe<Scalars['UUID']>;
  last_updated?: InputMaybe<RangeInput>;
  status?: InputMaybe<Array<MerchantOrderStatusEnum>>;
  store_uuid?: InputMaybe<Scalars['UUID']>;
  system?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<MerchantOrderTypeEnum>>;
  user_uuid?: InputMaybe<Scalars['UUID']>;
  warehouse_uuid?: InputMaybe<Scalars['UUID']>;
};

export enum OpsOrderHealthEnum {
  AtRisk = 'AT_RISK',
  OnTime = 'ON_TIME'
}

export type OpsOrderInternalTransaction = {
  __typename?: 'OpsOrderInternalTransaction';
  amount?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type OpsOrderItem = {
  __typename?: 'OpsOrderItem';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  item_location_name?: Maybe<Scalars['String']>;
  item_type: ItemType;
  name?: Maybe<Scalars['String']>;
};

/**
 * Bucket classification mirroring how MerchantOrderItems are split, with
 * CONTAINER_STATION split out from ITEM at the GraphQL boundary so the FE
 * can render station-as-asset distinctly from trackable-asset:
 *   CONTAINER         → ContainerTypes
 *   ITEM              → ItemTypes where Category != CONTAINER_STATION
 *                       (i.e. ASSET / STORE_ASSET — pickable trackables)
 *   CONTAINER_STATION → ItemTypes where Category = CONTAINER_STATION
 *   UNTRACKED_ITEM    → MerchantOrderItemOptions
 * CONTAINER_COLLECTION is a scan-input-only discriminator: it is accepted by
 * addItemToPickingJob / removeItemFromPickingJob to expand a barcoded
 * ContainerCollections row into N container scans, but it is never returned
 * as a PickingJobItem.category.
 */
export enum OpsOrderItemCategory {
  Container = 'CONTAINER',
  ContainerCollection = 'CONTAINER_COLLECTION',
  ContainerStation = 'CONTAINER_STATION',
  Item = 'ITEM',
  UntrackedItem = 'UNTRACKED_ITEM'
}

export type OpsOrderItemLocation = {
  __typename?: 'OpsOrderItemLocation';
  delivery_address?: Maybe<DeliveryAddressInfo>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type OpsOrderItemUpdateInput = {
  amount: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  item_location_id?: InputMaybe<Scalars['String']>;
  item_type_id: Scalars['Int'];
};

/**
 * Compact view of the picking job an ops order belongs to, for the order
 * detail backlink. Deliberately smaller than PickingJobListItem: the detail
 * page needs identity, state and progress only, while the list item's health,
 * weight and pallet fields all require the expensive per-job enrichment pass.
 */
export type OpsOrderPickingJobLink = {
  __typename?: 'OpsOrderPickingJobLink';
  carrier_pickup_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Where an admin decided the job's stock went (resolvePickingJob). Null while
   * unresolved. Carried on the backlink because it is what explains an order
   * canceled or delivered with no carrier event behind it — the order page has
   * to be able to say so without a second click.
   */
  resolution?: Maybe<PickingJobResolution>;
  segment: PickingJobSegment;
  status: PickingJobStatus;
  /**
   * Sum of AmountOrdered / AmountPicked across every bucket on the job, i.e.
   * across *all* orders bundled into it, not just this one.
   */
  total_amount_ordered: Scalars['Int'];
  total_amount_picked: Scalars['Int'];
};

export type OpsOrderSearchContainer = {
  __typename?: 'OpsOrderSearchContainer';
  amount: Scalars['Int'];
  order_key?: Maybe<Scalars['Int']>;
  type_name: Scalars['String'];
};

export type OpsOrderSearchItem = {
  __typename?: 'OpsOrderSearchItem';
  amount: Scalars['Int'];
  order_key?: Maybe<Scalars['Int']>;
  type_name: Scalars['String'];
};

export type OpsOrderSearchUntrackedItem = {
  __typename?: 'OpsOrderSearchUntrackedItem';
  amount: Scalars['Int'];
  order_key?: Maybe<Scalars['Int']>;
  type_name: Scalars['String'];
};

export type OpsOrderSort = {
  carrier?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  created_by?: InputMaybe<SortOrder>;
  delivery_date?: InputMaybe<SortOrder>;
  health?: InputMaybe<SortOrder>;
  item_location?: InputMaybe<SortOrder>;
  last_updated?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  store_name?: InputMaybe<SortOrder>;
  system?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<SortOrder>;
};

export type OpsOrderSplitContainerInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type OpsOrderSplitItemInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type OpsOrderSplitUntrackedItemInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type OpsOrderStatusHistory = {
  __typename?: 'OpsOrderStatusHistory';
  changed_by?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  status: MerchantOrderStatusEnum;
  timestamp: Scalars['String'];
};

/**
 * The two order systems an ops order can belong to: event orders (tied to an
 * Event) and open-system orders (everything else).
 */
export enum OpsOrderSystem {
  Event = 'EVENT',
  OpenSystem = 'OPEN_SYSTEM'
}

export type OpsOrderUntrackedItem = {
  __typename?: 'OpsOrderUntrackedItem';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  item_location_id?: Maybe<Scalars['ID']>;
  item_location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: OpsOrderUntrackedItemType;
};

export type OpsOrderUntrackedItemType = {
  __typename?: 'OpsOrderUntrackedItemType';
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OpsOrderUntrackedItemUpdateInput = {
  amount: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  item_location_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type_id: Scalars['Int'];
};

export type OpsOrderUpdateInput = {
  carrier?: InputMaybe<OpsOrderCarrier>;
  carrier_pickup_date?: InputMaybe<Scalars['String']>;
  carrier_service?: InputMaybe<OpsOrderCarrierService>;
  comment?: InputMaybe<Scalars['String']>;
  containers?: InputMaybe<Array<OpsOrderContainerUpdateInput>>;
  delivery_address?: InputMaybe<DeliveryAddressUpdateInput>;
  delivery_date?: InputMaybe<Scalars['String']>;
  execution_date?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<OpsOrderItemUpdateInput>>;
  language?: InputMaybe<Scalars['String']>;
  ops_comment?: InputMaybe<Scalars['String']>;
  package_count?: InputMaybe<Scalars['Int']>;
  package_weights?: InputMaybe<Array<Scalars['Int']>>;
  reset_sendcloud?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<MerchantOrderStatusEnum>;
  untracked_items?: InputMaybe<Array<OpsOrderUntrackedItemUpdateInput>>;
  warehouse_uuid?: InputMaybe<Scalars['UUID']>;
};

export type OpsOrderValidationRules = {
  __typename?: 'OpsOrderValidationRules';
  additional_info: ValidationRule;
  city: ValidationRule;
  company: ValidationRule;
  country: ValidationRule;
  email: ValidationRule;
  name: ValidationRule;
  phone_number: ValidationRule;
  streetname: ValidationRule;
  zip: ValidationRule;
};

export type OpsOrdersSearchResponse = {
  __typename?: 'OpsOrdersSearchResponse';
  items: Array<OpsOrder>;
  total: Scalars['Int'];
};

/**
 * One warned item, or one request a checkpoint blocked. See
 * docs/clickhouse/opsWarnings.md.
 */
export type OpsWarning = {
  __typename?: 'OpsWarning';
  /** The viewer, or the self-heal system actor. */
  actor_user_id: Scalars['String'];
  /** True when the warning accompanies a state change this code inferred. */
  auto_healed: Scalars['Boolean'];
  blocking_orders: Array<OpsWarningBlockingOrder>;
  carrier: Scalars['String'];
  /**
   * An OpsWarningCode when outcome is WARNED. The rejection's error code, such
   * as SCANNED_ITEM_NOT_FOUND, when outcome is BLOCKED.
   */
  code: Scalars['String'];
  /** The older picking job holding the claim. Picking only. */
  conflicting_picking_job_id: Scalars['String'];
  /** Free text. On a BLOCKED row, the reason the request was rejected with. */
  detail: Scalars['String'];
  event_account_id: Scalars['String'];
  event_id: Scalars['String'];
  /** The step the self-heal stopped at. Empty when it did not fail. */
  failed_steps: Array<SelfHealStep>;
  flow: OpsWarningFlow;
  /**
   * The scanned or returned instance. A blocked V2 scan that named no item id
   * holds the raw scanned code; a blocked receive shipment of several items
   * holds none.
   */
  item_id: Scalars['String'];
  /** Null where the flow could not classify the instance. */
  item_kind?: Maybe<OpsWarningItemKind>;
  merchant_order_id: Scalars['String'];
  occurred_at: Scalars['String'];
  /**
   * The GraphQL operation a checkpoint rejected, such as addItemToPickingJobV2.
   * Empty when outcome is WARNED.
   */
  operation: Scalars['String'];
  outcome: OpsWarningOutcome;
  /** The picking job being scanned into, or the one that was auto-confirmed. */
  picking_job_id: Scalars['String'];
  /** open_system / event */
  segment: Scalars['String'];
  stage: Scalars['String'];
  /** The steps of this warning's self-heal that completed, in order. */
  succeeded_steps: Array<SelfHealStep>;
  warehouse_item_location_id: Scalars['String'];
  warehouse_store_id: Scalars['String'];
};

/**
 * A merchant order that kept a cross-job claim alive, with the status it held
 * when the warning was raised — not its status now.
 */
export type OpsWarningBlockingOrder = {
  __typename?: 'OpsWarningBlockingOrder';
  merchant_order_id: Scalars['UUID'];
  revision_id: Scalars['Int'];
  status: Scalars['Int'];
  status_name: Scalars['String'];
};

/** Which compensating action a warehouse flow had to take. */
export enum OpsWarningCode {
  /** A delivery was confirmed by the self-heal system actor rather than by a human. flow says which warehouse flow confirmed it. */
  DeliveryAutoConfirmed = 'DELIVERY_AUTO_CONFIRMED',
  /** A receive shipment could not book the delivery of the picking job that still held the item. The job was left as it was, and the item was received as its location history says. detail names the failure. */
  DeliveryAutoConfirmFailed = 'DELIVERY_AUTO_CONFIRM_FAILED',
  /** A cross-job claim held by an open-system job, or by an event job whose orders bundle events that book at different times, was dropped: the picked row was deleted and the holding orders carry a new ERROR revision naming the item. On a picking scan, conflicting_picking_job_id is the job that took the item; on a receive shipment, picking_job_id is the job that lost it. */
  PickingClaimRemovedFromJob = 'PICKING_CLAIM_REMOVED_FROM_JOB',
  /** A picking scan hit a cross-job claim. The scan proceeded and the older picking job released its claim. */
  PickingItemOnUndeliveredJob = 'PICKING_ITEM_ON_UNDELIVERED_JOB',
  /** A received item's location history named no event account, so nothing could place it and no fulfillment was built. An item an open picking job still holds is the delivery-confirm case instead. */
  ReceiveShipmentItemWithoutEvent = 'RECEIVE_SHIPMENT_ITEM_WITHOUT_EVENT',
  /** The item was booked back from its event to the warehouse without a human receiving it, so a scan or a return could proceed. */
  ReturnAutoBooked = 'RETURN_AUTO_BOOKED'
}

/**
 * Every field is optional and narrows the result. An omitted field does not
 * filter at all; an empty list is the same as omitting it.
 */
export type OpsWarningFilter = {
  carriers?: InputMaybe<Array<Scalars['String']>>;
  /** OpsWarningCode values and rejection error codes alike. */
  codes?: InputMaybe<Array<Scalars['String']>>;
  event_ids?: InputMaybe<Array<Scalars['ID']>>;
  flows?: InputMaybe<Array<OpsWarningFlow>>;
  /** ISO timestamp. Inclusive. */
  from?: InputMaybe<Scalars['String']>;
  /** The scanned or returned instances, as item_id holds them. */
  item_ids?: InputMaybe<Array<Scalars['ID']>>;
  outcomes?: InputMaybe<Array<OpsWarningOutcome>>;
  /** ISO timestamp. Inclusive. */
  to?: InputMaybe<Scalars['String']>;
  warehouse_store_ids?: InputMaybe<Array<Scalars['UUID']>>;
};

export enum OpsWarningFlow {
  Picking = 'PICKING',
  ReceiveShipment = 'RECEIVE_SHIPMENT'
}

/**
 * What kind of instance a warning is about. UNTRACKED_ITEM is never scanned,
 * but it is ordered and therefore picked, so it warns like the rest.
 */
export enum OpsWarningItemKind {
  Container = 'CONTAINER',
  ContainerStation = 'CONTAINER_STATION',
  Item = 'ITEM',
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** What the flow did with the request. */
export enum OpsWarningOutcome {
  /** A checkpoint rejected the request. code is the error code the request was rejected with; detail is its reason. */
  Blocked = 'BLOCKED',
  /** The flow met a contradicting state, took the compensating action and went on. code is an OpsWarningCode. */
  Warned = 'WARNED'
}

export type OpsWarningsPaginatedResult = {
  __typename?: 'OpsWarningsPaginatedResult';
  rows: Array<OpsWarning>;
  total: Scalars['Int'];
};

export type Order = {
  __typename?: 'Order';
  basket_id?: Maybe<Scalars['ID']>;
  bell_status?: Maybe<BellStatus>;
  booked?: Maybe<Scalars['Boolean']>;
  campaign?: Maybe<Campaign>;
  code_emoji?: Maybe<Scalars['String']>;
  code_text?: Maybe<Scalars['String']>;
  commission_rate?: Maybe<Scalars['Int']>;
  containers?: Maybe<Array<Maybe<Container>>>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  cutlery?: Maybe<CutleryPreferences>;
  delivery_address?: Maybe<DeliveryAddress>;
  delivery_fee?: Maybe<Scalars['Int']>;
  discount_amount?: Maybe<Scalars['Int']>;
  discount_by_vytal_credits: Scalars['Int'];
  discount_platform_cost?: Maybe<Scalars['Int']>;
  eat_in?: Maybe<Scalars['Boolean']>;
  external_id?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_master?: Maybe<Scalars['Boolean']>;
  is_shared?: Maybe<Scalars['Boolean']>;
  is_test_order?: Maybe<Scalars['Boolean']>;
  item_count?: Maybe<Scalars['Int']>;
  item_total?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<OrderItem>>>;
  main_basket_id?: Maybe<Scalars['ID']>;
  main_order_id?: Maybe<Scalars['ID']>;
  master_user_id?: Maybe<Scalars['ID']>;
  min_delivery_order_value_diff?: Maybe<Scalars['Int']>;
  min_order_value_diff?: Maybe<Scalars['Int']>;
  new_master_notified?: Maybe<Scalars['Boolean']>;
  payment_method?: Maybe<Scalars['String']>;
  paypal_info?: Maybe<PaypalData>;
  pickedup_time?: Maybe<Scalars['String']>;
  pickup_time?: Maybe<Scalars['String']>;
  platform_fee?: Maybe<Scalars['Int']>;
  platform_fee_campaign_id?: Maybe<Scalars['ID']>;
  readable_id?: Maybe<Scalars['ID']>;
  status?: Maybe<StatusEnum>;
  status_history?: Maybe<Array<Maybe<StatusHistory>>>;
  store?: Maybe<Store>;
  store_discount_amount?: Maybe<Scalars['Int']>;
  store_id?: Maybe<Scalars['ID']>;
  store_total?: Maybe<Scalars['Int']>;
  store_vat_total?: Maybe<Array<Maybe<VatGroup>>>;
  stripe_charge_id?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<OrderTags>>>;
  tenant?: Maybe<TenantType>;
  terminal_total?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['ID']>;
  transfer_amount?: Maybe<Scalars['Int']>;
  type?: Maybe<OrderType>;
  updated_at?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']>;
  user_rating?: Maybe<OrderUserRating>;
  users_infos?: Maybe<Array<Maybe<SharedOrderInfo>>>;
  vat_total?: Maybe<Array<Maybe<VatGroup>>>;
  vending_machine?: Maybe<VendingMachine>;
  vending_machine_qr_code?: Maybe<Scalars['String']>;
};

export type OrderCreatedResult = Order | PaymentAuthRequired | VendingMachineOrderError;

export type OrderFulfillment = {
  __typename?: 'OrderFulfillment';
  assets: Array<TrackableItem>;
  authorized_signer_id?: Maybe<Scalars['ID']>;
  authorized_signer_name?: Maybe<Scalars['String']>;
  change_history: Array<OrderFulfillmentChange>;
  container_stations: Array<OrderFulfillmentContainerStation>;
  created_by_id: Scalars['ID'];
  created_by_name: Scalars['String'];
  event: Event;
  event_account: EventAccount;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  goodwill: Array<ContainerTypeAmount>;
  id: Scalars['ID'];
  is_billable: Scalars['Boolean'];
  item_location: ItemLocation;
  manual_amounts: Array<ContainerTypeAmount>;
  pictures: Array<OrderFulfillmentPicture>;
  single_containers: Array<OrderFulfillmentContainerLocation>;
  status: OrderFulfillmentStatus;
  timestamp: Scalars['String'];
  type: Scalars['String'];
};

export type OrderFulfillmentChange = {
  __typename?: 'OrderFulfillmentChange';
  changed_at: Scalars['String'];
  changed_by_id: Scalars['ID'];
  changed_by_name: Scalars['String'];
  new_values: Scalars['String'];
  old_values: Scalars['String'];
};

export type OrderFulfillmentContainerLocation = {
  __typename?: 'OrderFulfillmentContainerLocation';
  container_id: Scalars['ID'];
  container_name: Scalars['String'];
  container_station_id?: Maybe<Scalars['ID']>;
  container_type_id: Scalars['Int'];
  container_type_image?: Maybe<Scalars['String']>;
  container_type_name: Scalars['String'];
  container_type_packing_unit?: Maybe<Scalars['Int']>;
  container_type_size_helper?: Maybe<Scalars['String']>;
  next_owner_id?: Maybe<Scalars['ID']>;
  owner_till?: Maybe<Scalars['String']>;
};

export type OrderFulfillmentContainerStation = {
  __typename?: 'OrderFulfillmentContainerStation';
  /** @deprecated Use item_type instead */
  color_hex_code?: Maybe<Scalars['String']>;
  containers: Array<OrderFulfillmentContainerLocation>;
  counted_after_return: Scalars['Boolean'];
  counted_at?: Maybe<Scalars['String']>;
  counted_by_id?: Maybe<Scalars['ID']>;
  counted_by_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use item_type instead */
  image_url?: Maybe<Scalars['String']>;
  item_type: ItemType;
  manual_amounts: Array<ContainerTypeAmount>;
  name: Scalars['String'];
  pictures: Array<OrderFulfillmentPicture>;
  returned_sealed: Scalars['Boolean'];
  sealed: Scalars['Boolean'];
  status: ContainerStationStatus;
  /** @deprecated Use item_type instead */
  type: ContainerStationType;
};

export type OrderFulfillmentContainerStationReduced = {
  __typename?: 'OrderFulfillmentContainerStationReduced';
  id: Scalars['ID'];
  missing_container_count: Scalars['Int'];
  name: Scalars['String'];
};

export type OrderFulfillmentFilter = {
  authorized_signer_id?: InputMaybe<Scalars['ID']>;
  container_type_ids?: InputMaybe<Array<Scalars['Int']>>;
  end_date?: InputMaybe<Scalars['String']>;
  event_account_id?: InputMaybe<Scalars['ID']>;
  event_id?: InputMaybe<Scalars['ID']>;
  item_location_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderFulfillmentStatus>;
  type?: InputMaybe<OrderFulfillmentType>;
};

export type OrderFulfillmentPaginatedResult = {
  __typename?: 'OrderFulfillmentPaginatedResult';
  order_fulfillments: Array<OrderFulfillment>;
  total: Scalars['Int'];
};

export type OrderFulfillmentPicture = {
  __typename?: 'OrderFulfillmentPicture';
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  created_by_id: Scalars['ID'];
  created_by_name: Scalars['String'];
  id: Scalars['ID'];
  item_location_history_entry_id?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  order_fulfillment_id?: Maybe<Scalars['ID']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  taken_at?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  url_full_size: Scalars['String'];
};

export type OrderFulfillmentPictureFilter = {
  comment?: InputMaybe<Scalars['String']>;
  created_by_user_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};

export enum OrderFulfillmentStatus {
  AllCounted = 'ALL_COUNTED',
  MissingCounts = 'MISSING_COUNTS'
}

export enum OrderFulfillmentType {
  CountAndPack = 'COUNT_AND_PACK',
  Delivery = 'DELIVERY',
  PackedBoxesAfterCleaning = 'PACKED_BOXES_AFTER_CLEANING',
  Picking = 'PICKING',
  ReceiveShipment = 'RECEIVE_SHIPMENT',
  Return = 'RETURN'
}

export type OrderFulfillmentTypeCount = {
  __typename?: 'OrderFulfillmentTypeCount';
  amount: Scalars['Int'];
  amount_container_stations: Scalars['Int'];
  amount_sealed: Scalars['Int'];
  fulfillment_type: OrderFulfillmentType;
};

export type OrderFulfillmentTypeCountV2 = {
  __typename?: 'OrderFulfillmentTypeCountV2';
  amount: Scalars['Int'];
  amount_container_stations: Scalars['Int'];
  /**
   * Only populated when fulfillment_type is RECEIVE_SHIPMENT (and only on
   * container_types entries). It is the count of picked container stations
   * (for this container type, scoped to the same event) that were SEALED on
   * the matching receive shipment fulfillment. Always 0 for every other
   * fulfillment_type and on container_stations / assets entries.
   */
  amount_container_stations_sealed: Scalars['Int'];
  amount_sealed: Scalars['Int'];
  fulfillment_type: OrderFulfillmentType;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  canceled?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  store_total?: Maybe<Scalars['Int']>;
  successful?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  base_price?: Maybe<Scalars['Int']>;
  brand_id?: Maybe<Scalars['ID']>;
  category_id?: Maybe<Scalars['ID']>;
  charged_price_total?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  disabled_minutes?: Maybe<Scalars['Int']>;
  extras?: Maybe<Array<Maybe<Extra>>>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  in_stock?: Maybe<Scalars['Boolean']>;
  is_hot?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  price?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  ready?: Maybe<Scalars['Boolean']>;
  stock_quantity?: Maybe<Scalars['Int']>;
  store_id?: Maybe<Scalars['ID']>;
  store_product?: Maybe<ProductStore>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  teaser_text?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['ID']>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type OrderTags = {
  __typename?: 'OrderTags';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export enum OrderType {
  DeliveryOrder = 'DELIVERY_ORDER',
  InstantOrder = 'INSTANT_ORDER',
  PreOrder = 'PRE_ORDER'
}

export enum OrderUserRating {
  Happy = 'HAPPY',
  Ok = 'OK',
  Sad = 'SAD'
}

export type OrderWarehouseConfig = {
  __typename?: 'OrderWarehouseConfig';
  event: WarehouseRouting;
  non_event: WarehouseRouting;
};

export type OrderWarehouseConfigInput = {
  event: WarehouseRoutingInput;
  non_event: WarehouseRoutingInput;
};

export enum OrderbyEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderingService = {
  __typename?: 'OrderingService';
  ordering_service_type: OrderingServiceType;
  url?: Maybe<Scalars['String']>;
};

export enum OrderingServiceType {
  DidiFood = 'DIDI_FOOD',
  /** @deprecated EATIC is now LABONAPP. */
  Eatic = 'EATIC',
  Foodora = 'FOODORA',
  Habgusta = 'HABGUSTA',
  Labonapp = 'LABONAPP',
  Lieferando = 'LIEFERANDO',
  Mjam = 'MJAM',
  Rappi = 'RAPPI',
  SplitApp = 'SPLIT_APP',
  TooGoodToGo = 'TOO_GOOD_TO_GO',
  Ubereats = 'UBEREATS',
  Wolt = 'WOLT'
}

export enum OutOfStockUntilType {
  Completely = 'COMPLETELY',
  Timeout = 'TIMEOUT',
  Tomorrow = 'TOMORROW'
}

export type OverduePenaltyBillRefundResult = {
  __typename?: 'OverduePenaltyBillRefundResult';
  id: Scalars['ID'];
  payment_state: Scalars['Int'];
  refunded_amount?: Maybe<Scalars['Float']>;
};

export type OverduePenaltyContainerKey = {
  container_id: Scalars['ID'];
  container_location_number: Scalars['String'];
};

export type OverwriteCampaign = {
  campaign_id?: InputMaybe<Scalars['ID']>;
  no_fee_campaign_id?: InputMaybe<Scalars['ID']>;
};

export type PaginatedStoresResult = {
  __typename?: 'PaginatedStoresResult';
  last_evaluated_key?: Maybe<Scalars['ID']>;
  stores?: Maybe<Array<Maybe<Store>>>;
};

export type ParticipateInRaffleResponse = {
  __typename?: 'ParticipateInRaffleResponse';
  raffle_participant_id?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PartnerAccountSearchEventMatch = {
  __typename?: 'PartnerAccountSearchEventMatch';
  event: Event;
  matched: Scalars['Boolean'];
  score: Scalars['Float'];
};

export enum PartnerAccountSearchMatchType {
  Ancestor = 'ANCESTOR',
  Descendant = 'DESCENDANT',
  DirectAccount = 'DIRECT_ACCOUNT',
  ViaEvent = 'VIA_EVENT',
  ViaStore = 'VIA_STORE'
}

export type PartnerAccountSearchNode = {
  __typename?: 'PartnerAccountSearchNode';
  children: Array<PartnerAccountSearchNode>;
  event_account: EventAccount;
  events: Array<PartnerAccountSearchEventMatch>;
  match_type: PartnerAccountSearchMatchType;
  score: Scalars['Float'];
  stores: Array<PartnerAccountSearchStoreMatch>;
};

export type PartnerAccountSearchResult = {
  __typename?: 'PartnerAccountSearchResult';
  orphaned_events: Array<PartnerAccountSearchEventMatch>;
  orphaned_stores: Array<PartnerAccountSearchStoreMatch>;
  partner_accounts: Array<PartnerAccountSearchNode>;
  removed_stores_filtered_count: Scalars['Int'];
};

export type PartnerAccountSearchStoreMatch = {
  __typename?: 'PartnerAccountSearchStoreMatch';
  matched: Scalars['Boolean'];
  score: Scalars['Float'];
  store: Store;
};

export type PartnerAppFeatureFlags = {
  __typename?: 'PartnerAppFeatureFlags';
  admin_add_offline_cards_to_stock_enabled: Scalars['Boolean'];
  admin_add_to_container_collection_enabled: Scalars['Boolean'];
  admin_change_container_account_enabled: Scalars['Boolean'];
  admin_change_container_type_enabled: Scalars['Boolean'];
  admin_change_trackable_item_type_enabled: Scalars['Boolean'];
  change_item_location_enabled: Scalars['Boolean'];
  checkin_enabled: Scalars['Boolean'];
  checkout_enabled: Scalars['Boolean'];
  clear_box_content: Scalars['Boolean'];
  commissioning_enabled: Scalars['Boolean'];
  container_box_counting_enabled: Scalars['Boolean'];
  container_box_info_enabled: Scalars['Boolean'];
  container_box_packing_enabled: Scalars['Boolean'];
  container_collection_enabled: Scalars['Boolean'];
  count_and_pack: Scalars['Boolean'];
  delivery_confirmation_enabled: Scalars['Boolean'];
  event_delivery_enabled: Scalars['Boolean'];
  event_return_enabled: Scalars['Boolean'];
  link_return_qrcode_enabled: Scalars['Boolean'];
  order_enabled: Scalars['Boolean'];
  orderfulfillments_enabled: Scalars['Boolean'];
  past_inventory_checks_enabled: Scalars['Boolean'];
  picking_enabled: Scalars['Boolean'];
  receive_shipment_enabled: Scalars['Boolean'];
  statistics_enabled: Scalars['Boolean'];
  stock_enabled: Scalars['Boolean'];
  user_info_enabled: Scalars['Boolean'];
};

export type PartnerInvoice = {
  __typename?: 'PartnerInvoice';
  account_ledger?: Maybe<AccountLedger>;
  admin_info?: Maybe<BillomatInvoice>;
  date?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoice_number?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  parsed_amount?: Maybe<Scalars['String']>;
  parsed_payment_direction?: Maybe<Scalars['String']>;
  status?: Maybe<BillomatInvoiceStatus>;
  store_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  total_gross?: Maybe<Scalars['String']>;
  total_net?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PartnerSelfSignup = {
  __typename?: 'PartnerSelfSignup';
  address?: Maybe<PartnerSelfSignupAddress>;
  allow_marketing?: Maybe<Scalars['Boolean']>;
  bic?: Maybe<Scalars['String']>;
  billing_address?: Maybe<PartnerSelfSignupAddress>;
  company_name?: Maybe<Scalars['String']>;
  company_type?: Maybe<Scalars['String']>;
  completed_steps?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  has_foodora?: Maybe<Scalars['Boolean']>;
  has_lieferando?: Maybe<Scalars['Boolean']>;
  has_mjam?: Maybe<Scalars['Boolean']>;
  has_uber_eats?: Maybe<Scalars['Boolean']>;
  has_wolt?: Maybe<Scalars['Boolean']>;
  how_did_you_know_about_vytal?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  iban_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  package?: Maybe<Scalars['String']>;
  panda_doc_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  referred_by?: Maybe<Scalars['String']>;
  signed_at?: Maybe<Scalars['String']>;
  signup_code?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
  wanted_container_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PartnerSelfSignupAddress = {
  __typename?: 'PartnerSelfSignupAddress';
  city?: Maybe<Scalars['String']>;
  cost_center?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  invoice_email?: Maybe<Scalars['String']>;
  poi_box?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type PartnerSelfSignupAddressUpdate = {
  city?: InputMaybe<Scalars['String']>;
  cost_center?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  invoice_email?: InputMaybe<Scalars['String']>;
  poi_box?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type PartnerSelfSignupConfig = {
  __typename?: 'PartnerSelfSignupConfig';
  billing_address?: Maybe<PartnerSelfSignupAddress>;
  cancelation_terms?: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  id: Scalars['String'];
  onboarding_fee_cent: Scalars['Int'];
  products_onboarding?: Maybe<Array<Maybe<OnboardingProduct>>>;
  products_purchase?: Maybe<Array<Maybe<ProductPurchase>>>;
  products_rental?: Maybe<Array<Maybe<ProductRental>>>;
  products_transactions?: Maybe<Array<Maybe<ProductTransactions>>>;
  signup_code: Scalars['String'];
  type: PartnerSelfSignupConfigType;
};

export enum PartnerSelfSignupConfigType {
  Caterer = 'CATERER',
  Kam = 'KAM'
}

export type PartnerSelfSignupConfigUpdate = {
  billing_address?: InputMaybe<PartnerSelfSignupAddressUpdate>;
  cancelation_terms?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  onboarding_fee_cent?: InputMaybe<Scalars['Int']>;
  products_onboarding?: InputMaybe<Array<InputMaybe<OnboardingProductUpdate>>>;
  products_purchase?: InputMaybe<Array<InputMaybe<ProductPurchaseUpdate>>>;
  products_rental?: InputMaybe<Array<InputMaybe<ProductRentalUpdate>>>;
  products_transactions?: InputMaybe<Array<InputMaybe<ProductTransactionsUpdate>>>;
  type?: InputMaybe<PartnerSelfSignupConfigType>;
};

export type PaymentAuthRequired = {
  __typename?: 'PaymentAuthRequired';
  client_secret?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type PaymentConfirmation = {
  __typename?: 'PaymentConfirmation';
  id: Scalars['ID'];
  total: Scalars['Int'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  client_secret?: Maybe<Scalars['String']>;
};

export enum PaymentStatusEnum {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  TokenActive = 'TOKEN_ACTIVE'
}

export type PaypalData = {
  __typename?: 'PaypalData';
  authorizationId?: Maybe<Scalars['ID']>;
  captureId?: Maybe<Scalars['ID']>;
  paymentId?: Maybe<Scalars['ID']>;
  refundId?: Maybe<Scalars['ID']>;
};

export type PaypalDataInput = {
  authorizationId?: InputMaybe<Scalars['ID']>;
  captureId?: InputMaybe<Scalars['ID']>;
  payerId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
  refundId?: InputMaybe<Scalars['ID']>;
};

export type PaypalPaymentInfo = {
  __typename?: 'PaypalPaymentInfo';
  approvalUrl?: Maybe<Scalars['String']>;
  authorizationId?: Maybe<Scalars['ID']>;
  captureId?: Maybe<Scalars['ID']>;
  paymentId?: Maybe<Scalars['ID']>;
  refundId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type PickingJob = {
  __typename?: 'PickingJob';
  /**
   * System-calculated package count from calcPackageCount, for the OS
   * flow. Lets the FE display "calculated: 3, you sent: 4" before
   * confirming. Null on event-segment jobs.
   */
  calculated_package_count?: Maybe<Scalars['Int']>;
  /**
   * Calculated pallet count (ignores any override). Always set on
   * materialized jobs.
   */
  calculated_pallet_count?: Maybe<Scalars['Int']>;
  /**
   * Calculated total weight in *kilograms*, rounded UP (ceil), ignoring
   * any override. Includes both item weight and pallet tare (same rule as
   * total_weight). Always set on materialized jobs so the picker can see
   * both the model number and any manual correction side by side.
   */
  calculated_total_weight?: Maybe<Scalars['Int']>;
  carrier_delivery_date?: Maybe<Scalars['String']>;
  /**
   * Comment left by the confirming user on the latest delivery confirm
   * (confirmPickingJobDelivery). Required when the job was confirmed
   * DELIVERY_INCOMPLETE. Overwritten on each confirm; null until first
   * confirmed.
   */
  carrier_employee_comment?: Maybe<Scalars['String']>;
  carrier_pickup_date?: Maybe<Scalars['String']>;
  context: PickingJobContext;
  created_at: Scalars['String'];
  /** Timestamp of the latest delivery confirm. Null until first confirmed. */
  delivery_confirmed_at?: Maybe<Scalars['String']>;
  /** User who performed the latest delivery confirm. Null until first confirmed. */
  delivery_confirmed_by?: Maybe<IdName>;
  destination: PickingJobDestination;
  /**
   * Contact email of the warehouse store, sourced from its DynamoDB
   * delivery_address.email (resolved via MerchantStores.ExternalPickpackId
   * on the warehouse). The stored field may hold several comma/semicolon-
   * separated addresses; this returns the first (primary) one. The
   * picking-confirm email still reaches every configured address. Null when
   * the warehouse has no DynamoDB record or no delivery email on file.
   */
  email_warehouse?: Maybe<Scalars['String']>;
  /**
   * Whether any picked row of the job is booked (BookedAt) or delivered
   * (DeliveredAt). An EVENT job with such rows cannot be resolved to the
   * WAREHOUSE (resolvePickingJob refuses it with INVALID_STATUS): its stock is
   * inside a billable fulfillment, even while the status still says
   * PICKING_IN_PROGRESS. False for a virtual job.
   */
  has_booked_or_delivered_rows: Scalars['Boolean'];
  health: PickingJobHealth;
  id: Scalars['ID'];
  item_location_warehouse: IdName;
  items: Array<PickingJobItem>;
  ops_orders: Array<PickingJobOpsOrder>;
  order_type: PickingJobOrderType;
  /**
   * Number of packages effectively used for shipping this job's order.
   * Open-system only (1 picking job ↔ 1 merchant order today); null for
   * event-segment jobs. Equal to package_weights.length.
   */
  package_count?: Maybe<Scalars['Int']>;
  /**
   * Per-package shipping weights in kilograms for the linked merchant
   * order, sourced from MerchantOrderRevisions.PackageWeights. Open-system
   * only; null for event-segment jobs. Use updatePickingJob or
   * confirmPickingJob's package_weights_kg arg to overwrite.
   */
  package_weights?: Maybe<Array<Scalars['Int']>>;
  /**
   * Effective pallet count: the event-segment override
   * (PickingJobs.OverridePalletCount) when set, otherwise the calculated
   * value from calculatePalletCount(...). Null for virtual jobs.
   */
  pallet_count?: Maybe<Scalars['Int']>;
  print_jobs: Array<PrintJob>;
  /**
   * Where an admin decided this job's stock went (resolvePickingJob, or the
   * outbound error resolution before it), with when, by whom and why. Null
   * while the job is unresolved, and always on a virtual job.
   */
  resolution?: Maybe<PickingJobResolution>;
  segment: PickingJobSegment;
  status: PickingJobStatus;
  total_amount_ordered: Scalars['Int'];
  total_amount_picked: Scalars['Int'];
  /**
   * Effective shipping weight in *kilograms*, rounded UP (ceil): the
   * event-segment override (PickingJobs.OverrideTotalWeightG) when set,
   * otherwise the calculated sum (Σ per-bucket weight) across every bucket
   * plus the hardcoded pallet tare weight (25 kg per Europallet, 30 kg per
   * US pallet × calculated_pallet_count). Per bucket this is weight_g ×
   * pieces, except event_portfolio CONTAINER types whose weight_g is already
   * per-station and is multiplied by stations (boxes). Always rounds up so
   * the displayed weight never undersells the shipment. Null for
   * still-virtual PICKING_NOT_STARTED jobs.
   */
  total_weight?: Maybe<Scalars['Int']>;
  updated_at: Scalars['String'];
  /**
   * Phone number to reach with picking questions. For event-segment jobs
   * this is the event manager's Mobile (falling back to Phone) from the
   * bundled event's ZohoUser. For open-system jobs it's the warehouse
   * store's DynamoDB delivery_address.phone_number. Null when the
   * underlying field is empty.
   */
  whatsapp?: Maybe<Scalars['String']>;
};

/**
 * Echoed back on every PickingJob response so the frontend never has to
 * reconstruct it. Pass the same value into mutations and getPickingJob to
 * resolve still-virtual jobs.
 *
 * wave is the bundling-key wave counter — wave 0 is the first job at this
 * (delivery_address, carrier_pickup_date, item_location) triple; once that
 * job is confirmed (PICKED), subsequent SENT_TO_PICKING orders at the same
 * bundling key surface as wave 1, then wave 2, etc. The deterministic
 * picking_job_id includes the wave in its uuidv5 input, so each wave gets
 * a fresh distinct id.
 */
export type PickingJobContext = {
  __typename?: 'PickingJobContext';
  carrier_pickup_date: Scalars['String'];
  delivery_address_id: Scalars['ID'];
  item_location_id: Scalars['UUID'];
  segment: PickingJobSegment;
  wave: Scalars['Int'];
};

export type PickingJobContextInput = {
  carrier_pickup_date: Scalars['String'];
  delivery_address_id: Scalars['ID'];
  item_location_id: Scalars['UUID'];
  segment: PickingJobSegment;
  wave?: InputMaybe<Scalars['Int']>;
};

/**
 * Every error code the delivery feature can return via
 * errors[].extensions.code. Exposed so the frontend can switch on codes
 * type-safely (its codegen generates a matching TS enum) instead of comparing
 * raw strings. Grouped by origin: Notion-aligned scan checkpoints, net-new
 * delivery codes, and backend-only validation. Add a new code here whenever a
 * delivery error path is introduced so the FE's exhaustive switch keeps up.
 */
export enum PickingJobDeliveryErrorCode {
  AmbiguousScan = 'AMBIGUOUS_SCAN',
  BoxContentMismatch = 'BOX_CONTENT_MISMATCH',
  BoxRecalled = 'BOX_RECALLED',
  CollectionCodeNotAllowed = 'COLLECTION_CODE_NOT_ALLOWED',
  ContainerNotAllowed = 'CONTAINER_NOT_ALLOWED',
  DeliveryNotEligibleCarrier = 'DELIVERY_NOT_ELIGIBLE_CARRIER',
  DeliveryNotEligibleEventType = 'DELIVERY_NOT_ELIGIBLE_EVENT_TYPE',
  EventStockNotBooked = 'EVENT_STOCK_NOT_BOOKED',
  FilterTooBroad = 'FILTER_TOO_BROAD',
  Forbidden = 'FORBIDDEN',
  IncompletePickingBlocksConfirm = 'INCOMPLETE_PICKING_BLOCKS_CONFIRM',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidStatus = 'INVALID_STATUS',
  ItemAlreadyDelivered = 'ITEM_ALREADY_DELIVERED',
  ItemBookedToEventAccount = 'ITEM_BOOKED_TO_EVENT_ACCOUNT',
  ItemMovedSincePicking = 'ITEM_MOVED_SINCE_PICKING',
  ItemNotDelivered = 'ITEM_NOT_DELIVERED',
  ItemNotInPickingJob = 'ITEM_NOT_IN_PICKING_JOB',
  ItemNotPickedForEvent = 'ITEM_NOT_PICKED_FOR_EVENT',
  JobAlreadyDelivered = 'JOB_ALREADY_DELIVERED',
  JobAlreadyResolved = 'JOB_ALREADY_RESOLVED',
  LabelRetryInProgress = 'LABEL_RETRY_IN_PROGRESS',
  MissingComment = 'MISSING_COMMENT',
  NotAllDelivered = 'NOT_ALL_DELIVERED',
  PickingJobNotFound = 'PICKING_JOB_NOT_FOUND',
  ScannedItemNotFound = 'SCANNED_ITEM_NOT_FOUND',
  SearchTooShort = 'SEARCH_TOO_SHORT',
  StatusTransitionNotAllowed = 'STATUS_TRANSITION_NOT_ALLOWED',
  StockNotBookable = 'STOCK_NOT_BOOKABLE',
  UntrackedNotScannable = 'UNTRACKED_NOT_SCANNABLE'
}

/** Status a picker can finalize a delivery with via confirmPickingJobDelivery. */
export enum PickingJobDeliveryStatusInput {
  Delivered = 'DELIVERED',
  DeliveryIncomplete = 'DELIVERY_INCOMPLETE'
}

export type PickingJobDestination = {
  __typename?: 'PickingJobDestination';
  /**
   * ISO 3166-1 alpha-2 country of the delivery address
   * (DeliveryAddresses.Country). Null when the address has no country.
   */
  country?: Maybe<Scalars['String']>;
  drop_off_location?: Maybe<IdName>;
  event?: Maybe<PickingJobEvent>;
  partner_name?: Maybe<Scalars['String']>;
};

export type PickingJobEvent = {
  __typename?: 'PickingJobEvent';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
};

export enum PickingJobHealth {
  AtRisk = 'AT_RISK',
  OnTime = 'ON_TIME'
}

/**
 * One bucket of items to pick within a job — uniquely keyed by (category, type_id).
 * The type_id refers to ContainerTypes.Id, ItemTypes.Id, or MerchantOrderItemOptions.TypeId
 * depending on category. amount_picked is always 0 for virtual (Phase 1) jobs.
 */
export type PickingJobItem = {
  __typename?: 'PickingJobItem';
  /**
   * How much of this bucket has been delivered, computed with the SAME dispatch
   * as amount_picked (so the two reconcile per bucket and share the event
   * box-normalization): a delivered container station fans its contents across
   * their CONTAINER buckets, a trackable/asset counts as 1 on its ITEM bucket,
   * and untracked rows contribute their (partial-aware) delivered pieces. For
   * EVENT jobs CONTAINER amounts are in boxes (ceil(pieces / packing_unit)),
   * matching amount_ordered / amount_picked; open-system stays in pieces.
   * Always 0 on virtual jobs.
   */
  amount_delivered: Scalars['Int'];
  amount_ordered: Scalars['Int'];
  amount_picked: Scalars['Int'];
  category: OpsOrderItemCategory;
  hex_code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  is_over_picked: Scalars['Boolean'];
  /**
   * Number of pieces per box for CONTAINER buckets (1 means each piece is its own box).
   * Null for ITEM and UNTRACKED_ITEM buckets, where the concept doesn't apply.
   */
  packing_unit?: Maybe<Scalars['Int']>;
  picking_job_id: Scalars['ID'];
  type_id: Scalars['Int'];
  type_name: Scalars['String'];
};

export type PickingJobListItem = {
  __typename?: 'PickingJobListItem';
  /**
   * Box counts split into S (cutlery) and L (everything else), matching
   * MerchantOrder.box_counts.
   */
  box_counts: Array<OpsOrderBoxCount>;
  carrier_delivery_date?: Maybe<Scalars['String']>;
  carrier_pickup_date?: Maybe<Scalars['String']>;
  context: PickingJobContext;
  destination: PickingJobDestination;
  health: PickingJobHealth;
  id: Scalars['ID'];
  order_type: PickingJobOrderType;
  /**
   * Pallet roll-up (ceil(total boxes / DEFAULT_BOXES_PER_PALLET)), matching
   * PickingJob.pallet_count.
   */
  pallet_count: Scalars['Int'];
  segment: PickingJobSegment;
  status: PickingJobStatus;
  total_amount_ordered: Scalars['Int'];
  total_amount_picked: Scalars['Int'];
  /**
   * Sum of (type weight × amount) across every bucket plus the hardcoded
   * pallet tare weight × pallet_count, converted to *kilograms* and rounded
   * UP (ceil) to match PickingJob.total_weight. Per-piece weight comes from
   * ContainerType.Weight × pieces for normal CONTAINER buckets,
   * ItemTypes.Weight for ITEM and CONTAINER_STATION buckets, and a hardcoded
   * 500 g default for UNTRACKED buckets. event_portfolio CONTAINER types are
   * the exception: their ContainerType.Weight already holds the per-station
   * weight (a full PackingUnit of pieces plus the station box), so it is
   * multiplied by the number of stations, not pieces. Pallet tare is 25 kg
   * per Europallet, 30 kg per US pallet (routed by destination country,
   * same mapping as pallet_count). Reflects any event-segment override.
   */
  total_weight: Scalars['Int'];
  /**
   * All ITEM-category buckets ordered on this job (assets, container
   * stations, store assets — distinguished by each entry's category field).
   */
  trackable_items: Array<PickingJobTrackableItem>;
};

export type PickingJobOpsOrder = {
  __typename?: 'PickingJobOpsOrder';
  comment?: Maybe<Scalars['String']>;
  delivery_note_id?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  ops_comment?: Maybe<Scalars['String']>;
  /**
   * Whether this job owns the order. False when the order is also linked to a
   * newer live picking job (it was resolved to the warehouse and picked again,
   * or its job froze and the next wave took it): that job owns its status and
   * its shipment, and this job's resolution leaves it alone and ignores it in
   * its gates. Always true on a virtual (not yet materialized) job.
   */
  owned_by_job: Scalars['Boolean'];
  status: MerchantOrderStatusEnum;
  type?: Maybe<MerchantOrderTypeEnum>;
};

export enum PickingJobOrderType {
  Onboarding = 'ONBOARDING',
  Resupply = 'RESUPPLY'
}

/**
 * A single picker action recorded against a bucket. reference_id is the
 * scanned instance id (Container.Id, ContainerStation.Id, or TrackableItem.Id)
 * for tracked categories, and null for UNTRACKED_ITEM. name is the
 * human-readable label, resolved from the strongest-typed source for the
 * scan: ContainerStation.Name → Container.Name → ItemType.Name →
 * MerchantOrderItemOption.Name.
 *
 * When the (category, type_id) filter on getPickingJobPickedItems is set,
 * amount reflects the row's contribution to that specific bucket — most
 * notably, a ContainerStation scan contributes the count of its current
 * contents matching the requested ContainerType, so one station row appears
 * with amount=N rather than N separate rows.
 */
export type PickingJobPickedItem = {
  __typename?: 'PickingJobPickedItem';
  added_at: Scalars['String'];
  added_by?: Maybe<IdName>;
  amount: Scalars['Int'];
  /**
   * How much of this scan row has been marked delivered (0..amount). For
   * tracked rows this is 0 or 1; for UNTRACKED_ITEM rows it counts up across
   * partial mark-as-delivered calls.
   */
  delivered_amount: Scalars['Int'];
  /** Timestamp the row reached full delivery (delivered_amount == amount). Null until then. */
  delivered_at?: Maybe<Scalars['String']>;
  /** User who finalized delivery of this row. Null until fully delivered. */
  delivered_by?: Maybe<IdName>;
  id: Scalars['ID'];
  /**
   * What this row's scan booked, and so what reference_id holds:
   *   CONTAINER         → Container.Id (uuid)
   *   CONTAINER_STATION → ContainerStation.Id (6 characters)
   *   ITEM              → TrackableItem.Id (6 characters)
   *   UNTRACKED_ITEM    → reference_id is null
   * It is the kind of the scanned thing, not of the bucket: a station scan
   * stays CONTAINER_STATION with the station id even when a CONTAINER filter
   * fans its contents into amount. Never CONTAINER_COLLECTION — a collection
   * scan is booked as its individual containers. (kind, reference_id) has the
   * shape of the (category, item_id) pair resolvePickingJobByItem and the
   * mark mutations take.
   */
  kind: OpsOrderItemCategory;
  name?: Maybe<Scalars['String']>;
  picking_job_item_id: Scalars['ID'];
  reference_id?: Maybe<Scalars['String']>;
};

export type PickingJobPickedItemsPage = {
  __typename?: 'PickingJobPickedItemsPage';
  items: Array<PickingJobPickedItem>;
  total: Scalars['Int'];
};

export type PickingJobResolution = {
  __typename?: 'PickingJobResolution';
  destination: PickingJobResolutionDestination;
  reason: Scalars['String'];
  resolved_at: Scalars['String'];
  /** Null when the resolution recorded no actor. */
  resolved_by?: Maybe<IdName>;
};

/** Where resolvePickingJob sends a stuck job's picked stock. */
export enum PickingJobResolutionDestination {
  /** The stock is with the partner; the job ends DELIVERED. */
  Partner = 'PARTNER',
  /** The stock is (brought) back at the job's warehouse; the job ends RELEASED. */
  Warehouse = 'WAREHOUSE'
}

/**
 * Lean acknowledgement returned by addItemToPickingJobV2 — only what the scan
 * changed, instead of the full PickingJob. Merge recipe: patch changed_items
 * into the last full fetch by bucket id and replace total_amount_picked;
 * everything else on PickingJob (orders, weights, pallets, addresses, ...)
 * is unchanged by a scan.
 *
 * The complete refreshed job is additionally rebuilt by a background worker
 * and published to onPickingJobUpdate. That push is BEST-EFFORT and may
 * arrive out of order under concurrent scans — compare updated_at and ignore
 * pushes older than the state you already hold; reconcile with a
 * getPickingJob refetch when in doubt (e.g. on reconnect).
 */
export type PickingJobScanAck = {
  __typename?: 'PickingJobScanAck';
  /**
   * Buckets whose amount_picked changed from this scan. A single container
   * scan changes one bucket; a collection or open-system station scan can
   * change several (one per contained ContainerType, plus the transport box's
   * own 0-ordered bucket).
   */
  changed_items: Array<PickingJobScanAckItem>;
  id: Scalars['ID'];
  /**
   * The category the scan resolved to. For code-based scans this tells the
   * client what the code turned out to be (the CheckCode replacement).
   */
  scanned_category: OpsOrderItemCategory;
  /**
   * The resolved instance id the scan booked (container uuid, station id,
   * trackable id, collection id, or the untracked type id). For code-based
   * scans this is the only place the client learns it — pass this pair to
   * removeItemFromPickingJob to undo the scan.
   */
  scanned_item_id: Scalars['ID'];
  /** Job status after the scan (a scan never changes it: PICKING_IN_PROGRESS). */
  status: PickingJobStatus;
  /**
   * Post-scan Σ amount_picked across ALL buckets, same normalization as
   * PickingJob.total_amount_picked — replaces the job-level total on merge.
   */
  total_amount_picked: Scalars['Int'];
  /** ISO timestamp of the UpdatedAt bump this scan wrote. */
  updated_at: Scalars['String'];
};

/**
 * One bucket whose amounts changed as a result of an addItemToPickingJobV2
 * scan. id equals the corresponding PickingJobItem.id, so the client can merge
 * the new amounts into a previously fetched PickingJob by bucket id. Amounts
 * follow the exact same rules as PickingJobItem: for EVENT jobs CONTAINER
 * amounts are in boxes (ceil(pieces / packing_unit)); open-system stays in
 * pieces.
 */
export type PickingJobScanAckItem = {
  __typename?: 'PickingJobScanAckItem';
  amount_ordered: Scalars['Int'];
  amount_picked: Scalars['Int'];
  category: OpsOrderItemCategory;
  id: Scalars['ID'];
  is_over_picked: Scalars['Boolean'];
  type_id: Scalars['Int'];
};

export enum PickingJobSegment {
  Event = 'EVENT',
  OpenSystem = 'OPEN_SYSTEM'
}

/**
 * PICKING_NOT_STARTED is only ever returned for virtual jobs (not yet
 * materialized in the PickingJobs table). Once the first scan lands the job
 * exists with at minimum PICKING_IN_PROGRESS, and PICKED is the terminal
 * picking-side state. The delivery-side states (DELIVERY_IN_PROGRESS,
 * DELIVERY_INCOMPLETE, DELIVERED) follow PICKED for MANUAL-carrier jobs that
 * go through the delivery-confirmation flow.
 *
 * RELEASED is the second terminal state, next to DELIVERED. It is never
 * reached by the picking or delivery flow — only by resolvePickingJob to the
 * WAREHOUSE, an admin undoing a job that could not be delivered. Nothing
 * transitions out of it.
 */
export enum PickingJobStatus {
  Delivered = 'DELIVERED',
  DeliveryIncomplete = 'DELIVERY_INCOMPLETE',
  DeliveryInProgress = 'DELIVERY_IN_PROGRESS',
  Picked = 'PICKED',
  PickingInProgress = 'PICKING_IN_PROGRESS',
  PickingNotStarted = 'PICKING_NOT_STARTED',
  Released = 'RELEASED'
}

/**
 * One ITEM-category bucket on the picking job — an "asset" being picked
 * alongside containers (e.g. station racks, cleaning supplies, branded
 * decals). Surfaced as an array on the list item so the FE can render
 * asset-side detail without a follow-up getPickingJob call. category mirrors
 * ItemTypes.Category — nullable because the underlying column is nullable
 * in the DB even though every shipped row uses one of the three enum values.
 */
export type PickingJobTrackableItem = {
  __typename?: 'PickingJobTrackableItem';
  amount: Scalars['Int'];
  category?: Maybe<ItemTypeCategory>;
  name: Scalars['String'];
  type_id: Scalars['Int'];
};

export type PickupPoint = {
  __typename?: 'PickupPoint';
  image?: Maybe<Scalars['String']>;
  max_height?: Maybe<Scalars['String']>;
  scale?: Maybe<Scalars['Float']>;
};

export enum PickupPointType {
  Cashier = 'CASHIER',
  Drop = 'DROP',
  Vertical = 'VERTICAL'
}

export type PickupSlot = {
  __typename?: 'PickupSlot';
  end?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Product>>>;
  start?: Maybe<Scalars['String']>;
};

export type PickupSlotUpdate = {
  end?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['String']>;
};

export enum PostApplyPromotionActionType {
  Default = 'DEFAULT',
  WwfDonationScreen = 'WWF_DONATION_SCREEN'
}

export enum PowerCableStatusChange {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED'
}

export enum PowerStatusSource {
  StatusReport = 'STATUS_REPORT',
  UserAction = 'USER_ACTION'
}

export type PreorderedProducts = {
  __typename?: 'PreorderedProducts';
  order_id?: Maybe<Scalars['String']>;
  pickup_time?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  state?: Maybe<PreorderedState>;
  type?: Maybe<OrderType>;
};

export enum PreorderedState {
  Empty = 'EMPTY',
  Filled = 'FILLED'
}

export type PreviousNonUsageFeeInfo = {
  __typename?: 'PreviousNonUsageFeeInfo';
  exclusion_reason?: Maybe<Scalars['String']>;
  is_net_receiver: Scalars['Boolean'];
  last_updated_at?: Maybe<Scalars['String']>;
  month: Scalars['Int'];
  total: NonUsageFeeTotalInfo;
  year: Scalars['Int'];
};

export type PrintJob = {
  __typename?: 'PrintJob';
  content_type: Scalars['String'];
  content_url: Scalars['String'];
  created_at: Scalars['DateTime'];
  group_id?: Maybe<Scalars['ID']>;
  group_label?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_location_id: Scalars['ID'];
  status: PrintJobStatus;
  status_message?: Maybe<Scalars['String']>;
  target_printer_role: PrinterRole;
  updated_at: Scalars['DateTime'];
};

/**
 * Reserved for forward compatibility: the schema pins this union member so
 * downstream clients have a stable type when a v1.1 admin cancel arrives.
 * Nothing emits it in v1 — operator "stop this print" goes through
 * updatePrintJobStatus with status: FAILED.
 */
export type PrintJobCancelled = {
  __typename?: 'PrintJobCancelled';
  job_id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type PrintJobCreated = {
  __typename?: 'PrintJobCreated';
  job: PrintJob;
};

export type PrintJobEvent = PrintJobCancelled | PrintJobCreated | PrintJobUpdated;

export enum PrintJobStatus {
  AwaitingPrinterConfig = 'AWAITING_PRINTER_CONFIG',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Printing = 'PRINTING',
  Received = 'RECEIVED'
}

export type PrintJobUpdated = {
  __typename?: 'PrintJobUpdated';
  job: PrintJob;
};

export enum PrinterRole {
  DeliveryNote = 'DELIVERY_NOTE',
  Label = 'LABEL'
}

export type Problem = {
  __typename?: 'Problem';
  creation_timestamp: Scalars['String'];
  event_data: Scalars['String'];
  event_name: Scalars['String'];
  id: Scalars['ID'];
  store_name?: Maybe<Scalars['String']>;
  store_text_id?: Maybe<Scalars['String']>;
};

export enum ProblemType {
  BowlReturnedCharged = 'BOWL_RETURNED_CHARGED',
  BowlReturnedNotCharged = 'BOWL_RETURNED_NOT_CHARGED',
  Orther = 'ORTHER',
  Other = 'OTHER'
}

export type ProcessAccountLedgerResult = {
  __typename?: 'ProcessAccountLedgerResult';
  billomat_invoice_matched: Scalars['Boolean'];
  billomat_invoice_was_already_linked: Scalars['Boolean'];
  id: Scalars['ID'];
  match_log: Scalars['String'];
  store?: Maybe<Store>;
  store_id?: Maybe<Scalars['ID']>;
  was_already_existing: Scalars['Boolean'];
  was_created: Scalars['Boolean'];
  was_updated: Scalars['Boolean'];
};

export type ProcessAccountLedgersResult = {
  __typename?: 'ProcessAccountLedgersResult';
  created_count: Scalars['Int'];
  invoice_linked_count: Scalars['Int'];
  processed_count: Scalars['Int'];
  results: Array<ProcessAccountLedgerResult>;
  updated_count: Scalars['Int'];
};

export type Product = ProductInterface & {
  __typename?: 'Product';
  allergens?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  contingent?: Maybe<Scalars['Int']>;
  disabled_minutes?: Maybe<Scalars['Int']>;
  extra_groups?: Maybe<Array<Maybe<ExtraGroup>>>;
  /** @deprecated Field is deprecated! */
  extras?: Maybe<Array<Maybe<Extra>>>;
  has_cutlery?: Maybe<Scalars['Boolean']>;
  has_extras_or_variants?: Maybe<Scalars['Boolean']>;
  has_inherited_extras?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  in_stock?: Maybe<Scalars['Boolean']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_default?: Maybe<Scalars['Boolean']>;
  is_featured?: Maybe<Scalars['Boolean']>;
  is_hot?: Maybe<Scalars['Boolean']>;
  is_promo?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  old_price?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  preferred_height?: Maybe<Scalars['Int']>;
  prep_time?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  price_info?: Maybe<Scalars['String']>;
  price_purchase?: Maybe<Scalars['Int']>;
  price_retail?: Maybe<Scalars['Int']>;
  price_to_go?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  reusable_packaging?: Maybe<Scalars['Boolean']>;
  specialities?: Maybe<Specialities>;
  standard_amount?: Maybe<Scalars['Int']>;
  storage_time?: Maybe<Scalars['Int']>;
  store_product_id?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  teaser_text?: Maybe<Scalars['String']>;
  teaser_text_long?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ProductType>;
  variant_id?: Maybe<Scalars['ID']>;
  variants?: Maybe<Array<Maybe<Product>>>;
  vat_rate?: Maybe<Scalars['Int']>;
  vat_shadow_price?: Maybe<Scalars['Int']>;
};

export enum ProductFilter {
  All = 'ALL',
  InStock = 'IN_STOCK'
}

export type ProductFilterOptions = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
};

export type ProductInput = {
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  brand_id?: InputMaybe<Scalars['ID']>;
  category_id?: InputMaybe<Scalars['ID']>;
  contingent?: InputMaybe<Scalars['Int']>;
  extra_groups_order?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  extras?: InputMaybe<Array<InputMaybe<IngestExtraInput>>>;
  has_cutlery?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  ingredients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_hot?: InputMaybe<Scalars['Boolean']>;
  is_promo?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  old_price?: InputMaybe<Scalars['Int']>;
  prep_time?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  price_purchase?: InputMaybe<Scalars['Int']>;
  price_retail?: InputMaybe<Scalars['Int']>;
  price_to_go?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reusable_packaging?: InputMaybe<Scalars['Boolean']>;
  specialities?: InputMaybe<SpecialitiesInput>;
  storage_time?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teaser_text?: InputMaybe<Scalars['String']>;
  teaser_text_long?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
  variants?: InputMaybe<ProductVariantsInput>;
  vat_rate?: InputMaybe<Scalars['Int']>;
  vat_shadow_price?: InputMaybe<Scalars['Int']>;
};

export type ProductInterface = {
  allergens?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  extra_groups?: Maybe<Array<Maybe<ExtraGroup>>>;
  /** @deprecated Field is deprecated, use extra_groups instead! */
  extras?: Maybe<Array<Maybe<Extra>>>;
  has_cutlery?: Maybe<Scalars['Boolean']>;
  has_extras_or_variants?: Maybe<Scalars['Boolean']>;
  has_inherited_extras?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_promo?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  old_price?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  preferred_height?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  reusable_packaging?: Maybe<Scalars['Boolean']>;
  specialities?: Maybe<Specialities>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  teaser_text?: Maybe<Scalars['String']>;
  teaser_text_long?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<Product>>>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type ProductOutOfStock = {
  __typename?: 'ProductOutOfStock';
  available: Scalars['Int'];
  product?: Maybe<Product>;
  product_id: Scalars['String'];
  requested: Scalars['Int'];
};

export type ProductPurchase = {
  __typename?: 'ProductPurchase';
  article_number: Scalars['Int'];
  gtin: Scalars['String'];
  name: Scalars['String'];
  price_cent: Scalars['Int'];
};

export type ProductPurchaseUpdate = {
  article_number?: InputMaybe<Scalars['Int']>;
  gtin?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price_cent?: InputMaybe<Scalars['Int']>;
};

export type ProductRental = {
  __typename?: 'ProductRental';
  name: Scalars['String'];
  price_cent: Scalars['Int'];
};

export type ProductRentalUpdate = {
  name?: InputMaybe<Scalars['String']>;
  price_cent?: InputMaybe<Scalars['Int']>;
};

export type ProductStore = {
  __typename?: 'ProductStore';
  id?: Maybe<Scalars['ID']>;
  in_stock?: Maybe<Scalars['Boolean']>;
  is_available?: Maybe<Scalars['Boolean']>;
  is_featured?: Maybe<Scalars['Boolean']>;
  oos_timeout?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['ID']>;
  proximity_id?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  store?: Maybe<Store>;
  store_id?: Maybe<Scalars['ID']>;
  store_product_id: Scalars['ID'];
  test?: Maybe<Scalars['Boolean']>;
  test2?: Maybe<Scalars['Boolean']>;
};

export type ProductTransactions = {
  __typename?: 'ProductTransactions';
  article_number: Scalars['Int'];
  gtin: Scalars['String'];
  name: Scalars['String'];
  price_cent: Scalars['Int'];
};

export type ProductTransactionsUpdate = {
  article_number?: InputMaybe<Scalars['Int']>;
  gtin?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price_cent?: InputMaybe<Scalars['Int']>;
};

export enum ProductType {
  Extra = 'EXTRA',
  Product = 'PRODUCT',
  Variant = 'VARIANT'
}

export type ProductVariantsInput = {
  default_variant: Scalars['ID'];
  variant_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/**
 * Effective purchasing-order gating of a store. Gated when the store's own
 * needs_purchasing_order_number is on, or when any partner account above the
 * store carries the account-level flag. A configured contact on its own never
 * gates.
 */
export type PurchasingOrderGating = {
  __typename?: 'PurchasingOrderGating';
  /**
   * True when the store's partner invoices are held in DRAFT until a purchase
   * order is provided.
   */
  needs_purchasing_order_number: Scalars['Boolean'];
  /**
   * Effective purchasing-order contact(s), semicolon separated: the store's own
   * purchasing_order_email, or the nearest partner account's when the store has
   * none.
   */
  purchasing_order_email?: Maybe<Scalars['String']>;
  /**
   * Which level supplies the gating. STORE wins over PARTNER_ACCOUNT when both
   * have the flag; NONE means not gated.
   */
  source: PurchasingOrderGatingSource;
  /**
   * The nearest partner account carrying the account-level flag, when one
   * exists — also set while the store's own flag is the source, so consumers
   * can tell the store would stay gated without it.
   */
  source_account_id?: Maybe<Scalars['ID']>;
  source_account_name?: Maybe<Scalars['String']>;
};

export enum PurchasingOrderGatingSource {
  None = 'NONE',
  PartnerAccount = 'PARTNER_ACCOUNT',
  Store = 'STORE'
}

export type Query = {
  __typename?: 'Query';
  accountLedger?: Maybe<AccountLedger>;
  accountLedgers: Array<AccountLedger>;
  achievement?: Maybe<Achievement>;
  achievements?: Maybe<Array<Maybe<Achievement>>>;
  analyticsUsers: AnalyticsUsersPaginatedResult;
  appLoginToken?: Maybe<AppLoginToken>;
  authorizedSigner: AuthorizedSigner;
  basket?: Maybe<Basket>;
  baskets?: Maybe<Array<Maybe<Basket>>>;
  billingItems?: Maybe<Array<Maybe<OrderItem>>>;
  brand?: Maybe<Brand>;
  brandApiTokens?: Maybe<Array<Maybe<ApiToken>>>;
  brandCategoryProductsByBrand?: Maybe<Array<Maybe<CategoryAndStores>>>;
  brandCategoryProductsByStore?: Maybe<Array<Maybe<CategoryAndStores>>>;
  brandProducts?: Maybe<Array<Maybe<Product>>>;
  brandStores?: Maybe<Array<Maybe<Store>>>;
  brandVatRatesByStore?: Maybe<Array<Maybe<Scalars['Int']>>>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  calcPackageCount: Scalars['Int'];
  campaign?: Maybe<Campaign>;
  campaignSearch?: Maybe<Array<Maybe<Campaign>>>;
  /**
   * Values available for the shop's filter sidebar (only ones with ACTIVE
   * products). Category names are resolved to the requested language; the
   * ordering always follows the base (non-localized) names.
   *
   * country / account type names are not localized yet — countries carry an
   * iso_code the client can localize itself (Intl.DisplayNames).
   */
  catalogFilterMetadata: CatalogFilterMetadata;
  /**
   * Public product detail. Returns null when the product does not exist or is
   * not ACTIVE.
   */
  catalogProduct?: Maybe<CatalogProduct>;
  /**
   * Public product list for the shop. Only ACTIVE products. Sorted by the base
   * (non-localized) product name unless sort_by says otherwise.
   */
  catalogProducts: CatalogProductListResult;
  categories?: Maybe<Array<Maybe<Category>>>;
  category?: Maybe<Category>;
  checkEmail?: Maybe<Scalars['Boolean']>;
  checkPaymentToken?: Maybe<OneTimeToken>;
  checkPromotionCode?: Maybe<Campaign>;
  cities?: Maybe<Array<Maybe<City>>>;
  /** Returns the committed transaction volume for a given store. */
  committedTransactionVolume?: Maybe<CommittedTransactionVolume>;
  containerQrRedirectionCampaigns?: Maybe<Array<Maybe<ContainerQrRedirectionCampaign>>>;
  containerStation: ContainerStation;
  countryCodes: Array<CountryCode>;
  creditToPartnerOptions: Array<CreditToPartnerOption>;
  deliveryAddressSearch?: Maybe<Array<Maybe<AddressSearchResult>>>;
  deliveryToken?: Maybe<DeliveryToken>;
  deliveryTokensForUser?: Maybe<Array<Maybe<DeliveryToken>>>;
  /**
   * Every carrier status seedDevParcelStatusHistory accepts and every preset
   * scenario, straight from SENDCLOUD_STATUS_MAP. Dev/staging only.
   */
  devParcelStatusCatalog: DevParcelStatusCatalog;
  event?: Maybe<Event>;
  eventAccount?: Maybe<EventAccount>;
  eventAccountByZohoId?: Maybe<EventAccount>;
  eventAccounts?: Maybe<Array<EventAccount>>;
  eventByZohoId?: Maybe<Event>;
  eventMerchantOrderSharedLinkInfo: EventMerchantOrderSharedLinkInfo;
  eventPrices: Array<EventPrice>;
  events?: Maybe<Array<Event>>;
  eventsPaginated: EventPaginatedResult;
  exportContainerTypeGroupLinksCsv: Scalars['String'];
  exportEventAccountOrderFulfillments: Scalars['String'];
  /**
   * The columns of the import template, in order: id, the read-only columns
   * entity_type and name, then the importable columns.
   */
  financeBulkImportTemplateColumns: Array<Scalars['String']>;
  findCurrentStockForContainerStationPaginated: FindStockOnDayForContainerStationPaginatedResponse;
  findDeliveryFulfillmentInfoForContainerStation: ContainerStationDeliveryFulfillmentInfo;
  findLastOrderFulfillmentForContainerStation?: Maybe<OrderFulfillment>;
  findLocation: ItemLocation;
  findMovedContainersForContainerStation: Array<ContainerStationContainer>;
  findMovedContainersForContainerStationPaginated: FindMovedContainersForContainerStationPaginatedResponse;
  findOpsOrder?: Maybe<OpsOrderDetail>;
  /** Returns the service package for a given store (with only the store's active revision). */
  findServicePackageForStore?: Maybe<ServicePackageTerm>;
  findStockOnDayForContainerStation: Array<ContainerStationContainer>;
  findStockOnDayForContainerStationPaginated: FindStockOnDayForContainerStationPaginatedResponse;
  fraudCheck?: Maybe<Scalars['Boolean']>;
  /**
   * A funnel project (configurator draft) by the uuid from a shared link.
   * Returns null when it does not exist.
   */
  funnelProject?: Maybe<FunnelProject>;
  getAccountLedgersForStore: Array<AccountLedger>;
  getActiveRaffleCampaigns: Array<RaffleCampaign>;
  getAggregatedEventMerchantOrderDataByType: GetAggregatedEventMerchantOrderDataByTypeResult;
  getAggregatedOrderFulfillmentDataByType: GetAggregatedOrderFulfillmentDataByTypeResult;
  getAggregatedOrderFulfillmentDataByTypeV2: GetAggregatedOrderFulfillmentDataByTypeV2Result;
  getAllContainerClassesAdmin: Array<Scalars['String']>;
  getAllContainerTypeGroups: Array<ContainerTypeGroup>;
  getAllContainerTypesAdmin: AdminContainerTypePage;
  getAllEventAccountsStock: EventAccountStock;
  getAllEventLinkedUsers: Array<EventLinkedUser>;
  getAllEventSupervisors: Array<ExternalEventSupervisor>;
  getAllRaffleCampaigns: Array<RaffleCampaign>;
  getAllRaffleCycles: Array<RaffleCycle>;
  getAllRndCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getAppTranslations: Array<AppTranslationEntry>;
  getBlockedCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getClientLang?: Maybe<Scalars['String']>;
  getContainerPricingAdmin: AdminContainerPricing;
  getContainerStationsWithManualAmountStock: Array<ContainerStationWithManualAmountStock>;
  getContainerTypeFacetsAdmin: AdminContainerTypeFacets;
  getCurrentRaffleCycles: Array<RaffleCycle>;
  getCustomBillomatArticlesConfig?: Maybe<Scalars['String']>;
  getCustomerCateringUsersForStore: GetCustomerCateringUsersForStoreResult;
  getDefaultCarrierByCountryConfig: Array<DefaultCarrierByCountryEntry>;
  getDeliveryAddresses?: Maybe<Array<Maybe<DeliveryAddress>>>;
  getDeliveryAddressesForEvent: Array<EventDeliveryAddress>;
  getEventAccountInvoices: ZohoInvoicePaginatedResult;
  getEventAccountStock: EventAccountStock;
  getEventFulfillmentDataByFulfillmentStep: EventFulfillmentDataByFulfillmentStep;
  getEventFulfillmentDataByFulfillmentStepV2: EventFulfillmentDataByFulfillmentStepV2;
  getEventInvoices: ZohoInvoicePaginatedResult;
  getEventInvoicingReadiness: Array<EventInvoicingReadiness>;
  getEventStock: EventStock;
  getExternalAuthClientConfig?: Maybe<ExternalAuthClient>;
  getFeatureFlags?: Maybe<FeatureFlags>;
  getFilteredItemLocations: GetFilteredItemLocationsResponse;
  getFriendsCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getInvoiceData?: Maybe<InvoiceSummary>;
  getInvoicesForInvoiceCollection?: Maybe<Array<Maybe<BillomatInvoice>>>;
  getItemLocationHistory: Array<ItemLocationHistoryEntry>;
  getItemLocationHistoryPaginated?: Maybe<GetItemLocationHistoryPaginatedResponse>;
  getItemLocationStock: ItemLocationStock;
  getItemLocationTypes: Array<ItemLocationType>;
  getItemTypePrice: ItemTypePrice;
  getItemsAtLocation: Array<Item>;
  getLastAccountLedgerProcessedConfig?: Maybe<LastAccountLedgerProcessedConfig>;
  getLinkAccountType?: Maybe<LinkType>;
  getMerchantOrderSharedLink?: Maybe<MerchantOrderSharedLink>;
  getMerchantOrderSharedLinksForEvent: GetMerchantOrderSharedLinksForEventResponse;
  getNews?: Maybe<Array<Maybe<NewsContent>>>;
  getNewsNoLocation?: Maybe<Array<Maybe<NewsContent>>>;
  getNotifications?: Maybe<Array<Maybe<Notification>>>;
  getOrderFulfillments: OrderFulfillmentPaginatedResult;
  getOrderFulfillmentsByAuthorizedSignerId: Array<OrderFulfillment>;
  getOrderFulfillmentsByAuthorizedSignerIdPaginated: OrderFulfillmentPaginatedResult;
  getOrderFulfillmentsByEventAccountId: Array<OrderFulfillment>;
  getOrderFulfillmentsByEventAccountIdPaginated: OrderFulfillmentPaginatedResult;
  getOrderWarehouseConfig: OrderWarehouseConfig;
  getPartnerAppVersion?: Maybe<Scalars['String']>;
  getPartnerInvoicesForInvoiceCollection: Array<PartnerInvoice>;
  getPartnerNews?: Maybe<Array<Maybe<NewsContent>>>;
  getPartnerSelfSignUpConfig?: Maybe<PartnerSelfSignupConfig>;
  getPartnerSelfSignUpConfigs?: Maybe<Array<Maybe<PartnerSelfSignupConfig>>>;
  getPartnerStoreInvoices?: Maybe<Array<Maybe<PartnerInvoice>>>;
  getPartnerStoreNonLinkedAccountLedgers?: Maybe<Array<Maybe<AccountLedger>>>;
  /**
   * Returns a single picking job by id. For materialized jobs, the
   * context input is optional. For still-virtual jobs, context is required and
   * must hash to the supplied picking_job_id.
   */
  getPickingJob?: Maybe<PickingJob>;
  /**
   * Returns the per-scan log for a materialized picking job. The optional
   * (category, type_id) pair narrows to scans contributing to a specific
   * bucket — both must be supplied together; passing only one is a no-op.
   * With the type filter set, ContainerStation scans collapse to one row
   * per station with amount = count of matching contents (e.g. "this
   * station holds 5 of ContainerType Y" → one row, amount=5). Without a
   * filter, station rows show amount = total contents (or 1 for empty
   * stations). The optional search is case-insensitive: container / station /
   * item-type names and the MOI option name match as a substring, the
   * varchar(6) station and trackable ids and the container ShortId match
   * exactly (a code, not a prefix).
   *
   * Use getPickingJobPickedItemsPaginated for large jobs.
   */
  getPickingJobPickedItems: Array<PickingJobPickedItem>;
  /**
   * Paginated variant of getPickingJobPickedItems. One scan row = one
   * paginated row; ContainerStation fan-out only affects the displayed
   * amount on the row, not the row count. total reflects the full count
   * after all filters are applied.
   */
  getPickingJobPickedItemsPaginated: PickingJobPickedItemsPage;
  /**
   * Returns picking jobs (virtual + materialized) for the supplied filters on a
   * given date range. Default range is start-of-today to end-of-today UTC.
   *
   * Filter args double as auth gates: the resolver runs a three-step pipeline —
   * (1) per-role auto-scope fills in the defaults a non-privileged viewer can't
   * choose, (2) explicit-arg validation rejects any value the viewer can't see
   * (FORBIDDEN), (3) a breadth check requires at least one of item_location_id /
   * event_id / target_store_id to resolve (FILTER_TOO_BROAD).
   *
   * Per role:
   *   • admin / accountManager / operations / support / eventManager —
   *     free filter; must narrow by item_location_id, event_id or
   *     target_store_id (else FILTER_TOO_BROAD). statuses default to all.
   *   • externalEventSupervisor / eventOwner — auto-scoped to the viewer's
   *     accessible events (viewer.event_ids); explicit event_id outside that
   *     set errors FORBIDDEN. statuses hard-scoped to picked-and-later
   *     {PICKED, DELIVERY_IN_PROGRESS, DELIVERY_INCOMPLETE, DELIVERED}.
   *   • carrier_employee — item_location_id auto-set to the viewer's warehouse;
   *     explicit mismatch errors FORBIDDEN. statuses hard-scoped to
   *     picked-and-later.
   *   • warehouseCleaning — item_location_id auto-set to the viewer's
   *     warehouse; explicit mismatch errors FORBIDDEN. statuses hard-scoped to
   *     the picking side {PICKING_NOT_STARTED, PICKING_IN_PROGRESS, PICKED}.
   *
   * Errors:
   *   FORBIDDEN        — an explicit arg falls outside the viewer's accessible
   *                      set (foreign event, foreign warehouse, or a status
   *                      outside the role's hard-scoped set).
   *   FILTER_TOO_BROAD — a privileged caller supplied none of item_location_id /
   *                      event_id / target_store_id.
   */
  getPickingJobs: Array<PickingJobListItem>;
  getPosCampaignsByStore?: Maybe<Array<Maybe<Campaign>>>;
  getProblems: Array<Problem>;
  getRaffleCampaign?: Maybe<RaffleCampaign>;
  getRaffleCampaignStatistics?: Maybe<CampaignStatistics>;
  getRaffleCampaignsByStore: Array<RaffleCampaign>;
  getRaffleParticipantStatus: RaffleParticipantStatus;
  getRaffleTickets: Array<RaffleTicketWithStoreName>;
  getRaffleWinnersForCurrentCycle: Array<RaffleWinner>;
  getScanTunnelSession: ScanTunnelSession;
  getScanTunnelSessions: Array<ScanTunnelSession>;
  getSentInvoicesInMonth?: Maybe<Scalars['Int']>;
  /**
   * Current in-stock containers per container type for each of the given stores,
   * counted from the open ContainerLocations rows of the store's app users (its
   * MerchantStoreAppUserLinks plus its DefaultStockUserId). One round trip for many
   * stores — built for the admin's stadium stock dashboard, which polls it every few
   * seconds. Unknown store uuids are left out of the result.
   */
  getStoresContainerStock: Array<StoreContainerStock>;
  /**
   * Published stores inside the bounding box, with their checkouts and problem
   * reports for the 30 days before the given date.
   */
  getStoresInBoundingBox: Array<Maybe<StoreInBoundingBox>>;
  getStoresInViewpoint?: Maybe<Array<Maybe<Store>>>;
  getTapToBorrowSupportByCountry: TapToBorrowSupportByCountry;
  getTransaction?: Maybe<Transaction>;
  getTranslationFile?: Maybe<Scalars['String']>;
  getUnlinkedOrderFulfillmentPictures: GetUnlinkedOrderFulfillmentPicturesResult;
  getUsedPartnerCredits?: Maybe<Scalars['Int']>;
  getUser?: Maybe<User>;
  getUserLocationFromIp?: Maybe<UserLocationFromIpResponse>;
  getUserRaffleParticipation: UserRaffleParticipation;
  getWWFPromoCode?: Maybe<Scalars['String']>;
  getWWFReferralActivationCount?: Maybe<Scalars['Int']>;
  getZohoDealQuoteMeta: ZohoDealQuoteMeta;
  heavenHrJobs?: Maybe<Array<Maybe<HeavenHrJobs>>>;
  integrationOptions: Array<IntegrationOption>;
  invoiceCollection?: Maybe<InvoiceCollection>;
  invoiceCollections?: Maybe<Array<Maybe<InvoiceCollection>>>;
  invoiceRun?: Maybe<InvoiceRun>;
  /**
   * Fresh, short-lived download link for a result file. Generated on click so
   * links never go stale.
   */
  invoiceRunFileUrl: Scalars['String'];
  invoiceRuns: Array<InvoiceRun>;
  invoicingCapability: InvoicingCapability;
  isInDeliveryArea: Scalars['Boolean'];
  itemLocation: ItemLocation;
  itemType: ItemType;
  itemTypes: ItemTypesResult;
  location?: Maybe<Location>;
  locationGroupedStores?: Maybe<LocationGroupedStores>;
  locationStores?: Maybe<LocationStores>;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsCategories?: Maybe<Array<Maybe<LocationCategories>>>;
  locationsTopProducts?: Maybe<Array<Maybe<LocationTopProducts>>>;
  locationsWeb?: Maybe<Array<Maybe<Location>>>;
  merchantOrderItemOption?: Maybe<MerchantOrderItemOption>;
  merchantOrderItemOptions: Array<MerchantOrderItemOption>;
  miniReturner?: Maybe<MiniReturner>;
  /** Every mini returner known to the backend, most recently seen first. */
  miniReturners: Array<MiniReturner>;
  nearestFeaturedProducts?: Maybe<Array<Maybe<FeaturedProduct>>>;
  nearestGroupedStores?: Maybe<Array<Maybe<GroupedStore>>>;
  nearestStores?: Maybe<Array<Maybe<Store>>>;
  nearestVytalStores?: Maybe<Array<Maybe<Store>>>;
  nearestVytalStoresNoLocation?: Maybe<NearestStoresNoLocationResponse>;
  news?: Maybe<Array<Maybe<NewsContent>>>;
  /**
   * Suggestion for the Spanish start-run form: highest ES number used in
   * Billomat + 1. Queries Billomat live — call on form open / refresh click,
   * not on every render.
   */
  nextFreeEsInvoiceNumber: Scalars['Int'];
  /**
   * Every user who has created at least one ops order, sorted by display name.
   * Populates the "Created by" filter of the ops order table - the returned id
   * goes straight into OpsOrderFilter.user_uuid. Pass system to only list
   * creators of that order system; omit it to list creators of both.
   */
  opsOrderCreators: Array<IdName>;
  opsOrderValidation: OpsOrderValidationRules;
  opsOrdersSearch: OpsOrdersSearchResponse;
  /**
   * Ops warnings, newest first. ClickHouse exists only in production, so this
   * returns an empty result anywhere else.
   */
  opsWarnings: OpsWarningsPaginatedResult;
  order?: Maybe<Order>;
  orderFulfillment: OrderFulfillment;
  orderFulfillmentPicture: OrderFulfillmentPicture;
  orderHistory?: Maybe<Array<Maybe<OrderHistory>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  paginatedStores?: Maybe<PaginatedStoresResult>;
  partnerSelfSignup?: Maybe<PartnerSelfSignup>;
  paymentClientToken?: Maybe<ClientToken>;
  /**
   * Every in-flight print job for the item location (warehouse) — i.e. status
   * NOT IN (COMPLETED, FAILED, CANCELLED). Drives the desktop's polling
   * fallback and its boot-time reconciliation pass.
   *
   * The item location id is the same warehouse identifier the Picking module
   * uses (PickingJobs.ItemLocationId / the getPickingJobs item_location_id
   * filter).
   */
  pendingPrintJobs: Array<PrintJob>;
  popularVytalStores?: Maybe<Array<Maybe<Store>>>;
  product?: Maybe<Product>;
  productCategories?: Maybe<Array<Maybe<Category>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  regions: Array<Region>;
  /**
   * Resolves a scanned tracked instance to the unique OPEN picking job that has
   * it picked — the delivery-side "scan an item to pull up its job" entry point,
   * mirroring the mark mutations' (category, item_id) input.
   *
   * Accepts CONTAINER_STATION (ContainerStation.Id) and ITEM (TrackableItem.Id)
   * only — the other categories have no single scannable instance to resolve by.
   *
   * "Open" means a job in a deliverable, non-terminal state: PICKED,
   * DELIVERY_IN_PROGRESS, or DELIVERY_INCOMPLETE. Not-yet-PICKED and fully
   * DELIVERED jobs are not returned. Delivery eligibility (MANUAL /
   * standard_per_gastronomist) is NOT gated here — that is enforced when the
   * picker marks or confirms, so a scan can still surface an ineligible job.
   *
   * Errors (PickingJobDeliveryErrorCode):
   *   CONTAINER_NOT_ALLOWED       — category = CONTAINER (delivered via its station).
   *   COLLECTION_CODE_NOT_ALLOWED — category = CONTAINER_COLLECTION.
   *   UNTRACKED_NOT_SCANNABLE     — category = UNTRACKED_ITEM (no instance id).
   *   SCANNED_ITEM_NOT_FOUND      — item_id is not a real ContainerStation / TrackableItem.
   *   ITEM_NOT_IN_PICKING_JOB     — the instance exists but no open job has it picked.
   *   AMBIGUOUS_SCAN              — more than one open job has it (defensive; the
   *                                 per-instance scan uniqueness should prevent it).
   */
  resolvePickingJobByItem?: Maybe<PickingJob>;
  scanTunnel: ScanTunnel;
  scanTunnels: Array<ScanTunnel>;
  searchAdminV2: PartnerAccountSearchResult;
  searchAutocomplete?: Maybe<Array<Maybe<SearchResult>>>;
  searchContainerStations: Array<ContainerStation>;
  searchContainerStationsPaginated: ContainerStationSearchPaginatedResponse;
  searchEventAccounts: Array<EventAccountSearchResult>;
  searchItemLocations: Array<ItemLocation>;
  searchOrderFulfillments: OrderFulfillmentPaginatedResult;
  searchTrackableItemsPaginated?: Maybe<SearchTrackableItemPaginatedResponse>;
  searchUsers?: Maybe<Array<Maybe<User>>>;
  searchVytalMerchants?: Maybe<Array<Maybe<VytalMerchantSearchResult>>>;
  selectedCities?: Maybe<Array<Maybe<Location>>>;
  /**
   * Returns a single service package by its natural (currency, package_type) key.
   * Returns null when no package exists for the given combination.
   */
  servicePackage?: Maybe<ServicePackage>;
  /** Returns all service packages, optionally filtered to specific currencies. */
  servicePackages: Array<ServicePackage>;
  store?: Maybe<Store>;
  storeAsset: StoreAssetV2;
  storeAssets?: Maybe<Array<Maybe<StoreAsset>>>;
  storeAssetsV2: StoreAssetsResult;
  storeBasket?: Maybe<Basket>;
  storeContainerStations: Array<ContainerStation>;
  storeContainerStationsPaginated?: Maybe<ContainerStationPaginatedResponse>;
  storeSearch: Array<StoreSearchResult>;
  storeSearchAdmin: Array<StoreSearchResult>;
  storeSearchCountOnly: StoreSearchCountOnlyResult;
  storefront?: Maybe<StoreFront>;
  stores?: Maybe<Array<Maybe<Store>>>;
  storesByLocation?: Maybe<Array<Maybe<Store>>>;
  storesGrafana?: Maybe<Array<Maybe<Store>>>;
  storesWithAssets?: Maybe<Array<Maybe<Store>>>;
  storesWithContainerStations: Array<IdName>;
  trackableItem: TrackableItem;
  trackableItems?: Maybe<Array<TrackableItem>>;
  user?: Maybe<User>;
  vendingMachine?: Maybe<VendingMachine>;
  vytalBrandStores?: Maybe<Array<Maybe<Store>>>;
  vytalLocationGroupedStores?: Maybe<LocationGroupedStores>;
  vytalNearestGroupedStores?: Maybe<Array<Maybe<GroupedStore>>>;
  vytalStoresWithGeoKey?: Maybe<VytalStoresByGeoKey>;
  warehouses: Array<Warehouse>;
  /**
   * Current stage of one container station in the Onsite & Clear cycle of an
   * event. Operations and administrators only.
   */
  washingHubStationState: WashingHubStationState;
};


export type QueryAccountLedgerArgs = {
  id: Scalars['ID'];
};


export type QueryAccountLedgersArgs = {
  batch_number?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAchievementArgs = {
  id: Scalars['ID'];
};


export type QueryAnalyticsUsersArgs = {
  account_ids?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  merchant_text_ids?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  store_text_ids?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAppLoginTokenArgs = {
  id: Scalars['ID'];
};


export type QueryAuthorizedSignerArgs = {
  id: Scalars['ID'];
};


export type QueryBasketArgs = {
  id: Scalars['ID'];
};


export type QueryBillingItemsArgs = {
  sort_by?: InputMaybe<OrderbyEnum>;
  store_id?: InputMaybe<Scalars['ID']>;
  timespan?: InputMaybe<Range>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandApiTokensArgs = {
  brand_id: Scalars['ID'];
};


export type QueryBrandCategoryProductsByBrandArgs = {
  brand_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandCategoryProductsByStoreArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandProductsArgs = {
  brand_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandStoresArgs = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
  brand_id: Scalars['ID'];
  geokey?: InputMaybe<Scalars['String']>;
};


export type QueryBrandVatRatesByStoreArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandsArgs = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCalcPackageCountArgs = {
  containers: Array<CalcPackageCountContainerInput>;
  items?: InputMaybe<Array<CalcPackageCountItemInput>>;
  untracked_items?: InputMaybe<Array<CalcPackageCountUntrackedItemInput>>;
};


export type QueryCampaignArgs = {
  campaign_id?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignSearchArgs = {
  search_term: Scalars['String'];
};


export type QueryCatalogFilterMetadataArgs = {
  language?: InputMaybe<CatalogLanguageCode>;
};


export type QueryCatalogProductArgs = {
  id: Scalars['ID'];
  language?: InputMaybe<CatalogLanguageCode>;
};


export type QueryCatalogProductsArgs = {
  filter?: InputMaybe<CatalogProductFilter>;
  language?: InputMaybe<CatalogLanguageCode>;
  skip?: InputMaybe<Scalars['Int']>;
  sort_by?: InputMaybe<CatalogProductSortField>;
  sort_order?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryCheckEmailArgs = {
  email: Scalars['String'];
};


export type QueryCheckPaymentTokenArgs = {
  token: Scalars['ID'];
};


export type QueryCheckPromotionCodeArgs = {
  promotion_code?: InputMaybe<Scalars['String']>;
};


export type QueryCommittedTransactionVolumeArgs = {
  store_uuid: Scalars['ID'];
};


export type QueryContainerStationArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryAddressSearchArgs = {
  query?: InputMaybe<Scalars['String']>;
  userLocation?: InputMaybe<LonLatIn>;
};


export type QueryDeliveryTokenArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryTokensForUserArgs = {
  user_id: Scalars['ID'];
};


export type QueryEventArgs = {
  id: Scalars['ID'];
};


export type QueryEventAccountArgs = {
  id: Scalars['ID'];
};


export type QueryEventAccountByZohoIdArgs = {
  external_zoho_id: Scalars['ID'];
};


export type QueryEventAccountsArgs = {
  include_deleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEventByZohoIdArgs = {
  external_zoho_id: Scalars['ID'];
};


export type QueryEventMerchantOrderSharedLinkInfoArgs = {
  merchant_order_shared_link_id: Scalars['ID'];
};


export type QueryEventPricesArgs = {
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
};


export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  include_deleted?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<Range>;
  type?: InputMaybe<EventType>;
};


export type QueryEventsPaginatedArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryExportContainerTypeGroupLinksCsvArgs = {
  group_id: Scalars['Int'];
};


export type QueryExportEventAccountOrderFulfillmentsArgs = {
  event_account_id?: InputMaybe<Scalars['ID']>;
  event_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderFulfillmentFilter>;
  include_single_container_info?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFindCurrentStockForContainerStationPaginatedArgs = {
  container_station_id: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryFindDeliveryFulfillmentInfoForContainerStationArgs = {
  container_station_id: Scalars['ID'];
  event_account_id?: InputMaybe<Scalars['ID']>;
};


export type QueryFindLastOrderFulfillmentForContainerStationArgs = {
  container_station_id: Scalars['ID'];
};


export type QueryFindLocationArgs = {
  id: Scalars['ID'];
};


export type QueryFindMovedContainersForContainerStationArgs = {
  container_station_id: Scalars['ID'];
  direction: ContainerLocationDirection;
  end_date: Scalars['String'];
  start_date: Scalars['String'];
};


export type QueryFindMovedContainersForContainerStationPaginatedArgs = {
  container_station_id: Scalars['ID'];
  direction: ContainerLocationDirection;
  end_date: Scalars['String'];
  skip: Scalars['Int'];
  start_date: Scalars['String'];
  take: Scalars['Int'];
};


export type QueryFindOpsOrderArgs = {
  id: Scalars['ID'];
};


export type QueryFindServicePackageForStoreArgs = {
  store_uuid: Scalars['ID'];
};


export type QueryFindStockOnDayForContainerStationArgs = {
  container_station_id: Scalars['ID'];
  date: Scalars['String'];
};


export type QueryFindStockOnDayForContainerStationPaginatedArgs = {
  container_station_id: Scalars['ID'];
  date: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryFraudCheckArgs = {
  id: Scalars['ID'];
};


export type QueryFunnelProjectArgs = {
  id: Scalars['UUID'];
};


export type QueryGetAccountLedgersForStoreArgs = {
  store_id: Scalars['ID'];
};


export type QueryGetAggregatedEventMerchantOrderDataByTypeArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_account_ids?: InputMaybe<Array<Scalars['ID']>>;
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetAggregatedOrderFulfillmentDataByTypeArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_account_ids?: InputMaybe<Array<Scalars['ID']>>;
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetAggregatedOrderFulfillmentDataByTypeV2Args = {
  end_date?: InputMaybe<Scalars['String']>;
  event_account_ids?: InputMaybe<Array<Scalars['ID']>>;
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllContainerTypesAdminArgs = {
  filter?: InputMaybe<AdminContainerTypeFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllEventAccountsStockArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllEventLinkedUsersArgs = {
  filter: GetAllLinkedUserFilterInput;
};


export type QueryGetAllEventSupervisorsArgs = {
  filter: GetAllEventSupervisorsFilterInput;
};


export type QueryGetAllRaffleCyclesArgs = {
  campaign_id: Scalars['String'];
};


export type QueryGetAppTranslationsArgs = {
  app_type: AppTranslationAppType;
};


export type QueryGetContainerStationsWithManualAmountStockArgs = {
  item_location_id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  page_size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCurrentRaffleCyclesArgs = {
  campaign_id: Scalars['String'];
};


export type QueryGetCustomerCateringUsersForStoreArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  store_text_id: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDeliveryAddressesArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetDeliveryAddressesForEventArgs = {
  event_id: Scalars['ID'];
};


export type QueryGetEventAccountInvoicesArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_account_id: Scalars['ID'];
  pagination?: InputMaybe<ZohoInvoicePaginationInput>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventAccountStockArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_account_id: Scalars['ID'];
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventFulfillmentDataByFulfillmentStepArgs = {
  event_id: Scalars['ID'];
};


export type QueryGetEventFulfillmentDataByFulfillmentStepV2Args = {
  event_id: Scalars['ID'];
};


export type QueryGetEventInvoicesArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_id: Scalars['ID'];
  pagination?: InputMaybe<ZohoInvoicePaginationInput>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventInvoicingReadinessArgs = {
  event_id: Scalars['ID'];
};


export type QueryGetEventStockArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  event_id: Scalars['ID'];
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetExternalAuthClientConfigArgs = {
  client_id?: InputMaybe<Scalars['String']>;
  hostname: Scalars['String'];
};


export type QueryGetFilteredItemLocationsArgs = {
  filter: ItemLocationFilterInput;
  search_term: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetInvoiceDataArgs = {
  month: Scalars['Int'];
  store_id: Scalars['ID'];
  year: Scalars['Int'];
};


export type QueryGetInvoicesForInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
};


export type QueryGetItemLocationHistoryArgs = {
  item_id: Scalars['ID'];
};


export type QueryGetItemLocationHistoryPaginatedArgs = {
  item_id: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetItemLocationStockArgs = {
  item_location_id: Scalars['ID'];
};


export type QueryGetItemTypePriceArgs = {
  id: Scalars['Int'];
  store_id: Scalars['ID'];
};


export type QueryGetItemsAtLocationArgs = {
  filter?: InputMaybe<TrackableItemFilterInput>;
  location_id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  page_size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLinkAccountTypeArgs = {
  link_type?: InputMaybe<Scalars['String']>;
};


export type QueryGetMerchantOrderSharedLinkArgs = {
  id: Scalars['ID'];
};


export type QueryGetMerchantOrderSharedLinksForEventArgs = {
  event_id: Scalars['ID'];
  filter?: InputMaybe<MerchantOrderSharedLinksFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetNewsArgs = {
  geohash: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetNewsNoLocationArgs = {
  city_id: Scalars['ID'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetNotificationsArgs = {
  show_all?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetOrderFulfillmentsArgs = {
  filter: OrderFulfillmentFilter;
  skip: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrderFulfillmentsByAuthorizedSignerIdArgs = {
  authorized_signer_id: Scalars['ID'];
};


export type QueryGetOrderFulfillmentsByAuthorizedSignerIdPaginatedArgs = {
  authorized_signer_id: Scalars['ID'];
  filter?: InputMaybe<OrderFulfillmentFilter>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetOrderFulfillmentsByEventAccountIdArgs = {
  event_account_id: Scalars['ID'];
};


export type QueryGetOrderFulfillmentsByEventAccountIdPaginatedArgs = {
  event_account_id: Scalars['ID'];
  event_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderFulfillmentFilter>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetPartnerAppVersionArgs = {
  platform?: InputMaybe<AppPlatform>;
};


export type QueryGetPartnerInvoicesForInvoiceCollectionArgs = {
  invoice_collection_id: Scalars['ID'];
};


export type QueryGetPartnerNewsArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPartnerSelfSignUpConfigArgs = {
  id: Scalars['String'];
};


export type QueryGetPartnerStoreInvoicesArgs = {
  store_id: Scalars['ID'];
};


export type QueryGetPartnerStoreNonLinkedAccountLedgersArgs = {
  store_id: Scalars['ID'];
};


export type QueryGetPickingJobArgs = {
  context?: InputMaybe<PickingJobContextInput>;
  picking_job_id: Scalars['ID'];
};


export type QueryGetPickingJobPickedItemsArgs = {
  category?: InputMaybe<OpsOrderItemCategory>;
  picking_job_id: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  type_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPickingJobPickedItemsPaginatedArgs = {
  category?: InputMaybe<OpsOrderItemCategory>;
  picking_job_id: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPickingJobsArgs = {
  delivery_address_id?: InputMaybe<Scalars['UUID']>;
  event_id?: InputMaybe<Scalars['ID']>;
  item_location_id?: InputMaybe<Scalars['UUID']>;
  picked_item_search?: InputMaybe<Scalars['String']>;
  pickup_date_from?: InputMaybe<Scalars['String']>;
  pickup_date_to?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PickingJobStatus>>;
  target_store_id?: InputMaybe<Scalars['UUID']>;
};


export type QueryGetPosCampaignsByStoreArgs = {
  sort_by?: InputMaybe<OrderbyEnum>;
  store_id: Scalars['ID'];
  timespan?: InputMaybe<Range>;
};


export type QueryGetProblemsArgs = {
  uuid: Scalars['ID'];
};


export type QueryGetRaffleCampaignArgs = {
  id: Scalars['String'];
};


export type QueryGetRaffleCampaignStatisticsArgs = {
  campaign_id: Scalars['String'];
};


export type QueryGetRaffleCampaignsByStoreArgs = {
  store_id: Scalars['String'];
};


export type QueryGetRaffleParticipantStatusArgs = {
  raffle_participant_id: Scalars['String'];
};


export type QueryGetRaffleTicketsArgs = {
  payload: GetRaffleTicketsInput;
};


export type QueryGetRaffleWinnersForCurrentCycleArgs = {
  cycle_id: Scalars['String'];
};


export type QueryGetScanTunnelSessionArgs = {
  id: Scalars['ID'];
};


export type QueryGetScanTunnelSessionsArgs = {
  scan_tunnel_id: Scalars['ID'];
};


export type QueryGetSentInvoicesInMonthArgs = {
  date: Scalars['String'];
};


export type QueryGetStoresContainerStockArgs = {
  store_uuids: Array<Scalars['UUID']>;
};


export type QueryGetStoresInBoundingBoxArgs = {
  date: Scalars['String'];
  north_east: LonLatIn;
  south_west: LonLatIn;
  with_recent_activity_only?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetStoresInViewpointArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  north_east?: InputMaybe<LonLatIn>;
  south_west?: InputMaybe<LonLatIn>;
};


export type QueryGetTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryGetUnlinkedOrderFulfillmentPicturesArgs = {
  filter: OrderFulfillmentPictureFilter;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetUsedPartnerCreditsArgs = {
  store_id: Scalars['ID'];
};


export type QueryGetUserArgs = {
  forceRefresh?: InputMaybe<Scalars['Boolean']>;
  session_device_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetUserLocationFromIpArgs = {
  city_id?: InputMaybe<Scalars['String']>;
  proximity_city: Scalars['Int'];
};


export type QueryGetUserRaffleParticipationArgs = {
  user_id: Scalars['String'];
};


export type QueryGetWwfPromoCodeArgs = {
  id: Scalars['ID'];
};


export type QueryGetWwfReferralActivationCountArgs = {
  id: Scalars['ID'];
};


export type QueryGetZohoDealQuoteMetaArgs = {
  dealId: Scalars['String'];
};


export type QueryInvoiceCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceRunArgs = {
  id: Scalars['UUID'];
};


export type QueryInvoiceRunFileUrlArgs = {
  key: Scalars['String'];
};


export type QueryInvoiceRunsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryIsInDeliveryAreaArgs = {
  lonlat: LonLatIn;
  store_id: Scalars['ID'];
};


export type QueryItemLocationArgs = {
  id: Scalars['ID'];
};


export type QueryItemTypeArgs = {
  id: Scalars['Int'];
};


export type QueryItemTypesArgs = {
  filter?: InputMaybe<ItemTypeFilter>;
  price_for_store_id?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLocationArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryLocationGroupedStoresArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey?: InputMaybe<Scalars['String']>;
  location_id: Scalars['ID'];
};


export type QueryLocationStoresArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey?: InputMaybe<Scalars['String']>;
  location_id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<LocationFilter>;
};


export type QueryLocationsCategoriesArgs = {
  filter?: InputMaybe<StoreFilter>;
  locations?: InputMaybe<Array<InputMaybe<ExtLocationRequest>>>;
};


export type QueryLocationsTopProductsArgs = {
  filter?: InputMaybe<StoreFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<InputMaybe<ExtLocationRequest>>>;
};


export type QueryLocationsWebArgs = {
  city?: InputMaybe<Scalars['String']>;
};


export type QueryMerchantOrderItemOptionArgs = {
  type_id: Scalars['Int'];
};


export type QueryMerchantOrderItemOptionsArgs = {
  filter: MerchantOrderItemOptionsFilter;
};


export type QueryMiniReturnerArgs = {
  id: Scalars['UUID'];
};


export type QueryNearestFeaturedProductsArgs = {
  geokey: Scalars['String'];
  proximity?: InputMaybe<Scalars['Int']>;
};


export type QueryNearestGroupedStoresArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey: Scalars['String'];
  proximity: Scalars['Int'];
};


export type QueryNearestStoresArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey: Scalars['String'];
  proximity: Scalars['Int'];
};


export type QueryNearestVytalStoresArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  geokey: Scalars['String'];
  proximity: Scalars['Int'];
  transform?: InputMaybe<TransformOptions>;
};


export type QueryNearestVytalStoresNoLocationArgs = {
  city_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<VytalStoreFilter>;
  proximity: Scalars['Int'];
  proximity_city: Scalars['Int'];
};


export type QueryOpsOrderCreatorsArgs = {
  system?: InputMaybe<OpsOrderSystem>;
};


export type QueryOpsOrderValidationArgs = {
  carrier: OpsOrderCarrier;
  service?: InputMaybe<OpsOrderCarrierService>;
};


export type QueryOpsOrdersSearchArgs = {
  filter?: InputMaybe<OpsOrderFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OpsOrderSort>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOpsWarningsArgs = {
  filter?: InputMaybe<OpsWarningFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderFulfillmentArgs = {
  id: Scalars['ID'];
};


export type QueryOrderFulfillmentPictureArgs = {
  id: Scalars['ID'];
};


export type QueryOrderHistoryArgs = {
  store_id: Scalars['ID'];
};


export type QueryOrdersArgs = {
  include_external?: InputMaybe<Scalars['Boolean']>;
  sort_by?: InputMaybe<OrderbyEnum>;
  store_id?: InputMaybe<Scalars['ID']>;
  store_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  timespan?: InputMaybe<Range>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryPaginatedStoresArgs = {
  filter?: InputMaybe<StoreFilterDb>;
  last_evaluated_key?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPartnerSelfSignupArgs = {
  id: Scalars['ID'];
};


export type QueryPendingPrintJobsArgs = {
  item_location_id: Scalars['ID'];
};


export type QueryPopularVytalStoresArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  transform?: InputMaybe<TransformOptions>;
};


export type QueryProductArgs = {
  filter?: InputMaybe<ProductFilter>;
  id: Scalars['ID'];
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryProductCategoriesArgs = {
  filter?: InputMaybe<ProductFilter>;
  filter_options?: InputMaybe<ProductFilterOptions>;
  get_all?: InputMaybe<Scalars['Boolean']>;
  include_extras?: InputMaybe<Scalars['Boolean']>;
  store_id: Scalars['ID'];
  vending_machine_id?: InputMaybe<Scalars['ID']>;
};


export type QueryProductsArgs = {
  product_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  store_id?: InputMaybe<Scalars['ID']>;
};


export type QueryResolvePickingJobByItemArgs = {
  category: OpsOrderItemCategory;
  item_id: Scalars['ID'];
};


export type QueryScanTunnelArgs = {
  id: Scalars['ID'];
};


export type QuerySearchAdminV2Args = {
  filter?: InputMaybe<SearchAdminV2Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchAutocompleteArgs = {
  filter?: InputMaybe<SearchAutocompleteFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  search_address?: InputMaybe<Scalars['Boolean']>;
  userLocation?: InputMaybe<LonLatIn>;
};


export type QuerySearchContainerStationsArgs = {
  search_term: Scalars['String'];
};


export type QuerySearchContainerStationsPaginatedArgs = {
  search_term: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QuerySearchEventAccountsArgs = {
  filter?: InputMaybe<EventAccountSearchFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchItemLocationsArgs = {
  event_id?: InputMaybe<Scalars['String']>;
  include_disabled?: InputMaybe<Scalars['Boolean']>;
  include_unassigned?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  search_term: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QuerySearchOrderFulfillmentsArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<OrderFulfillmentType>>;
};


export type QuerySearchTrackableItemsPaginatedArgs = {
  filter?: InputMaybe<ItemTypeSearchFilter>;
  search_term?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QuerySearchUsersArgs = {
  search_term?: InputMaybe<Scalars['String']>;
};


export type QuerySearchVytalMerchantsArgs = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  search_address?: InputMaybe<Scalars['Boolean']>;
};


export type QueryServicePackageArgs = {
  currency: Scalars['String'];
  packageType: ServicePackageType;
};


export type QueryServicePackagesArgs = {
  currencies?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStoreArgs = {
  filter?: InputMaybe<Scalars['String']>;
  geokey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryStoreAssetArgs = {
  id: Scalars['ID'];
};


export type QueryStoreAssetsV2Args = {
  filter?: InputMaybe<StoreAssetFilterV2>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStoreBasketArgs = {
  campaigns?: InputMaybe<OverwriteCampaign>;
  store_id: Scalars['ID'];
};


export type QueryStoreContainerStationsArgs = {
  store_id: Scalars['ID'];
};


export type QueryStoreContainerStationsPaginatedArgs = {
  skip: Scalars['Int'];
  store_id: Scalars['ID'];
  take: Scalars['Int'];
};


export type QueryStoreSearchArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  user_location?: InputMaybe<LonLatIn>;
};


export type QueryStoreSearchAdminArgs = {
  filter?: InputMaybe<StoreSearchAdminFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  search_address?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStoreSearchCountOnlyArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  query: Scalars['String'];
  user_location?: InputMaybe<LonLatIn>;
};


export type QueryStorefrontArgs = {
  filter?: InputMaybe<Scalars['String']>;
  store_id: Scalars['ID'];
};


export type QueryStoresArgs = {
  filter?: InputMaybe<StoreFilter>;
  geokey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  store_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryStoresByLocationArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  location_id: Scalars['ID'];
};


export type QueryStoresGrafanaArgs = {
  filter?: InputMaybe<GrafanaStoreFilter>;
};


export type QueryStoresWithAssetsArgs = {
  filter?: InputMaybe<StoreAssetFilter>;
};


export type QueryStoresWithContainerStationsArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryTrackableItemArgs = {
  id: Scalars['ID'];
};


export type QueryTrackableItemsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryVendingMachineArgs = {
  id: Scalars['ID'];
};


export type QueryVytalBrandStoresArgs = {
  brand_id: Scalars['ID'];
  filter?: InputMaybe<VytalStoreFilter>;
  geokey?: InputMaybe<Scalars['String']>;
};


export type QueryVytalLocationGroupedStoresArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  location_id: Scalars['ID'];
};


export type QueryVytalNearestGroupedStoresArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  geokey: Scalars['String'];
  proximity: Scalars['Int'];
};


export type QueryVytalStoresWithGeoKeyArgs = {
  filter?: InputMaybe<VytalStoreFilter>;
  geo_key: Scalars['String'];
};


export type QueryWashingHubStationStateArgs = {
  container_station_id: Scalars['ID'];
  event_id: Scalars['ID'];
};

export type RaffleCampaign = {
  __typename?: 'RaffleCampaign';
  cycle_interval_type?: Maybe<Scalars['String']>;
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  deduplicate_winner_emails: Scalars['Boolean'];
  id: Scalars['String'];
  is_active: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  partner_email_addresses: Array<Scalars['String']>;
  redirect_campaign_ids: Array<Scalars['Int']>;
  select_winners_overall_stores: Scalars['Boolean'];
  select_winners_per_store_per_cycle: Scalars['Boolean'];
  status: Scalars['String'];
  store_ids: Array<Scalars['String']>;
  store_names: Array<Scalars['String']>;
  ticket_count: Scalars['Int'];
  winners_per_cycle?: Maybe<Scalars['Int']>;
};

export type RaffleCycle = {
  __typename?: 'RaffleCycle';
  created_at: Scalars['String'];
  cycle_interval_type?: Maybe<Scalars['String']>;
  cycle_iteration: Scalars['Int'];
  id: Scalars['String'];
  raffle_campaign_id: Scalars['String'];
  ticket_count: Scalars['Int'];
};

export type RaffleParticipantStatus = {
  __typename?: 'RaffleParticipantStatus';
  ticket_status: Scalars['String'];
};

export type RaffleTicket = {
  __typename?: 'RaffleTicket';
  activated: Scalars['Boolean'];
  container_location_id: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  user_id: Scalars['String'];
};

export type RaffleTicketWithStoreName = {
  __typename?: 'RaffleTicketWithStoreName';
  activated: Scalars['Boolean'];
  container_location_id: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  store_name: Scalars['String'];
  user_id: Scalars['String'];
};

export type RaffleWinner = {
  __typename?: 'RaffleWinner';
  created_at: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  raffle_cycle_id: Scalars['String'];
  raffle_tickets_id: Scalars['String'];
  store_id?: Maybe<Scalars['String']>;
};

export type Range = {
  from: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
};

export type RangeInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type ReceiveShipmentInput = {
  container_station_id: Scalars['ID'];
  is_sealed: Scalars['Boolean'];
};

export type RefetchDeliveryNoteResult = {
  __typename?: 'RefetchDeliveryNoteResult';
  delivery_note_url: Scalars['String'];
  has_errors: Scalars['Boolean'];
  successful_order_ids: Array<Scalars['ID']>;
};

export type RefetchOrderDocumentsResult = {
  __typename?: 'RefetchOrderDocumentsResult';
  delivery_note_url: Scalars['String'];
  has_errors: Scalars['Boolean'];
  labels_url: Scalars['String'];
  successful_order_ids: Array<Scalars['ID']>;
};

export type RefreshAccessTokenResponse = {
  __typename?: 'RefreshAccessTokenResponse';
  access_token?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type RegionInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type RegisterSourceIntent = {
  __typename?: 'RegisterSourceIntent';
  client_secret?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ReplacementShipmentResult = {
  __typename?: 'ReplacementShipmentResult';
  /** False when an earlier call had already created this replacement. */
  created: Scalars['Boolean'];
  /** Merged PDF of the replacement attempt's labels. Null when Sendcloud returned no label content. */
  labels_url?: Maybe<Scalars['String']>;
  order_id: Scalars['ID'];
  shipment_attempt_number: Scalars['Int'];
  status: MerchantOrderStatusEnum;
  tracking_numbers: Array<Scalars['String']>;
};

export type ReportProblemInput = {
  container_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  problem_type?: InputMaybe<ProblemType>;
  returned_containers_at?: InputMaybe<Scalars['String']>;
  store_info?: InputMaybe<Scalars['String']>;
};

export enum ReportType {
  BillomatInvoicePdfArchive = 'BILLOMAT_INVOICE_PDF_ARCHIVE',
  BillomatInvoiceReport = 'BILLOMAT_INVOICE_REPORT',
  DeadlineExtensionBills = 'DEADLINE_EXTENSION_BILLS',
  DeadlineExtensionBillsShort = 'DEADLINE_EXTENSION_BILLS_SHORT',
  Debitor = 'DEBITOR',
  DebitorBalance = 'DEBITOR_BALANCE',
  Dunning = 'DUNNING',
  FinanceBulkImportTemplate = 'FINANCE_BULK_IMPORT_TEMPLATE',
  InvoiceSummary = 'INVOICE_SUMMARY',
  InvoiceSummaryWithDeactivated = 'INVOICE_SUMMARY_WITH_DEACTIVATED',
  NonLinkedStoreAccountLedgers = 'NON_LINKED_STORE_ACCOUNT_LEDGERS',
  OverduePenaltyReport = 'OVERDUE_PENALTY_REPORT',
  OverduePenaltyReportShort = 'OVERDUE_PENALTY_REPORT_SHORT',
  PartnerSepaTransfer = 'PARTNER_SEPA_TRANSFER',
  Preorder = 'PREORDER',
  PreorderShort = 'PREORDER_SHORT'
}

export type RequestOrderFulfillmentPictureUploadUrlResult = {
  __typename?: 'RequestOrderFulfillmentPictureUploadUrlResult';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export enum RequestUploadUrlType {
  AppTranslation = 'APP_TRANSLATION',
  Default = 'DEFAULT',
  EventImage = 'EVENT_IMAGE',
  Picture = 'PICTURE'
}

export type ReseedDemoDatabaseResult = {
  __typename?: 'ReseedDemoDatabaseResult';
  duration_ms: Scalars['Int'];
  /** Tail of the seed's combined stdout/stderr. */
  log: Scalars['String'];
  /**
   * Whether the seed process exited 0. On false the database is whatever the
   * seed left behind — re-run it once the log says why it stopped.
   */
  succeeded: Scalars['Boolean'];
};

export enum RetrySendCloudLabelOutcome {
  /** The attempt failed permanently; the order is now ERROR. */
  Failed = 'FAILED',
  /** Another retry of this order is running; this call did nothing. */
  InProgress = 'IN_PROGRESS',
  /** The label was created; the order is PICKED again. */
  Recovered = 'RECOVERED',
  /** The attempt failed transiently; the order stays ERROR_RETRYABLE. */
  StillRetrying = 'STILL_RETRYING'
}

export type RetrySendCloudLabelResult = {
  __typename?: 'RetrySendCloudLabelResult';
  order_id: Scalars['ID'];
  outcome: RetrySendCloudLabelOutcome;
  /** The order's status after the call. */
  status: MerchantOrderStatusEnum;
};

export type ReturnReminder = {
  __typename?: 'ReturnReminder';
  accepted: Scalars['Boolean'];
  day: Scalars['Int'];
};

export type ReturnReminderInput = {
  accepted: Scalars['Boolean'];
  day: Scalars['Int'];
};

export enum Role {
  AccountManager = 'ACCOUNT_MANAGER',
  Administrator = 'ADMINISTRATOR',
  BrandOwner = 'BRAND_OWNER',
  BrandPos = 'BRAND_POS',
  CarrierEmployee = 'CARRIER_EMPLOYEE',
  Customer = 'CUSTOMER',
  EventAccount = 'EVENT_ACCOUNT',
  EventCleaningEmployee = 'EVENT_CLEANING_EMPLOYEE',
  EventManager = 'EVENT_MANAGER',
  EventOwner = 'EVENT_OWNER',
  ExternalEventSupervisor = 'EXTERNAL_EVENT_SUPERVISOR',
  Finance = 'FINANCE',
  HumanResources = 'HUMAN_RESOURCES',
  Marketing = 'MARKETING',
  Operations = 'OPERATIONS',
  StoreOwner = 'STORE_OWNER',
  Support = 'SUPPORT',
  TerminalUser = 'TERMINAL_USER',
  WarehouseCleaning = 'WAREHOUSE_CLEANING'
}

export type SaveServicePackageRevisionInput = {
  allowances: Array<ServicePackageAssetAllowanceInput>;
  /**
   * Natural key of the parent package.
   * The package is created if it does not yet exist.
   */
  currency: Scalars['String'];
  free_checkouts: Array<ServicePackageFreeCheckoutInput>;
  /** Contract term in months — must be a positive integer. */
  min_contract_term_months: Scalars['Int'];
  monthly_service_fee_in_cents: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  onboarding_fee_in_cents: Scalars['Int'];
  ops_order_price_in_cents: Scalars['Int'];
  package_type: ServicePackageType;
};

export type SaveServicePackageRevisionResult = {
  __typename?: 'SaveServicePackageRevisionResult';
  /** The parent package with its updated revision. */
  package: ServicePackage;
  /** The newly written revision. */
  revision: ServicePackageRevision;
};

export type ScanTunnel = {
  __typename?: 'ScanTunnel';
  container_type_id?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mode: ScanTunnelMode;
  name: Scalars['String'];
};

export enum ScanTunnelMode {
  App = 'app',
  AppCreateContainer = 'app_create_container',
  AppLess = 'app_less',
  AppSetContainerType = 'app_set_container_type'
}

export type ScanTunnelSession = {
  __typename?: 'ScanTunnelSession';
  active_until?: Maybe<Scalars['String']>;
  container_stations: Array<ContainerStation>;
  containers: Array<ContainerStationContainer>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  scan_tunnel_id: Scalars['ID'];
};

export type ScheduledMinOrderTimeRule = {
  __typename?: 'ScheduledMinOrderTimeRule';
  day?: Maybe<Scalars['Int']>;
  min_order_time?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
};

export type SearchAdminV2Filter = {
  include_deleted?: InputMaybe<Scalars['Boolean']>;
  include_events?: InputMaybe<Scalars['Boolean']>;
  include_partner_accounts?: InputMaybe<Scalars['Boolean']>;
  include_stores?: InputMaybe<Scalars['Boolean']>;
};

export type SearchAutocompleteFilter = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
  include_geo_results?: InputMaybe<Scalars['Boolean']>;
  include_locations?: InputMaybe<Scalars['Boolean']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  brand?: Maybe<Brand>;
  geo_hash?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  location_type?: Maybe<LocationType>;
  logo?: Maybe<Scalars['String']>;
  lonlat?: Maybe<LonLat>;
  name?: Maybe<Scalars['String']>;
  result_type: SearchResultType;
  stores?: Maybe<Array<Maybe<Store>>>;
};

export enum SearchResultType {
  Brand = 'BRAND',
  Googlelocation = 'GOOGLELOCATION',
  Poi = 'POI',
  Store = 'STORE'
}

export type SearchTrackableItemPaginatedResponse = {
  __typename?: 'SearchTrackableItemPaginatedResponse';
  total: Scalars['Int'];
  trackable_items: Array<TrackableItem>;
};

export type SeedDevContainerCollectionResult = {
  __typename?: 'SeedDevContainerCollectionResult';
  collection_ids: Array<Scalars['ID']>;
  container_ids: Array<Scalars['ID']>;
};

export type SeedDevContainerStationResult = {
  __typename?: 'SeedDevContainerStationResult';
  container_station_ids: Array<Scalars['ID']>;
};

export type SeedDevContainersResult = {
  __typename?: 'SeedDevContainersResult';
  container_ids: Array<Scalars['ID']>;
};

export type SeedDevEventOrdersResult = {
  __typename?: 'SeedDevEventOrdersResult';
  buffer_order_id: Scalars['ID'];
  delivery_address_ids: Array<Scalars['ID']>;
  event_account_order_ids: Array<Scalars['ID']>;
};

export type SeedDevMarkOrderDeliveredResult = {
  __typename?: 'SeedDevMarkOrderDeliveredResult';
  merchant_order_ids: Array<Scalars['ID']>;
  new_status: Scalars['String'];
};

export type SeedDevMinimalEventOrdersResult = {
  __typename?: 'SeedDevMinimalEventOrdersResult';
  buffer_order_id: Scalars['ID'];
};

export type SeedDevParcelStatusApplied = {
  __typename?: 'SeedDevParcelStatusApplied';
  /**
   * Whether the replay asked for the customer.io mail a real webhook would
   * send. handleCarrierStatusResult returns early when the order has no
   * recipient and swallows a failed send, so neither reaches this — the field
   * is the request, not a delivery receipt.
   */
  cio_requested: Scalars['Boolean'];
  /**
   * Why the machinery rejected this status (e.g. STATUS_TRANSITION_NOT_ALLOWED).
   * The replay continues with the next status, exactly as separate webhooks would.
   */
  error?: Maybe<Scalars['String']>;
  /**
   * True when the parcel is not on the order's active shipment attempt: the
   * status is recorded in SendcloudStatusHistory but moves nothing, notifies
   * nobody and makes nothing bookable.
   */
  history_only: Scalars['Boolean'];
  message: Scalars['String'];
  parcel_id: Scalars['String'];
  timestamp: Scalars['String'];
  /** The status the order transitioned to, or null when it did not move. */
  transitioned_to?: Maybe<Scalars['String']>;
};

export type SeedDevParcelStatusHistoryInput = {
  /** Carrier of the created order. Defaults to DPD. Ignored for an existing order. */
  carrier?: InputMaybe<OpsOrderCarrier>;
  /** Service of the created order. Defaults to HOME_DELIVERY. Ignored for an existing order. */
  carrier_service?: InputMaybe<OpsOrderCarrierService>;
  /** Existing order to apply the statuses to. Omit to create a fresh order. */
  merchant_order_id?: InputMaybe<Scalars['UUID']>;
  /** Spacing of the recorded timestamps. Defaults to 60. */
  minutes_between_statuses?: InputMaybe<Scalars['Int']>;
  /**
   * Supersede the order's current shipment attempt and seed the parcels onto a
   * fresh one, which is what a successful createReplacementSendCloudShipment
   * would have produced — from any status, where that mutation needs
   * RETURN_TO_SENDER or one of the two ERRORs it accepts as an entry. Requires
   * merchant_order_id: a freshly created order has no attempt to supersede and
   * would start life on attempt 2.
   */
  new_shipment_attempt?: InputMaybe<Scalars['Boolean']>;
  /**
   * Parcels to seed onto the order's active shipment attempt and replay the
   * statuses across (1-10, default 1). Use more than one to exercise the
   * all-parcels-reached-tier rule.
   */
  parcel_count?: InputMaybe<Scalars['Int']>;
  /**
   * Replay onto these parcels the order already carries instead of seeding new
   * ones — the way to drive a parcel of a superseded attempt and watch the
   * events land in history without moving the order. Requires
   * merchant_order_id; parcel_count is ignored.
   */
  parcel_ids?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Clear the order's existing SendcloudStatusHistory, SendCloudParcelIds,
   * DpdStatusCodes and shipment attempts first, so carrier_status and the
   * attempt show only what this call writes. The order status itself is left
   * alone. Ignored for a created order.
   */
  reset?: InputMaybe<Scalars['Boolean']>;
  /**
   * Create the order as a PICKUP (return-direction) order instead of a RESUPPLY.
   * Ignored for an existing order.
   */
  return_order?: InputMaybe<Scalars['Boolean']>;
  /** Preset sequence to replay. Ignored when statuses is non-empty. */
  scenario?: InputMaybe<DevParcelStatusScenario>;
  /**
   * Actually send the customer.io status emails a real webhook would send.
   * Defaults to false — statuses replay without mailing anyone.
   */
  send_cio?: InputMaybe<Scalars['Boolean']>;
  /** Custom sequence, replayed in order. Takes precedence over scenario. */
  statuses?: InputMaybe<Array<DevParcelStatusInput>>;
  /** Store text id the created order targets. Required without merchant_order_id. */
  store_id?: InputMaybe<Scalars['ID']>;
};

export type SeedDevParcelStatusHistoryResult = {
  __typename?: 'SeedDevParcelStatusHistoryResult';
  applied: Array<SeedDevParcelStatusApplied>;
  /** State of the order's current attempt afterwards (active/returned/...). */
  final_attempt_state?: Maybe<Scalars['String']>;
  final_error_message?: Maybe<Scalars['String']>;
  final_error_type?: Maybe<Scalars['String']>;
  final_status: Scalars['String'];
  merchant_order_id: Scalars['ID'];
  order_created: Scalars['Boolean'];
  parcel_ids: Array<Scalars['String']>;
  /** The shipment attempt the replayed parcels belong to. */
  shipment_attempt_number: Scalars['Int'];
  /** The attempt new_shipment_attempt superseded, if it created one. */
  superseded_attempt_number?: Maybe<Scalars['Int']>;
  tracking_numbers: Array<Scalars['String']>;
};

export type SeedDevPickedEventPickingJobResult = {
  __typename?: 'SeedDevPickedEventPickingJobResult';
  container_station_ids: Array<Scalars['ID']>;
  picking_job_id: Scalars['ID'];
  trackable_item_ids: Array<Scalars['ID']>;
};

export type SeedDevPickedOpenSystemPickingJobResult = {
  __typename?: 'SeedDevPickedOpenSystemPickingJobResult';
  container_ids: Array<Scalars['ID']>;
  container_station_ids: Array<Scalars['ID']>;
  picking_job_id: Scalars['ID'];
  store_asset_ids: Array<Scalars['ID']>;
  untracked_item_type_ids: Array<Scalars['Int']>;
};

export type SeedDevTrackableItemsResult = {
  __typename?: 'SeedDevTrackableItemsResult';
  trackable_item_ids: Array<Scalars['ID']>;
};

export type Selection = {
  menu: Scalars['String'];
  selection: Scalars['String'];
};

/** One write a self-heal is made of. */
export enum SelfHealStep {
  /** The delivery was booked out to the event: an order fulfillment of type picking. */
  DeliveryBooked = 'DELIVERY_BOOKED',
  /** The claim holder's picked row, or the whole non-SPG job, was marked delivered. */
  DeliveryMarked = 'DELIVERY_MARKED',
  /** An SPG job whose set stays open booked one delivery round, as a partial delivery-confirm does. */
  DeliveryRoundBooked = 'DELIVERY_ROUND_BOOKED',
  /** A booking of the heal failed, so the delivery marks and the status change it had written were undone. The holder is left as it was. */
  DeliveryUnmarked = 'DELIVERY_UNMARKED',
  /** The job and its orders were set to delivered. */
  JobDelivered = 'JOB_DELIVERED',
  /** An order of that job got an ERROR revision naming the item. One per order. */
  OrderErrorWritten = 'ORDER_ERROR_WRITTEN',
  /** The item was booked back to the warehouse. */
  ReturnBooked = 'RETURN_BOOKED',
  /** The item's picked row was taken off the job that held it. */
  RowRemoved = 'ROW_REMOVED'
}

/**
 * A self-return QR code sticker. The 6-character id is what a consumer scans to
 * return a container at a store without an app checkout, and — since the sticker
 * is also warehouse stock — what a picker scans to pick it onto an ops order.
 *
 * `trackable_item_id` is the STORE_ASSET TrackableItem behind the physical
 * sticker. Codes created before stickers became trackable have none; they can
 * still be scanned by consumers, but cannot be picked.
 */
export type SelfReturnCode = {
  __typename?: 'SelfReturnCode';
  id: Scalars['ID'];
  is_valid: Scalars['Boolean'];
  linked_at?: Maybe<Scalars['DateTime']>;
  store_id?: Maybe<Scalars['ID']>;
  trackable_item_id?: Maybe<Scalars['ID']>;
};

export type SendEventMerchantOrderFormLinksInput = {
  event_account_ids: Array<Scalars['ID']>;
  event_id: Scalars['ID'];
};

export type SendEventMerchantOrderFormLinksResult = SendEventMerchantOrderFormLinksSuccess | SendEventMerchantOrderFormLinksValidationError;

export type SendEventMerchantOrderFormLinksSuccess = {
  __typename?: 'SendEventMerchantOrderFormLinksSuccess';
  event_account_ids: Array<Scalars['ID']>;
  sent_count: Scalars['Int'];
};

export type SendEventMerchantOrderFormLinksValidationError = {
  __typename?: 'SendEventMerchantOrderFormLinksValidationError';
  error_code: Scalars['String'];
  event_accounts_missing_email?: Maybe<Array<EventAccountMissingEmail>>;
  invalid_event_account_ids?: Maybe<Array<Scalars['ID']>>;
  message: Scalars['String'];
  not_participating_event_account_ids?: Maybe<Array<Scalars['ID']>>;
};

export type SendToPickingResult = {
  __typename?: 'SendToPickingResult';
  delivery_note_url: Scalars['String'];
  has_errors: Scalars['Boolean'];
  labels_url: Scalars['String'];
  successful_order_ids: Array<Scalars['ID']>;
  successful_orders: Array<OpsOrder>;
};

export type SepaFraudCheck = {
  amount?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
  sepa?: InputMaybe<Scalars['String']>;
  street_name?: InputMaybe<Scalars['String']>;
  street_no?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['Int']>;
};

/**
 * A service package plan for a specific (package_type, currency) combination.
 * The unique constraint on the backend ensures at most one ServicePackage exists
 * per (package_type, currency) pair.
 */
export type ServicePackage = {
  __typename?: 'ServicePackage';
  created_at: Scalars['String'];
  /** ISO 4217 currency code, e.g. "EUR", "GBP", "CHF". */
  currency: Scalars['String'];
  id: Scalars['ID'];
  package_type: ServicePackageType;
  /**
   * The latest revision for each contract term
   * for this package (highest revision number, no store override).
   */
  revisions: Array<ServicePackageRevision>;
};

export type ServicePackageAssetAllowance = {
  __typename?: 'ServicePackageAssetAllowance';
  id: Scalars['ID'];
  /** Only Store Assets are allowed to be bundled into a service package allowance. */
  item: ItemType;
  monthly_quantity: Scalars['Int'];
};

export type ServicePackageAssetAllowanceInput = {
  item_type_id: Scalars['ID'];
  monthly_quantity: Scalars['Int'];
};

export type ServicePackageFreeCheckout = {
  __typename?: 'ServicePackageFreeCheckout';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  segment: ContainerTypeSegment;
};

export type ServicePackageFreeCheckoutInput = {
  amount: Scalars['Int'];
  segment: ContainerTypeSegment;
};

/**
 * A versioned snapshot of a service package's pricing for one contract term.
 * A new revision is written each time an admin saves changes to a term; the
 * previous revision is kept for audit / invoice history.
 * Stores reference a specific revision ID so their billing is never affected by
 * future price edits.
 */
export type ServicePackageRevision = {
  __typename?: 'ServicePackageRevision';
  allowances: Array<ServicePackageAssetAllowance>;
  created_at: Scalars['String'];
  created_by?: Maybe<Scalars['String']>;
  /** Per-segment free checkout counts included in this revision. */
  free_checkouts: Array<ServicePackageFreeCheckout>;
  id: Scalars['ID'];
  /** Contract length in months — any positive integer (12, 24, 36, …). */
  min_contract_term_months: Scalars['Int'];
  monthly_service_fee_in_cents: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  onboarding_fee_in_cents: Scalars['Int'];
  /** Per-ops-order price charged to the store at billing time. */
  ops_order_price_in_cents: Scalars['Int'];
  /** Monotonically increasing per (package, min_contract_term_month, store_uuid) tuple. */
  revision_number: Scalars['Int'];
};

/**
 * A service package scoped to a single contract term (one revision).
 * Used when querying a store's active plan or any context where only one
 * revision is relevant.
 */
export type ServicePackageTerm = {
  __typename?: 'ServicePackageTerm';
  created_at: Scalars['String'];
  /** ISO 4217 currency code, e.g. "EUR", "GBP", "CHF". */
  currency: Scalars['String'];
  id: Scalars['ID'];
  package_type: ServicePackageType;
  /** The single active revision for this term. */
  revision: ServicePackageRevision;
};

export enum ServicePackageType {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Essential = 'essential',
  ProPlus = 'pro_plus'
}

export type SetCommittedTransactionVolumeInput = {
  committed_volume: Scalars['Int'];
  discount_per_transaction_in_cents: Scalars['Int'];
  store_uuid: Scalars['ID'];
};

export type SetItemTypePriceInput = {
  billing_frequency: BillingFrequency;
  item_type_id: Scalars['Int'];
  price: Scalars['Int'];
  store_id?: InputMaybe<Scalars['ID']>;
};

export type SetStoreLabel = {
  color?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
};

export type SetStoreServicePackageInput = {
  /** The container type segment for which free checkouts apply (FOOD or DRINKS). */
  free_checkout_segment: ContainerTypeSegment;
  /** The exact ServicePackageRevision to pin to this store. */
  service_package_revision_id: Scalars['ID'];
  /** The start date for billing this service package. ISO date string. */
  service_package_start_date?: InputMaybe<Scalars['String']>;
  store_uuid: Scalars['ID'];
};

export type SharedOrderInfo = {
  __typename?: 'SharedOrderInfo';
  basket_id?: Maybe<Scalars['ID']>;
  cancelled_items?: Maybe<Array<Maybe<OrderItem>>>;
  items?: Maybe<Array<Maybe<BasketItem>>>;
  order_cancelled?: Maybe<Scalars['Boolean']>;
  order_id?: Maybe<Scalars['ID']>;
  user_id?: Maybe<Scalars['ID']>;
  user_name?: Maybe<Scalars['String']>;
  user_profile_picture?: Maybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialOpeningHours = {
  __typename?: 'SpecialOpeningHours';
  day: Scalars['String'];
  time: Scalars['String'];
};

export type SpecialOpeningHoursMulti = {
  __typename?: 'SpecialOpeningHoursMulti';
  day: Scalars['String'];
  time?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Specialities = {
  __typename?: 'Specialities';
  food_type?: Maybe<FoodTypeEnum>;
  is_halal?: Maybe<Scalars['Boolean']>;
  is_kosher?: Maybe<Scalars['Boolean']>;
};

export type SpecialitiesInput = {
  food_type?: InputMaybe<FoodTypeEnum>;
  is_halal?: InputMaybe<Scalars['Boolean']>;
  is_kosher?: InputMaybe<Scalars['Boolean']>;
};

export enum StatusEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  CanceledStore = 'CANCELED_STORE',
  CanceledUser = 'CANCELED_USER',
  Completed = 'COMPLETED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryCompletedTimeout = 'DELIVERY_COMPLETED_TIMEOUT',
  DeliveryInProgress = 'DELIVERY_IN_PROGRESS',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  NewConflict = 'NEW_CONFLICT',
  PaymentError = 'PAYMENT_ERROR',
  Pending = 'PENDING',
  PendingCanceled = 'PENDING_CANCELED',
  PickedUp = 'PICKED_UP',
  PickedUpTimeout = 'PICKED_UP_TIMEOUT',
  Ready = 'READY',
  ReadyNoShow = 'READY_NO_SHOW'
}

export type StatusHistory = {
  __typename?: 'StatusHistory';
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Store = {
  __typename?: 'Store';
  accepted_container_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
  accepted_container_type_group_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  accepted_container_types?: Maybe<Array<Maybe<AcceptedContainerType>>>;
  acquired_at?: Maybe<Scalars['String']>;
  acquired_by?: Maybe<Scalars['String']>;
  active_inventory_check?: Maybe<ActiveInventoryCheck>;
  additional_allowance?: Maybe<Scalars['Int']>;
  additional_allowance_valid_until?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  all_non_usage_fee_info: AllNonUsageFeeInfo;
  allow_inventory_checks_for_terminal_users?: Maybe<Scalars['Boolean']>;
  allow_inventory_checks_for_terminal_users_permanently?: Maybe<Scalars['Boolean']>;
  allow_inventory_checks_for_terminal_users_until?: Maybe<Scalars['String']>;
  allow_ops_order_search_for_terminal_users: Scalars['Boolean'];
  allow_request_return_order_for_terminal_users: Scalars['Boolean'];
  always_online?: Maybe<Scalars['Boolean']>;
  available_carrier_services: Array<AvailableCarrierService>;
  available_from?: Maybe<Scalars['String']>;
  available_soon: Scalars['Boolean'];
  banner?: Maybe<Scalars['String']>;
  block_campaigns?: Maybe<Scalars['Boolean']>;
  borough?: Maybe<Scalars['String']>;
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['ID']>;
  busy_minutes?: Maybe<Scalars['Int']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  can_deliver?: Maybe<Scalars['Boolean']>;
  can_eat_in: Scalars['Boolean'];
  /** @deprecated No longer supported */
  can_get_bowl?: Maybe<Scalars['Boolean']>;
  can_order_secondary_portfolio: Scalars['Boolean'];
  can_preorder?: Maybe<Scalars['Boolean']>;
  cancelation_time?: Maybe<Scalars['Int']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  change_history?: Maybe<Array<Maybe<StoreChangeHistory>>>;
  charge_non_usage_fee?: Maybe<Scalars['Boolean']>;
  charge_onboarding_fee?: Maybe<Scalars['Boolean']>;
  cio_identifier_secret?: Maybe<Scalars['String']>;
  city_id?: Maybe<Scalars['String']>;
  coming_soon?: Maybe<Scalars['Boolean']>;
  company_legal_form?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<StoreContact>>>;
  container_groups?: Maybe<Array<ContainerGroup>>;
  contract_end_date?: Maybe<Scalars['String']>;
  contracted_date?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  credit_to_partner?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currency_minimum_stripe_amount?: Maybe<Scalars['Int']>;
  currency_symbol?: Maybe<Scalars['String']>;
  custom_invoice_items?: Maybe<Array<Maybe<CustomInvoiceItem>>>;
  debitor_account_number?: Maybe<Scalars['Int']>;
  deeplink?: Maybe<Scalars['String']>;
  default_carriers?: Maybe<Array<DefaultCarrierEntry>>;
  default_inventory_check_expiration_days: Scalars['Int'];
  delivery_address?: Maybe<OpsDeliveryAddress>;
  delivery_area?: Maybe<Scalars['String']>;
  delivery_fee?: Maybe<Scalars['Int']>;
  delivery_hours?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  delivery_hours_raw?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  description?: Maybe<Scalars['String']>;
  description_al?: Maybe<Scalars['String']>;
  description_ca?: Maybe<Scalars['String']>;
  description_da?: Maybe<Scalars['String']>;
  description_de?: Maybe<Scalars['String']>;
  description_el?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_et?: Maybe<Scalars['String']>;
  description_eu?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_gl?: Maybe<Scalars['String']>;
  description_hu?: Maybe<Scalars['String']>;
  description_lb?: Maybe<Scalars['String']>;
  description_nl?: Maybe<Scalars['String']>;
  description_no?: Maybe<Scalars['String']>;
  description_pl?: Maybe<Scalars['String']>;
  description_pt?: Maybe<Scalars['String']>;
  description_sv?: Maybe<Scalars['String']>;
  didi_food_url?: Maybe<Scalars['String']>;
  disable_automatic_partner_charging?: Maybe<Scalars['Boolean']>;
  disable_automatic_partner_invoice_sending?: Maybe<Scalars['Boolean']>;
  distance?: Maybe<Distance>;
  dpd_pickup_compulsory?: Maybe<Scalars['Boolean']>;
  dunning_reminder_block_permanent_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_permanent_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_reason?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_at?: Maybe<Scalars['String']>;
  dunning_reminder_block_temporary_set_by?: Maybe<Scalars['String']>;
  dunning_reminder_block_type?: Maybe<DunningReminderBlockType>;
  dunning_reminder_block_until?: Maybe<Scalars['String']>;
  eat_in_option?: Maybe<Scalars['Boolean']>;
  eatic_url?: Maybe<Scalars['String']>;
  effective_default_carriers: Array<DefaultCarrierEntry>;
  employee_only: Scalars['Boolean'];
  excluded_from_nuf_until?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['ID']>;
  external_salesforce_id?: Maybe<Scalars['String']>;
  external_vytal_id?: Maybe<Scalars['String']>;
  external_zoho_crm_id?: Maybe<Scalars['String']>;
  feature_container_collection_enabled?: Maybe<Scalars['Boolean']>;
  feature_container_station_packing_enabled?: Maybe<Scalars['Boolean']>;
  floor_plan?: Maybe<Scalars['String']>;
  food_categories?: Maybe<Array<Maybe<FoodCategory>>>;
  food_info_de?: Maybe<Scalars['String']>;
  food_info_en?: Maybe<Scalars['String']>;
  foodora_url?: Maybe<Scalars['String']>;
  foodpanda_url?: Maybe<Scalars['String']>;
  foreign_id?: Maybe<Scalars['ID']>;
  free_checkout_segment?: Maybe<ContainerTypeSegment>;
  geo_hash?: Maybe<Scalars['ID']>;
  geo_key?: Maybe<Scalars['ID']>;
  google_places_id?: Maybe<Scalars['String']>;
  google_review?: Maybe<Scalars['Float']>;
  gray_heart_icon?: Maybe<Scalars['Boolean']>;
  habgusta_url?: Maybe<Scalars['String']>;
  has_didi_food: Scalars['Boolean'];
  has_eatic: Scalars['Boolean'];
  has_foodora: Scalars['Boolean'];
  has_foodpanda: Scalars['Boolean'];
  has_habgusta: Scalars['Boolean'];
  has_labonapp: Scalars['Boolean'];
  has_lieferando: Scalars['Boolean'];
  has_linked_app_user: Scalars['Boolean'];
  has_mjam: Scalars['Boolean'];
  has_rappi: Scalars['Boolean'];
  has_return_box_published_in_app: Scalars['Boolean'];
  has_split_app: Scalars['Boolean'];
  has_too_good_to_go: Scalars['Boolean'];
  has_ubereats: Scalars['Boolean'];
  has_wolt: Scalars['Boolean'];
  heartbeat?: Maybe<Scalars['String']>;
  hidden_invoice_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  image_urls?: Maybe<Array<Maybe<Scalars['String']>>>;
  images?: Maybe<Array<Maybe<StoreImage>>>;
  incubation?: Maybe<Scalars['Boolean']>;
  inkassokennzeichen?: Maybe<Scalars['Boolean']>;
  instant_disabled?: Maybe<Scalars['Boolean']>;
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  internal_comment?: Maybe<Scalars['String']>;
  invoice_address?: Maybe<Address>;
  invoice_collection?: Maybe<InvoiceCollection>;
  invoice_collection_id?: Maybe<Scalars['ID']>;
  invoice_email?: Maybe<Scalars['String']>;
  invoice_email_subject_prefix?: Maybe<Scalars['String']>;
  invoice_headline?: Maybe<Scalars['String']>;
  invoice_iban?: Maybe<Scalars['String']>;
  invoice_iban_name?: Maybe<Scalars['String']>;
  invoice_routing_id?: Maybe<Scalars['String']>;
  invoice_run_country?: Maybe<Scalars['String']>;
  invoice_yearly?: Maybe<Scalars['Boolean']>;
  invoicing_disabled_permanently?: Maybe<Scalars['Boolean']>;
  invoicing_disabled_until?: Maybe<Scalars['String']>;
  is_dunning_reminder_stopped?: Maybe<Scalars['Boolean']>;
  is_first_order?: Maybe<Scalars['Boolean']>;
  is_invoicing_currently_disabled?: Maybe<Scalars['Boolean']>;
  is_net_receiver?: Maybe<Scalars['Boolean']>;
  is_new?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Array<Maybe<StoreLabel>>>;
  labonapp_url?: Maybe<Scalars['String']>;
  last_google_opening_hours_sync?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  lieferando_url?: Maybe<Scalars['String']>;
  linked_city?: Maybe<Location>;
  linked_location?: Maybe<Location>;
  localized_address?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  location_name_long?: Maybe<Scalars['String']>;
  lonlat?: Maybe<LonLat>;
  manual_overwrite_store_info?: Maybe<Scalars['Boolean']>;
  map_banner?: Maybe<Scalars['String']>;
  menu_link?: Maybe<Scalars['String']>;
  migrated_from_vytal?: Maybe<Scalars['Boolean']>;
  min_delivery_order_value?: Maybe<Scalars['Int']>;
  min_delivery_time?: Maybe<Scalars['Int']>;
  min_order_time?: Maybe<Scalars['Int']>;
  min_order_time_default?: Maybe<Scalars['Int']>;
  mini_returners?: Maybe<Array<StoreMiniReturner>>;
  minimum_monthly_transaction_charge?: Maybe<Scalars['Int']>;
  mjam_url?: Maybe<Scalars['String']>;
  monthly_flat_fee?: Maybe<Scalars['Int']>;
  monthly_service_fee?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nearest_store_distance?: Maybe<Scalars['Int']>;
  needs_purchasing_order_number?: Maybe<Scalars['Boolean']>;
  /**
   * Store-level inventory-check billing policy: inventory checks created from now on
   * for this store are non-billable. Independent of the partner account policy
   * (EventAccount.new_inventory_checks_are_non_billable) — either one is sufficient.
   * Only affects checks created after the change; existing checks keep their
   * billability and can still be overridden individually.
   */
  new_inventory_checks_are_non_billable: Scalars['Boolean'];
  non_usage_fee_enabled?: Maybe<Scalars['Boolean']>;
  non_usage_fee_info?: Maybe<Array<Maybe<NonUsageFeeInfo>>>;
  nuf_comment?: Maybe<Scalars['String']>;
  offline_card_cost?: Maybe<Scalars['Int']>;
  offline_minutes?: Maybe<Scalars['Int']>;
  offline_timeout?: Maybe<Scalars['String']>;
  onboarded_date?: Maybe<Scalars['String']>;
  onboarding_fee_vytal?: Maybe<Scalars['Int']>;
  onboarding_status?: Maybe<OnboardingStatus>;
  online?: Maybe<Scalars['Boolean']>;
  opening_hours?: Maybe<Array<Maybe<OpeningHours>>>;
  opening_hours_multi?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  opening_hours_multi_raw?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  order_number?: Maybe<Scalars['String']>;
  order_preferences?: Maybe<StoreOrderPreferences>;
  ordering_services?: Maybe<Array<Maybe<OrderingService>>>;
  package?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['ID']>;
  partner_credits?: Maybe<Scalars['Int']>;
  partner_credits_usable_until?: Maybe<Scalars['String']>;
  partner_newsletter_email?: Maybe<Scalars['String']>;
  payment_details?: Maybe<GlypoUser>;
  permanently_closed?: Maybe<Scalars['Boolean']>;
  permanently_removed?: Maybe<Scalars['Boolean']>;
  phone_from_vytal?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<StorePhone>>>;
  pickie?: Maybe<Scalars['String']>;
  pickup_point?: Maybe<PickupPoint>;
  pickup_point_image?: Maybe<Scalars['String']>;
  pickup_point_type?: Maybe<PickupPointType>;
  pickup_route_help?: Maybe<Scalars['String']>;
  poi_location?: Maybe<Scalars['String']>;
  possible_merchant_order_types?: Maybe<Array<Maybe<Scalars['Int']>>>;
  power_cable_status?: Maybe<PowerCableStatusChange>;
  preferred_locale?: Maybe<Scalars['String']>;
  preorder_hours?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  preorder_hours_raw?: Maybe<Array<Maybe<OpeningHoursMulti>>>;
  preorder_sms_number?: Maybe<Scalars['String']>;
  /** @deprecated private_contact is deprecated. Use contacts instead. */
  private_contact_email?: Maybe<Scalars['String']>;
  /** @deprecated private_contact is deprecated. Use contacts instead. */
  private_contact_info?: Maybe<Scalars['String']>;
  /** @deprecated private_contact is deprecated. Use contacts instead. */
  private_contact_name?: Maybe<Scalars['String']>;
  product_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  published?: Maybe<Scalars['Boolean']>;
  /**
   * Dedicated purchasing-order contact(s) for this store, semicolon-separated,
   * as many addresses as needed. Deliberately separate from invoice_email: the
   * people who issue a purchasing order are usually not the people who receive
   * the invoice. A store without a contact falls back to the nearest partner
   * account's purchasing_order_email, never to invoice_email.
   */
  purchasing_order_email?: Maybe<Scalars['String']>;
  /**
   * Effective purchasing-order gating: combines the store's own
   * needs_purchasing_order_number with the flag of any partner account above the
   * store, so consumers see the state invoicing acts on — not just the store
   * field.
   */
  purchasing_order_gating?: Maybe<PurchasingOrderGating>;
  quality_rank?: Maybe<Scalars['String']>;
  rappi_url?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['Int']>;
  regular_payment_target_days?: Maybe<Scalars['Int']>;
  removal_reason?: Maybe<Scalars['String']>;
  return_boxes?: Maybe<Array<Maybe<StoreReturnBox>>>;
  revenue_tier?: Maybe<StoreTier>;
  rider_pickup_possible?: Maybe<Scalars['Boolean']>;
  route_help?: Maybe<Scalars['String']>;
  saved_packages_total_count?: Maybe<Scalars['Int']>;
  scheduled_min_order_time_rules?: Maybe<Array<Maybe<ScheduledMinOrderTimeRule>>>;
  sd_application_key?: Maybe<Scalars['String']>;
  sd_store_id?: Maybe<Scalars['String']>;
  seller_id?: Maybe<Scalars['String']>;
  send_nuf_info_to_invoice_address?: Maybe<Scalars['Boolean']>;
  sepa_2_percent_discount?: Maybe<Scalars['Boolean']>;
  service_package?: Maybe<ServicePackageTerm>;
  service_package_start_date?: Maybe<Scalars['String']>;
  service_package_type?: Maybe<ServicePackageType>;
  shared_order_enabled?: Maybe<Scalars['Boolean']>;
  show_in_stats?: Maybe<Scalars['Boolean']>;
  sim_info?: Maybe<Scalars['String']>;
  sim_payment_automation?: Maybe<Scalars['Boolean']>;
  sim_phone_number?: Maybe<Scalars['String']>;
  special_delivery_hours?: Maybe<Array<Maybe<SpecialOpeningHoursMulti>>>;
  special_opening_hours?: Maybe<Array<Maybe<SpecialOpeningHours>>>;
  special_opening_hours_multi?: Maybe<Array<Maybe<SpecialOpeningHoursMulti>>>;
  special_role?: Maybe<Scalars['String']>;
  split_app_url?: Maybe<Scalars['String']>;
  store_layout?: Maybe<Array<Maybe<Scalars['String']>>>;
  store_layout_vending_machines_json?: Maybe<Scalars['String']>;
  store_wide_discount_percent?: Maybe<Scalars['Int']>;
  suburb?: Maybe<Scalars['String']>;
  /**
   * Whether the monthly sustainability report is generated and emailed for this store.
   * Defaults to true; the cron job skips stores where it is false even if the service
   * package would otherwise qualify.
   */
  sustainability_reports_enabled: Scalars['Boolean'];
  tap2borrow_devices?: Maybe<Array<StoreTap2BorrowDevice>>;
  temporarily_closed?: Maybe<Scalars['Boolean']>;
  temporary_access_from?: Maybe<Scalars['String']>;
  termination_comment?: Maybe<Scalars['String']>;
  termination_reason?: Maybe<TerminationReason>;
  test_period_end?: Maybe<Scalars['String']>;
  tier?: Maybe<StoreTier>;
  timezone?: Maybe<Scalars['String']>;
  too_good_to_go_url?: Maybe<Scalars['String']>;
  type?: Maybe<StoreType>;
  ubereats_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  use_circulation_based_billing?: Maybe<Scalars['Boolean']>;
  use_new_inventory_check_version: Scalars['Boolean'];
  used_self_signup?: Maybe<Scalars['Boolean']>;
  vat_number?: Maybe<Scalars['String']>;
  vending_machines?: Maybe<Array<Maybe<VendingMachine>>>;
  vendor_id?: Maybe<Scalars['ID']>;
  watched_onboarding_videos?: Maybe<Scalars['Boolean']>;
  website?: Maybe<Scalars['String']>;
  wolt_url?: Maybe<Scalars['String']>;
  yearly_renewal_fee?: Maybe<Scalars['Int']>;
  /**
   * Calendar month (1-12) the yearly renewal fee is charged in. Null means the
   * default: the anniversary of the month the store was onboarded in.
   */
  yearly_renewal_fee_month?: Maybe<Scalars['Int']>;
};

export type StoreAsset = {
  __typename?: 'StoreAsset';
  asset_type?: Maybe<AssetType>;
  billing_frequency?: Maybe<BillingFrequency>;
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding?: Maybe<Scalars['Boolean']>;
  creation_timestamp?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  location?: Maybe<Scalars['String']>;
  monthly_charge?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  publish_return_box_in_app?: Maybe<Scalars['Boolean']>;
  serial_number?: Maybe<Scalars['String']>;
  serviced?: Maybe<Scalars['Boolean']>;
  sim_card_number?: Maybe<Scalars['String']>;
  sim_provided?: Maybe<Scalars['Boolean']>;
  store_id?: Maybe<Scalars['ID']>;
  store_name?: Maybe<Scalars['String']>;
  store_vytal_id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreAssetFilter = {
  include_phones?: InputMaybe<Scalars['Boolean']>;
  include_return_boxes?: InputMaybe<Scalars['Boolean']>;
};

export type StoreAssetFilterV2 = {
  include_deleted?: InputMaybe<Scalars['Boolean']>;
  include_recalled?: InputMaybe<Scalars['Boolean']>;
  item_type_id?: InputMaybe<Scalars['Int']>;
  store_id?: InputMaybe<Scalars['ID']>;
};

export type StoreAssetV2 = {
  __typename?: 'StoreAssetV2';
  /**
   * Exclusive end of billing: the first day that is NOT billed (ISO date).
   * Billing runs up to but not including this day. Null means open-ended billing.
   */
  billing_end?: Maybe<Scalars['String']>;
  billing_frequency?: Maybe<BillingFrequency>;
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding?: Maybe<Scalars['Boolean']>;
  creation_timestamp?: Maybe<Scalars['String']>;
  custom_fields: Array<CustomFieldValue>;
  description?: Maybe<Scalars['String']>;
  epc_tag: Scalars['String'];
  id: Scalars['ID'];
  /**
   * Vytal-internal note about this asset. Not to be confused with description,
   * which the partner reads on the invoice — this one stays internal, so it is
   * gated to Vytal staff and never reaches an event owner.
   */
  internal_comment?: Maybe<Scalars['String']>;
  is_billable?: Maybe<Scalars['Boolean']>;
  is_recalled?: Maybe<Scalars['Boolean']>;
  item_type: ItemType;
  name: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  removed_at?: Maybe<Scalars['String']>;
  store?: Maybe<Store>;
  store_id?: Maybe<Scalars['ID']>;
};

export type StoreAssetsResult = {
  __typename?: 'StoreAssetsResult';
  items: Array<StoreAssetV2>;
  total: Scalars['Int'];
};

export type StoreCategory = {
  __typename?: 'StoreCategory';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StoreChangeHistory = {
  __typename?: 'StoreChangeHistory';
  changed_at?: Maybe<Scalars['String']>;
  changed_by?: Maybe<Scalars['String']>;
  changed_by_raw?: Maybe<Scalars['String']>;
  new_values?: Maybe<Scalars['String']>;
  old_values?: Maybe<Scalars['String']>;
};

export type StoreContact = {
  __typename?: 'StoreContact';
  contact_departments?: Maybe<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<ContactRole>>>;
  salutation?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * The current stock of one merchant store, one entry per container type that has at
 * least one container in stock. A store with nothing in stock has an empty list.
 */
export type StoreContainerStock = {
  __typename?: 'StoreContainerStock';
  container_type_stock: Array<ContainerTypeStockCount>;
  store_name?: Maybe<Scalars['String']>;
  store_text_id?: Maybe<Scalars['String']>;
  store_uuid: Scalars['UUID'];
};

export type StoreFilter = {
  admin_show_all?: InputMaybe<Scalars['Boolean']>;
  admin_show_removed?: InputMaybe<Scalars['Boolean']>;
  can_deliver?: InputMaybe<Scalars['Boolean']>;
  can_preorder?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city_id?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  food_categories?: InputMaybe<Array<InputMaybe<FoodCategory>>>;
  has_didi_food?: InputMaybe<Scalars['Boolean']>;
  has_eatic?: InputMaybe<Scalars['Boolean']>;
  has_foodora?: InputMaybe<Scalars['Boolean']>;
  has_foodpanda?: InputMaybe<Scalars['Boolean']>;
  has_habgusta?: InputMaybe<Scalars['Boolean']>;
  has_labonapp?: InputMaybe<Scalars['Boolean']>;
  has_lieferando?: InputMaybe<Scalars['Boolean']>;
  has_mjam?: InputMaybe<Scalars['Boolean']>;
  has_rappi?: InputMaybe<Scalars['Boolean']>;
  has_too_good_to_go?: InputMaybe<Scalars['Boolean']>;
  has_ubereats?: InputMaybe<Scalars['Boolean']>;
  has_wolt?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  show_offline?: InputMaybe<Scalars['Boolean']>;
};

export type StoreFilterDb = {
  admin_show_removed?: InputMaybe<Scalars['Boolean']>;
  admin_show_unpublished?: InputMaybe<Scalars['Boolean']>;
  can_deliver?: InputMaybe<Scalars['Boolean']>;
  can_preorder?: InputMaybe<Scalars['Boolean']>;
  city_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employee_only?: InputMaybe<Scalars['Boolean']>;
  exclude_location?: InputMaybe<Scalars['String']>;
  exclude_net_receivers?: InputMaybe<Scalars['Boolean']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  food_categories?: InputMaybe<Array<InputMaybe<FoodCategory>>>;
  has_didi_food?: InputMaybe<Scalars['Boolean']>;
  has_eatic?: InputMaybe<Scalars['Boolean']>;
  has_foodora?: InputMaybe<Scalars['Boolean']>;
  has_foodpanda?: InputMaybe<Scalars['Boolean']>;
  has_habgusta?: InputMaybe<Scalars['Boolean']>;
  has_labonapp?: InputMaybe<Scalars['Boolean']>;
  has_lieferando?: InputMaybe<Scalars['Boolean']>;
  has_mjam?: InputMaybe<Scalars['Boolean']>;
  has_rappi?: InputMaybe<Scalars['Boolean']>;
  has_too_good_to_go?: InputMaybe<Scalars['Boolean']>;
  has_ubereats?: InputMaybe<Scalars['Boolean']>;
  has_wolt?: InputMaybe<Scalars['Boolean']>;
  include_unpublished_employee_only_stores?: InputMaybe<Scalars['Boolean']>;
  no_preorder?: InputMaybe<Scalars['Boolean']>;
  non_usage_fee_enabled?: InputMaybe<Scalars['Boolean']>;
  only_preorder?: InputMaybe<Scalars['Boolean']>;
  region_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StoreFront = {
  __typename?: 'StoreFront';
  brand?: Maybe<Brand>;
  products?: Maybe<StoreProduct>;
  store?: Maybe<Store>;
};

export type StoreImage = {
  __typename?: 'StoreImage';
  created_at?: Maybe<Scalars['String']>;
  origin_url?: Maybe<Scalars['String']>;
  original_url?: Maybe<Scalars['String']>;
  source?: Maybe<ImageSource>;
  url?: Maybe<Scalars['String']>;
};

export type StoreImageInput = {
  created_at?: InputMaybe<Scalars['String']>;
  origin_url?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<ImageSource>;
  url?: InputMaybe<Scalars['String']>;
};

export type StoreInBoundingBox = {
  __typename?: 'StoreInBoundingBox';
  checkouts_last_30_days: Scalars['Int'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  reports_last_30_days: Scalars['Int'];
  store_name: Scalars['String'];
  store_text_id: Scalars['String'];
  store_type: Scalars['String'];
};

export type StoreInfo = {
  __typename?: 'StoreInfo';
  name?: Maybe<Scalars['String']>;
  text_id: Scalars['String'];
  uuid: Scalars['String'];
};

export type StoreInvoiceChargeResult = {
  __typename?: 'StoreInvoiceChargeResult';
  charge_id?: Maybe<Scalars['String']>;
  charge_result?: Maybe<Scalars['String']>;
  link_to_transaction?: Maybe<Scalars['String']>;
  partner_has_payment_method?: Maybe<Scalars['Boolean']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreLabel = {
  __typename?: 'StoreLabel';
  color?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  text_color: Scalars['String'];
};

export type StoreMiniReturner = {
  __typename?: 'StoreMiniReturner';
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding: Scalars['Boolean'];
  id: Scalars['ID'];
  monthly_charge: Scalars['Int'];
};

export type StoreOrderPreferences = {
  __typename?: 'StoreOrderPreferences';
  allow_koziol?: Maybe<Scalars['Boolean']>;
  allow_mepal?: Maybe<Scalars['Boolean']>;
};

export type StoreOrderPreferencesInput = {
  allow_koziol?: InputMaybe<Scalars['Boolean']>;
  allow_mepal?: InputMaybe<Scalars['Boolean']>;
};

export type StorePhone = {
  __typename?: 'StorePhone';
  billing_frequency?: Maybe<BillingFrequency>;
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding?: Maybe<Scalars['Boolean']>;
  creation_timestamp?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  monthly_charge?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  sim_card_number?: Maybe<Scalars['String']>;
  sim_provided?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreProduct = {
  __typename?: 'StoreProduct';
  categories?: Maybe<Array<Maybe<Category>>>;
  featured_products?: Maybe<Array<Maybe<Product>>>;
};

export type StoreReturnBox = {
  __typename?: 'StoreReturnBox';
  billing_frequency?: Maybe<BillingFrequency>;
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding?: Maybe<Scalars['Boolean']>;
  creation_timestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  location?: Maybe<Scalars['String']>;
  monthly_charge?: Maybe<Scalars['Int']>;
  publish_return_box_in_app?: Maybe<Scalars['Boolean']>;
  serviced?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreSearchAdminFilter = {
  store_type?: InputMaybe<StoreType>;
};

export type StoreSearchCountOnlyResult = {
  __typename?: 'StoreSearchCountOnlyResult';
  store_count: Scalars['Int'];
};

export type StoreSearchResult = {
  __typename?: 'StoreSearchResult';
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lonlat?: Maybe<LonLat>;
  name?: Maybe<Scalars['String']>;
  result_type: SearchResultType;
  store?: Maybe<Store>;
};

export type StoreSettings = {
  min_order_time?: InputMaybe<Scalars['Int']>;
  online?: InputMaybe<Scalars['Boolean']>;
};

export type StoreTap2BorrowDevice = {
  __typename?: 'StoreTap2BorrowDevice';
  billing_start?: Maybe<Scalars['String']>;
  billing_start_with_onboarding: Scalars['Boolean'];
  hide_on_invoice?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  monthly_charge: Scalars['Int'];
  serial_number?: Maybe<Scalars['String']>;
  type: StoreTap2BorrowDeviceType;
};

export enum StoreTap2BorrowDeviceType {
  SamsungGalaxyA16 = 'SAMSUNG_GALAXY_A16',
  StripeHubForReaderS700 = 'STRIPE_HUB_FOR_READER_S700',
  StripeReaderS700 = 'STRIPE_READER_S700',
  ZebraDs9308 = 'ZEBRA_DS9308'
}

export enum StoreTier {
  A = 'A',
  Aaa = 'AAA',
  B = 'B',
  C = 'C'
}

export enum StoreType {
  /** @deprecated BIO_SUPERMARKET is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  BioSupermarket = 'BIO_SUPERMARKET',
  /** @deprecated CAFETERIA is deprecated. Use UNIVERSITY_CANTEEN instead. */
  Cafeteria = 'CAFETERIA',
  Campus = 'CAMPUS',
  Canteen = 'CANTEEN',
  Caterer = 'CATERER',
  /** @deprecated No longer supported */
  Default = 'DEFAULT',
  DemoStore = 'DEMO_STORE',
  Entertainment = 'ENTERTAINMENT',
  Festival = 'FESTIVAL',
  Franchisee = 'FRANCHISEE',
  Hospital = 'HOSPITAL',
  Internal = 'INTERNAL',
  InternationalCateringCompany = 'INTERNATIONAL_CATERING_COMPANY',
  InternationalChain = 'INTERNATIONAL_CHAIN',
  LocalRetailer = 'LOCAL_RETAILER',
  LostBowls = 'LOST_BOWLS',
  NationalCateringCompany = 'NATIONAL_CATERING_COMPANY',
  NationalChain = 'NATIONAL_CHAIN',
  OnlineRetailer = 'ONLINE_RETAILER',
  PublicEvents = 'PUBLIC_EVENTS',
  Restaurant = 'RESTAURANT',
  /** @deprecated RETAIL is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Retail = 'RETAIL',
  RetailChain = 'RETAIL_CHAIN',
  ReturnBox = 'RETURN_BOX',
  /** @deprecated REWE is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Rewe = 'REWE',
  SelfOperatedCanteen = 'SELF_OPERATED_CANTEEN',
  /** @deprecated SERVICED_RETURN_BOX is deprecated. Use SERVICED_RETURN_BOX_PAID, SERVICED_RETURN_BOX_UNPAID instead. */
  ServicedReturnBox = 'SERVICED_RETURN_BOX',
  ServicedReturnBoxPaid = 'SERVICED_RETURN_BOX_PAID',
  ServicedReturnBoxUnpaid = 'SERVICED_RETURN_BOX_UNPAID',
  SmallRestaurantChain = 'SMALL_RESTAURANT_CHAIN',
  Stadium = 'STADIUM',
  /** @deprecated SUPERMARKET is deprecated. Use LOCAL_RETAILER, RETAIL_CHAIN, ONLINE_RETAILER instead. */
  Supermarket = 'SUPERMARKET',
  UniversityCanteen = 'UNIVERSITY_CANTEEN',
  Venue = 'VENUE',
  Warehouse = 'WAREHOUSE'
}

export enum StripeAccount {
  Pickpack = 'PICKPACK',
  Vytal = 'VYTAL'
}

export type StripeSource = {
  __typename?: 'StripeSource';
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  error_codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type StripeTerminalLocation = {
  __typename?: 'StripeTerminalLocation';
  address: StripeTerminalLocationAddress;
  deleted?: Maybe<Scalars['Boolean']>;
  display_name: Scalars['String'];
  id: Scalars['ID'];
  livemode: Scalars['Boolean'];
  object: Scalars['String'];
};

export type StripeTerminalLocationAddress = {
  __typename?: 'StripeTerminalLocationAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type SubmitEventMerchantOrderEventAccountInput = {
  billing_additional_address_info?: InputMaybe<Scalars['String']>;
  billing_city?: InputMaybe<Scalars['String']>;
  billing_country_code?: InputMaybe<Scalars['String']>;
  billing_email?: InputMaybe<Scalars['String']>;
  billing_first_name?: InputMaybe<Scalars['String']>;
  billing_last_name?: InputMaybe<Scalars['String']>;
  billing_mail?: InputMaybe<Scalars['String']>;
  billing_state?: InputMaybe<Scalars['String']>;
  billing_street?: InputMaybe<Scalars['String']>;
  billing_zip?: InputMaybe<Scalars['String']>;
  business_type?: InputMaybe<BusinessType>;
  company_name?: InputMaybe<Scalars['String']>;
  corporate_structure_info?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  vat?: InputMaybe<Scalars['String']>;
};

export type SubmitEventMerchantOrderInput = {
  comment?: InputMaybe<Scalars['String']>;
  event_account: SubmitEventMerchantOrderEventAccountInput;
  merchant_order_items: Array<SubmitEventMerchantOrderItemInput>;
  merchant_order_shared_link_id: Scalars['ID'];
};

/**
 * One line of an order form. A container line names its container type in
 * type_id; a container station line (an ItemType from the event's
 * allowed_item_types) sets item_type_id and passes 0 as type_id.
 */
export type SubmitEventMerchantOrderItemInput = {
  amount_int: Scalars['Int'];
  item_location_id?: InputMaybe<Scalars['ID']>;
  /** ItemTypes.Id for a container station line; null for containers. */
  item_type_id?: InputMaybe<Scalars['Int']>;
  type_id: Scalars['Int'];
  unit: MerchantOrderItemUnit;
};

export type SubmitProblemExtendedResult = {
  __typename?: 'SubmitProblemExtendedResult';
  case_number?: Maybe<Scalars['String']>;
  containers_broken: Array<Scalars['String']>;
  containers_extended: Array<ExtendedContainers>;
  containers_set_on_hold: Array<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  basket?: Maybe<Basket>;
  containerCheckout?: Maybe<ContainerCheckout>;
  messageFeed: Message;
  /**
   * Receives the full PickingJob payload whenever a scan is recorded against
   * it. Subscribing to a still-virtual job materializes it (same idempotent
   * helper as addItemToPickingJob) so future trigger-based updates reach the
   * subscriber. Context is required for virtual jobs, optional once
   * materialized.
   */
  onPickingJobUpdate: PickingJob;
  orderCreated?: Maybe<Order>;
  orderUpdated?: Maybe<Order>;
  /**
   * Per-item-location stream — the Turboprint desktop subscribes with its own
   * item_location_id and receives only that site's print-job events.
   */
  printJobEvents: PrintJobEvent;
  /**
   * Per-picking-job stream — the picker's mobile app subscribes with the
   * picking job it just confirmed and sees live print state for it.
   */
  printJobEventsByPickingJob: PrintJobEvent;
  storeOrdersUpdated?: Maybe<Order>;
  storeUpdate?: Maybe<Store>;
};


export type SubscriptionBasketArgs = {
  id: Scalars['ID'];
};


export type SubscriptionContainerCheckoutArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionMessageFeedArgs = {
  type?: InputMaybe<MessageType>;
};


export type SubscriptionOnPickingJobUpdateArgs = {
  context?: InputMaybe<PickingJobContextInput>;
  picking_job_id: Scalars['ID'];
};


export type SubscriptionOrderCreatedArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionOrderUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionPrintJobEventsArgs = {
  item_location_id: Scalars['ID'];
};


export type SubscriptionPrintJobEventsByPickingJobArgs = {
  picking_job_id: Scalars['ID'];
};


export type SubscriptionStoreOrdersUpdatedArgs = {
  store_id?: InputMaybe<Scalars['ID']>;
  timespan?: InputMaybe<Range>;
};


export type SubscriptionStoreUpdateArgs = {
  id: Scalars['ID'];
};

export enum SubscriptionState {
  OptedIn = 'OPTED_IN',
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum SupersetRole {
  Admin = 'ADMIN',
  Alpha = 'ALPHA',
  Gamma = 'GAMMA'
}

export type SyncBillomatInvoicesResult = {
  __typename?: 'SyncBillomatInvoicesResult';
  errorIds: Array<Scalars['String']>;
  errors: Scalars['Int'];
  synced: Scalars['Int'];
  total: Scalars['Int'];
};

/** Result of reversing a "tap to borrow & pay" transaction at the payment terminal. */
export type TapToBorrowPaymentReversal = {
  __typename?: 'TapToBorrowPaymentReversal';
  /** Containers of the transaction that had already been returned before this call. */
  already_returned_container_ids: Array<Scalars['UUID']>;
  /** The Stripe PaymentIntent (pi_...) that was reversed. */
  payment_intent_id: Scalars['String'];
  /**
   * What happened to the payment in this call:
   * - refunded: the captured amount was refunded to the card, including the reversal of
   *   the product-amount transfer to the partner's connected account
   * - canceled: the authorization was still open and has been released
   * - already_reversed: the payment had been refunded or canceled before (retry)
   */
  payment_status: Scalars['String'];
  /** The Stripe refund id (re_...) when the payment was refunded, now or in an earlier call. */
  refund_id?: Maybe<Scalars['String']>;
  /**
   * Containers that were still at the tap-to-borrow user and have been booked back to
   * the terminal's store by this call.
   */
  reversed_container_ids: Array<Scalars['UUID']>;
  /** The vytal container transaction (ContainerLocations.TransactionId) of the checkout. */
  transaction_id?: Maybe<Scalars['UUID']>;
};

export type TapToBorrowSupportByCountry = {
  __typename?: 'TapToBorrowSupportByCountry';
  countries_enabled_for_stripe_payment_intent: Array<Scalars['String']>;
  countries_enabled_for_stripe_payment_intent_and_pay: Array<Scalars['String']>;
  countries_enabled_for_stripe_payment_intent_and_pay_saved_card: Array<Scalars['String']>;
  countries_enabled_for_stripe_setup_intent: Array<Scalars['String']>;
  countries_enabled_for_stripe_setup_intent_incl_pi_fallback: Array<Scalars['String']>;
};

export enum TapToBorrowType {
  StripePaymentIntent = 'STRIPE_PAYMENT_INTENT',
  StripePaymentIntentAndPay = 'STRIPE_PAYMENT_INTENT_AND_PAY',
  StripePaymentIntentAndPaySavedCard = 'STRIPE_PAYMENT_INTENT_AND_PAY_SAVED_CARD',
  StripeSetupIntent = 'STRIPE_SETUP_INTENT'
}

export enum TenantType {
  Pickpack = 'PICKPACK',
  Vytal = 'VYTAL'
}

export enum TerminationReason {
  InternalAccount = 'INTERNAL_ACCOUNT',
  LostToCompetitor = 'LOST_TO_COMPETITOR',
  LowUserDemand = 'LOW_USER_DEMAND',
  Other = 'OTHER',
  PartnerClosedDown = 'PARTNER_CLOSED_DOWN',
  SustainableContainerStock = 'SUSTAINABLE_CONTAINER_STOCK',
  TemporaryEventAccount = 'TEMPORARY_EVENT_ACCOUNT',
  UnsatisfiedWithProductService = 'UNSATISFIED_WITH_PRODUCT_SERVICE',
  WrongAdministrationSalesforceAdminfrontend = 'WRONG_ADMINISTRATION_SALESFORCE_ADMINFRONTEND'
}

export type TextIdName = {
  __typename?: 'TextIdName';
  name: Scalars['String'];
  text_id?: Maybe<Scalars['String']>;
};

export type TicketStatistics = {
  __typename?: 'TicketStatistics';
  active_tickets: Scalars['Int'];
  cycle_iteration: Scalars['Int'];
  inactive_tickets: Scalars['Int'];
  total_tickets: Scalars['Int'];
};

export type TrackableItem = {
  __typename?: 'TrackableItem';
  epc_tag: Scalars['String'];
  id: Scalars['ID'];
  is_recalled: Scalars['Boolean'];
  item_location?: Maybe<ItemLocation>;
  item_type: ItemType;
  name: Scalars['String'];
};

export type TrackableItemFilterInput = {
  item_type_category?: InputMaybe<Scalars['String']>;
  item_type_id?: InputMaybe<Scalars['Int']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  charge_id?: Maybe<Scalars['ID']>;
  credits_used?: Maybe<Scalars['Int']>;
  history?: Maybe<Array<Maybe<TransactionHistoryEntry>>>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<TransactionStateEnum>;
  tap_to_borrow_stripe_account_country?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type TransactionHistoryEntry = {
  __typename?: 'TransactionHistoryEntry';
  state?: Maybe<TransactionStateEnum>;
  updated_at?: Maybe<Scalars['String']>;
};

export enum TransactionStateEnum {
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  Disputed = 'DISPUTED',
  Error = 'ERROR',
  Init = 'INIT',
  Pending = 'PENDING',
  Started = 'STARTED'
}

export enum TransactionType {
  ContainerExtension = 'CONTAINER_EXTENSION',
  ContainerPurchase = 'CONTAINER_PURCHASE',
  Default = 'DEFAULT',
  Preorder = 'PREORDER',
  StoreMonthlyInvoice = 'STORE_MONTHLY_INVOICE'
}

export type TransformOptions = {
  shuffle_first?: InputMaybe<Scalars['Int']>;
};

export type UpdateAccountLedgerInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_hidden?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAnalyticsUserInput = {
  account_ids?: InputMaybe<Array<Scalars['String']>>;
  country?: InputMaybe<UserCountry>;
  merchant_text_ids?: InputMaybe<Array<Scalars['String']>>;
  preferred_locale?: InputMaybe<Scalars['String']>;
  store_text_ids?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateAppTranslationInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateBasket = {
  delivery_address_id?: InputMaybe<Scalars['ID']>;
  eat_in?: InputMaybe<Scalars['Boolean']>;
  new_master_notified?: InputMaybe<Scalars['Boolean']>;
  pickup_time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrderType>;
};

export type UpdateBrand = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<CreateAddress>;
  contact?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_vytal_id?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  migrated_from_vytal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateBrandInvoiceInfo = {
  address2?: InputMaybe<CreateAddress>;
  commission_rate?: InputMaybe<Scalars['Int']>;
  dunning_reminder_block_reason?: InputMaybe<Scalars['String']>;
  dunning_reminder_block_type?: InputMaybe<DunningReminderBlockType>;
  invoice_email?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  monthly_fee?: InputMaybe<Scalars['Int']>;
  onboarding_fee_vytal?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
  regular_payment_target_days?: InputMaybe<Scalars['Int']>;
  separate_invoice_each_store?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCategory = {
  icon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reusable_packaging?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateContainerTypeGroupInput = {
  category?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateEventAccountInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  external_zoho_id?: InputMaybe<Scalars['ID']>;
  invoice_language?: InputMaybe<InvoiceLanguage>;
  is_billable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  send_order_fulfillment_emails?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEventAccountUserInput = {
  can_do_order_fulfillments: Scalars['Boolean'];
  password: Scalars['String'];
  user_name: Scalars['String'];
};

export type UpdateEventDeliveryAddressInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /**
   * Promote this address to the event default, clearing the previous one.
   * Only true is accepted — an event always keeps exactly one default, so
   * demote by promoting a different address instead.
   */
  is_event_default?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetno?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateEventInput = {
  allowed_container_type_ids?: InputMaybe<Array<Scalars['Int']>>;
  /**
   * Replaces the event's item type allow list. Every id must be a non-archived
   * ItemType of category CONTAINER_STATION or ASSET; omit to leave the list
   * untouched, pass [] to clear it.
   */
  allowed_item_type_ids?: InputMaybe<Array<Scalars['Int']>>;
  billing_contact_zoho_id?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  default_logistics?: InputMaybe<EventDefaultLogistics>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<LegalEntity>;
  event_manager_zoho_user_id?: InputMaybe<Scalars['ID']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_authorized_signer_necessary?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<Array<EventPriceInput>>;
  start_date?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EventType>;
  uses_deposit?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateInvoiceCollection = {
  collapse_invoice_items?: InputMaybe<Scalars['Boolean']>;
  disable_automatic_partner_invoice_sending?: InputMaybe<Scalars['Boolean']>;
  dunning_reminder_block_reason?: InputMaybe<Scalars['String']>;
  dunning_reminder_block_type?: InputMaybe<DunningReminderBlockType>;
  excluded_store_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  external_id?: InputMaybe<Scalars['ID']>;
  inkassokennzeichen?: InputMaybe<Scalars['Boolean']>;
  invoice_address?: InputMaybe<CreateAddress>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_email_subject_prefix?: InputMaybe<Scalars['String']>;
  invoice_headline?: InputMaybe<Scalars['String']>;
  invoice_iban?: InputMaybe<Scalars['String']>;
  invoice_iban_name?: InputMaybe<Scalars['String']>;
  invoice_routing_id?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  needs_invoice_collection_breakdown?: InputMaybe<Scalars['Boolean']>;
  needs_purchasing_order_number?: InputMaybe<Scalars['Boolean']>;
  order_number?: InputMaybe<Scalars['String']>;
  /** Comma or semicolon separated, max three addresses. Empty clears the field. */
  purchasing_order_email?: InputMaybe<Scalars['String']>;
  regular_payment_target_days?: InputMaybe<Scalars['Int']>;
  seller_id?: InputMaybe<Scalars['String']>;
  sepa_2_percent_discount?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<StoreType>;
  vat_number?: InputMaybe<Scalars['String']>;
};

export type UpdateItemType = {
  archived?: InputMaybe<Scalars['Boolean']>;
  billing_category?: InputMaybe<BillingCategory>;
  billing_frequency?: InputMaybe<BillingFrequency>;
  billomat_article_ids_by_country?: InputMaybe<Array<BillomatArticleIdByCountryInput>>;
  color_hex_code?: InputMaybe<Scalars['String']>;
  custom_field_definitions?: InputMaybe<Array<CustomFieldDefinitionInput>>;
  /** Entries for currencies left out are not touched. */
  default_event_prices?: InputMaybe<Array<ItemTypeDefaultEventPriceInput>>;
  depth_mm?: InputMaybe<Scalars['Int']>;
  height_mm?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  /** Uppercased and trimmed; an empty string clears it. Must be unique. */
  sku?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
  width_mm?: InputMaybe<Scalars['Int']>;
};

export type UpdateMerchantOrderSharedLinkInput = {
  comment?: InputMaybe<Scalars['String']>;
  merchant_order_items?: InputMaybe<Array<SubmitEventMerchantOrderItemInput>>;
  merchant_order_shared_link_id: Scalars['ID'];
  status?: InputMaybe<MerchantOrderStatusEnum>;
};

export type UpdateMiniReturnerInput = {
  /** Optional operator label, max 100 characters. Null or empty clears it. */
  name?: InputMaybe<Scalars['String']>;
  /** Free text for operations. Null or empty clears it. */
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateNewsContent = {
  banner?: InputMaybe<Scalars['String']>;
  city_id?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<UserCountry>;
  country_codes?: InputMaybe<Array<InputMaybe<UserCountry>>>;
  for_consumers?: InputMaybe<Scalars['Boolean']>;
  for_partners?: InputMaybe<Scalars['Boolean']>;
  geohash?: InputMaybe<Scalars['String']>;
  hide_from?: InputMaybe<Scalars['String']>;
  link_al?: InputMaybe<Scalars['String']>;
  link_ca?: InputMaybe<Scalars['String']>;
  link_da?: InputMaybe<Scalars['String']>;
  link_de?: InputMaybe<Scalars['String']>;
  link_el?: InputMaybe<Scalars['String']>;
  link_en?: InputMaybe<Scalars['String']>;
  link_es?: InputMaybe<Scalars['String']>;
  link_et?: InputMaybe<Scalars['String']>;
  link_eu?: InputMaybe<Scalars['String']>;
  link_fr?: InputMaybe<Scalars['String']>;
  link_gl?: InputMaybe<Scalars['String']>;
  link_hu?: InputMaybe<Scalars['String']>;
  link_lb?: InputMaybe<Scalars['String']>;
  link_nl?: InputMaybe<Scalars['String']>;
  link_no?: InputMaybe<Scalars['String']>;
  link_pl?: InputMaybe<Scalars['String']>;
  link_pt?: InputMaybe<Scalars['String']>;
  link_sv?: InputMaybe<Scalars['String']>;
  only_for_languages?: InputMaybe<Array<InputMaybe<UserLocale>>>;
  only_for_non_usage_fee_enabled?: InputMaybe<Scalars['Boolean']>;
  only_for_store_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  only_never_used_delivery_token_users?: InputMaybe<Scalars['Boolean']>;
  only_new_users?: InputMaybe<Scalars['Boolean']>;
  only_used_brands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  only_used_stores?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  published?: InputMaybe<Scalars['Boolean']>;
  radius_meter?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitle_al?: InputMaybe<Scalars['String']>;
  subtitle_ca?: InputMaybe<Scalars['String']>;
  subtitle_da?: InputMaybe<Scalars['String']>;
  subtitle_de?: InputMaybe<Scalars['String']>;
  subtitle_el?: InputMaybe<Scalars['String']>;
  subtitle_en?: InputMaybe<Scalars['String']>;
  subtitle_es?: InputMaybe<Scalars['String']>;
  subtitle_et?: InputMaybe<Scalars['String']>;
  subtitle_eu?: InputMaybe<Scalars['String']>;
  subtitle_fr?: InputMaybe<Scalars['String']>;
  subtitle_gl?: InputMaybe<Scalars['String']>;
  subtitle_hu?: InputMaybe<Scalars['String']>;
  subtitle_lb?: InputMaybe<Scalars['String']>;
  subtitle_nl?: InputMaybe<Scalars['String']>;
  subtitle_no?: InputMaybe<Scalars['String']>;
  subtitle_pl?: InputMaybe<Scalars['String']>;
  subtitle_pt?: InputMaybe<Scalars['String']>;
  subtitle_sv?: InputMaybe<Scalars['String']>;
  title_al?: InputMaybe<Scalars['String']>;
  title_ca?: InputMaybe<Scalars['String']>;
  title_da?: InputMaybe<Scalars['String']>;
  title_de?: InputMaybe<Scalars['String']>;
  title_el?: InputMaybe<Scalars['String']>;
  title_en?: InputMaybe<Scalars['String']>;
  title_es?: InputMaybe<Scalars['String']>;
  title_et?: InputMaybe<Scalars['String']>;
  title_eu?: InputMaybe<Scalars['String']>;
  title_fr?: InputMaybe<Scalars['String']>;
  title_gl?: InputMaybe<Scalars['String']>;
  title_hu?: InputMaybe<Scalars['String']>;
  title_lb?: InputMaybe<Scalars['String']>;
  title_nl?: InputMaybe<Scalars['String']>;
  title_no?: InputMaybe<Scalars['String']>;
  title_pl?: InputMaybe<Scalars['String']>;
  title_pt?: InputMaybe<Scalars['String']>;
  title_sv?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ContentType>;
};

export type UpdateOrder = {
  bell_status?: InputMaybe<BellStatus>;
  booked?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  feedback?: InputMaybe<Scalars['String']>;
  new_master_notified?: InputMaybe<Scalars['Boolean']>;
  paypal_info?: InputMaybe<PaypalDataInput>;
  pickup_time?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatusEnum>;
  stripe_charge_id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
  user_rating?: InputMaybe<OrderUserRating>;
};

export type UpdateOrderFulfillmentPictureInput = {
  comment?: InputMaybe<Scalars['String']>;
};

export type UpdateProductStore = {
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  store_id: Scalars['ID'];
};

export type UpdateScanTunnelInput = {
  container_type_id?: InputMaybe<Scalars['Int']>;
  mode: ScanTunnelMode;
  name: Scalars['String'];
};

export type UpdateStore = {
  accepted_container_groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accepted_container_type_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  address?: InputMaybe<CreateAddress>;
  available_from?: InputMaybe<Scalars['String']>;
  available_soon?: InputMaybe<Scalars['Boolean']>;
  banner?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  cancelation_time?: InputMaybe<Scalars['Int']>;
  coming_soon?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Currency>;
  delivery_address?: InputMaybe<CreateOpsDeliveryAddress>;
  delivery_fee?: InputMaybe<Scalars['Int']>;
  delivery_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  description?: InputMaybe<Scalars['String']>;
  description_al?: InputMaybe<Scalars['String']>;
  description_ca?: InputMaybe<Scalars['String']>;
  description_da?: InputMaybe<Scalars['String']>;
  description_de?: InputMaybe<Scalars['String']>;
  description_el?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_et?: InputMaybe<Scalars['String']>;
  description_eu?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_gl?: InputMaybe<Scalars['String']>;
  description_hu?: InputMaybe<Scalars['String']>;
  description_lb?: InputMaybe<Scalars['String']>;
  description_nl?: InputMaybe<Scalars['String']>;
  description_no?: InputMaybe<Scalars['String']>;
  description_pl?: InputMaybe<Scalars['String']>;
  description_pt?: InputMaybe<Scalars['String']>;
  description_sv?: InputMaybe<Scalars['String']>;
  didi_food_url?: InputMaybe<Scalars['String']>;
  eatic_url?: InputMaybe<Scalars['String']>;
  external_vytal_id?: InputMaybe<Scalars['String']>;
  food_categories?: InputMaybe<Array<InputMaybe<FoodCategory>>>;
  food_info_de?: InputMaybe<Scalars['String']>;
  food_info_en?: InputMaybe<Scalars['String']>;
  foodora_url?: InputMaybe<Scalars['String']>;
  foodpanda_url?: InputMaybe<Scalars['String']>;
  foreign_id?: InputMaybe<Scalars['ID']>;
  habgusta_url?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<StoreImageInput>>>;
  labonapp_url?: InputMaybe<Scalars['String']>;
  lieferando_url?: InputMaybe<Scalars['String']>;
  lonlat?: InputMaybe<LonLatIn>;
  manual_overwrite_store_info?: InputMaybe<Scalars['Boolean']>;
  menu_link?: InputMaybe<Scalars['String']>;
  migrated_from_vytal?: InputMaybe<Scalars['Boolean']>;
  min_delivery_order_value?: InputMaybe<Scalars['Int']>;
  min_delivery_time?: InputMaybe<Scalars['Int']>;
  min_order_time?: InputMaybe<Scalars['Int']>;
  mjam_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  online?: InputMaybe<Scalars['Boolean']>;
  opening_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHours>>>;
  opening_hours_multi?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  partner_newsletter_email?: InputMaybe<Scalars['String']>;
  permanently_removed?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  preferred_locale?: InputMaybe<Scalars['String']>;
  preorder_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  preorder_sms_number?: InputMaybe<Scalars['String']>;
  private_contact_email?: InputMaybe<Scalars['String']>;
  private_contact_info?: InputMaybe<Scalars['String']>;
  private_contact_name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  rappi_url?: InputMaybe<Scalars['String']>;
  special_delivery_hours?: InputMaybe<Array<InputMaybe<CreateSpeicalOpeningHoursMulti>>>;
  special_opening_hours_multi?: InputMaybe<Array<InputMaybe<CreateSpeicalOpeningHoursMulti>>>;
  split_app_url?: InputMaybe<Scalars['String']>;
  store_layout?: InputMaybe<Array<Scalars['String']>>;
  store_layout_vending_machines_json?: InputMaybe<Scalars['String']>;
  too_good_to_go_url?: InputMaybe<Scalars['String']>;
  ubereats_url?: InputMaybe<Scalars['String']>;
  watched_onboarding_videos?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  wolt_url?: InputMaybe<Scalars['String']>;
};

export type UpdateStoreAssetBaseInput = {
  /**
   * Exclusive end of billing: the first day that is NOT billed (ISO date).
   * Billing runs up to but not including this day — e.g. to bill through the
   * whole of May 2026, set 2026-06-01 (NOT 2026-05-31, which stops after May 30).
   * Must be after billing_start. Omit to leave the current value unchanged.
   */
  billing_end?: InputMaybe<Scalars['String']>;
  billing_frequency?: InputMaybe<BillingFrequency>;
  billing_start?: InputMaybe<Scalars['String']>;
  billing_start_with_onboarding?: InputMaybe<Scalars['Boolean']>;
  custom_fields?: InputMaybe<Array<CustomFieldValueInput>>;
  description?: InputMaybe<Scalars['String']>;
  /** Vytal-internal note, never shown to the partner. Pass null to clear it; omit to leave unchanged. */
  internal_comment?: InputMaybe<Scalars['String']>;
  is_billable?: InputMaybe<Scalars['Boolean']>;
  is_recalled?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type UpdateStoreAssetInput = {
  base?: InputMaybe<UpdateStoreAssetBaseInput>;
};

export type UpdateStoreSuperAdmin = {
  accepted_container_groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accepted_container_type_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  acquired_at?: InputMaybe<Scalars['String']>;
  acquired_by?: InputMaybe<Scalars['String']>;
  additional_allowance?: InputMaybe<Scalars['Int']>;
  additional_allowance_valid_until?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<CreateAddress>;
  allow_inventory_checks_for_terminal_users?: InputMaybe<Scalars['Boolean']>;
  allow_inventory_checks_for_terminal_users_until?: InputMaybe<Scalars['String']>;
  always_online?: InputMaybe<Scalars['Boolean']>;
  available_from?: InputMaybe<Scalars['String']>;
  available_soon?: InputMaybe<Scalars['Boolean']>;
  banner?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  can_deliver?: InputMaybe<Scalars['Boolean']>;
  can_get_bowl?: InputMaybe<Scalars['Boolean']>;
  can_order_secondary_portfolio?: InputMaybe<Scalars['Boolean']>;
  can_preorder?: InputMaybe<Scalars['Boolean']>;
  cancelation_time?: InputMaybe<Scalars['Int']>;
  charge_onboarding_fee?: InputMaybe<Scalars['Boolean']>;
  city_id?: InputMaybe<Scalars['String']>;
  coming_soon?: InputMaybe<Scalars['Boolean']>;
  contract_end_date?: InputMaybe<Scalars['String']>;
  contracted_date?: InputMaybe<Scalars['String']>;
  credit_to_partner?: InputMaybe<Scalars['String']>;
  custom_invoice_items?: InputMaybe<Array<InputMaybe<CustomInvoiceItemInput>>>;
  debitor_account_number?: InputMaybe<Scalars['Int']>;
  default_carriers?: InputMaybe<Array<DefaultCarrierEntryInput>>;
  default_inventory_check_expiration_days?: InputMaybe<Scalars['Int']>;
  delivery_address?: InputMaybe<CreateOpsDeliveryAddress>;
  delivery_area?: InputMaybe<Scalars['String']>;
  delivery_fee?: InputMaybe<Scalars['Int']>;
  delivery_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  description?: InputMaybe<Scalars['String']>;
  description_al?: InputMaybe<Scalars['String']>;
  description_ca?: InputMaybe<Scalars['String']>;
  description_da?: InputMaybe<Scalars['String']>;
  description_de?: InputMaybe<Scalars['String']>;
  description_el?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_et?: InputMaybe<Scalars['String']>;
  description_eu?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_gl?: InputMaybe<Scalars['String']>;
  description_hu?: InputMaybe<Scalars['String']>;
  description_lb?: InputMaybe<Scalars['String']>;
  description_nl?: InputMaybe<Scalars['String']>;
  description_no?: InputMaybe<Scalars['String']>;
  description_pl?: InputMaybe<Scalars['String']>;
  description_pt?: InputMaybe<Scalars['String']>;
  description_sv?: InputMaybe<Scalars['String']>;
  didi_food_url?: InputMaybe<Scalars['String']>;
  disable_automatic_partner_charging?: InputMaybe<Scalars['Boolean']>;
  disable_automatic_partner_invoice_sending?: InputMaybe<Scalars['Boolean']>;
  dpd_pickup_compulsory?: InputMaybe<Scalars['Boolean']>;
  dunning_reminder_block_reason?: InputMaybe<Scalars['String']>;
  dunning_reminder_block_type?: InputMaybe<DunningReminderBlockType>;
  eatic_url?: InputMaybe<Scalars['String']>;
  employee_only?: InputMaybe<Scalars['Boolean']>;
  excluded_from_nuf_until?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['ID']>;
  external_vytal_id?: InputMaybe<Scalars['String']>;
  feature_container_collection_enabled?: InputMaybe<Scalars['Boolean']>;
  feature_container_station_packing_enabled?: InputMaybe<Scalars['Boolean']>;
  food_categories?: InputMaybe<Array<InputMaybe<FoodCategory>>>;
  food_info_de?: InputMaybe<Scalars['String']>;
  food_info_en?: InputMaybe<Scalars['String']>;
  foodora_url?: InputMaybe<Scalars['String']>;
  foodpanda_url?: InputMaybe<Scalars['String']>;
  foreign_id?: InputMaybe<Scalars['ID']>;
  google_places_id?: InputMaybe<Scalars['String']>;
  google_review?: InputMaybe<Scalars['Float']>;
  habgusta_url?: InputMaybe<Scalars['String']>;
  has_wolt?: InputMaybe<Scalars['Boolean']>;
  hidden_invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  images?: InputMaybe<Array<InputMaybe<StoreImageInput>>>;
  inkassokennzeichen?: InputMaybe<Scalars['Boolean']>;
  integrations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internal_comment?: InputMaybe<Scalars['String']>;
  invoice_address?: InputMaybe<CreateAddress>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_email_subject_prefix?: InputMaybe<Scalars['String']>;
  invoice_headline?: InputMaybe<Scalars['String']>;
  invoice_iban?: InputMaybe<Scalars['String']>;
  invoice_iban_name?: InputMaybe<Scalars['String']>;
  invoice_routing_id?: InputMaybe<Scalars['String']>;
  invoice_yearly?: InputMaybe<Scalars['Boolean']>;
  invoicing_disabled_permanently?: InputMaybe<Scalars['Boolean']>;
  invoicing_disabled_until?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<InputMaybe<SetStoreLabel>>>;
  labonapp_url?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  lieferando_url?: InputMaybe<Scalars['String']>;
  lonlat?: InputMaybe<LonLatIn>;
  manual_overwrite_store_info?: InputMaybe<Scalars['Boolean']>;
  menu_link?: InputMaybe<Scalars['String']>;
  migrated_from_vytal?: InputMaybe<Scalars['Boolean']>;
  min_delivery_order_value?: InputMaybe<Scalars['Int']>;
  min_delivery_time?: InputMaybe<Scalars['Int']>;
  min_order_time?: InputMaybe<Scalars['Int']>;
  mini_returners?: InputMaybe<Array<InputMaybe<CreateStoreMiniReturner>>>;
  minimum_monthly_transaction_charge?: InputMaybe<Scalars['Int']>;
  mjam_url?: InputMaybe<Scalars['String']>;
  monthly_flat_fee?: InputMaybe<Scalars['Int']>;
  monthly_service_fee?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  needs_purchasing_order_number?: InputMaybe<Scalars['Boolean']>;
  new_inventory_checks_are_non_billable?: InputMaybe<Scalars['Boolean']>;
  non_usage_fee_enabled?: InputMaybe<Scalars['Boolean']>;
  nuf_comment?: InputMaybe<Scalars['String']>;
  offline_card_cost?: InputMaybe<Scalars['Int']>;
  onboarded_date?: InputMaybe<Scalars['String']>;
  onboarding_fee_vytal?: InputMaybe<Scalars['Int']>;
  onboarding_status?: InputMaybe<OnboardingStatus>;
  online?: InputMaybe<Scalars['Boolean']>;
  opening_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHours>>>;
  opening_hours_multi?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  order_number?: InputMaybe<Scalars['String']>;
  order_preferences?: InputMaybe<StoreOrderPreferencesInput>;
  partner_credits?: InputMaybe<Scalars['Int']>;
  partner_credits_usable_until?: InputMaybe<Scalars['String']>;
  partner_newsletter_email?: InputMaybe<Scalars['String']>;
  permanently_closed?: InputMaybe<Scalars['Boolean']>;
  permanently_removed?: InputMaybe<Scalars['Boolean']>;
  phone_from_vytal?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<InputMaybe<CreateStorePhone>>>;
  preferred_locale?: InputMaybe<Scalars['String']>;
  preorder_hours?: InputMaybe<Array<InputMaybe<CreateOpeningHoursMulti>>>;
  preorder_sms_number?: InputMaybe<Scalars['String']>;
  private_contact_email?: InputMaybe<Scalars['String']>;
  private_contact_info?: InputMaybe<Scalars['String']>;
  private_contact_name?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  /** Comma or semicolon separated, max three addresses. Empty clears the field. */
  purchasing_order_email?: InputMaybe<Scalars['String']>;
  rappi_url?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['Int']>;
  regular_payment_target_days?: InputMaybe<Scalars['Int']>;
  removal_reason?: InputMaybe<Scalars['String']>;
  return_boxes?: InputMaybe<Array<InputMaybe<CreateStoreReturnBox>>>;
  revenue_tier?: InputMaybe<StoreTier>;
  sd_application_key?: InputMaybe<Scalars['String']>;
  sd_store_id?: InputMaybe<Scalars['String']>;
  seller_id?: InputMaybe<Scalars['String']>;
  send_nuf_info_to_invoice_address?: InputMaybe<Scalars['Boolean']>;
  sepa_2_percent_discount?: InputMaybe<Scalars['Boolean']>;
  service_package_type?: InputMaybe<ServicePackageType>;
  show_in_stats?: InputMaybe<Scalars['Boolean']>;
  sim_info?: InputMaybe<Scalars['String']>;
  sim_payment_automation?: InputMaybe<Scalars['Boolean']>;
  sim_phone_number?: InputMaybe<Scalars['String']>;
  special_delivery_hours?: InputMaybe<Array<InputMaybe<CreateSpeicalOpeningHoursMulti>>>;
  special_opening_hours_multi?: InputMaybe<Array<InputMaybe<CreateSpeicalOpeningHoursMulti>>>;
  split_app_url?: InputMaybe<Scalars['String']>;
  store_layout?: InputMaybe<Array<Scalars['String']>>;
  store_layout_vending_machines_json?: InputMaybe<Scalars['String']>;
  store_wide_discount_percent?: InputMaybe<Scalars['Int']>;
  sustainability_reports_enabled?: InputMaybe<Scalars['Boolean']>;
  tap2borrow_devices?: InputMaybe<Array<CreateStoreTap2BorrowDevice>>;
  temporarily_closed?: InputMaybe<Scalars['Boolean']>;
  temporary_access_from?: InputMaybe<Scalars['String']>;
  termination_comment?: InputMaybe<Scalars['String']>;
  termination_reason?: InputMaybe<TerminationReason>;
  test_period_end?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<StoreTier>;
  too_good_to_go_url?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<StoreType>;
  ubereats_url?: InputMaybe<Scalars['String']>;
  use_circulation_based_billing?: InputMaybe<Scalars['Boolean']>;
  use_new_inventory_check_version?: InputMaybe<Scalars['Boolean']>;
  vat_number?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wolt_url?: InputMaybe<Scalars['String']>;
  yearly_renewal_fee?: InputMaybe<Scalars['Int']>;
  /** Calendar month 1-12. Null charges the fee in the onboarding month instead. */
  yearly_renewal_fee_month?: InputMaybe<Scalars['Int']>;
};

export type UpdateTrackableItem = {
  item_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTrackableItemBulk = {
  id: Scalars['ID'];
  update: UpdateTrackableItem;
};

export type UpdateUser = {
  accept_agb?: InputMaybe<Scalars['Boolean']>;
  accept_email_functional?: InputMaybe<AcceptedState>;
  accept_email_marketing?: InputMaybe<AcceptedState>;
  accept_newsletter?: InputMaybe<Scalars['Boolean']>;
  accept_privacy?: InputMaybe<Scalars['Boolean']>;
  accept_push?: InputMaybe<Scalars['Boolean']>;
  accept_push_functional?: InputMaybe<AcceptedState>;
  accept_push_marketing?: InputMaybe<AcceptedState>;
  accepted_agb?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<CreateAddress>;
  birthdate?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<UserCountry>;
  email?: InputMaybe<Scalars['String']>;
  family_name?: InputMaybe<Scalars['String']>;
  given_name?: InputMaybe<Scalars['String']>;
  last_order_in_city?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  push_id?: InputMaybe<Scalars['ID']>;
  return_reminders?: InputMaybe<Array<InputMaybe<ReturnReminderInput>>>;
};

export type UpdateVendingMachine = {
  name?: InputMaybe<Scalars['String']>;
  pickup_slots?: InputMaybe<Array<InputMaybe<PickupSlotUpdate>>>;
};

export type User = {
  __typename?: 'User';
  accept_agb?: Maybe<Scalars['Boolean']>;
  accept_email_functional?: Maybe<AcceptedState>;
  accept_email_marketing?: Maybe<AcceptedState>;
  accept_newsletter?: Maybe<Scalars['Boolean']>;
  accept_privacy?: Maybe<Scalars['Boolean']>;
  accept_push?: Maybe<Scalars['Boolean']>;
  accept_push_functional?: Maybe<AcceptedState>;
  accept_push_marketing?: Maybe<AcceptedState>;
  accepted_agb?: Maybe<Scalars['Int']>;
  account_type?: Maybe<Scalars['String']>;
  active_campaigns?: Maybe<Array<Maybe<Campaign>>>;
  active_ops_orders?: Maybe<Array<Maybe<OpsOrder>>>;
  address?: Maybe<Address>;
  app_metadata?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  block_payment?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['ID']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  can_delete_profile_picture?: Maybe<Scalars['Boolean']>;
  client_name?: Maybe<Scalars['String']>;
  client_version?: Maybe<Scalars['String']>;
  completed_one_last_question_step: Scalars['Boolean'];
  completed_privacy_onboarding: Scalars['Boolean'];
  container_transaction_count: Scalars['Int'];
  country?: Maybe<UserCountry>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  email?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  email_subscription?: Maybe<SubscriptionState>;
  email_verified?: Maybe<Scalars['Boolean']>;
  event_account?: Maybe<EventAccount>;
  external_id?: Maybe<Scalars['ID']>;
  family_name?: Maybe<Scalars['String']>;
  favorite_stores?: Maybe<Array<Maybe<Scalars['ID']>>>;
  feature_can_do_order_fulfillments: Scalars['Boolean'];
  feature_container_collection_enabled: Scalars['Boolean'];
  feature_container_station_packing_enabled: Scalars['Boolean'];
  feature_flags?: Maybe<FeatureFlags>;
  feature_inventory_check_enabled?: Maybe<Scalars['Boolean']>;
  feature_link_self_return_qr_code_enabled?: Maybe<Scalars['Boolean']>;
  feature_next_handout_enabled: Scalars['Boolean'];
  feature_ops_order_search_enabled: Scalars['Boolean'];
  feature_request_return_order_enabled: Scalars['Boolean'];
  feature_scan_benchmark_test_enabled: Scalars['Boolean'];
  feature_scantunnel_enabled: Scalars['Boolean'];
  feature_tap_to_borrow_enabled: Scalars['Boolean'];
  feature_tap_to_borrow_two_tap_flow: Scalars['Boolean'];
  feature_user_scan_enabled: Scalars['Boolean'];
  fraud_check?: Maybe<Scalars['Boolean']>;
  given_name?: Maybe<Scalars['String']>;
  has_payment: Scalars['Boolean'];
  id: Scalars['ID'];
  identities?: Maybe<Array<Maybe<Auth0Identities>>>;
  last_login?: Maybe<Scalars['String']>;
  last_order_date?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  order_count?: Maybe<Scalars['Int']>;
  payment_details?: Maybe<GlypoUser>;
  phone_number?: Maybe<Scalars['String']>;
  phone_number_verified?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  push_id?: Maybe<Scalars['ID']>;
  /** @deprecated No longer supported */
  push_subscription?: Maybe<SubscriptionState>;
  qr_referral_code?: Maybe<Scalars['String']>;
  readable_id?: Maybe<Scalars['ID']>;
  referral_code?: Maybe<Scalars['String']>;
  referral_code2?: Maybe<Scalars['String']>;
  return_reminders?: Maybe<Array<Maybe<ReturnReminder>>>;
  return_reminders_set_by_user: Scalars['Boolean'];
  role?: Maybe<Role>;
  self_checkin_enabled?: Maybe<Scalars['Boolean']>;
  self_checkout_enabled?: Maybe<Scalars['Boolean']>;
  store?: Maybe<Store>;
  store_default_item_location_id?: Maybe<Scalars['ID']>;
  store_id?: Maybe<Scalars['ID']>;
  store_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  stripe_connected_account_id?: Maybe<Scalars['String']>;
  success_campaign?: Maybe<Campaign>;
  tap_to_borrow_type: TapToBorrowType;
  unlocked_achievements?: Maybe<Array<Maybe<Achievement>>>;
  updated_at?: Maybe<Scalars['String']>;
  use_new_inventory_check_version: Scalars['Boolean'];
  used_brand_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  used_brands?: Maybe<Array<Maybe<Brand>>>;
  used_preorder?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['ID']>;
  vytal_credits: Scalars['Int'];
  vytal_qr_code?: Maybe<Scalars['String']>;
};

export enum UserCountry {
  Ae = 'AE',
  Al = 'AL',
  At = 'AT',
  Be = 'BE',
  Ch = 'CH',
  De = 'DE',
  Dk = 'DK',
  Do = 'DO',
  Ec = 'EC',
  Ee = 'EE',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  Gr = 'GR',
  Hu = 'HU',
  Ie = 'IE',
  Il = 'IL',
  Lu = 'LU',
  Mx = 'MX',
  Nl = 'NL',
  No = 'NO',
  Pl = 'PL',
  Pt = 'PT',
  Se = 'SE',
  Us = 'US',
  Za = 'ZA'
}

export enum UserLocale {
  Al = 'AL',
  Ca = 'CA',
  Da = 'DA',
  De = 'DE',
  El = 'EL',
  En = 'EN',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fr = 'FR',
  Gl = 'GL',
  Hu = 'HU',
  Lb = 'LB',
  Nl = 'NL',
  No = 'NO',
  Pl = 'PL',
  Pt = 'PT',
  Sv = 'SV'
}

export type UserLocationFromIpResponse = {
  __typename?: 'UserLocationFromIpResponse';
  geo_hash_by_ip: Scalars['String'];
  selected_city?: Maybe<Location>;
};

export type UserRaffleParticipation = {
  __typename?: 'UserRaffleParticipation';
  campaigns: Array<Scalars['String']>;
  has_participated: Scalars['Boolean'];
  ticket_ids: Array<Scalars['String']>;
};

export type ValidationRule = {
  __typename?: 'ValidationRule';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  regex?: Maybe<Scalars['String']>;
  support: ValidationSupport;
};

export enum ValidationSupport {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
  Unsupported = 'UNSUPPORTED'
}

export type VariantInput = {
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image?: InputMaybe<Scalars['String']>;
  ingredients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  prep_time?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  price_purchase?: InputMaybe<Scalars['Int']>;
  price_retail?: InputMaybe<Scalars['Int']>;
  price_to_go?: InputMaybe<Scalars['Int']>;
  specialities?: InputMaybe<SpecialitiesInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teaser_text?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['ID']>;
  vat_rate?: InputMaybe<Scalars['Int']>;
};

export type VatGroup = {
  __typename?: 'VatGroup';
  total_amount?: Maybe<Scalars['Int']>;
  vat_amount?: Maybe<Scalars['Int']>;
  vat_rate?: Maybe<Scalars['Int']>;
};

export type VendingMachine = {
  __typename?: 'VendingMachine';
  compartments?: Maybe<Array<Maybe<Compartment>>>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  pickup_slots?: Maybe<Array<Maybe<PickupSlot>>>;
  store?: Maybe<Store>;
  store_id?: Maybe<Scalars['ID']>;
};

export type VendingMachineOrderError = {
  __typename?: 'VendingMachineOrderError';
  products_out_of_stock?: Maybe<Array<Maybe<ProductOutOfStock>>>;
};

export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Scalars['String']>;
  commission_rate?: Maybe<Scalars['Int']>;
  commission_rate_reduced?: Maybe<Scalars['Int']>;
  contact?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  vendor_id?: Maybe<Scalars['ID']>;
};

export type VytalCharge = {
  __typename?: 'VytalCharge';
  credits_left: Scalars['Int'];
  credits_used: Scalars['Int'];
  source_charge: Scalars['Boolean'];
  total_charged: Scalars['Int'];
  transaction?: Maybe<Transaction>;
};

export type VytalMerchantSearchResult = {
  __typename?: 'VytalMerchantSearchResult';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type VytalStoreFilter = {
  can_deliver?: InputMaybe<Scalars['Boolean']>;
  can_preorder?: InputMaybe<Scalars['Boolean']>;
  food_categories?: InputMaybe<Array<InputMaybe<FoodCategory>>>;
  has_didi_food?: InputMaybe<Scalars['Boolean']>;
  has_eatic?: InputMaybe<Scalars['Boolean']>;
  has_foodora?: InputMaybe<Scalars['Boolean']>;
  has_foodpanda?: InputMaybe<Scalars['Boolean']>;
  has_habgusta?: InputMaybe<Scalars['Boolean']>;
  has_labonapp?: InputMaybe<Scalars['Boolean']>;
  has_lieferando?: InputMaybe<Scalars['Boolean']>;
  has_mjam?: InputMaybe<Scalars['Boolean']>;
  has_rappi?: InputMaybe<Scalars['Boolean']>;
  has_too_good_to_go?: InputMaybe<Scalars['Boolean']>;
  has_ubereats?: InputMaybe<Scalars['Boolean']>;
  has_wolt?: InputMaybe<Scalars['Boolean']>;
  include_unpublished_employee_only_stores?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  no_preorder?: InputMaybe<Scalars['Boolean']>;
  only_preorder?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<StoreType>>;
};

export type VytalStoresByGeoKey = {
  __typename?: 'VytalStoresByGeoKey';
  geo_key?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<Maybe<Store>>>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['UUID'];
  /**
   * The warehouse's item location (MerchantStores.DefaultItemLocationId) —
   * the identifier the print-job API is scoped by: pass it to
   * pendingPrintJobs / printJobEvents and match it against
   * PrintJob.item_location_id. Null for a warehouse store that has no
   * default item location configured.
   */
  item_location_id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  text_id: Scalars['String'];
};

export type WarehouseRouting = {
  __typename?: 'WarehouseRouting';
  countries: Array<WarehouseRoutingCountryEntry>;
  default_warehouse_uuid?: Maybe<Scalars['UUID']>;
  fallback_warehouse_uuid: Scalars['UUID'];
};

export type WarehouseRoutingCountryEntry = {
  __typename?: 'WarehouseRoutingCountryEntry';
  country_code: Scalars['String'];
  warehouse_uuid: Scalars['UUID'];
};

export type WarehouseRoutingCountryInput = {
  country_code: Scalars['String'];
  warehouse_uuid: Scalars['UUID'];
};

export type WarehouseRoutingInput = {
  countries: Array<WarehouseRoutingCountryInput>;
  default_warehouse_uuid?: InputMaybe<Scalars['UUID']>;
};

/**
 * A buffer order the washing hub dashboard created (EVENT_BUFFER_ORDER whose
 * ops comment starts with "[DEMO] Washing Hub", or "[washing-hub]" for older
 * ones) and its picking progress.
 * Amounts are pieces, summed over the whole picking job.
 */
export type WashingHubBufferOrder = {
  __typename?: 'WashingHubBufferOrder';
  /** Pieces ordered on this buffer order. */
  amount: Scalars['Int'];
  amount_ordered: Scalars['Int'];
  amount_picked: Scalars['Int'];
  carrier_pickup_date?: Maybe<Scalars['String']>;
  container_type_id?: Maybe<Scalars['Int']>;
  container_type_name?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  id: Scalars['UUID'];
  /** Null while the picking job is still virtual (nothing scanned yet). */
  picking_job_id?: Maybe<Scalars['UUID']>;
  picking_job_status?: Maybe<PickingJobStatus>;
  /** True when another order shares the picking job (same bundling key). */
  shares_picking_job: Scalars['Boolean'];
  status: MerchantOrderStatusEnum;
};

/** The two sub-steps shown under CLEANING. */
export type WashingHubCleaningSteps = {
  __typename?: 'WashingHubCleaningSteps';
  /** Clear box content: when the box was emptied. */
  cleared_at?: Maybe<Scalars['String']>;
  /** Count box content: when the returned content was counted. */
  counted_at?: Maybe<Scalars['String']>;
};

export type WashingHubContainerStation = {
  __typename?: 'WashingHubContainerStation';
  counted_at?: Maybe<Scalars['String']>;
  current_item_location?: Maybe<IdName>;
  id: Scalars['ID'];
  item_type_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sealed: Scalars['Boolean'];
  total_amount: Scalars['Int'];
};

export type WashingHubEvent = {
  __typename?: 'WashingHubEvent';
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  type: EventType;
};

export type WashingHubGastronomist = {
  __typename?: 'WashingHubGastronomist';
  id: Scalars['ID'];
  is_billable: Scalars['Boolean'];
  name: Scalars['String'];
  /** True when order fulfillment emails go out to this account. */
  sends_order_fulfillment_emails: Scalars['Boolean'];
};

export type WashingHubLocation = {
  __typename?: 'WashingHubLocation';
  id: Scalars['UUID'];
  name: Scalars['String'];
  role: WashingHubLocationRole;
};

/** Role of a location the washing hub simulation books to. */
export enum WashingHubLocationRole {
  Arrival = 'ARRIVAL',
  EventWarehouse = 'EVENT_WAREHOUSE',
  Picking = 'PICKING',
  ReturnDelivery = 'RETURN_DELIVERY',
  Storage = 'STORAGE'
}

/** Which warehouse app feature packed the box. */
export enum WashingHubPackingFeature {
  /** Count & pack: booked through a packed_boxes_after_cleaning fulfillment. */
  CountAndPack = 'COUNT_AND_PACK',
  /** Pack boxes: a plain pack booking without an order fulfillment. */
  PackBoxes = 'PACK_BOXES'
}

/**
 * The nine stations of the Onsite & Clear cycle one eurobox (container station)
 * runs through, in cycle order. PACKING is followed by STORAGE again.
 */
export enum WashingHubStage {
  /**
   * Not a booking of its own: the box counts as being cleaned from the moment
   * its content was counted or cleared after receiving until it is packed.
   */
  Cleaning = 'CLEANING',
  /** Delivery to the event confirmed (or booked to the event on confirm). */
  Delivery = 'DELIVERY',
  /** Handed out to a gastronomist (delivery order fulfillment). */
  HandOut = 'HAND_OUT',
  /** An open washing hub buffer order for the event is waiting in picking. */
  Order = 'ORDER',
  /**
   * Packed and sealed again with clean containers. Passed together with STORAGE
   * at the packing time, so it is never the current stage.
   */
  Packing = 'PACKING',
  /** Scanned into the buffer order's picking job. */
  Picking = 'PICKING',
  /** Received at the washing centre (receive_shipment fulfillment). */
  ReceiveShipment = 'RECEIVE_SHIPMENT',
  /**
   * Sealed and booked to the warehouse storage location. Packing books the box
   * to its storage location, so a packed box is in storage from the packing time.
   */
  Storage = 'STORAGE',
  /** Taken back from the gastronomist (return order fulfillment). */
  TakeBack = 'TAKE_BACK'
}

export type WashingHubStageTimestamp = {
  __typename?: 'WashingHubStageTimestamp';
  /** When the box reached the stage in the current cycle. Null if not yet. */
  reached_at?: Maybe<Scalars['String']>;
  stage: WashingHubStage;
};

/**
 * Everything the washing hub TV shows for one container station, derived from
 * the station's location history, its picking rows and the event's washing hub
 * buffer orders in a single request.
 */
export type WashingHubStationState = {
  __typename?: 'WashingHubStationState';
  /**
   * The open washing hub buffer order of the event, else the one the box was
   * picked into in this cycle.
   */
  buffer_order?: Maybe<WashingHubBufferOrder>;
  cleaning: WashingHubCleaningSteps;
  container_station: WashingHubContainerStation;
  event: WashingHubEvent;
  /** The gastronomist of this cycle's hand out, once it happened. */
  gastronomist?: Maybe<IdName>;
  gastronomists: Array<WashingHubGastronomist>;
  locations: Array<WashingHubLocation>;
  next_stage: WashingHubStage;
  packing_feature?: Maybe<WashingHubPackingFeature>;
  stage: WashingHubStage;
  /** All nine stages in cycle order with the time each was reached. */
  stages: Array<WashingHubStageTimestamp>;
  /** Server time of the derivation. */
  updated_at: Scalars['String'];
};

export enum WeightClass {
  Heavy = 'heavy',
  Light = 'light',
  Medium = 'medium'
}

export type ZohoContact = {
  __typename?: 'ZohoContact';
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  other_phone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ZohoDealQuoteMeta = {
  __typename?: 'ZohoDealQuoteMeta';
  availableTaxes: Array<ZohoQuoteTax>;
  containerTypes: Array<ZohoQuoteContainerType>;
  currency: Scalars['String'];
  dealId: Scalars['String'];
  dealName?: Maybe<Scalars['String']>;
  defaultLanguage: Scalars['String'];
  entity: Scalars['String'];
  mainContractor?: Maybe<ZohoQuoteMainContractor>;
  suggestedTaxId?: Maybe<Scalars['String']>;
};

export type ZohoInvoice = {
  __typename?: 'ZohoInvoice';
  balance: Scalars['Float'];
  created_time: Scalars['String'];
  currency_symbol: Scalars['String'];
  customer_name: Scalars['String'];
  date: Scalars['String'];
  due_date: Scalars['String'];
  event_account_id?: Maybe<Scalars['ID']>;
  event_account_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['ID']>;
  event_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_number: Scalars['String'];
  status: ZohoInvoiceStatus;
  total: Scalars['Float'];
};

export type ZohoInvoicePaginatedResult = {
  __typename?: 'ZohoInvoicePaginatedResult';
  has_more_pages: Scalars['Boolean'];
  invoices: Array<ZohoInvoice>;
  page: Scalars['Int'];
  per_page: Scalars['Int'];
  total: Scalars['Int'];
};

export type ZohoInvoicePaginationInput = {
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
};

export enum ZohoInvoiceStatus {
  Draft = 'draft',
  Overdue = 'overdue',
  Paid = 'paid',
  PartiallyPaid = 'partially_paid',
  Sent = 'sent',
  Unpaid = 'unpaid',
  Viewed = 'viewed',
  Void = 'void'
}

export type ZohoQuoteContainerType = {
  __typename?: 'ZohoQuoteContainerType';
  defaultCleaningPrice: Scalars['Int'];
  defaultClearingPrice: Scalars['Int'];
  defaultLossPrice: Scalars['Int'];
  defaultRentPrice: Scalars['Int'];
  group: Scalars['String'];
  hexCode?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  packingUnit: Scalars['Int'];
};

export type ZohoQuoteLineItemInput = {
  boxAmount: Scalars['Int'];
  cleaningPrice: Scalars['Int'];
  clearingPrice: Scalars['Int'];
  containerTypeId: Scalars['Int'];
  lossPrice: Scalars['Int'];
  rentPrice: Scalars['Int'];
};

export type ZohoQuoteMainContractor = {
  __typename?: 'ZohoQuoteMainContractor';
  accountId: Scalars['String'];
  billingCountryCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ZohoQuoteTax = {
  __typename?: 'ZohoQuoteTax';
  taxId: Scalars['String'];
  taxName?: Maybe<Scalars['String']>;
  taxPercentage?: Maybe<Scalars['Float']>;
};

export type ZohoUser = {
  __typename?: 'ZohoUser';
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobile?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};
